(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@innovyze/stylovyze"), require("@innovyze/lib-am-common/Utils"), require("styled-components"), require("@mui/material"), require("@reduxjs/toolkit"), require("@innovyze/lib-am-common/Reducers"), require("react-redux"), require("react-i18next"), require("@mui/styles"), require("@innovyze/lib-am-common/Components"), require("@innovyze/lib-am-common/Types"), require("@mui/system"), require("@mui/x-data-grid-premium"), require("react-router-dom"), require("@mui/icons-material"), require("@innovyze/lib_asset_schema_store"), require("@mui/icons-material/DoneSharp"), require("@mui/icons-material/ArrowForward"), require("@mui/icons-material/ArrowDownward"), require("@mui/icons-material/Star"), require("@mui/material/Skeleton"), require("@mui/icons-material/Help"), require("@innovyze/lib-am-common/Actions"), require("@innovyze/lib-am-common/Selectors"), require("@innovyze/shared-utils"), require("@innovyze/lib_get_service"), require("i18next"), require("@innovyze/lib_asset_schema"), require("@mui/icons-material/CheckCircle"), require("@mui/icons-material/RemoveCircle"), require("@mui/icons-material/FilterAlt"), require("@mui/material/colors"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "@Innovyze/Stylovyze", "@innovyze/lib-am-common/Utils", "StyledComponents", "@MaterialUi/Core", "@Reduxjs/Toolkit", "@innovyze/lib-am-common/Reducers", "ReactRedux", "ReactI18next", "@MaterialUi/styles", "@innovyze/lib-am-common/Components", "@innovyze/lib-am-common/Types", "@mui/system", "@mui/x-data-grid-premium", "ReactRouterDom", "@mui/icons-material", "@innovyze/lib_asset_schema_store", "@mui/icons-material/DoneSharp", "@mui/icons-material/ArrowForward", "@mui/icons-material/ArrowDownward", "@mui/icons-material/Star", "@mui/material/Skeleton", "@mui/icons-material/Help", "@innovyze/lib-am-common/Actions", "@innovyze/lib-am-common/Selectors", "@innovyze/shared-utils", "@innovyze/lib_get_service", "I18next", "@innovyze/lib_asset_schema", "@mui/icons-material/CheckCircle", "@mui/icons-material/RemoveCircle", "@mui/icons-material/FilterAlt", "@mui/material/colors"], factory);
	else if(typeof exports === 'object')
		exports["app-MODULE-NAME"] = factory(require("react"), require("@innovyze/stylovyze"), require("@innovyze/lib-am-common/Utils"), require("styled-components"), require("@mui/material"), require("@reduxjs/toolkit"), require("@innovyze/lib-am-common/Reducers"), require("react-redux"), require("react-i18next"), require("@mui/styles"), require("@innovyze/lib-am-common/Components"), require("@innovyze/lib-am-common/Types"), require("@mui/system"), require("@mui/x-data-grid-premium"), require("react-router-dom"), require("@mui/icons-material"), require("@innovyze/lib_asset_schema_store"), require("@mui/icons-material/DoneSharp"), require("@mui/icons-material/ArrowForward"), require("@mui/icons-material/ArrowDownward"), require("@mui/icons-material/Star"), require("@mui/material/Skeleton"), require("@mui/icons-material/Help"), require("@innovyze/lib-am-common/Actions"), require("@innovyze/lib-am-common/Selectors"), require("@innovyze/shared-utils"), require("@innovyze/lib_get_service"), require("i18next"), require("@innovyze/lib_asset_schema"), require("@mui/icons-material/CheckCircle"), require("@mui/icons-material/RemoveCircle"), require("@mui/icons-material/FilterAlt"), require("@mui/material/colors"));
	else
		root["app-MODULE-NAME"] = factory(root["React"], root["@Innovyze/Stylovyze"], root["@innovyze/lib-am-common/Utils"], root["StyledComponents"], root["@MaterialUi/Core"], root["@Reduxjs/Toolkit"], root["@innovyze/lib-am-common/Reducers"], root["ReactRedux"], root["ReactI18next"], root["@MaterialUi/styles"], root["@innovyze/lib-am-common/Components"], root["@innovyze/lib-am-common/Types"], root["@mui/system"], root["@mui/x-data-grid-premium"], root["ReactRouterDom"], root["@mui/icons-material"], root["@innovyze/lib_asset_schema_store"], root["@mui/icons-material/DoneSharp"], root["@mui/icons-material/ArrowForward"], root["@mui/icons-material/ArrowDownward"], root["@mui/icons-material/Star"], root["@mui/material/Skeleton"], root["@mui/icons-material/Help"], root["@innovyze/lib-am-common/Actions"], root["@innovyze/lib-am-common/Selectors"], root["@innovyze/shared-utils"], root["@innovyze/lib_get_service"], root["I18next"], root["@innovyze/lib_asset_schema"], root["@mui/icons-material/CheckCircle"], root["@mui/icons-material/RemoveCircle"], root["@mui/icons-material/FilterAlt"], root["@mui/material/colors"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE__innovyze_stylovyze__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Utils__, __WEBPACK_EXTERNAL_MODULE_styled_components__, __WEBPACK_EXTERNAL_MODULE__mui_material__, __WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Reducers__, __WEBPACK_EXTERNAL_MODULE_react_redux__, __WEBPACK_EXTERNAL_MODULE_react_i18next__, __WEBPACK_EXTERNAL_MODULE__mui_styles__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Components__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Types__, __WEBPACK_EXTERNAL_MODULE__mui_system__, __WEBPACK_EXTERNAL_MODULE__mui_x_data_grid_premium__, __WEBPACK_EXTERNAL_MODULE_react_router_dom__, __WEBPACK_EXTERNAL_MODULE__mui_icons_material__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_asset_schema_store__, __WEBPACK_EXTERNAL_MODULE__mui_icons_material_DoneSharp__, __WEBPACK_EXTERNAL_MODULE__mui_icons_material_ArrowForward__, __WEBPACK_EXTERNAL_MODULE__mui_icons_material_ArrowDownward__, __WEBPACK_EXTERNAL_MODULE__mui_icons_material_Star__, __WEBPACK_EXTERNAL_MODULE__mui_material_Skeleton__, __WEBPACK_EXTERNAL_MODULE__mui_icons_material_Help__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Actions__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Selectors__, __WEBPACK_EXTERNAL_MODULE__innovyze_shared_utils__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_get_service__, __WEBPACK_EXTERNAL_MODULE_i18next__, __WEBPACK_EXTERNAL_MODULE__innovyze_lib_asset_schema__, __WEBPACK_EXTERNAL_MODULE__mui_icons_material_CheckCircle__, __WEBPACK_EXTERNAL_MODULE__mui_icons_material_RemoveCircle__, __WEBPACK_EXTERNAL_MODULE__mui_icons_material_FilterAlt__, __WEBPACK_EXTERNAL_MODULE__mui_material_colors__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "../node_modules/css-loader/dist/cjs.js!./components/RiskList/risk-card.css":
/*!**********************************************************************************!*\
  !*** ../node_modules/css-loader/dist/cjs.js!./components/RiskList/risk-card.css ***!
  \**********************************************************************************/
/***/ ((module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../node_modules/css-loader/dist/runtime/sourceMaps.js */ "../node_modules/css-loader/dist/runtime/sourceMaps.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../node_modules/css-loader/dist/runtime/api.js */ "../node_modules/css-loader/dist/runtime/api.js");
/* harmony import */ var _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1__);
// Imports


var ___CSS_LOADER_EXPORT___ = _node_modules_css_loader_dist_runtime_api_js__WEBPACK_IMPORTED_MODULE_1___default()((_node_modules_css_loader_dist_runtime_sourceMaps_js__WEBPACK_IMPORTED_MODULE_0___default()));
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adjusted-menu-position .InfoCard--header {
  padding-right: 0.3rem;
}

.adjusted-menu-position .ContentCard--body > div {
  grid-template-columns: minmax(0,1.25fr) minmax(0,0.75fr);
}

.header-container {
  display: flex;
  width: 100%;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./components/RiskList/risk-card.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".adjusted-menu-position .InfoCard--header {\n  padding-right: 0.3rem;\n}\n\n.adjusted-menu-position .ContentCard--body > div {\n  grid-template-columns: minmax(0,1.25fr) minmax(0,0.75fr);\n}\n\n.header-container {\n  display: flex;\n  width: 100%;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (___CSS_LOADER_EXPORT___);


/***/ }),

/***/ "../node_modules/css-loader/dist/runtime/api.js":
/*!******************************************************!*\
  !*** ../node_modules/css-loader/dist/runtime/api.js ***!
  \******************************************************/
/***/ ((module) => {



/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
module.exports = function (cssWithMappingToString) {
  var list = [];

  // return the list of modules as css string
  list.toString = function toString() {
    return this.map(function (item) {
      var content = "";
      var needLayer = typeof item[5] !== "undefined";
      if (item[4]) {
        content += "@supports (".concat(item[4], ") {");
      }
      if (item[2]) {
        content += "@media ".concat(item[2], " {");
      }
      if (needLayer) {
        content += "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {");
      }
      content += cssWithMappingToString(item);
      if (needLayer) {
        content += "}";
      }
      if (item[2]) {
        content += "}";
      }
      if (item[4]) {
        content += "}";
      }
      return content;
    }).join("");
  };

  // import a list of modules into the list
  list.i = function i(modules, media, dedupe, supports, layer) {
    if (typeof modules === "string") {
      modules = [[null, modules, undefined]];
    }
    var alreadyImportedModules = {};
    if (dedupe) {
      for (var k = 0; k < this.length; k++) {
        var id = this[k][0];
        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }
    for (var _k = 0; _k < modules.length; _k++) {
      var item = [].concat(modules[_k]);
      if (dedupe && alreadyImportedModules[item[0]]) {
        continue;
      }
      if (typeof layer !== "undefined") {
        if (typeof item[5] === "undefined") {
          item[5] = layer;
        } else {
          item[1] = "@layer".concat(item[5].length > 0 ? " ".concat(item[5]) : "", " {").concat(item[1], "}");
          item[5] = layer;
        }
      }
      if (media) {
        if (!item[2]) {
          item[2] = media;
        } else {
          item[1] = "@media ".concat(item[2], " {").concat(item[1], "}");
          item[2] = media;
        }
      }
      if (supports) {
        if (!item[4]) {
          item[4] = "".concat(supports);
        } else {
          item[1] = "@supports (".concat(item[4], ") {").concat(item[1], "}");
          item[4] = supports;
        }
      }
      list.push(item);
    }
  };
  return list;
};

/***/ }),

/***/ "../node_modules/css-loader/dist/runtime/sourceMaps.js":
/*!*************************************************************!*\
  !*** ../node_modules/css-loader/dist/runtime/sourceMaps.js ***!
  \*************************************************************/
/***/ ((module) => {



module.exports = function (item) {
  var content = item[1];
  var cssMapping = item[3];
  if (!cssMapping) {
    return content;
  }
  if (typeof btoa === "function") {
    var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(cssMapping))));
    var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
    var sourceMapping = "/*# ".concat(data, " */");
    return [content].concat([sourceMapping]).join("\n");
  }
  return [content].join("\n");
};

/***/ }),

/***/ "../node_modules/decode-uri-component/index.js":
/*!*****************************************************!*\
  !*** ../node_modules/decode-uri-component/index.js ***!
  \*****************************************************/
/***/ ((module) => {


var token = '%[a-f0-9]{2}';
var singleMatcher = new RegExp('(' + token + ')|([^%]+?)', 'gi');
var multiMatcher = new RegExp('(' + token + ')+', 'gi');

function decodeComponents(components, split) {
	try {
		// Try to decode the entire string first
		return [decodeURIComponent(components.join(''))];
	} catch (err) {
		// Do nothing
	}

	if (components.length === 1) {
		return components;
	}

	split = split || 1;

	// Split the array in 2 parts
	var left = components.slice(0, split);
	var right = components.slice(split);

	return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
}

function decode(input) {
	try {
		return decodeURIComponent(input);
	} catch (err) {
		var tokens = input.match(singleMatcher) || [];

		for (var i = 1; i < tokens.length; i++) {
			input = decodeComponents(tokens, i).join('');

			tokens = input.match(singleMatcher) || [];
		}

		return input;
	}
}

function customDecodeURIComponent(input) {
	// Keep track of all the replacements and prefill the map with the `BOM`
	var replaceMap = {
		'%FE%FF': '\uFFFD\uFFFD',
		'%FF%FE': '\uFFFD\uFFFD'
	};

	var match = multiMatcher.exec(input);
	while (match) {
		try {
			// Decode as big chunks as possible
			replaceMap[match[0]] = decodeURIComponent(match[0]);
		} catch (err) {
			var result = decode(match[0]);

			if (result !== match[0]) {
				replaceMap[match[0]] = result;
			}
		}

		match = multiMatcher.exec(input);
	}

	// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
	replaceMap['%C2'] = '\uFFFD';

	var entries = Object.keys(replaceMap);

	for (var i = 0; i < entries.length; i++) {
		// Replace all decoded components
		var key = entries[i];
		input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
	}

	return input;
}

module.exports = function (encodedURI) {
	if (typeof encodedURI !== 'string') {
		throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
	}

	try {
		encodedURI = encodedURI.replace(/\+/g, ' ');

		// Try the built in decoder first
		return decodeURIComponent(encodedURI);
	} catch (err) {
		// Fallback to a more advanced decoder
		return customDecodeURIComponent(encodedURI);
	}
};


/***/ }),

/***/ "../node_modules/filter-obj/index.js":
/*!*******************************************!*\
  !*** ../node_modules/filter-obj/index.js ***!
  \*******************************************/
/***/ ((module) => {


module.exports = function (obj, predicate) {
	var ret = {};
	var keys = Object.keys(obj);
	var isArr = Array.isArray(predicate);

	for (var i = 0; i < keys.length; i++) {
		var key = keys[i];
		var val = obj[key];

		if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) {
			ret[key] = val;
		}
	}

	return ret;
};


/***/ }),

/***/ "../node_modules/luxon/build/node/luxon.js":
/*!*************************************************!*\
  !*** ../node_modules/luxon/build/node/luxon.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({ value: true }));

// these aren't really private, but nor are they really useful to document

/**
 * @private
 */
class LuxonError extends Error {}

/**
 * @private
 */
class InvalidDateTimeError extends LuxonError {
  constructor(reason) {
    super(`Invalid DateTime: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class InvalidIntervalError extends LuxonError {
  constructor(reason) {
    super(`Invalid Interval: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class InvalidDurationError extends LuxonError {
  constructor(reason) {
    super(`Invalid Duration: ${reason.toMessage()}`);
  }
}

/**
 * @private
 */
class ConflictingSpecificationError extends LuxonError {}

/**
 * @private
 */
class InvalidUnitError extends LuxonError {
  constructor(unit) {
    super(`Invalid unit ${unit}`);
  }
}

/**
 * @private
 */
class InvalidArgumentError extends LuxonError {}

/**
 * @private
 */
class ZoneIsAbstractError extends LuxonError {
  constructor() {
    super("Zone is an abstract class");
  }
}

/**
 * @private
 */

const n = "numeric",
  s = "short",
  l = "long";
const DATE_SHORT = {
  year: n,
  month: n,
  day: n
};
const DATE_MED = {
  year: n,
  month: s,
  day: n
};
const DATE_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s
};
const DATE_FULL = {
  year: n,
  month: l,
  day: n
};
const DATE_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l
};
const TIME_SIMPLE = {
  hour: n,
  minute: n
};
const TIME_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n
};
const TIME_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
const TIME_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};
const TIME_24_SIMPLE = {
  hour: n,
  minute: n,
  hourCycle: "h23"
};
const TIME_24_WITH_SECONDS = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23"
};
const TIME_24_WITH_SHORT_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: s
};
const TIME_24_WITH_LONG_OFFSET = {
  hour: n,
  minute: n,
  second: n,
  hourCycle: "h23",
  timeZoneName: l
};
const DATETIME_SHORT = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n
};
const DATETIME_SHORT_WITH_SECONDS = {
  year: n,
  month: n,
  day: n,
  hour: n,
  minute: n,
  second: n
};
const DATETIME_MED = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n
};
const DATETIME_MED_WITH_SECONDS = {
  year: n,
  month: s,
  day: n,
  hour: n,
  minute: n,
  second: n
};
const DATETIME_MED_WITH_WEEKDAY = {
  year: n,
  month: s,
  day: n,
  weekday: s,
  hour: n,
  minute: n
};
const DATETIME_FULL = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  timeZoneName: s
};
const DATETIME_FULL_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: s
};
const DATETIME_HUGE = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  timeZoneName: l
};
const DATETIME_HUGE_WITH_SECONDS = {
  year: n,
  month: l,
  day: n,
  weekday: l,
  hour: n,
  minute: n,
  second: n,
  timeZoneName: l
};

/**
 * @interface
 */
class Zone {
  /**
   * The type of zone
   * @abstract
   * @type {string}
   */
  get type() {
    throw new ZoneIsAbstractError();
  }

  /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */
  get name() {
    throw new ZoneIsAbstractError();
  }

  /**
   * The IANA name of this zone.
   * Defaults to `name` if not overwritten by a subclass.
   * @abstract
   * @type {string}
   */
  get ianaName() {
    return this.name;
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */
  get isUniversal() {
    throw new ZoneIsAbstractError();
  }

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, opts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    throw new ZoneIsAbstractError();
  }

  /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */
  get isValid() {
    throw new ZoneIsAbstractError();
  }
}

let singleton$1 = null;

/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */
class SystemZone extends Zone {
  /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */
  static get instance() {
    if (singleton$1 === null) {
      singleton$1 = new SystemZone();
    }
    return singleton$1;
  }

  /** @override **/
  get type() {
    return "system";
  }

  /** @override **/
  get name() {
    return new Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName(ts, {
    format,
    locale
  }) {
    return parseZoneInfo(ts, format, locale);
  }

  /** @override **/
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /** @override **/
  offset(ts) {
    return -new Date(ts).getTimezoneOffset();
  }

  /** @override **/
  equals(otherZone) {
    return otherZone.type === "system";
  }

  /** @override **/
  get isValid() {
    return true;
  }
}

let dtfCache = {};
function makeDTF(zone) {
  if (!dtfCache[zone]) {
    dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
      hour12: false,
      timeZone: zone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      era: "short"
    });
  }
  return dtfCache[zone];
}
const typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  era: 3,
  hour: 4,
  minute: 5,
  second: 6
};
function hackyOffset(dtf, date) {
  const formatted = dtf.format(date).replace(/\u200E/g, ""),
    parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted),
    [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
  return [fYear, fMonth, fDay, fadOrBc, fHour, fMinute, fSecond];
}
function partsOffset(dtf, date) {
  const formatted = dtf.formatToParts(date);
  const filled = [];
  for (let i = 0; i < formatted.length; i++) {
    const {
      type,
      value
    } = formatted[i];
    const pos = typeToPos[type];
    if (type === "era") {
      filled[pos] = value;
    } else if (!isUndefined(pos)) {
      filled[pos] = parseInt(value, 10);
    }
  }
  return filled;
}
let ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */
class IANAZone extends Zone {
  /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */
  static create(name) {
    if (!ianaZoneCache[name]) {
      ianaZoneCache[name] = new IANAZone(name);
    }
    return ianaZoneCache[name];
  }

  /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCache() {
    ianaZoneCache = {};
    dtfCache = {};
  }

  /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated For backward compatibility, this forwards to isValidZone, better use `isValidZone()` directly instead.
   * @return {boolean}
   */
  static isValidSpecifier(s) {
    return this.isValidZone(s);
  }

  /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */
  static isValidZone(zone) {
    if (!zone) {
      return false;
    }
    try {
      new Intl.DateTimeFormat("en-US", {
        timeZone: zone
      }).format();
      return true;
    } catch (e) {
      return false;
    }
  }
  constructor(name) {
    super();
    /** @private **/
    this.zoneName = name;
    /** @private **/
    this.valid = IANAZone.isValidZone(name);
  }

  /**
   * The type of zone. `iana` for all instances of `IANAZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "iana";
  }

  /**
   * The name of this zone (i.e. the IANA zone name).
   * @override
   * @type {string}
   */
  get name() {
    return this.zoneName;
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns false for all IANA zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return false;
  }

  /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */
  offsetName(ts, {
    format,
    locale
  }) {
    return parseZoneInfo(ts, format, locale, this.name);
  }

  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.offset(ts), format);
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @override
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */
  offset(ts) {
    const date = new Date(ts);
    if (isNaN(date)) return NaN;
    const dtf = makeDTF(this.name);
    let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
    if (adOrBc === "BC") {
      year = -Math.abs(year) + 1;
    }

    // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
    const adjustedHour = hour === 24 ? 0 : hour;
    const asUTC = objToLocalTS({
      year,
      month,
      day,
      hour: adjustedHour,
      minute,
      second,
      millisecond: 0
    });
    let asTS = +date;
    const over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return (asUTC - asTS) / (60 * 1000);
  }

  /**
   * Return whether this Zone is equal to another zone
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "iana" && otherZone.name === this.name;
  }

  /**
   * Return whether this Zone is valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return this.valid;
  }
}

// todo - remap caching

let intlLFCache = {};
function getCachedLF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlLFCache[key];
  if (!dtf) {
    dtf = new Intl.ListFormat(locString, opts);
    intlLFCache[key] = dtf;
  }
  return dtf;
}
let intlDTCache = {};
function getCachedDTF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let dtf = intlDTCache[key];
  if (!dtf) {
    dtf = new Intl.DateTimeFormat(locString, opts);
    intlDTCache[key] = dtf;
  }
  return dtf;
}
let intlNumCache = {};
function getCachedINF(locString, opts = {}) {
  const key = JSON.stringify([locString, opts]);
  let inf = intlNumCache[key];
  if (!inf) {
    inf = new Intl.NumberFormat(locString, opts);
    intlNumCache[key] = inf;
  }
  return inf;
}
let intlRelCache = {};
function getCachedRTF(locString, opts = {}) {
  const {
    base,
    ...cacheKeyOpts
  } = opts; // exclude `base` from the options
  const key = JSON.stringify([locString, cacheKeyOpts]);
  let inf = intlRelCache[key];
  if (!inf) {
    inf = new Intl.RelativeTimeFormat(locString, opts);
    intlRelCache[key] = inf;
  }
  return inf;
}
let sysLocaleCache = null;
function systemLocale() {
  if (sysLocaleCache) {
    return sysLocaleCache;
  } else {
    sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
    return sysLocaleCache;
  }
}
let weekInfoCache = {};
function getCachedWeekInfo(locString) {
  let data = weekInfoCache[locString];
  if (!data) {
    const locale = new Intl.Locale(locString);
    // browsers currently implement this as a property, but spec says it should be a getter function
    data = "getWeekInfo" in locale ? locale.getWeekInfo() : locale.weekInfo;
    weekInfoCache[locString] = data;
  }
  return data;
}
function parseLocaleString(localeStr) {
  // I really want to avoid writing a BCP 47 parser
  // see, e.g. https://github.com/wooorm/bcp-47
  // Instead, we'll do this:

  // a) if the string has no -u extensions, just leave it alone
  // b) if it does, use Intl to resolve everything
  // c) if Intl fails, try again without the -u

  // private subtags and unicode subtags have ordering requirements,
  // and we're not properly parsing this, so just strip out the
  // private ones if they exist.
  const xIndex = localeStr.indexOf("-x-");
  if (xIndex !== -1) {
    localeStr = localeStr.substring(0, xIndex);
  }
  const uIndex = localeStr.indexOf("-u-");
  if (uIndex === -1) {
    return [localeStr];
  } else {
    let options;
    let selectedStr;
    try {
      options = getCachedDTF(localeStr).resolvedOptions();
      selectedStr = localeStr;
    } catch (e) {
      const smaller = localeStr.substring(0, uIndex);
      options = getCachedDTF(smaller).resolvedOptions();
      selectedStr = smaller;
    }
    const {
      numberingSystem,
      calendar
    } = options;
    return [selectedStr, numberingSystem, calendar];
  }
}
function intlConfigString(localeStr, numberingSystem, outputCalendar) {
  if (outputCalendar || numberingSystem) {
    if (!localeStr.includes("-u-")) {
      localeStr += "-u";
    }
    if (outputCalendar) {
      localeStr += `-ca-${outputCalendar}`;
    }
    if (numberingSystem) {
      localeStr += `-nu-${numberingSystem}`;
    }
    return localeStr;
  } else {
    return localeStr;
  }
}
function mapMonths(f) {
  const ms = [];
  for (let i = 1; i <= 12; i++) {
    const dt = DateTime.utc(2009, i, 1);
    ms.push(f(dt));
  }
  return ms;
}
function mapWeekdays(f) {
  const ms = [];
  for (let i = 1; i <= 7; i++) {
    const dt = DateTime.utc(2016, 11, 13 + i);
    ms.push(f(dt));
  }
  return ms;
}
function listStuff(loc, length, englishFn, intlFn) {
  const mode = loc.listingMode();
  if (mode === "error") {
    return null;
  } else if (mode === "en") {
    return englishFn(length);
  } else {
    return intlFn(length);
  }
}
function supportsFastNumbers(loc) {
  if (loc.numberingSystem && loc.numberingSystem !== "latn") {
    return false;
  } else {
    return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
  }
}

/**
 * @private
 */

class PolyNumberFormatter {
  constructor(intl, forceSimple, opts) {
    this.padTo = opts.padTo || 0;
    this.floor = opts.floor || false;
    const {
      padTo,
      floor,
      ...otherOpts
    } = opts;
    if (!forceSimple || Object.keys(otherOpts).length > 0) {
      const intlOpts = {
        useGrouping: false,
        ...opts
      };
      if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
      this.inf = getCachedINF(intl, intlOpts);
    }
  }
  format(i) {
    if (this.inf) {
      const fixed = this.floor ? Math.floor(i) : i;
      return this.inf.format(fixed);
    } else {
      // to match the browser's numberformatter defaults
      const fixed = this.floor ? Math.floor(i) : roundTo(i, 3);
      return padStart(fixed, this.padTo);
    }
  }
}

/**
 * @private
 */

class PolyDateFormatter {
  constructor(dt, intl, opts) {
    this.opts = opts;
    this.originalZone = undefined;
    let z = undefined;
    if (this.opts.timeZone) {
      // Don't apply any workarounds if a timeZone is explicitly provided in opts
      this.dt = dt;
    } else if (dt.zone.type === "fixed") {
      // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
      // That is why fixed-offset TZ is set to that unless it is:
      // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
      // 2. Unsupported by the browser:
      //    - some do not support Etc/
      //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
      const gmtOffset = -1 * (dt.offset / 60);
      const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
      if (dt.offset !== 0 && IANAZone.create(offsetZ).valid) {
        z = offsetZ;
        this.dt = dt;
      } else {
        // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
        // we manually apply the offset and substitute the zone as needed.
        z = "UTC";
        this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
          minutes: dt.offset
        });
        this.originalZone = dt.zone;
      }
    } else if (dt.zone.type === "system") {
      this.dt = dt;
    } else if (dt.zone.type === "iana") {
      this.dt = dt;
      z = dt.zone.name;
    } else {
      // Custom zones can have any offset / offsetName so we just manually
      // apply the offset and substitute the zone as needed.
      z = "UTC";
      this.dt = dt.setZone("UTC").plus({
        minutes: dt.offset
      });
      this.originalZone = dt.zone;
    }
    const intlOpts = {
      ...this.opts
    };
    intlOpts.timeZone = intlOpts.timeZone || z;
    this.dtf = getCachedDTF(intl, intlOpts);
  }
  format() {
    if (this.originalZone) {
      // If we have to substitute in the actual zone name, we have to use
      // formatToParts so that the timezone can be replaced.
      return this.formatToParts().map(({
        value
      }) => value).join("");
    }
    return this.dtf.format(this.dt.toJSDate());
  }
  formatToParts() {
    const parts = this.dtf.formatToParts(this.dt.toJSDate());
    if (this.originalZone) {
      return parts.map(part => {
        if (part.type === "timeZoneName") {
          const offsetName = this.originalZone.offsetName(this.dt.ts, {
            locale: this.dt.locale,
            format: this.opts.timeZoneName
          });
          return {
            ...part,
            value: offsetName
          };
        } else {
          return part;
        }
      });
    }
    return parts;
  }
  resolvedOptions() {
    return this.dtf.resolvedOptions();
  }
}

/**
 * @private
 */
class PolyRelFormatter {
  constructor(intl, isEnglish, opts) {
    this.opts = {
      style: "long",
      ...opts
    };
    if (!isEnglish && hasRelative()) {
      this.rtf = getCachedRTF(intl, opts);
    }
  }
  format(count, unit) {
    if (this.rtf) {
      return this.rtf.format(count, unit);
    } else {
      return formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
  }
  formatToParts(count, unit) {
    if (this.rtf) {
      return this.rtf.formatToParts(count, unit);
    } else {
      return [];
    }
  }
}
const fallbackWeekSettings = {
  firstDay: 1,
  minimalDays: 4,
  weekend: [6, 7]
};

/**
 * @private
 */

class Locale {
  static fromOpts(opts) {
    return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.weekSettings, opts.defaultToEN);
  }
  static create(locale, numberingSystem, outputCalendar, weekSettings, defaultToEN = false) {
    const specifiedLocale = locale || Settings.defaultLocale;
    // the system locale is useful for human-readable strings but annoying for parsing/formatting known formats
    const localeR = specifiedLocale || (defaultToEN ? "en-US" : systemLocale());
    const numberingSystemR = numberingSystem || Settings.defaultNumberingSystem;
    const outputCalendarR = outputCalendar || Settings.defaultOutputCalendar;
    const weekSettingsR = validateWeekSettings(weekSettings) || Settings.defaultWeekSettings;
    return new Locale(localeR, numberingSystemR, outputCalendarR, weekSettingsR, specifiedLocale);
  }
  static resetCache() {
    sysLocaleCache = null;
    intlDTCache = {};
    intlNumCache = {};
    intlRelCache = {};
  }
  static fromObject({
    locale,
    numberingSystem,
    outputCalendar,
    weekSettings
  } = {}) {
    return Locale.create(locale, numberingSystem, outputCalendar, weekSettings);
  }
  constructor(locale, numbering, outputCalendar, weekSettings, specifiedLocale) {
    const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = parseLocaleString(locale);
    this.locale = parsedLocale;
    this.numberingSystem = numbering || parsedNumberingSystem || null;
    this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
    this.weekSettings = weekSettings;
    this.intl = intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
    this.weekdaysCache = {
      format: {},
      standalone: {}
    };
    this.monthsCache = {
      format: {},
      standalone: {}
    };
    this.meridiemCache = null;
    this.eraCache = {};
    this.specifiedLocale = specifiedLocale;
    this.fastNumbersCached = null;
  }
  get fastNumbers() {
    if (this.fastNumbersCached == null) {
      this.fastNumbersCached = supportsFastNumbers(this);
    }
    return this.fastNumbersCached;
  }
  listingMode() {
    const isActuallyEn = this.isEnglish();
    const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
    return isActuallyEn && hasNoWeirdness ? "en" : "intl";
  }
  clone(alts) {
    if (!alts || Object.getOwnPropertyNames(alts).length === 0) {
      return this;
    } else {
      return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, validateWeekSettings(alts.weekSettings) || this.weekSettings, alts.defaultToEN || false);
    }
  }
  redefaultToEN(alts = {}) {
    return this.clone({
      ...alts,
      defaultToEN: true
    });
  }
  redefaultToSystem(alts = {}) {
    return this.clone({
      ...alts,
      defaultToEN: false
    });
  }
  months(length, format = false) {
    return listStuff(this, length, months, () => {
      const intl = format ? {
          month: length,
          day: "numeric"
        } : {
          month: length
        },
        formatStr = format ? "format" : "standalone";
      if (!this.monthsCache[formatStr][length]) {
        this.monthsCache[formatStr][length] = mapMonths(dt => this.extract(dt, intl, "month"));
      }
      return this.monthsCache[formatStr][length];
    });
  }
  weekdays(length, format = false) {
    return listStuff(this, length, weekdays, () => {
      const intl = format ? {
          weekday: length,
          year: "numeric",
          month: "long",
          day: "numeric"
        } : {
          weekday: length
        },
        formatStr = format ? "format" : "standalone";
      if (!this.weekdaysCache[formatStr][length]) {
        this.weekdaysCache[formatStr][length] = mapWeekdays(dt => this.extract(dt, intl, "weekday"));
      }
      return this.weekdaysCache[formatStr][length];
    });
  }
  meridiems() {
    return listStuff(this, undefined, () => meridiems, () => {
      // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
      // for AM and PM. This is probably wrong, but it's makes parsing way easier.
      if (!this.meridiemCache) {
        const intl = {
          hour: "numeric",
          hourCycle: "h12"
        };
        this.meridiemCache = [DateTime.utc(2016, 11, 13, 9), DateTime.utc(2016, 11, 13, 19)].map(dt => this.extract(dt, intl, "dayperiod"));
      }
      return this.meridiemCache;
    });
  }
  eras(length) {
    return listStuff(this, length, eras, () => {
      const intl = {
        era: length
      };

      // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
      // to definitely enumerate them.
      if (!this.eraCache[length]) {
        this.eraCache[length] = [DateTime.utc(-40, 1, 1), DateTime.utc(2017, 1, 1)].map(dt => this.extract(dt, intl, "era"));
      }
      return this.eraCache[length];
    });
  }
  extract(dt, intlOpts, field) {
    const df = this.dtFormatter(dt, intlOpts),
      results = df.formatToParts(),
      matching = results.find(m => m.type.toLowerCase() === field);
    return matching ? matching.value : null;
  }
  numberFormatter(opts = {}) {
    // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
    // (in contrast, the rest of the condition is used heavily)
    return new PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
  }
  dtFormatter(dt, intlOpts = {}) {
    return new PolyDateFormatter(dt, this.intl, intlOpts);
  }
  relFormatter(opts = {}) {
    return new PolyRelFormatter(this.intl, this.isEnglish(), opts);
  }
  listFormatter(opts = {}) {
    return getCachedLF(this.intl, opts);
  }
  isEnglish() {
    return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
  }
  getWeekSettings() {
    if (this.weekSettings) {
      return this.weekSettings;
    } else if (!hasLocaleWeekInfo()) {
      return fallbackWeekSettings;
    } else {
      return getCachedWeekInfo(this.locale);
    }
  }
  getStartOfWeek() {
    return this.getWeekSettings().firstDay;
  }
  getMinDaysInFirstWeek() {
    return this.getWeekSettings().minimalDays;
  }
  getWeekendDays() {
    return this.getWeekSettings().weekend;
  }
  equals(other) {
    return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
  }
  toString() {
    return `Locale(${this.locale}, ${this.numberingSystem}, ${this.outputCalendar})`;
  }
}

let singleton = null;

/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */
class FixedOffsetZone extends Zone {
  /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */
  static get utcInstance() {
    if (singleton === null) {
      singleton = new FixedOffsetZone(0);
    }
    return singleton;
  }

  /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */
  static instance(offset) {
    return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
  }

  /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */
  static parseSpecifier(s) {
    if (s) {
      const r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
      if (r) {
        return new FixedOffsetZone(signedOffset(r[1], r[2]));
      }
    }
    return null;
  }
  constructor(offset) {
    super();
    /** @private **/
    this.fixed = offset;
  }

  /**
   * The type of zone. `fixed` for all instances of `FixedOffsetZone`.
   * @override
   * @type {string}
   */
  get type() {
    return "fixed";
  }

  /**
   * The name of this zone.
   * All fixed zones' names always start with "UTC" (plus optional offset)
   * @override
   * @type {string}
   */
  get name() {
    return this.fixed === 0 ? "UTC" : `UTC${formatOffset(this.fixed, "narrow")}`;
  }

  /**
   * The IANA name of this zone, i.e. `Etc/UTC` or `Etc/GMT+/-nn`
   *
   * @override
   * @type {string}
   */
  get ianaName() {
    if (this.fixed === 0) {
      return "Etc/UTC";
    } else {
      return `Etc/GMT${formatOffset(-this.fixed, "narrow")}`;
    }
  }

  /**
   * Returns the offset's common name at the specified timestamp.
   *
   * For fixed offset zones this equals to the zone name.
   * @override
   */
  offsetName() {
    return this.name;
  }

  /**
   * Returns the offset's value as a string
   * @override
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */
  formatOffset(ts, format) {
    return formatOffset(this.fixed, format);
  }

  /**
   * Returns whether the offset is known to be fixed for the whole year:
   * Always returns true for all fixed offset zones.
   * @override
   * @type {boolean}
   */
  get isUniversal() {
    return true;
  }

  /**
   * Return the offset in minutes for this zone at the specified timestamp.
   *
   * For fixed offset zones, this is constant and does not depend on a timestamp.
   * @override
   * @return {number}
   */
  offset() {
    return this.fixed;
  }

  /**
   * Return whether this Zone is equal to another zone (i.e. also fixed and same offset)
   * @override
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */
  equals(otherZone) {
    return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
  }

  /**
   * Return whether this Zone is valid:
   * All fixed offset zones are valid.
   * @override
   * @type {boolean}
   */
  get isValid() {
    return true;
  }
}

/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */
class InvalidZone extends Zone {
  constructor(zoneName) {
    super();
    /**  @private */
    this.zoneName = zoneName;
  }

  /** @override **/
  get type() {
    return "invalid";
  }

  /** @override **/
  get name() {
    return this.zoneName;
  }

  /** @override **/
  get isUniversal() {
    return false;
  }

  /** @override **/
  offsetName() {
    return null;
  }

  /** @override **/
  formatOffset() {
    return "";
  }

  /** @override **/
  offset() {
    return NaN;
  }

  /** @override **/
  equals() {
    return false;
  }

  /** @override **/
  get isValid() {
    return false;
  }
}

/**
 * @private
 */
function normalizeZone(input, defaultZone) {
  if (isUndefined(input) || input === null) {
    return defaultZone;
  } else if (input instanceof Zone) {
    return input;
  } else if (isString(input)) {
    const lowered = input.toLowerCase();
    if (lowered === "default") return defaultZone;else if (lowered === "local" || lowered === "system") return SystemZone.instance;else if (lowered === "utc" || lowered === "gmt") return FixedOffsetZone.utcInstance;else return FixedOffsetZone.parseSpecifier(lowered) || IANAZone.create(input);
  } else if (isNumber(input)) {
    return FixedOffsetZone.instance(input);
  } else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") {
    // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
  } else {
    return new InvalidZone(input);
  }
}

const numberingSystems = {
  arab: "[\u0660-\u0669]",
  arabext: "[\u06F0-\u06F9]",
  bali: "[\u1B50-\u1B59]",
  beng: "[\u09E6-\u09EF]",
  deva: "[\u0966-\u096F]",
  fullwide: "[\uFF10-\uFF19]",
  gujr: "[\u0AE6-\u0AEF]",
  hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
  khmr: "[\u17E0-\u17E9]",
  knda: "[\u0CE6-\u0CEF]",
  laoo: "[\u0ED0-\u0ED9]",
  limb: "[\u1946-\u194F]",
  mlym: "[\u0D66-\u0D6F]",
  mong: "[\u1810-\u1819]",
  mymr: "[\u1040-\u1049]",
  orya: "[\u0B66-\u0B6F]",
  tamldec: "[\u0BE6-\u0BEF]",
  telu: "[\u0C66-\u0C6F]",
  thai: "[\u0E50-\u0E59]",
  tibt: "[\u0F20-\u0F29]",
  latn: "\\d"
};
const numberingSystemsUTF16 = {
  arab: [1632, 1641],
  arabext: [1776, 1785],
  bali: [6992, 7001],
  beng: [2534, 2543],
  deva: [2406, 2415],
  fullwide: [65296, 65303],
  gujr: [2790, 2799],
  khmr: [6112, 6121],
  knda: [3302, 3311],
  laoo: [3792, 3801],
  limb: [6470, 6479],
  mlym: [3430, 3439],
  mong: [6160, 6169],
  mymr: [4160, 4169],
  orya: [2918, 2927],
  tamldec: [3046, 3055],
  telu: [3174, 3183],
  thai: [3664, 3673],
  tibt: [3872, 3881]
};
const hanidecChars = numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function parseDigits(str) {
  let value = parseInt(str, 10);
  if (isNaN(value)) {
    value = "";
    for (let i = 0; i < str.length; i++) {
      const code = str.charCodeAt(i);
      if (str[i].search(numberingSystems.hanidec) !== -1) {
        value += hanidecChars.indexOf(str[i]);
      } else {
        for (const key in numberingSystemsUTF16) {
          const [min, max] = numberingSystemsUTF16[key];
          if (code >= min && code <= max) {
            value += code - min;
          }
        }
      }
    }
    return parseInt(value, 10);
  } else {
    return value;
  }
}

// cache of {numberingSystem: {append: regex}}
let digitRegexCache = {};
function resetDigitRegexCache() {
  digitRegexCache = {};
}
function digitRegex({
  numberingSystem
}, append = "") {
  const ns = numberingSystem || "latn";
  if (!digitRegexCache[ns]) {
    digitRegexCache[ns] = {};
  }
  if (!digitRegexCache[ns][append]) {
    digitRegexCache[ns][append] = new RegExp(`${numberingSystems[ns]}${append}`);
  }
  return digitRegexCache[ns][append];
}

let now = () => Date.now(),
  defaultZone = "system",
  defaultLocale = null,
  defaultNumberingSystem = null,
  defaultOutputCalendar = null,
  twoDigitCutoffYear = 60,
  throwOnInvalid,
  defaultWeekSettings = null;

/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */
class Settings {
  /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */
  static get now() {
    return now;
  }

  /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */
  static set now(n) {
    now = n;
  }

  /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */
  static set defaultZone(zone) {
    defaultZone = zone;
  }

  /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */
  static get defaultZone() {
    return normalizeZone(defaultZone, SystemZone.instance);
  }

  /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultLocale() {
    return defaultLocale;
  }

  /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultLocale(locale) {
    defaultLocale = locale;
  }

  /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultNumberingSystem() {
    return defaultNumberingSystem;
  }

  /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultNumberingSystem(numberingSystem) {
    defaultNumberingSystem = numberingSystem;
  }

  /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static get defaultOutputCalendar() {
    return defaultOutputCalendar;
  }

  /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */
  static set defaultOutputCalendar(outputCalendar) {
    defaultOutputCalendar = outputCalendar;
  }

  /**
   * @typedef {Object} WeekSettings
   * @property {number} firstDay
   * @property {number} minimalDays
   * @property {number[]} weekend
   */

  /**
   * @return {WeekSettings|null}
   */
  static get defaultWeekSettings() {
    return defaultWeekSettings;
  }

  /**
   * Allows overriding the default locale week settings, i.e. the start of the week, the weekend and
   * how many days are required in the first week of a year.
   * Does not affect existing instances.
   *
   * @param {WeekSettings|null} weekSettings
   */
  static set defaultWeekSettings(weekSettings) {
    defaultWeekSettings = validateWeekSettings(weekSettings);
  }

  /**
   * Get the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   */
  static get twoDigitCutoffYear() {
    return twoDigitCutoffYear;
  }

  /**
   * Set the cutoff year for whether a 2-digit year string is interpreted in the current or previous century. Numbers higher than the cutoff will be considered to mean 19xx and numbers lower or equal to the cutoff will be considered 20xx.
   * @type {number}
   * @example Settings.twoDigitCutoffYear = 0 // all 'yy' are interpreted as 20th century
   * @example Settings.twoDigitCutoffYear = 99 // all 'yy' are interpreted as 21st century
   * @example Settings.twoDigitCutoffYear = 50 // '49' -> 2049; '50' -> 1950
   * @example Settings.twoDigitCutoffYear = 1950 // interpreted as 50
   * @example Settings.twoDigitCutoffYear = 2050 // ALSO interpreted as 50
   */
  static set twoDigitCutoffYear(cutoffYear) {
    twoDigitCutoffYear = cutoffYear % 100;
  }

  /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static get throwOnInvalid() {
    return throwOnInvalid;
  }

  /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */
  static set throwOnInvalid(t) {
    throwOnInvalid = t;
  }

  /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */
  static resetCaches() {
    Locale.resetCache();
    IANAZone.resetCache();
    DateTime.resetCache();
    resetDigitRegexCache();
  }
}

class Invalid {
  constructor(reason, explanation) {
    this.reason = reason;
    this.explanation = explanation;
  }
  toMessage() {
    if (this.explanation) {
      return `${this.reason}: ${this.explanation}`;
    } else {
      return this.reason;
    }
  }
}

const nonLeapLadder = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334],
  leapLadder = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
function unitOutOfRange(unit, value) {
  return new Invalid("unit out of range", `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`);
}
function dayOfWeek(year, month, day) {
  const d = new Date(Date.UTC(year, month - 1, day));
  if (year < 100 && year >= 0) {
    d.setUTCFullYear(d.getUTCFullYear() - 1900);
  }
  const js = d.getUTCDay();
  return js === 0 ? 7 : js;
}
function computeOrdinal(year, month, day) {
  return day + (isLeapYear(year) ? leapLadder : nonLeapLadder)[month - 1];
}
function uncomputeOrdinal(year, ordinal) {
  const table = isLeapYear(year) ? leapLadder : nonLeapLadder,
    month0 = table.findIndex(i => i < ordinal),
    day = ordinal - table[month0];
  return {
    month: month0 + 1,
    day
  };
}
function isoWeekdayToLocal(isoWeekday, startOfWeek) {
  return (isoWeekday - startOfWeek + 7) % 7 + 1;
}

/**
 * @private
 */

function gregorianToWeek(gregObj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const {
      year,
      month,
      day
    } = gregObj,
    ordinal = computeOrdinal(year, month, day),
    weekday = isoWeekdayToLocal(dayOfWeek(year, month, day), startOfWeek);
  let weekNumber = Math.floor((ordinal - weekday + 14 - minDaysInFirstWeek) / 7),
    weekYear;
  if (weekNumber < 1) {
    weekYear = year - 1;
    weekNumber = weeksInWeekYear(weekYear, minDaysInFirstWeek, startOfWeek);
  } else if (weekNumber > weeksInWeekYear(year, minDaysInFirstWeek, startOfWeek)) {
    weekYear = year + 1;
    weekNumber = 1;
  } else {
    weekYear = year;
  }
  return {
    weekYear,
    weekNumber,
    weekday,
    ...timeObject(gregObj)
  };
}
function weekToGregorian(weekData, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const {
      weekYear,
      weekNumber,
      weekday
    } = weekData,
    weekdayOfJan4 = isoWeekdayToLocal(dayOfWeek(weekYear, 1, minDaysInFirstWeek), startOfWeek),
    yearInDays = daysInYear(weekYear);
  let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 7 + minDaysInFirstWeek,
    year;
  if (ordinal < 1) {
    year = weekYear - 1;
    ordinal += daysInYear(year);
  } else if (ordinal > yearInDays) {
    year = weekYear + 1;
    ordinal -= daysInYear(weekYear);
  } else {
    year = weekYear;
  }
  const {
    month,
    day
  } = uncomputeOrdinal(year, ordinal);
  return {
    year,
    month,
    day,
    ...timeObject(weekData)
  };
}
function gregorianToOrdinal(gregData) {
  const {
    year,
    month,
    day
  } = gregData;
  const ordinal = computeOrdinal(year, month, day);
  return {
    year,
    ordinal,
    ...timeObject(gregData)
  };
}
function ordinalToGregorian(ordinalData) {
  const {
    year,
    ordinal
  } = ordinalData;
  const {
    month,
    day
  } = uncomputeOrdinal(year, ordinal);
  return {
    year,
    month,
    day,
    ...timeObject(ordinalData)
  };
}

/**
 * Check if local week units like localWeekday are used in obj.
 * If so, validates that they are not mixed with ISO week units and then copies them to the normal week unit properties.
 * Modifies obj in-place!
 * @param obj the object values
 */
function usesLocalWeekValues(obj, loc) {
  const hasLocaleWeekData = !isUndefined(obj.localWeekday) || !isUndefined(obj.localWeekNumber) || !isUndefined(obj.localWeekYear);
  if (hasLocaleWeekData) {
    const hasIsoWeekData = !isUndefined(obj.weekday) || !isUndefined(obj.weekNumber) || !isUndefined(obj.weekYear);
    if (hasIsoWeekData) {
      throw new ConflictingSpecificationError("Cannot mix locale-based week fields with ISO-based week fields");
    }
    if (!isUndefined(obj.localWeekday)) obj.weekday = obj.localWeekday;
    if (!isUndefined(obj.localWeekNumber)) obj.weekNumber = obj.localWeekNumber;
    if (!isUndefined(obj.localWeekYear)) obj.weekYear = obj.localWeekYear;
    delete obj.localWeekday;
    delete obj.localWeekNumber;
    delete obj.localWeekYear;
    return {
      minDaysInFirstWeek: loc.getMinDaysInFirstWeek(),
      startOfWeek: loc.getStartOfWeek()
    };
  } else {
    return {
      minDaysInFirstWeek: 4,
      startOfWeek: 1
    };
  }
}
function hasInvalidWeekData(obj, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const validYear = isInteger(obj.weekYear),
    validWeek = integerBetween(obj.weekNumber, 1, weeksInWeekYear(obj.weekYear, minDaysInFirstWeek, startOfWeek)),
    validWeekday = integerBetween(obj.weekday, 1, 7);
  if (!validYear) {
    return unitOutOfRange("weekYear", obj.weekYear);
  } else if (!validWeek) {
    return unitOutOfRange("week", obj.weekNumber);
  } else if (!validWeekday) {
    return unitOutOfRange("weekday", obj.weekday);
  } else return false;
}
function hasInvalidOrdinalData(obj) {
  const validYear = isInteger(obj.year),
    validOrdinal = integerBetween(obj.ordinal, 1, daysInYear(obj.year));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validOrdinal) {
    return unitOutOfRange("ordinal", obj.ordinal);
  } else return false;
}
function hasInvalidGregorianData(obj) {
  const validYear = isInteger(obj.year),
    validMonth = integerBetween(obj.month, 1, 12),
    validDay = integerBetween(obj.day, 1, daysInMonth(obj.year, obj.month));
  if (!validYear) {
    return unitOutOfRange("year", obj.year);
  } else if (!validMonth) {
    return unitOutOfRange("month", obj.month);
  } else if (!validDay) {
    return unitOutOfRange("day", obj.day);
  } else return false;
}
function hasInvalidTimeData(obj) {
  const {
    hour,
    minute,
    second,
    millisecond
  } = obj;
  const validHour = integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0,
    validMinute = integerBetween(minute, 0, 59),
    validSecond = integerBetween(second, 0, 59),
    validMillisecond = integerBetween(millisecond, 0, 999);
  if (!validHour) {
    return unitOutOfRange("hour", hour);
  } else if (!validMinute) {
    return unitOutOfRange("minute", minute);
  } else if (!validSecond) {
    return unitOutOfRange("second", second);
  } else if (!validMillisecond) {
    return unitOutOfRange("millisecond", millisecond);
  } else return false;
}

/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/

/**
 * @private
 */

// TYPES

function isUndefined(o) {
  return typeof o === "undefined";
}
function isNumber(o) {
  return typeof o === "number";
}
function isInteger(o) {
  return typeof o === "number" && o % 1 === 0;
}
function isString(o) {
  return typeof o === "string";
}
function isDate(o) {
  return Object.prototype.toString.call(o) === "[object Date]";
}

// CAPABILITIES

function hasRelative() {
  try {
    return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
  } catch (e) {
    return false;
  }
}
function hasLocaleWeekInfo() {
  try {
    return typeof Intl !== "undefined" && !!Intl.Locale && ("weekInfo" in Intl.Locale.prototype || "getWeekInfo" in Intl.Locale.prototype);
  } catch (e) {
    return false;
  }
}

// OBJECTS AND ARRAYS

function maybeArray(thing) {
  return Array.isArray(thing) ? thing : [thing];
}
function bestBy(arr, by, compare) {
  if (arr.length === 0) {
    return undefined;
  }
  return arr.reduce((best, next) => {
    const pair = [by(next), next];
    if (!best) {
      return pair;
    } else if (compare(best[0], pair[0]) === best[0]) {
      return best;
    } else {
      return pair;
    }
  }, null)[1];
}
function pick(obj, keys) {
  return keys.reduce((a, k) => {
    a[k] = obj[k];
    return a;
  }, {});
}
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
function validateWeekSettings(settings) {
  if (settings == null) {
    return null;
  } else if (typeof settings !== "object") {
    throw new InvalidArgumentError("Week settings must be an object");
  } else {
    if (!integerBetween(settings.firstDay, 1, 7) || !integerBetween(settings.minimalDays, 1, 7) || !Array.isArray(settings.weekend) || settings.weekend.some(v => !integerBetween(v, 1, 7))) {
      throw new InvalidArgumentError("Invalid week settings");
    }
    return {
      firstDay: settings.firstDay,
      minimalDays: settings.minimalDays,
      weekend: Array.from(settings.weekend)
    };
  }
}

// NUMBERS AND STRINGS

function integerBetween(thing, bottom, top) {
  return isInteger(thing) && thing >= bottom && thing <= top;
}

// x % n but takes the sign of n instead of x
function floorMod(x, n) {
  return x - n * Math.floor(x / n);
}
function padStart(input, n = 2) {
  const isNeg = input < 0;
  let padded;
  if (isNeg) {
    padded = "-" + ("" + -input).padStart(n, "0");
  } else {
    padded = ("" + input).padStart(n, "0");
  }
  return padded;
}
function parseInteger(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseInt(string, 10);
  }
}
function parseFloating(string) {
  if (isUndefined(string) || string === null || string === "") {
    return undefined;
  } else {
    return parseFloat(string);
  }
}
function parseMillis(fraction) {
  // Return undefined (instead of 0) in these cases, where fraction is not set
  if (isUndefined(fraction) || fraction === null || fraction === "") {
    return undefined;
  } else {
    const f = parseFloat("0." + fraction) * 1000;
    return Math.floor(f);
  }
}
function roundTo(number, digits, towardZero = false) {
  const factor = 10 ** digits,
    rounder = towardZero ? Math.trunc : Math.round;
  return rounder(number * factor) / factor;
}

// DATE BASICS

function isLeapYear(year) {
  return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function daysInYear(year) {
  return isLeapYear(year) ? 366 : 365;
}
function daysInMonth(year, month) {
  const modMonth = floorMod(month - 1, 12) + 1,
    modYear = year + (month - modMonth) / 12;
  if (modMonth === 2) {
    return isLeapYear(modYear) ? 29 : 28;
  } else {
    return [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][modMonth - 1];
  }
}

// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function objToLocalTS(obj) {
  let d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);

  // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
  if (obj.year < 100 && obj.year >= 0) {
    d = new Date(d);
    // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
    // so if obj.year is in 99, but obj.day makes it roll over into year 100,
    // the calculations done by Date.UTC are using year 2000 - which is incorrect
    d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
  }
  return +d;
}

// adapted from moment.js: https://github.com/moment/moment/blob/000ac1800e620f770f4eb31b5ae908f6167b0ab2/src/lib/units/week-calendar-utils.js
function firstWeekOffset(year, minDaysInFirstWeek, startOfWeek) {
  const fwdlw = isoWeekdayToLocal(dayOfWeek(year, 1, minDaysInFirstWeek), startOfWeek);
  return -fwdlw + minDaysInFirstWeek - 1;
}
function weeksInWeekYear(weekYear, minDaysInFirstWeek = 4, startOfWeek = 1) {
  const weekOffset = firstWeekOffset(weekYear, minDaysInFirstWeek, startOfWeek);
  const weekOffsetNext = firstWeekOffset(weekYear + 1, minDaysInFirstWeek, startOfWeek);
  return (daysInYear(weekYear) - weekOffset + weekOffsetNext) / 7;
}
function untruncateYear(year) {
  if (year > 99) {
    return year;
  } else return year > Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}

// PARSING

function parseZoneInfo(ts, offsetFormat, locale, timeZone = null) {
  const date = new Date(ts),
    intlOpts = {
      hourCycle: "h23",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    };
  if (timeZone) {
    intlOpts.timeZone = timeZone;
  }
  const modified = {
    timeZoneName: offsetFormat,
    ...intlOpts
  };
  const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(m => m.type.toLowerCase() === "timezonename");
  return parsed ? parsed.value : null;
}

// signedOffset('-5', '30') -> -330
function signedOffset(offHourStr, offMinuteStr) {
  let offHour = parseInt(offHourStr, 10);

  // don't || this because we want to preserve -0
  if (Number.isNaN(offHour)) {
    offHour = 0;
  }
  const offMin = parseInt(offMinuteStr, 10) || 0,
    offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
  return offHour * 60 + offMinSigned;
}

// COERCION

function asNumber(value) {
  const numericValue = Number(value);
  if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new InvalidArgumentError(`Invalid unit value ${value}`);
  return numericValue;
}
function normalizeObject(obj, normalizer) {
  const normalized = {};
  for (const u in obj) {
    if (hasOwnProperty(obj, u)) {
      const v = obj[u];
      if (v === undefined || v === null) continue;
      normalized[normalizer(u)] = asNumber(v);
    }
  }
  return normalized;
}

/**
 * Returns the offset's value as a string
 * @param {number} ts - Epoch milliseconds for which to get the offset
 * @param {string} format - What style of offset to return.
 *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
 * @return {string}
 */
function formatOffset(offset, format) {
  const hours = Math.trunc(Math.abs(offset / 60)),
    minutes = Math.trunc(Math.abs(offset % 60)),
    sign = offset >= 0 ? "+" : "-";
  switch (format) {
    case "short":
      return `${sign}${padStart(hours, 2)}:${padStart(minutes, 2)}`;
    case "narrow":
      return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
    case "techie":
      return `${sign}${padStart(hours, 2)}${padStart(minutes, 2)}`;
    default:
      throw new RangeError(`Value format ${format} is out of range for property format`);
  }
}
function timeObject(obj) {
  return pick(obj, ["hour", "minute", "second", "millisecond"]);
}

/**
 * @private
 */

const monthsLong = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
const monthsShort = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const monthsNarrow = ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"];
function months(length) {
  switch (length) {
    case "narrow":
      return [...monthsNarrow];
    case "short":
      return [...monthsShort];
    case "long":
      return [...monthsLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
    case "2-digit":
      return ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
    default:
      return null;
  }
}
const weekdaysLong = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const weekdaysShort = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const weekdaysNarrow = ["M", "T", "W", "T", "F", "S", "S"];
function weekdays(length) {
  switch (length) {
    case "narrow":
      return [...weekdaysNarrow];
    case "short":
      return [...weekdaysShort];
    case "long":
      return [...weekdaysLong];
    case "numeric":
      return ["1", "2", "3", "4", "5", "6", "7"];
    default:
      return null;
  }
}
const meridiems = ["AM", "PM"];
const erasLong = ["Before Christ", "Anno Domini"];
const erasShort = ["BC", "AD"];
const erasNarrow = ["B", "A"];
function eras(length) {
  switch (length) {
    case "narrow":
      return [...erasNarrow];
    case "short":
      return [...erasShort];
    case "long":
      return [...erasLong];
    default:
      return null;
  }
}
function meridiemForDateTime(dt) {
  return meridiems[dt.hour < 12 ? 0 : 1];
}
function weekdayForDateTime(dt, length) {
  return weekdays(length)[dt.weekday - 1];
}
function monthForDateTime(dt, length) {
  return months(length)[dt.month - 1];
}
function eraForDateTime(dt, length) {
  return eras(length)[dt.year < 0 ? 0 : 1];
}
function formatRelativeTime(unit, count, numeric = "always", narrow = false) {
  const units = {
    years: ["year", "yr."],
    quarters: ["quarter", "qtr."],
    months: ["month", "mo."],
    weeks: ["week", "wk."],
    days: ["day", "day", "days"],
    hours: ["hour", "hr."],
    minutes: ["minute", "min."],
    seconds: ["second", "sec."]
  };
  const lastable = ["hours", "minutes", "seconds"].indexOf(unit) === -1;
  if (numeric === "auto" && lastable) {
    const isDay = unit === "days";
    switch (count) {
      case 1:
        return isDay ? "tomorrow" : `next ${units[unit][0]}`;
      case -1:
        return isDay ? "yesterday" : `last ${units[unit][0]}`;
      case 0:
        return isDay ? "today" : `this ${units[unit][0]}`;
    }
  }

  const isInPast = Object.is(count, -0) || count < 0,
    fmtValue = Math.abs(count),
    singular = fmtValue === 1,
    lilUnits = units[unit],
    fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
  return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}

function stringifyTokens(splits, tokenToString) {
  let s = "";
  for (const token of splits) {
    if (token.literal) {
      s += token.val;
    } else {
      s += tokenToString(token.val);
    }
  }
  return s;
}
const macroTokenToFormatOpts = {
  D: DATE_SHORT,
  DD: DATE_MED,
  DDD: DATE_FULL,
  DDDD: DATE_HUGE,
  t: TIME_SIMPLE,
  tt: TIME_WITH_SECONDS,
  ttt: TIME_WITH_SHORT_OFFSET,
  tttt: TIME_WITH_LONG_OFFSET,
  T: TIME_24_SIMPLE,
  TT: TIME_24_WITH_SECONDS,
  TTT: TIME_24_WITH_SHORT_OFFSET,
  TTTT: TIME_24_WITH_LONG_OFFSET,
  f: DATETIME_SHORT,
  ff: DATETIME_MED,
  fff: DATETIME_FULL,
  ffff: DATETIME_HUGE,
  F: DATETIME_SHORT_WITH_SECONDS,
  FF: DATETIME_MED_WITH_SECONDS,
  FFF: DATETIME_FULL_WITH_SECONDS,
  FFFF: DATETIME_HUGE_WITH_SECONDS
};

/**
 * @private
 */

class Formatter {
  static create(locale, opts = {}) {
    return new Formatter(locale, opts);
  }
  static parseFormat(fmt) {
    // white-space is always considered a literal in user-provided formats
    // the " " token has a special meaning (see unitForToken)

    let current = null,
      currentFull = "",
      bracketed = false;
    const splits = [];
    for (let i = 0; i < fmt.length; i++) {
      const c = fmt.charAt(i);
      if (c === "'") {
        if (currentFull.length > 0) {
          splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        current = null;
        currentFull = "";
        bracketed = !bracketed;
      } else if (bracketed) {
        currentFull += c;
      } else if (c === current) {
        currentFull += c;
      } else {
        if (currentFull.length > 0) {
          splits.push({
            literal: /^\s+$/.test(currentFull),
            val: currentFull
          });
        }
        currentFull = c;
        current = c;
      }
    }
    if (currentFull.length > 0) {
      splits.push({
        literal: bracketed || /^\s+$/.test(currentFull),
        val: currentFull
      });
    }
    return splits;
  }
  static macroTokenToFormatOpts(token) {
    return macroTokenToFormatOpts[token];
  }
  constructor(locale, formatOpts) {
    this.opts = formatOpts;
    this.loc = locale;
    this.systemLoc = null;
  }
  formatWithSystemDefault(dt, opts) {
    if (this.systemLoc === null) {
      this.systemLoc = this.loc.redefaultToSystem();
    }
    const df = this.systemLoc.dtFormatter(dt, {
      ...this.opts,
      ...opts
    });
    return df.format();
  }
  dtFormatter(dt, opts = {}) {
    return this.loc.dtFormatter(dt, {
      ...this.opts,
      ...opts
    });
  }
  formatDateTime(dt, opts) {
    return this.dtFormatter(dt, opts).format();
  }
  formatDateTimeParts(dt, opts) {
    return this.dtFormatter(dt, opts).formatToParts();
  }
  formatInterval(interval, opts) {
    const df = this.dtFormatter(interval.start, opts);
    return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
  }
  resolvedOptions(dt, opts) {
    return this.dtFormatter(dt, opts).resolvedOptions();
  }
  num(n, p = 0) {
    // we get some perf out of doing this here, annoyingly
    if (this.opts.forceSimple) {
      return padStart(n, p);
    }
    const opts = {
      ...this.opts
    };
    if (p > 0) {
      opts.padTo = p;
    }
    return this.loc.numberFormatter(opts).format(n);
  }
  formatDateTimeFromString(dt, fmt) {
    const knownEnglish = this.loc.listingMode() === "en",
      useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory",
      string = (opts, extract) => this.loc.extract(dt, opts, extract),
      formatOffset = opts => {
        if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) {
          return "Z";
        }
        return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
      },
      meridiem = () => knownEnglish ? meridiemForDateTime(dt) : string({
        hour: "numeric",
        hourCycle: "h12"
      }, "dayperiod"),
      month = (length, standalone) => knownEnglish ? monthForDateTime(dt, length) : string(standalone ? {
        month: length
      } : {
        month: length,
        day: "numeric"
      }, "month"),
      weekday = (length, standalone) => knownEnglish ? weekdayForDateTime(dt, length) : string(standalone ? {
        weekday: length
      } : {
        weekday: length,
        month: "long",
        day: "numeric"
      }, "weekday"),
      maybeMacro = token => {
        const formatOpts = Formatter.macroTokenToFormatOpts(token);
        if (formatOpts) {
          return this.formatWithSystemDefault(dt, formatOpts);
        } else {
          return token;
        }
      },
      era = length => knownEnglish ? eraForDateTime(dt, length) : string({
        era: length
      }, "era"),
      tokenToString = token => {
        // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
        switch (token) {
          // ms
          case "S":
            return this.num(dt.millisecond);
          case "u":
          // falls through
          case "SSS":
            return this.num(dt.millisecond, 3);
          // seconds
          case "s":
            return this.num(dt.second);
          case "ss":
            return this.num(dt.second, 2);
          // fractional seconds
          case "uu":
            return this.num(Math.floor(dt.millisecond / 10), 2);
          case "uuu":
            return this.num(Math.floor(dt.millisecond / 100));
          // minutes
          case "m":
            return this.num(dt.minute);
          case "mm":
            return this.num(dt.minute, 2);
          // hours
          case "h":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
          case "hh":
            return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
          case "H":
            return this.num(dt.hour);
          case "HH":
            return this.num(dt.hour, 2);
          // offset
          case "Z":
            // like +6
            return formatOffset({
              format: "narrow",
              allowZ: this.opts.allowZ
            });
          case "ZZ":
            // like +06:00
            return formatOffset({
              format: "short",
              allowZ: this.opts.allowZ
            });
          case "ZZZ":
            // like +0600
            return formatOffset({
              format: "techie",
              allowZ: this.opts.allowZ
            });
          case "ZZZZ":
            // like EST
            return dt.zone.offsetName(dt.ts, {
              format: "short",
              locale: this.loc.locale
            });
          case "ZZZZZ":
            // like Eastern Standard Time
            return dt.zone.offsetName(dt.ts, {
              format: "long",
              locale: this.loc.locale
            });
          // zone
          case "z":
            // like America/New_York
            return dt.zoneName;
          // meridiems
          case "a":
            return meridiem();
          // dates
          case "d":
            return useDateTimeFormatter ? string({
              day: "numeric"
            }, "day") : this.num(dt.day);
          case "dd":
            return useDateTimeFormatter ? string({
              day: "2-digit"
            }, "day") : this.num(dt.day, 2);
          // weekdays - standalone
          case "c":
            // like 1
            return this.num(dt.weekday);
          case "ccc":
            // like 'Tues'
            return weekday("short", true);
          case "cccc":
            // like 'Tuesday'
            return weekday("long", true);
          case "ccccc":
            // like 'T'
            return weekday("narrow", true);
          // weekdays - format
          case "E":
            // like 1
            return this.num(dt.weekday);
          case "EEE":
            // like 'Tues'
            return weekday("short", false);
          case "EEEE":
            // like 'Tuesday'
            return weekday("long", false);
          case "EEEEE":
            // like 'T'
            return weekday("narrow", false);
          // months - standalone
          case "L":
            // like 1
            return useDateTimeFormatter ? string({
              month: "numeric",
              day: "numeric"
            }, "month") : this.num(dt.month);
          case "LL":
            // like 01, doesn't seem to work
            return useDateTimeFormatter ? string({
              month: "2-digit",
              day: "numeric"
            }, "month") : this.num(dt.month, 2);
          case "LLL":
            // like Jan
            return month("short", true);
          case "LLLL":
            // like January
            return month("long", true);
          case "LLLLL":
            // like J
            return month("narrow", true);
          // months - format
          case "M":
            // like 1
            return useDateTimeFormatter ? string({
              month: "numeric"
            }, "month") : this.num(dt.month);
          case "MM":
            // like 01
            return useDateTimeFormatter ? string({
              month: "2-digit"
            }, "month") : this.num(dt.month, 2);
          case "MMM":
            // like Jan
            return month("short", false);
          case "MMMM":
            // like January
            return month("long", false);
          case "MMMMM":
            // like J
            return month("narrow", false);
          // years
          case "y":
            // like 2014
            return useDateTimeFormatter ? string({
              year: "numeric"
            }, "year") : this.num(dt.year);
          case "yy":
            // like 14
            return useDateTimeFormatter ? string({
              year: "2-digit"
            }, "year") : this.num(dt.year.toString().slice(-2), 2);
          case "yyyy":
            // like 0012
            return useDateTimeFormatter ? string({
              year: "numeric"
            }, "year") : this.num(dt.year, 4);
          case "yyyyyy":
            // like 000012
            return useDateTimeFormatter ? string({
              year: "numeric"
            }, "year") : this.num(dt.year, 6);
          // eras
          case "G":
            // like AD
            return era("short");
          case "GG":
            // like Anno Domini
            return era("long");
          case "GGGGG":
            return era("narrow");
          case "kk":
            return this.num(dt.weekYear.toString().slice(-2), 2);
          case "kkkk":
            return this.num(dt.weekYear, 4);
          case "W":
            return this.num(dt.weekNumber);
          case "WW":
            return this.num(dt.weekNumber, 2);
          case "n":
            return this.num(dt.localWeekNumber);
          case "nn":
            return this.num(dt.localWeekNumber, 2);
          case "ii":
            return this.num(dt.localWeekYear.toString().slice(-2), 2);
          case "iiii":
            return this.num(dt.localWeekYear, 4);
          case "o":
            return this.num(dt.ordinal);
          case "ooo":
            return this.num(dt.ordinal, 3);
          case "q":
            // like 1
            return this.num(dt.quarter);
          case "qq":
            // like 01
            return this.num(dt.quarter, 2);
          case "X":
            return this.num(Math.floor(dt.ts / 1000));
          case "x":
            return this.num(dt.ts);
          default:
            return maybeMacro(token);
        }
      };
    return stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
  }
  formatDurationFromString(dur, fmt) {
    const tokenToField = token => {
        switch (token[0]) {
          case "S":
            return "millisecond";
          case "s":
            return "second";
          case "m":
            return "minute";
          case "h":
            return "hour";
          case "d":
            return "day";
          case "w":
            return "week";
          case "M":
            return "month";
          case "y":
            return "year";
          default:
            return null;
        }
      },
      tokenToString = lildur => token => {
        const mapped = tokenToField(token);
        if (mapped) {
          return this.num(lildur.get(mapped), token.length);
        } else {
          return token;
        }
      },
      tokens = Formatter.parseFormat(fmt),
      realTokens = tokens.reduce((found, {
        literal,
        val
      }) => literal ? found : found.concat(val), []),
      collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter(t => t));
    return stringifyTokens(tokens, tokenToString(collapsed));
  }
}

/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */

const ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function combineRegexes(...regexes) {
  const full = regexes.reduce((f, r) => f + r.source, "");
  return RegExp(`^${full}$`);
}
function combineExtractors(...extractors) {
  return m => extractors.reduce(([mergedVals, mergedZone, cursor], ex) => {
    const [val, zone, next] = ex(m, cursor);
    return [{
      ...mergedVals,
      ...val
    }, zone || mergedZone, next];
  }, [{}, null, 1]).slice(0, 2);
}
function parse(s, ...patterns) {
  if (s == null) {
    return [null, null];
  }
  for (const [regex, extractor] of patterns) {
    const m = regex.exec(s);
    if (m) {
      return extractor(m);
    }
  }
  return [null, null];
}
function simpleParse(...keys) {
  return (match, cursor) => {
    const ret = {};
    let i;
    for (i = 0; i < keys.length; i++) {
      ret[keys[i]] = parseInteger(match[cursor + i]);
    }
    return [ret, null, cursor + i];
  };
}

// ISO and SQL parsing
const offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
const isoExtendedZone = `(?:${offsetRegex.source}?(?:\\[(${ianaRegex.source})\\])?)?`;
const isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const isoTimeRegex = RegExp(`${isoTimeBaseRegex.source}${isoExtendedZone}`);
const isoTimeExtensionRegex = RegExp(`(?:T${isoTimeRegex.source})?`);
const isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const extractISOWeekData = simpleParse("weekYear", "weekNumber", "weekDay");
const extractISOOrdinalData = simpleParse("year", "ordinal");
const sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
const sqlTimeRegex = RegExp(`${isoTimeBaseRegex.source} ?(?:${offsetRegex.source}|(${ianaRegex.source}))?`);
const sqlTimeExtensionRegex = RegExp(`(?: ${sqlTimeRegex.source})?`);
function int(match, pos, fallback) {
  const m = match[pos];
  return isUndefined(m) ? fallback : parseInteger(m);
}
function extractISOYmd(match, cursor) {
  const item = {
    year: int(match, cursor),
    month: int(match, cursor + 1, 1),
    day: int(match, cursor + 2, 1)
  };
  return [item, null, cursor + 3];
}
function extractISOTime(match, cursor) {
  const item = {
    hours: int(match, cursor, 0),
    minutes: int(match, cursor + 1, 0),
    seconds: int(match, cursor + 2, 0),
    milliseconds: parseMillis(match[cursor + 3])
  };
  return [item, null, cursor + 4];
}
function extractISOOffset(match, cursor) {
  const local = !match[cursor] && !match[cursor + 1],
    fullOffset = signedOffset(match[cursor + 1], match[cursor + 2]),
    zone = local ? null : FixedOffsetZone.instance(fullOffset);
  return [{}, zone, cursor + 3];
}
function extractIANAZone(match, cursor) {
  const zone = match[cursor] ? IANAZone.create(match[cursor]) : null;
  return [{}, zone, cursor + 1];
}

// ISO time parsing

const isoTimeOnly = RegExp(`^T?${isoTimeBaseRegex.source}$`);

// ISO duration parsing

const isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function extractISODuration(match) {
  const [s, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match;
  const hasNegativePrefix = s[0] === "-";
  const negativeSeconds = secondStr && secondStr[0] === "-";
  const maybeNegate = (num, force = false) => num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
  return [{
    years: maybeNegate(parseFloating(yearStr)),
    months: maybeNegate(parseFloating(monthStr)),
    weeks: maybeNegate(parseFloating(weekStr)),
    days: maybeNegate(parseFloating(dayStr)),
    hours: maybeNegate(parseFloating(hourStr)),
    minutes: maybeNegate(parseFloating(minuteStr)),
    seconds: maybeNegate(parseFloating(secondStr), secondStr === "-0"),
    milliseconds: maybeNegate(parseMillis(millisecondsStr), negativeSeconds)
  }];
}

// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
const obsOffsets = {
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
  const result = {
    year: yearStr.length === 2 ? untruncateYear(parseInteger(yearStr)) : parseInteger(yearStr),
    month: monthsShort.indexOf(monthStr) + 1,
    day: parseInteger(dayStr),
    hour: parseInteger(hourStr),
    minute: parseInteger(minuteStr)
  };
  if (secondStr) result.second = parseInteger(secondStr);
  if (weekdayStr) {
    result.weekday = weekdayStr.length > 3 ? weekdaysLong.indexOf(weekdayStr) + 1 : weekdaysShort.indexOf(weekdayStr) + 1;
  }
  return result;
}

// RFC 2822/5322
const rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function extractRFC2822(match) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr, obsOffset, milOffset, offHourStr, offMinuteStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  let offset;
  if (obsOffset) {
    offset = obsOffsets[obsOffset];
  } else if (milOffset) {
    offset = 0;
  } else {
    offset = signedOffset(offHourStr, offMinuteStr);
  }
  return [result, new FixedOffsetZone(offset)];
}
function preprocessRFC2822(s) {
  // Remove comments and folding whitespace and replace multiple-spaces with a single space
  return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}

// http date

const rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/,
  rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/,
  ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function extractRFC1123Or850(match) {
  const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
function extractASCII(match) {
  const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match,
    result = fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
  return [result, FixedOffsetZone.utcInstance];
}
const isoYmdWithTimeExtensionRegex = combineRegexes(isoYmdRegex, isoTimeExtensionRegex);
const isoWeekWithTimeExtensionRegex = combineRegexes(isoWeekRegex, isoTimeExtensionRegex);
const isoOrdinalWithTimeExtensionRegex = combineRegexes(isoOrdinalRegex, isoTimeExtensionRegex);
const isoTimeCombinedRegex = combineRegexes(isoTimeRegex);
const extractISOYmdTimeAndOffset = combineExtractors(extractISOYmd, extractISOTime, extractISOOffset, extractIANAZone);
const extractISOWeekTimeAndOffset = combineExtractors(extractISOWeekData, extractISOTime, extractISOOffset, extractIANAZone);
const extractISOOrdinalDateAndTime = combineExtractors(extractISOOrdinalData, extractISOTime, extractISOOffset, extractIANAZone);
const extractISOTimeAndOffset = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);

/*
 * @private
 */

function parseISODate(s) {
  return parse(s, [isoYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [isoWeekWithTimeExtensionRegex, extractISOWeekTimeAndOffset], [isoOrdinalWithTimeExtensionRegex, extractISOOrdinalDateAndTime], [isoTimeCombinedRegex, extractISOTimeAndOffset]);
}
function parseRFC2822Date(s) {
  return parse(preprocessRFC2822(s), [rfc2822, extractRFC2822]);
}
function parseHTTPDate(s) {
  return parse(s, [rfc1123, extractRFC1123Or850], [rfc850, extractRFC1123Or850], [ascii, extractASCII]);
}
function parseISODuration(s) {
  return parse(s, [isoDuration, extractISODuration]);
}
const extractISOTimeOnly = combineExtractors(extractISOTime);
function parseISOTimeOnly(s) {
  return parse(s, [isoTimeOnly, extractISOTimeOnly]);
}
const sqlYmdWithTimeExtensionRegex = combineRegexes(sqlYmdRegex, sqlTimeExtensionRegex);
const sqlTimeCombinedRegex = combineRegexes(sqlTimeRegex);
const extractISOTimeOffsetAndIANAZone = combineExtractors(extractISOTime, extractISOOffset, extractIANAZone);
function parseSQL(s) {
  return parse(s, [sqlYmdWithTimeExtensionRegex, extractISOYmdTimeAndOffset], [sqlTimeCombinedRegex, extractISOTimeOffsetAndIANAZone]);
}

const INVALID$2 = "Invalid Duration";

// unit conversion constants
const lowOrderMatrix = {
    weeks: {
      days: 7,
      hours: 7 * 24,
      minutes: 7 * 24 * 60,
      seconds: 7 * 24 * 60 * 60,
      milliseconds: 7 * 24 * 60 * 60 * 1000
    },
    days: {
      hours: 24,
      minutes: 24 * 60,
      seconds: 24 * 60 * 60,
      milliseconds: 24 * 60 * 60 * 1000
    },
    hours: {
      minutes: 60,
      seconds: 60 * 60,
      milliseconds: 60 * 60 * 1000
    },
    minutes: {
      seconds: 60,
      milliseconds: 60 * 1000
    },
    seconds: {
      milliseconds: 1000
    }
  },
  casualMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: 52,
      days: 365,
      hours: 365 * 24,
      minutes: 365 * 24 * 60,
      seconds: 365 * 24 * 60 * 60,
      milliseconds: 365 * 24 * 60 * 60 * 1000
    },
    quarters: {
      months: 3,
      weeks: 13,
      days: 91,
      hours: 91 * 24,
      minutes: 91 * 24 * 60,
      seconds: 91 * 24 * 60 * 60,
      milliseconds: 91 * 24 * 60 * 60 * 1000
    },
    months: {
      weeks: 4,
      days: 30,
      hours: 30 * 24,
      minutes: 30 * 24 * 60,
      seconds: 30 * 24 * 60 * 60,
      milliseconds: 30 * 24 * 60 * 60 * 1000
    },
    ...lowOrderMatrix
  },
  daysInYearAccurate = 146097.0 / 400,
  daysInMonthAccurate = 146097.0 / 4800,
  accurateMatrix = {
    years: {
      quarters: 4,
      months: 12,
      weeks: daysInYearAccurate / 7,
      days: daysInYearAccurate,
      hours: daysInYearAccurate * 24,
      minutes: daysInYearAccurate * 24 * 60,
      seconds: daysInYearAccurate * 24 * 60 * 60,
      milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000
    },
    quarters: {
      months: 3,
      weeks: daysInYearAccurate / 28,
      days: daysInYearAccurate / 4,
      hours: daysInYearAccurate * 24 / 4,
      minutes: daysInYearAccurate * 24 * 60 / 4,
      seconds: daysInYearAccurate * 24 * 60 * 60 / 4,
      milliseconds: daysInYearAccurate * 24 * 60 * 60 * 1000 / 4
    },
    months: {
      weeks: daysInMonthAccurate / 7,
      days: daysInMonthAccurate,
      hours: daysInMonthAccurate * 24,
      minutes: daysInMonthAccurate * 24 * 60,
      seconds: daysInMonthAccurate * 24 * 60 * 60,
      milliseconds: daysInMonthAccurate * 24 * 60 * 60 * 1000
    },
    ...lowOrderMatrix
  };

// units ordered by size
const orderedUnits$1 = ["years", "quarters", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds"];
const reverseUnits = orderedUnits$1.slice(0).reverse();

// clone really means "create another instance just like this one, but with these changes"
function clone$1(dur, alts, clear = false) {
  // deep merge for vals
  const conf = {
    values: clear ? alts.values : {
      ...dur.values,
      ...(alts.values || {})
    },
    loc: dur.loc.clone(alts.loc),
    conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
    matrix: alts.matrix || dur.matrix
  };
  return new Duration(conf);
}
function durationToMillis(matrix, vals) {
  var _vals$milliseconds;
  let sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
  for (const unit of reverseUnits.slice(1)) {
    if (vals[unit]) {
      sum += vals[unit] * matrix[unit]["milliseconds"];
    }
  }
  return sum;
}

// NB: mutates parameters
function normalizeValues(matrix, vals) {
  // the logic below assumes the overall value of the duration is positive
  // if this is not the case, factor is used to make it so
  const factor = durationToMillis(matrix, vals) < 0 ? -1 : 1;
  orderedUnits$1.reduceRight((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const previousVal = vals[previous] * factor;
        const conv = matrix[current][previous];

        // if (previousVal < 0):
        // lower order unit is negative (e.g. { years: 2, days: -2 })
        // normalize this by reducing the higher order unit by the appropriate amount
        // and increasing the lower order unit
        // this can never make the higher order unit negative, because this function only operates
        // on positive durations, so the amount of time represented by the lower order unit cannot
        // be larger than the higher order unit
        // else:
        // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
        // in this case we attempt to convert as much as possible from the lower order unit into
        // the higher order one
        //
        // Math.floor takes care of both of these cases, rounding away from 0
        // if previousVal < 0 it makes the absolute value larger
        // if previousVal >= it makes the absolute value smaller
        const rollUp = Math.floor(previousVal / conv);
        vals[current] += rollUp * factor;
        vals[previous] -= rollUp * conv * factor;
      }
      return current;
    } else {
      return previous;
    }
  }, null);

  // try to convert any decimals into smaller units if possible
  // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
  orderedUnits$1.reduce((previous, current) => {
    if (!isUndefined(vals[current])) {
      if (previous) {
        const fraction = vals[previous] % 1;
        vals[previous] -= fraction;
        vals[current] += fraction * matrix[previous][current];
      }
      return current;
    } else {
      return previous;
    }
  }, null);
}

// Remove all properties with a value of 0 from an object
function removeZeroes(vals) {
  const newVals = {};
  for (const [key, value] of Object.entries(vals)) {
    if (value !== 0) {
      newVals[key] = value;
    }
  }
  return newVals;
}

/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */
class Duration {
  /**
   * @private
   */
  constructor(config) {
    const accurate = config.conversionAccuracy === "longterm" || false;
    let matrix = accurate ? accurateMatrix : casualMatrix;
    if (config.matrix) {
      matrix = config.matrix;
    }

    /**
     * @access private
     */
    this.values = config.values;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.conversionAccuracy = accurate ? "longterm" : "casual";
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.matrix = matrix;
    /**
     * @access private
     */
    this.isLuxonDuration = true;
  }

  /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  static fromMillis(count, opts) {
    return Duration.fromObject({
      milliseconds: count
    }, opts);
  }

  /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */
  static fromObject(obj, opts = {}) {
    if (obj == null || typeof obj !== "object") {
      throw new InvalidArgumentError(`Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`);
    }
    return new Duration({
      values: normalizeObject(obj, Duration.normalizeUnit),
      loc: Locale.fromObject(opts),
      conversionAccuracy: opts.conversionAccuracy,
      matrix: opts.matrix
    });
  }

  /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */
  static fromDurationLike(durationLike) {
    if (isNumber(durationLike)) {
      return Duration.fromMillis(durationLike);
    } else if (Duration.isDuration(durationLike)) {
      return durationLike;
    } else if (typeof durationLike === "object") {
      return Duration.fromObject(durationLike);
    } else {
      throw new InvalidArgumentError(`Unknown duration argument ${durationLike} of type ${typeof durationLike}`);
    }
  }

  /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */
  static fromISO(text, opts) {
    const [parsed] = parseISODuration(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }

  /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */
  static fromISOTime(text, opts) {
    const [parsed] = parseISOTimeOnly(text);
    if (parsed) {
      return Duration.fromObject(parsed, opts);
    } else {
      return Duration.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
  }

  /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Duration is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDurationError(invalid);
    } else {
      return new Duration({
        invalid
      });
    }
  }

  /**
   * @private
   */
  static normalizeUnit(unit) {
    const normalized = {
      year: "years",
      years: "years",
      quarter: "quarters",
      quarters: "quarters",
      month: "months",
      months: "months",
      week: "weeks",
      weeks: "weeks",
      day: "days",
      days: "days",
      hour: "hours",
      hours: "hours",
      minute: "minutes",
      minutes: "minutes",
      second: "seconds",
      seconds: "seconds",
      millisecond: "milliseconds",
      milliseconds: "milliseconds"
    }[unit ? unit.toLowerCase() : unit];
    if (!normalized) throw new InvalidUnitError(unit);
    return normalized;
  }

  /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDuration(o) {
    return o && o.isLuxonDuration || false;
  }

  /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }

  /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }

  /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    // reverse-compat since 1.2; we always round down now, never up, and we do it by default
    const fmtOpts = {
      ...opts,
      floor: opts.round !== false && opts.floor !== false
    };
    return this.isValid ? Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : INVALID$2;
  }

  /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior, use `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#options
   * @param {Object} opts - Formatting options. Accepts the same keys as the options parameter of the native `Intl.NumberFormat` constructor, as well as `listStyle`.
   * @param {string} [opts.listStyle='narrow'] - How to format the merged list. Corresponds to the `style` property of the options parameter of the native `Intl.ListFormat` constructor.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */
  toHuman(opts = {}) {
    if (!this.isValid) return INVALID$2;
    const l = orderedUnits$1.map(unit => {
      const val = this.values[unit];
      if (isUndefined(val)) {
        return null;
      }
      return this.loc.numberFormatter({
        style: "unit",
        unitDisplay: "long",
        ...opts,
        unit: unit.slice(0, -1)
      }).format(val);
    }).filter(n => n);
    return this.loc.listFormatter({
      type: "conjunction",
      style: opts.listStyle || "narrow",
      ...opts
    }).format(l);
  }

  /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */
  toObject() {
    if (!this.isValid) return {};
    return {
      ...this.values
    };
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */
  toISO() {
    // we could use the formatter, but this is an easier way to get the minimum string
    if (!this.isValid) return null;
    let s = "P";
    if (this.years !== 0) s += this.years + "Y";
    if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
    if (this.weeks !== 0) s += this.weeks + "W";
    if (this.days !== 0) s += this.days + "D";
    if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
    if (this.hours !== 0) s += this.hours + "H";
    if (this.minutes !== 0) s += this.minutes + "M";
    if (this.seconds !== 0 || this.milliseconds !== 0)
      // this will handle "floating point madness" by removing extra decimal places
      // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
      s += roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
    if (s === "P") s += "T0S";
    return s;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */
  toISOTime(opts = {}) {
    if (!this.isValid) return null;
    const millis = this.toMillis();
    if (millis < 0 || millis >= 86400000) return null;
    opts = {
      suppressMilliseconds: false,
      suppressSeconds: false,
      includePrefix: false,
      format: "extended",
      ...opts,
      includeOffset: false
    };
    const dateTime = DateTime.fromMillis(millis, {
      zone: "UTC"
    });
    return dateTime.toISOTime(opts);
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }

  /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */
  toString() {
    return this.toISO();
  }

  /**
   * Returns a string representation of this Duration appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Duration { values: ${JSON.stringify(this.values)} }`;
    } else {
      return `Duration { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */
  toMillis() {
    if (!this.isValid) return NaN;
    return durationToMillis(this.matrix, this.values);
  }

  /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }

  /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration),
      result = {};
    for (const k of orderedUnits$1) {
      if (hasOwnProperty(dur.values, k) || hasOwnProperty(this.values, k)) {
        result[k] = dur.get(k) + this.get(k);
      }
    }
    return clone$1(this, {
      values: result
    }, true);
  }

  /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return this.plus(dur.negate());
  }

  /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */
  mapUnits(fn) {
    if (!this.isValid) return this;
    const result = {};
    for (const k of Object.keys(this.values)) {
      result[k] = asNumber(fn(this.values[k], k));
    }
    return clone$1(this, {
      values: result
    }, true);
  }

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */
  get(unit) {
    return this[Duration.normalizeUnit(unit)];
  }

  /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */
  set(values) {
    if (!this.isValid) return this;
    const mixed = {
      ...this.values,
      ...normalizeObject(values, Duration.normalizeUnit)
    };
    return clone$1(this, {
      values: mixed
    });
  }

  /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */
  reconfigure({
    locale,
    numberingSystem,
    conversionAccuracy,
    matrix
  } = {}) {
    const loc = this.loc.clone({
      locale,
      numberingSystem
    });
    const opts = {
      loc,
      matrix,
      conversionAccuracy
    };
    return clone$1(this, opts);
  }

  /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */
  as(unit) {
    return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
  }

  /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see third example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */
  normalize() {
    if (!this.isValid) return this;
    const vals = this.toObject();
    normalizeValues(this.matrix, vals);
    return clone$1(this, {
      values: vals
    }, true);
  }

  /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */
  rescale() {
    if (!this.isValid) return this;
    const vals = removeZeroes(this.normalize().shiftToAll().toObject());
    return clone$1(this, {
      values: vals
    }, true);
  }

  /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */
  shiftTo(...units) {
    if (!this.isValid) return this;
    if (units.length === 0) {
      return this;
    }
    units = units.map(u => Duration.normalizeUnit(u));
    const built = {},
      accumulated = {},
      vals = this.toObject();
    let lastUnit;
    for (const k of orderedUnits$1) {
      if (units.indexOf(k) >= 0) {
        lastUnit = k;
        let own = 0;

        // anything we haven't boiled down yet should get boiled to this unit
        for (const ak in accumulated) {
          own += this.matrix[ak][k] * accumulated[ak];
          accumulated[ak] = 0;
        }

        // plus anything that's already in this unit
        if (isNumber(vals[k])) {
          own += vals[k];
        }

        // only keep the integer part for now in the hopes of putting any decimal part
        // into a smaller unit later
        const i = Math.trunc(own);
        built[k] = i;
        accumulated[k] = (own * 1000 - i * 1000) / 1000;

        // otherwise, keep it in the wings to boil it later
      } else if (isNumber(vals[k])) {
        accumulated[k] = vals[k];
      }
    }

    // anything leftover becomes the decimal for the last unit
    // lastUnit must be defined since units is not empty
    for (const key in accumulated) {
      if (accumulated[key] !== 0) {
        built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
      }
    }
    normalizeValues(this.matrix, built);
    return clone$1(this, {
      values: built
    }, true);
  }

  /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */
  shiftToAll() {
    if (!this.isValid) return this;
    return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
  }

  /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */
  negate() {
    if (!this.isValid) return this;
    const negated = {};
    for (const k of Object.keys(this.values)) {
      negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
    }
    return clone$1(this, {
      values: negated
    }, true);
  }

  /**
   * Get the years.
   * @type {number}
   */
  get years() {
    return this.isValid ? this.values.years || 0 : NaN;
  }

  /**
   * Get the quarters.
   * @type {number}
   */
  get quarters() {
    return this.isValid ? this.values.quarters || 0 : NaN;
  }

  /**
   * Get the months.
   * @type {number}
   */
  get months() {
    return this.isValid ? this.values.months || 0 : NaN;
  }

  /**
   * Get the weeks
   * @type {number}
   */
  get weeks() {
    return this.isValid ? this.values.weeks || 0 : NaN;
  }

  /**
   * Get the days.
   * @type {number}
   */
  get days() {
    return this.isValid ? this.values.days || 0 : NaN;
  }

  /**
   * Get the hours.
   * @type {number}
   */
  get hours() {
    return this.isValid ? this.values.hours || 0 : NaN;
  }

  /**
   * Get the minutes.
   * @type {number}
   */
  get minutes() {
    return this.isValid ? this.values.minutes || 0 : NaN;
  }

  /**
   * Get the seconds.
   * @return {number}
   */
  get seconds() {
    return this.isValid ? this.values.seconds || 0 : NaN;
  }

  /**
   * Get the milliseconds.
   * @return {number}
   */
  get milliseconds() {
    return this.isValid ? this.values.milliseconds || 0 : NaN;
  }

  /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }

  /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    if (!this.loc.equals(other.loc)) {
      return false;
    }
    function eq(v1, v2) {
      // Consider 0 and undefined as equal
      if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
      return v1 === v2;
    }
    for (const u of orderedUnits$1) {
      if (!eq(this.values[u], other.values[u])) {
        return false;
      }
    }
    return true;
  }
}

const INVALID$1 = "Invalid Interval";

// checks if the start is equal to or before the end
function validateStartEnd(start, end) {
  if (!start || !start.isValid) {
    return Interval.invalid("missing or invalid start");
  } else if (!end || !end.isValid) {
    return Interval.invalid("missing or invalid end");
  } else if (end < start) {
    return Interval.invalid("end before start", `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`);
  } else {
    return null;
  }
}

/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */
class Interval {
  /**
   * @private
   */
  constructor(config) {
    /**
     * @access private
     */
    this.s = config.start;
    /**
     * @access private
     */
    this.e = config.end;
    /**
     * @access private
     */
    this.invalid = config.invalid || null;
    /**
     * @access private
     */
    this.isLuxonInterval = true;
  }

  /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the Interval is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidIntervalError(invalid);
    } else {
      return new Interval({
        invalid
      });
    }
  }

  /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */
  static fromDateTimes(start, end) {
    const builtStart = friendlyDateTime(start),
      builtEnd = friendlyDateTime(end);
    const validateError = validateStartEnd(builtStart, builtEnd);
    if (validateError == null) {
      return new Interval({
        start: builtStart,
        end: builtEnd
      });
    } else {
      return validateError;
    }
  }

  /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static after(start, duration) {
    const dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(start);
    return Interval.fromDateTimes(dt, dt.plus(dur));
  }

  /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */
  static before(end, duration) {
    const dur = Duration.fromDurationLike(duration),
      dt = friendlyDateTime(end);
    return Interval.fromDateTimes(dt.minus(dur), dt);
  }

  /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */
  static fromISO(text, opts) {
    const [s, e] = (text || "").split("/", 2);
    if (s && e) {
      let start, startIsValid;
      try {
        start = DateTime.fromISO(s, opts);
        startIsValid = start.isValid;
      } catch (e) {
        startIsValid = false;
      }
      let end, endIsValid;
      try {
        end = DateTime.fromISO(e, opts);
        endIsValid = end.isValid;
      } catch (e) {
        endIsValid = false;
      }
      if (startIsValid && endIsValid) {
        return Interval.fromDateTimes(start, end);
      }
      if (startIsValid) {
        const dur = Duration.fromISO(e, opts);
        if (dur.isValid) {
          return Interval.after(start, dur);
        }
      } else if (endIsValid) {
        const dur = Duration.fromISO(s, opts);
        if (dur.isValid) {
          return Interval.before(end, dur);
        }
      }
    }
    return Interval.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
  }

  /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isInterval(o) {
    return o && o.isLuxonInterval || false;
  }

  /**
   * Returns the start of the Interval
   * @type {DateTime}
   */
  get start() {
    return this.isValid ? this.s : null;
  }

  /**
   * Returns the end of the Interval
   * @type {DateTime}
   */
  get end() {
    return this.isValid ? this.e : null;
  }

  /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */
  get isValid() {
    return this.invalidReason === null;
  }

  /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */
  length(unit = "milliseconds") {
    return this.isValid ? this.toDuration(...[unit]).get(unit) : NaN;
  }

  /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; this operation will always use the locale of the start DateTime
   * @return {number}
   */
  count(unit = "milliseconds", opts) {
    if (!this.isValid) return NaN;
    const start = this.start.startOf(unit, opts);
    let end;
    if (opts != null && opts.useLocaleWeeks) {
      end = this.end.reconfigure({
        locale: start.locale
      });
    } else {
      end = this.end;
    }
    end = end.startOf(unit, opts);
    return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
  }

  /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */
  hasSame(unit) {
    return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
  }

  /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */
  isEmpty() {
    return this.s.valueOf() === this.e.valueOf();
  }

  /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isAfter(dateTime) {
    if (!this.isValid) return false;
    return this.s > dateTime;
  }

  /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  isBefore(dateTime) {
    if (!this.isValid) return false;
    return this.e <= dateTime;
  }

  /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */
  contains(dateTime) {
    if (!this.isValid) return false;
    return this.s <= dateTime && this.e > dateTime;
  }

  /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */
  set({
    start,
    end
  } = {}) {
    if (!this.isValid) return this;
    return Interval.fromDateTimes(start || this.s, end || this.e);
  }

  /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */
  splitAt(...dateTimes) {
    if (!this.isValid) return [];
    const sorted = dateTimes.map(friendlyDateTime).filter(d => this.contains(d)).sort((a, b) => a.toMillis() - b.toMillis()),
      results = [];
    let {
        s
      } = this,
      i = 0;
    while (s < this.e) {
      const added = sorted[i] || this.e,
        next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      i += 1;
    }
    return results;
  }

  /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */
  splitBy(duration) {
    const dur = Duration.fromDurationLike(duration);
    if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) {
      return [];
    }
    let {
        s
      } = this,
      idx = 1,
      next;
    const results = [];
    while (s < this.e) {
      const added = this.start.plus(dur.mapUnits(x => x * idx));
      next = +added > +this.e ? this.e : added;
      results.push(Interval.fromDateTimes(s, next));
      s = next;
      idx += 1;
    }
    return results;
  }

  /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */
  divideEqually(numberOfParts) {
    if (!this.isValid) return [];
    return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
  }

  /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */
  overlaps(other) {
    return this.e > other.s && this.s < other.e;
  }

  /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsStart(other) {
    if (!this.isValid) return false;
    return +this.e === +other.s;
  }

  /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */
  abutsEnd(other) {
    if (!this.isValid) return false;
    return +other.e === +this.s;
  }

  /**
   * Returns true if this Interval fully contains the specified Interval, specifically if the intersect (of this Interval and the other Interval) is equal to the other Interval; false otherwise.
   * @param {Interval} other
   * @return {boolean}
   */
  engulfs(other) {
    if (!this.isValid) return false;
    return this.s <= other.s && this.e >= other.e;
  }

  /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */
  equals(other) {
    if (!this.isValid || !other.isValid) {
      return false;
    }
    return this.s.equals(other.s) && this.e.equals(other.e);
  }

  /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */
  intersection(other) {
    if (!this.isValid) return this;
    const s = this.s > other.s ? this.s : other.s,
      e = this.e < other.e ? this.e : other.e;
    if (s >= e) {
      return null;
    } else {
      return Interval.fromDateTimes(s, e);
    }
  }

  /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */
  union(other) {
    if (!this.isValid) return this;
    const s = this.s < other.s ? this.s : other.s,
      e = this.e > other.e ? this.e : other.e;
    return Interval.fromDateTimes(s, e);
  }

  /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static merge(intervals) {
    const [found, final] = intervals.sort((a, b) => a.s - b.s).reduce(([sofar, current], item) => {
      if (!current) {
        return [sofar, item];
      } else if (current.overlaps(item) || current.abutsStart(item)) {
        return [sofar, current.union(item)];
      } else {
        return [sofar.concat([current]), item];
      }
    }, [[], null]);
    if (final) {
      found.push(final);
    }
    return found;
  }

  /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */
  static xor(intervals) {
    let start = null,
      currentCount = 0;
    const results = [],
      ends = intervals.map(i => [{
        time: i.s,
        type: "s"
      }, {
        time: i.e,
        type: "e"
      }]),
      flattened = Array.prototype.concat(...ends),
      arr = flattened.sort((a, b) => a.time - b.time);
    for (const i of arr) {
      currentCount += i.type === "s" ? 1 : -1;
      if (currentCount === 1) {
        start = i.time;
      } else {
        if (start && +start !== +i.time) {
          results.push(Interval.fromDateTimes(start, i.time));
        }
        start = null;
      }
    }
    return Interval.merge(results);
  }

  /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */
  difference(...intervals) {
    return Interval.xor([this].concat(intervals)).map(i => this.intersection(i)).filter(i => i && !i.isEmpty());
  }

  /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */
  toString() {
    if (!this.isValid) return INVALID$1;
    return `[${this.s.toISO()} – ${this.e.toISO()})`;
  }

  /**
   * Returns a string representation of this Interval appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `Interval { start: ${this.s.toISO()}, end: ${this.e.toISO()} }`;
    } else {
      return `Interval { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : INVALID$1;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISO(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
  }

  /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */
  toISODate() {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISODate()}/${this.e.toISODate()}`;
  }

  /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */
  toISOTime(opts) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
  }

  /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */
  toFormat(dateFormat, {
    separator = " – "
  } = {}) {
    if (!this.isValid) return INVALID$1;
    return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
  }

  /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */
  toDuration(unit, opts) {
    if (!this.isValid) {
      return Duration.invalid(this.invalidReason);
    }
    return this.e.diff(this.s, unit, opts);
  }

  /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */
  mapEndpoints(mapFn) {
    return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
  }
}

/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */
class Info {
  /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */
  static hasDST(zone = Settings.defaultZone) {
    const proto = DateTime.now().setZone(zone).set({
      month: 12
    });
    return !zone.isUniversal && proto.offset !== proto.set({
      month: 6
    }).offset;
  }

  /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */
  static isValidIANAZone(zone) {
    return IANAZone.isValidZone(zone);
  }

  /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */
  static normalizeZone(input) {
    return normalizeZone(input, Settings.defaultZone);
  }

  /**
   * Get the weekday on which the week starts according to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number} the start of the week, 1 for Monday through 7 for Sunday
   */
  static getStartOfWeek({
    locale = null,
    locObj = null
  } = {}) {
    return (locObj || Locale.create(locale)).getStartOfWeek();
  }

  /**
   * Get the minimum number of days necessary in a week before it is considered part of the next year according
   * to the given locale.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number}
   */
  static getMinimumDaysInFirstWeek({
    locale = null,
    locObj = null
  } = {}) {
    return (locObj || Locale.create(locale)).getMinDaysInFirstWeek();
  }

  /**
   * Get the weekdays, which are considered the weekend according to the given locale
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @returns {number[]} an array of weekdays, 1 for Monday through 7 for Sunday
   */
  static getWeekendWeekdays({
    locale = null,
    locObj = null
  } = {}) {
    // copy the array, because we cache it internally
    return (locObj || Locale.create(locale)).getWeekendDays().slice();
  }

  /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */
  static months(length = "long", {
    locale = null,
    numberingSystem = null,
    locObj = null,
    outputCalendar = "gregory"
  } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length);
  }

  /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */
  static monthsFormat(length = "long", {
    locale = null,
    numberingSystem = null,
    locObj = null,
    outputCalendar = "gregory"
  } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
  }

  /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */
  static weekdays(length = "long", {
    locale = null,
    numberingSystem = null,
    locObj = null
  } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length);
  }

  /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */
  static weekdaysFormat(length = "long", {
    locale = null,
    numberingSystem = null,
    locObj = null
  } = {}) {
    return (locObj || Locale.create(locale, numberingSystem, null)).weekdays(length, true);
  }

  /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */
  static meridiems({
    locale = null
  } = {}) {
    return Locale.create(locale).meridiems();
  }

  /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */
  static eras(length = "short", {
    locale = null
  } = {}) {
    return Locale.create(locale, null, "gregory").eras(length);
  }

  /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * * `localeWeek`: whether this environment supports different weekdays for the start of the week based on the locale
   * @example Info.features() //=> { relative: false, localeWeek: true }
   * @return {Object}
   */
  static features() {
    return {
      relative: hasRelative(),
      localeWeek: hasLocaleWeekInfo()
    };
  }
}

function dayDiff(earlier, later) {
  const utcDayStart = dt => dt.toUTC(0, {
      keepLocalTime: true
    }).startOf("day").valueOf(),
    ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
  const differs = [["years", (a, b) => b.year - a.year], ["quarters", (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4], ["months", (a, b) => b.month - a.month + (b.year - a.year) * 12], ["weeks", (a, b) => {
    const days = dayDiff(a, b);
    return (days - days % 7) / 7;
  }], ["days", dayDiff]];
  const results = {};
  const earlier = cursor;
  let lowestOrder, highWater;

  /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */
  for (const [unit, differ] of differs) {
    if (units.indexOf(unit) >= 0) {
      lowestOrder = unit;
      results[unit] = differ(cursor, later);
      highWater = earlier.plus(results);
      if (highWater > later) {
        // we overshot the end point, backtrack cursor by 1
        results[unit]--;
        cursor = earlier.plus(results);

        // if we are still overshooting now, we need to backtrack again
        // this happens in certain situations when diffing times in different zones,
        // because this calculation ignores time zones
        if (cursor > later) {
          // keep the "overshot by 1" around as highWater
          highWater = cursor;
          // backtrack cursor by 1
          results[unit]--;
          cursor = earlier.plus(results);
        }
      } else {
        cursor = highWater;
      }
    }
  }
  return [cursor, results, highWater, lowestOrder];
}
function diff (earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor;
  const lowerOrderUnits = units.filter(u => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0);
  if (lowerOrderUnits.length === 0) {
    if (highWater < later) {
      highWater = cursor.plus({
        [lowestOrder]: 1
      });
    }
    if (highWater !== cursor) {
      results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
  }
  const duration = Duration.fromObject(results, opts);
  if (lowerOrderUnits.length > 0) {
    return Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
  } else {
    return duration;
  }
}

const MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function intUnit(regex, post = i => i) {
  return {
    regex,
    deser: ([s]) => post(parseDigits(s))
  };
}
const NBSP = String.fromCharCode(160);
const spaceOrNBSP = `[ ${NBSP}]`;
const spaceOrNBSPRegExp = new RegExp(spaceOrNBSP, "g");
function fixListRegex(s) {
  // make dots optional and also make them literal
  // make space and non breakable space characters interchangeable
  return s.replace(/\./g, "\\.?").replace(spaceOrNBSPRegExp, spaceOrNBSP);
}
function stripInsensitivities(s) {
  return s.replace(/\./g, "") // ignore dots that were made optional
  .replace(spaceOrNBSPRegExp, " ") // interchange space and nbsp
  .toLowerCase();
}
function oneOf(strings, startIndex) {
  if (strings === null) {
    return null;
  } else {
    return {
      regex: RegExp(strings.map(fixListRegex).join("|")),
      deser: ([s]) => strings.findIndex(i => stripInsensitivities(s) === stripInsensitivities(i)) + startIndex
    };
  }
}
function offset(regex, groups) {
  return {
    regex,
    deser: ([, h, m]) => signedOffset(h, m),
    groups
  };
}
function simple(regex) {
  return {
    regex,
    deser: ([s]) => s
  };
}
function escapeToken(value) {
  return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}

/**
 * @param token
 * @param {Locale} loc
 */
function unitForToken(token, loc) {
  const one = digitRegex(loc),
    two = digitRegex(loc, "{2}"),
    three = digitRegex(loc, "{3}"),
    four = digitRegex(loc, "{4}"),
    six = digitRegex(loc, "{6}"),
    oneOrTwo = digitRegex(loc, "{1,2}"),
    oneToThree = digitRegex(loc, "{1,3}"),
    oneToSix = digitRegex(loc, "{1,6}"),
    oneToNine = digitRegex(loc, "{1,9}"),
    twoToFour = digitRegex(loc, "{2,4}"),
    fourToSix = digitRegex(loc, "{4,6}"),
    literal = t => ({
      regex: RegExp(escapeToken(t.val)),
      deser: ([s]) => s,
      literal: true
    }),
    unitate = t => {
      if (token.literal) {
        return literal(t);
      }
      switch (t.val) {
        // era
        case "G":
          return oneOf(loc.eras("short"), 0);
        case "GG":
          return oneOf(loc.eras("long"), 0);
        // years
        case "y":
          return intUnit(oneToSix);
        case "yy":
          return intUnit(twoToFour, untruncateYear);
        case "yyyy":
          return intUnit(four);
        case "yyyyy":
          return intUnit(fourToSix);
        case "yyyyyy":
          return intUnit(six);
        // months
        case "M":
          return intUnit(oneOrTwo);
        case "MM":
          return intUnit(two);
        case "MMM":
          return oneOf(loc.months("short", true), 1);
        case "MMMM":
          return oneOf(loc.months("long", true), 1);
        case "L":
          return intUnit(oneOrTwo);
        case "LL":
          return intUnit(two);
        case "LLL":
          return oneOf(loc.months("short", false), 1);
        case "LLLL":
          return oneOf(loc.months("long", false), 1);
        // dates
        case "d":
          return intUnit(oneOrTwo);
        case "dd":
          return intUnit(two);
        // ordinals
        case "o":
          return intUnit(oneToThree);
        case "ooo":
          return intUnit(three);
        // time
        case "HH":
          return intUnit(two);
        case "H":
          return intUnit(oneOrTwo);
        case "hh":
          return intUnit(two);
        case "h":
          return intUnit(oneOrTwo);
        case "mm":
          return intUnit(two);
        case "m":
          return intUnit(oneOrTwo);
        case "q":
          return intUnit(oneOrTwo);
        case "qq":
          return intUnit(two);
        case "s":
          return intUnit(oneOrTwo);
        case "ss":
          return intUnit(two);
        case "S":
          return intUnit(oneToThree);
        case "SSS":
          return intUnit(three);
        case "u":
          return simple(oneToNine);
        case "uu":
          return simple(oneOrTwo);
        case "uuu":
          return intUnit(one);
        // meridiem
        case "a":
          return oneOf(loc.meridiems(), 0);
        // weekYear (k)
        case "kkkk":
          return intUnit(four);
        case "kk":
          return intUnit(twoToFour, untruncateYear);
        // weekNumber (W)
        case "W":
          return intUnit(oneOrTwo);
        case "WW":
          return intUnit(two);
        // weekdays
        case "E":
        case "c":
          return intUnit(one);
        case "EEE":
          return oneOf(loc.weekdays("short", false), 1);
        case "EEEE":
          return oneOf(loc.weekdays("long", false), 1);
        case "ccc":
          return oneOf(loc.weekdays("short", true), 1);
        case "cccc":
          return oneOf(loc.weekdays("long", true), 1);
        // offset/zone
        case "Z":
        case "ZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
        case "ZZZ":
          return offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
        // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
        // because we don't have any way to figure out what they are
        case "z":
          return simple(/[a-z_+-/]{1,256}?/i);
        // this special-case "token" represents a place where a macro-token expanded into a white-space literal
        // in this case we accept any non-newline white-space
        case " ":
          return simple(/[^\S\n\r]/);
        default:
          return literal(t);
      }
    };
  const unit = unitate(token) || {
    invalidReason: MISSING_FTP
  };
  unit.token = token;
  return unit;
}
const partTypeStyleToTokenVal = {
  year: {
    "2-digit": "yy",
    numeric: "yyyyy"
  },
  month: {
    numeric: "M",
    "2-digit": "MM",
    short: "MMM",
    long: "MMMM"
  },
  day: {
    numeric: "d",
    "2-digit": "dd"
  },
  weekday: {
    short: "EEE",
    long: "EEEE"
  },
  dayperiod: "a",
  dayPeriod: "a",
  hour12: {
    numeric: "h",
    "2-digit": "hh"
  },
  hour24: {
    numeric: "H",
    "2-digit": "HH"
  },
  minute: {
    numeric: "m",
    "2-digit": "mm"
  },
  second: {
    numeric: "s",
    "2-digit": "ss"
  },
  timeZoneName: {
    long: "ZZZZZ",
    short: "ZZZ"
  }
};
function tokenForPart(part, formatOpts, resolvedOpts) {
  const {
    type,
    value
  } = part;
  if (type === "literal") {
    const isSpace = /^\s+$/.test(value);
    return {
      literal: !isSpace,
      val: isSpace ? " " : value
    };
  }
  const style = formatOpts[type];

  // The user might have explicitly specified hour12 or hourCycle
  // if so, respect their decision
  // if not, refer back to the resolvedOpts, which are based on the locale
  let actualType = type;
  if (type === "hour") {
    if (formatOpts.hour12 != null) {
      actualType = formatOpts.hour12 ? "hour12" : "hour24";
    } else if (formatOpts.hourCycle != null) {
      if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") {
        actualType = "hour12";
      } else {
        actualType = "hour24";
      }
    } else {
      // tokens only differentiate between 24 hours or not,
      // so we do not need to check hourCycle here, which is less supported anyways
      actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
  }
  let val = partTypeStyleToTokenVal[actualType];
  if (typeof val === "object") {
    val = val[style];
  }
  if (val) {
    return {
      literal: false,
      val
    };
  }
  return undefined;
}
function buildRegex(units) {
  const re = units.map(u => u.regex).reduce((f, r) => `${f}(${r.source})`, "");
  return [`^${re}$`, units];
}
function match(input, regex, handlers) {
  const matches = input.match(regex);
  if (matches) {
    const all = {};
    let matchIndex = 1;
    for (const i in handlers) {
      if (hasOwnProperty(handlers, i)) {
        const h = handlers[i],
          groups = h.groups ? h.groups + 1 : 1;
        if (!h.literal && h.token) {
          all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
        }
        matchIndex += groups;
      }
    }
    return [matches, all];
  } else {
    return [matches, {}];
  }
}
function dateTimeFromMatches(matches) {
  const toField = token => {
    switch (token) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
      case "H":
        return "hour";
      case "d":
        return "day";
      case "o":
        return "ordinal";
      case "L":
      case "M":
        return "month";
      case "y":
        return "year";
      case "E":
      case "c":
        return "weekday";
      case "W":
        return "weekNumber";
      case "k":
        return "weekYear";
      case "q":
        return "quarter";
      default:
        return null;
    }
  };
  let zone = null;
  let specificOffset;
  if (!isUndefined(matches.z)) {
    zone = IANAZone.create(matches.z);
  }
  if (!isUndefined(matches.Z)) {
    if (!zone) {
      zone = new FixedOffsetZone(matches.Z);
    }
    specificOffset = matches.Z;
  }
  if (!isUndefined(matches.q)) {
    matches.M = (matches.q - 1) * 3 + 1;
  }
  if (!isUndefined(matches.h)) {
    if (matches.h < 12 && matches.a === 1) {
      matches.h += 12;
    } else if (matches.h === 12 && matches.a === 0) {
      matches.h = 0;
    }
  }
  if (matches.G === 0 && matches.y) {
    matches.y = -matches.y;
  }
  if (!isUndefined(matches.u)) {
    matches.S = parseMillis(matches.u);
  }
  const vals = Object.keys(matches).reduce((r, k) => {
    const f = toField(k);
    if (f) {
      r[f] = matches[k];
    }
    return r;
  }, {});
  return [vals, zone, specificOffset];
}
let dummyDateTimeCache = null;
function getDummyDateTime() {
  if (!dummyDateTimeCache) {
    dummyDateTimeCache = DateTime.fromMillis(1555555555555);
  }
  return dummyDateTimeCache;
}
function maybeExpandMacroToken(token, locale) {
  if (token.literal) {
    return token;
  }
  const formatOpts = Formatter.macroTokenToFormatOpts(token.val);
  const tokens = formatOptsToTokens(formatOpts, locale);
  if (tokens == null || tokens.includes(undefined)) {
    return token;
  }
  return tokens;
}
function expandMacroTokens(tokens, locale) {
  return Array.prototype.concat(...tokens.map(t => maybeExpandMacroToken(t, locale)));
}

/**
 * @private
 */

class TokenParser {
  constructor(locale, format) {
    this.locale = locale;
    this.format = format;
    this.tokens = expandMacroTokens(Formatter.parseFormat(format), locale);
    this.units = this.tokens.map(t => unitForToken(t, locale));
    this.disqualifyingUnit = this.units.find(t => t.invalidReason);
    if (!this.disqualifyingUnit) {
      const [regexString, handlers] = buildRegex(this.units);
      this.regex = RegExp(regexString, "i");
      this.handlers = handlers;
    }
  }
  explainFromTokens(input) {
    if (!this.isValid) {
      return {
        input,
        tokens: this.tokens,
        invalidReason: this.invalidReason
      };
    } else {
      const [rawMatches, matches] = match(input, this.regex, this.handlers),
        [result, zone, specificOffset] = matches ? dateTimeFromMatches(matches) : [null, null, undefined];
      if (hasOwnProperty(matches, "a") && hasOwnProperty(matches, "H")) {
        throw new ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
      }
      return {
        input,
        tokens: this.tokens,
        regex: this.regex,
        rawMatches,
        matches,
        result,
        zone,
        specificOffset
      };
    }
  }
  get isValid() {
    return !this.disqualifyingUnit;
  }
  get invalidReason() {
    return this.disqualifyingUnit ? this.disqualifyingUnit.invalidReason : null;
  }
}
function explainFromTokens(locale, input, format) {
  const parser = new TokenParser(locale, format);
  return parser.explainFromTokens(input);
}
function parseFromTokens(locale, input, format) {
  const {
    result,
    zone,
    specificOffset,
    invalidReason
  } = explainFromTokens(locale, input, format);
  return [result, zone, specificOffset, invalidReason];
}
function formatOptsToTokens(formatOpts, locale) {
  if (!formatOpts) {
    return null;
  }
  const formatter = Formatter.create(locale, formatOpts);
  const df = formatter.dtFormatter(getDummyDateTime());
  const parts = df.formatToParts();
  const resolvedOpts = df.resolvedOptions();
  return parts.map(p => tokenForPart(p, formatOpts, resolvedOpts));
}

const INVALID = "Invalid DateTime";
const MAX_DATE = 8.64e15;
function unsupportedZone(zone) {
  return new Invalid("unsupported zone", `the zone "${zone.name}" is not supported`);
}

// we cache week data on the DT object and this intermediates the cache
/**
 * @param {DateTime} dt
 */
function possiblyCachedWeekData(dt) {
  if (dt.weekData === null) {
    dt.weekData = gregorianToWeek(dt.c);
  }
  return dt.weekData;
}

/**
 * @param {DateTime} dt
 */
function possiblyCachedLocalWeekData(dt) {
  if (dt.localWeekData === null) {
    dt.localWeekData = gregorianToWeek(dt.c, dt.loc.getMinDaysInFirstWeek(), dt.loc.getStartOfWeek());
  }
  return dt.localWeekData;
}

// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function clone(inst, alts) {
  const current = {
    ts: inst.ts,
    zone: inst.zone,
    c: inst.c,
    o: inst.o,
    loc: inst.loc,
    invalid: inst.invalid
  };
  return new DateTime({
    ...current,
    ...alts,
    old: current
  });
}

// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function fixOffset(localTS, o, tz) {
  // Our UTC time is just a guess because our offset is just a guess
  let utcGuess = localTS - o * 60 * 1000;

  // Test whether the zone matches the offset for this ts
  const o2 = tz.offset(utcGuess);

  // If so, offset didn't change and we're done
  if (o === o2) {
    return [utcGuess, o];
  }

  // If not, change the ts by the difference in the offset
  utcGuess -= (o2 - o) * 60 * 1000;

  // If that gives us the local time we want, we're done
  const o3 = tz.offset(utcGuess);
  if (o2 === o3) {
    return [utcGuess, o2];
  }

  // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
  return [localTS - Math.min(o2, o3) * 60 * 1000, Math.max(o2, o3)];
}

// convert an epoch timestamp into a calendar object with the given offset
function tsToObj(ts, offset) {
  ts += offset * 60 * 1000;
  const d = new Date(ts);
  return {
    year: d.getUTCFullYear(),
    month: d.getUTCMonth() + 1,
    day: d.getUTCDate(),
    hour: d.getUTCHours(),
    minute: d.getUTCMinutes(),
    second: d.getUTCSeconds(),
    millisecond: d.getUTCMilliseconds()
  };
}

// convert a calendar object to a epoch timestamp
function objToTS(obj, offset, zone) {
  return fixOffset(objToLocalTS(obj), offset, zone);
}

// create a new DT instance by adding a duration, adjusting for DSTs
function adjustTime(inst, dur) {
  const oPre = inst.o,
    year = inst.c.year + Math.trunc(dur.years),
    month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3,
    c = {
      ...inst.c,
      year,
      month,
      day: Math.min(inst.c.day, daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    },
    millisToAdd = Duration.fromObject({
      years: dur.years - Math.trunc(dur.years),
      quarters: dur.quarters - Math.trunc(dur.quarters),
      months: dur.months - Math.trunc(dur.months),
      weeks: dur.weeks - Math.trunc(dur.weeks),
      days: dur.days - Math.trunc(dur.days),
      hours: dur.hours,
      minutes: dur.minutes,
      seconds: dur.seconds,
      milliseconds: dur.milliseconds
    }).as("milliseconds"),
    localTS = objToLocalTS(c);
  let [ts, o] = fixOffset(localTS, oPre, inst.zone);
  if (millisToAdd !== 0) {
    ts += millisToAdd;
    // that could have changed the offset by going over a DST, but we want to keep the ts the same
    o = inst.zone.offset(ts);
  }
  return {
    ts,
    o
  };
}

// helper useful in turning the results of parsing into real dates
// by handling the zone options
function parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
  const {
    setZone,
    zone
  } = opts;
  if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
    const interpretationZone = parsedZone || zone,
      inst = DateTime.fromObject(parsed, {
        ...opts,
        zone: interpretationZone,
        specificOffset
      });
    return setZone ? inst : inst.setZone(zone);
  } else {
    return DateTime.invalid(new Invalid("unparsable", `the input "${text}" can't be parsed as ${format}`));
  }
}

// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function toTechFormat(dt, format, allowZ = true) {
  return dt.isValid ? Formatter.create(Locale.create("en-US"), {
    allowZ,
    forceSimple: true
  }).formatDateTimeFromString(dt, format) : null;
}
function toISODate(o, extended) {
  const longFormat = o.c.year > 9999 || o.c.year < 0;
  let c = "";
  if (longFormat && o.c.year >= 0) c += "+";
  c += padStart(o.c.year, longFormat ? 6 : 4);
  if (extended) {
    c += "-";
    c += padStart(o.c.month);
    c += "-";
    c += padStart(o.c.day);
  } else {
    c += padStart(o.c.month);
    c += padStart(o.c.day);
  }
  return c;
}
function toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
  let c = padStart(o.c.hour);
  if (extended) {
    c += ":";
    c += padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
      c += ":";
    }
  } else {
    c += padStart(o.c.minute);
  }
  if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
    c += padStart(o.c.second);
    if (o.c.millisecond !== 0 || !suppressMilliseconds) {
      c += ".";
      c += padStart(o.c.millisecond, 3);
    }
  }
  if (includeOffset) {
    if (o.isOffsetFixed && o.offset === 0 && !extendedZone) {
      c += "Z";
    } else if (o.o < 0) {
      c += "-";
      c += padStart(Math.trunc(-o.o / 60));
      c += ":";
      c += padStart(Math.trunc(-o.o % 60));
    } else {
      c += "+";
      c += padStart(Math.trunc(o.o / 60));
      c += ":";
      c += padStart(Math.trunc(o.o % 60));
    }
  }
  if (extendedZone) {
    c += "[" + o.zone.ianaName + "]";
  }
  return c;
}

// defaults for unspecified units in the supported calendars
const defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  },
  defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  },
  defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
  };

// Units in the supported calendars, sorted by bigness
const orderedUnits = ["year", "month", "day", "hour", "minute", "second", "millisecond"],
  orderedWeekUnits = ["weekYear", "weekNumber", "weekday", "hour", "minute", "second", "millisecond"],
  orderedOrdinalUnits = ["year", "ordinal", "hour", "minute", "second", "millisecond"];

// standardize case and plurality in units
function normalizeUnit(unit) {
  const normalized = {
    year: "year",
    years: "year",
    month: "month",
    months: "month",
    day: "day",
    days: "day",
    hour: "hour",
    hours: "hour",
    minute: "minute",
    minutes: "minute",
    quarter: "quarter",
    quarters: "quarter",
    second: "second",
    seconds: "second",
    millisecond: "millisecond",
    milliseconds: "millisecond",
    weekday: "weekday",
    weekdays: "weekday",
    weeknumber: "weekNumber",
    weeksnumber: "weekNumber",
    weeknumbers: "weekNumber",
    weekyear: "weekYear",
    weekyears: "weekYear",
    ordinal: "ordinal"
  }[unit.toLowerCase()];
  if (!normalized) throw new InvalidUnitError(unit);
  return normalized;
}
function normalizeUnitWithLocalWeeks(unit) {
  switch (unit.toLowerCase()) {
    case "localweekday":
    case "localweekdays":
      return "localWeekday";
    case "localweeknumber":
    case "localweeknumbers":
      return "localWeekNumber";
    case "localweekyear":
    case "localweekyears":
      return "localWeekYear";
    default:
      return normalizeUnit(unit);
  }
}

// cache offsets for zones based on the current timestamp when this function is
// first called. When we are handling a datetime from components like (year,
// month, day, hour) in a time zone, we need a guess about what the timezone
// offset is so that we can convert into a UTC timestamp. One way is to find the
// offset of now in the zone. The actual date may have a different offset (for
// example, if we handle a date in June while we're in December in a zone that
// observes DST), but we can check and adjust that.
//
// When handling many dates, calculating the offset for now every time is
// expensive. It's just a guess, so we can cache the offset to use even if we
// are right on a time change boundary (we'll just correct in the other
// direction). Using a timestamp from first read is a slight optimization for
// handling dates close to the current date, since those dates will usually be
// in the same offset (we could set the timestamp statically, instead). We use a
// single timestamp for all zones to make things a bit more predictable.
//
// This is safe for quickDT (used by local() and utc()) because we don't fill in
// higher-order units from tsNow (as we do in fromObject, this requires that
// offset is calculated from tsNow).
function guessOffsetForZone(zone) {
  if (!zoneOffsetGuessCache[zone]) {
    if (zoneOffsetTs === undefined) {
      zoneOffsetTs = Settings.now();
    }
    zoneOffsetGuessCache[zone] = zone.offset(zoneOffsetTs);
  }
  return zoneOffsetGuessCache[zone];
}

// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function quickDT(obj, opts) {
  const zone = normalizeZone(opts.zone, Settings.defaultZone);
  if (!zone.isValid) {
    return DateTime.invalid(unsupportedZone(zone));
  }
  const loc = Locale.fromObject(opts);
  let ts, o;

  // assume we have the higher-order units
  if (!isUndefined(obj.year)) {
    for (const u of orderedUnits) {
      if (isUndefined(obj[u])) {
        obj[u] = defaultUnitValues[u];
      }
    }
    const invalid = hasInvalidGregorianData(obj) || hasInvalidTimeData(obj);
    if (invalid) {
      return DateTime.invalid(invalid);
    }
    const offsetProvis = guessOffsetForZone(zone);
    [ts, o] = objToTS(obj, offsetProvis, zone);
  } else {
    ts = Settings.now();
  }
  return new DateTime({
    ts,
    zone,
    loc,
    o
  });
}
function diffRelative(start, end, opts) {
  const round = isUndefined(opts.round) ? true : opts.round,
    format = (c, unit) => {
      c = roundTo(c, round || opts.calendary ? 0 : 2, true);
      const formatter = end.loc.clone(opts).relFormatter(opts);
      return formatter.format(c, unit);
    },
    differ = unit => {
      if (opts.calendary) {
        if (!end.hasSame(start, unit)) {
          return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
        } else return 0;
      } else {
        return end.diff(start, unit).get(unit);
      }
    };
  if (opts.unit) {
    return format(differ(opts.unit), opts.unit);
  }
  for (const unit of opts.units) {
    const count = differ(unit);
    if (Math.abs(count) >= 1) {
      return format(count, unit);
    }
  }
  return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function lastOpts(argList) {
  let opts = {},
    args;
  if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
    opts = argList[argList.length - 1];
    args = Array.from(argList).slice(0, argList.length - 1);
  } else {
    args = Array.from(argList);
  }
  return [opts, args];
}

/**
 * Timestamp to use for cached zone offset guesses (exposed for test)
 */
let zoneOffsetTs;
/**
 * Cache for zone offset guesses (exposed for test).
 *
 * This optimizes quickDT via guessOffsetForZone to avoid repeated calls of
 * zone.offset().
 */
let zoneOffsetGuessCache = {};

/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */
class DateTime {
  /**
   * @access private
   */
  constructor(config) {
    const zone = config.zone || Settings.defaultZone;
    let invalid = config.invalid || (Number.isNaN(config.ts) ? new Invalid("invalid input") : null) || (!zone.isValid ? unsupportedZone(zone) : null);
    /**
     * @access private
     */
    this.ts = isUndefined(config.ts) ? Settings.now() : config.ts;
    let c = null,
      o = null;
    if (!invalid) {
      const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
      if (unchanged) {
        [c, o] = [config.old.c, config.old.o];
      } else {
        // If an offset has been passed and we have not been called from
        // clone(), we can trust it and avoid the offset calculation.
        const ot = isNumber(config.o) && !config.old ? config.o : zone.offset(this.ts);
        c = tsToObj(this.ts, ot);
        invalid = Number.isNaN(c.year) ? new Invalid("invalid input") : null;
        c = invalid ? null : c;
        o = invalid ? null : ot;
      }
    }

    /**
     * @access private
     */
    this._zone = zone;
    /**
     * @access private
     */
    this.loc = config.loc || Locale.create();
    /**
     * @access private
     */
    this.invalid = invalid;
    /**
     * @access private
     */
    this.weekData = null;
    /**
     * @access private
     */
    this.localWeekData = null;
    /**
     * @access private
     */
    this.c = c;
    /**
     * @access private
     */
    this.o = o;
    /**
     * @access private
     */
    this.isLuxonDateTime = true;
  }

  // CONSTRUCT

  /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */
  static now() {
    return new DateTime({});
  }

  /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */
  static local() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;
    return quickDT({
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond
    }, opts);
  }

  /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [options.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */
  static utc() {
    const [opts, args] = lastOpts(arguments),
      [year, month, day, hour, minute, second, millisecond] = args;
    opts.zone = FixedOffsetZone.utcInstance;
    return quickDT({
      year,
      month,
      day,
      hour,
      minute,
      second,
      millisecond
    }, opts);
  }

  /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */
  static fromJSDate(date, options = {}) {
    const ts = isDate(date) ? date.valueOf() : NaN;
    if (Number.isNaN(ts)) {
      return DateTime.invalid("invalid input");
    }
    const zoneToUse = normalizeZone(options.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    return new DateTime({
      ts: ts,
      zone: zoneToUse,
      loc: Locale.fromObject(options)
    });
  }

  /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromMillis(milliseconds, options = {}) {
    if (!isNumber(milliseconds)) {
      throw new InvalidArgumentError(`fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`);
    } else if (milliseconds < -MAX_DATE || milliseconds > MAX_DATE) {
      // this isn't perfect because we can still end up out of range because of additional shifting, but it's a start
      return DateTime.invalid("Timestamp out of range");
    } else {
      return new DateTime({
        ts: milliseconds,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }

  /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} options.weekSettings - the week settings to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromSeconds(seconds, options = {}) {
    if (!isNumber(seconds)) {
      throw new InvalidArgumentError("fromSeconds requires a numerical input");
    } else {
      return new DateTime({
        ts: seconds * 1000,
        zone: normalizeZone(options.zone, Settings.defaultZone),
        loc: Locale.fromObject(options)
      });
    }
  }

  /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.localWeekYear - a week year, according to the locale
   * @param {number} obj.localWeekNumber - a week number, between 1 and 52 or 53, depending on the year, according to the locale
   * @param {number} obj.localWeekday - a weekday, 1-7, where 1 is the first and 7 is the last day of the week, according to the locale
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system\'s locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @example DateTime.fromObject({ localWeekYear: 2022, localWeekNumber: 1, localWeekday: 1 }, { locale: "en-US" }).toISODate() //=> '2021-12-26'
   * @return {DateTime}
   */
  static fromObject(obj, opts = {}) {
    obj = obj || {};
    const zoneToUse = normalizeZone(opts.zone, Settings.defaultZone);
    if (!zoneToUse.isValid) {
      return DateTime.invalid(unsupportedZone(zoneToUse));
    }
    const loc = Locale.fromObject(opts);
    const normalized = normalizeObject(obj, normalizeUnitWithLocalWeeks);
    const {
      minDaysInFirstWeek,
      startOfWeek
    } = usesLocalWeekValues(normalized, loc);
    const tsNow = Settings.now(),
      offsetProvis = !isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;

    // cases:
    // just a weekday -> this week's instance of that weekday, no worries
    // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
    // (gregorian month or day) + ordinal -> error
    // otherwise just use weeks or ordinals or gregorian, depending on what's specified

    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;

    // configure ourselves to deal with gregorian dates or week stuff
    let units,
      defaultValues,
      objNow = tsToObj(tsNow, offsetProvis);
    if (useWeekData) {
      units = orderedWeekUnits;
      defaultValues = defaultWeekUnitValues;
      objNow = gregorianToWeek(objNow, minDaysInFirstWeek, startOfWeek);
    } else if (containsOrdinal) {
      units = orderedOrdinalUnits;
      defaultValues = defaultOrdinalUnitValues;
      objNow = gregorianToOrdinal(objNow);
    } else {
      units = orderedUnits;
      defaultValues = defaultUnitValues;
    }

    // set default values for missing stuff
    let foundFirst = false;
    for (const u of units) {
      const v = normalized[u];
      if (!isUndefined(v)) {
        foundFirst = true;
      } else if (foundFirst) {
        normalized[u] = defaultValues[u];
      } else {
        normalized[u] = objNow[u];
      }
    }

    // make sure the values we have are in range
    const higherOrderInvalid = useWeekData ? hasInvalidWeekData(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? hasInvalidOrdinalData(normalized) : hasInvalidGregorianData(normalized),
      invalid = higherOrderInvalid || hasInvalidTimeData(normalized);
    if (invalid) {
      return DateTime.invalid(invalid);
    }

    // compute the actual time
    const gregorian = useWeekData ? weekToGregorian(normalized, minDaysInFirstWeek, startOfWeek) : containsOrdinal ? ordinalToGregorian(normalized) : normalized,
      [tsFinal, offsetFinal] = objToTS(gregorian, offsetProvis, zoneToUse),
      inst = new DateTime({
        ts: tsFinal,
        zone: zoneToUse,
        o: offsetFinal,
        loc
      });

    // gregorian data + weekday serves only to validate
    if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) {
      return DateTime.invalid("mismatched weekday", `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`);
    }
    if (!inst.isValid) {
      return DateTime.invalid(inst.invalid);
    }
    return inst;
  }

  /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @param {string} [opts.weekSettings] - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */
  static fromISO(text, opts = {}) {
    const [vals, parsedZone] = parseISODate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
  }

  /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */
  static fromRFC2822(text, opts = {}) {
    const [vals, parsedZone] = parseRFC2822Date(text);
    return parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
  }

  /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */
  static fromHTTP(text, opts = {}) {
    const [vals, parsedZone] = parseHTTPDate(text);
    return parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
  }

  /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */
  static fromFormat(text, fmt, opts = {}) {
    if (isUndefined(text) || isUndefined(fmt)) {
      throw new InvalidArgumentError("fromFormat requires an input string and a format");
    }
    const {
        locale = null,
        numberingSystem = null
      } = opts,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true
      }),
      [vals, parsedZone, specificOffset, invalid] = parseFromTokens(localeToUse, text, fmt);
    if (invalid) {
      return DateTime.invalid(invalid);
    } else {
      return parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
  }

  /**
   * @deprecated use fromFormat instead
   */
  static fromString(text, fmt, opts = {}) {
    return DateTime.fromFormat(text, fmt, opts);
  }

  /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.weekSettings - the week settings to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */
  static fromSQL(text, opts = {}) {
    const [vals, parsedZone] = parseSQL(text);
    return parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
  }

  /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */
  static invalid(reason, explanation = null) {
    if (!reason) {
      throw new InvalidArgumentError("need to specify a reason the DateTime is invalid");
    }
    const invalid = reason instanceof Invalid ? reason : new Invalid(reason, explanation);
    if (Settings.throwOnInvalid) {
      throw new InvalidDateTimeError(invalid);
    } else {
      return new DateTime({
        invalid
      });
    }
  }

  /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */
  static isDateTime(o) {
    return o && o.isLuxonDateTime || false;
  }

  /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */
  static parseFormatForOpts(formatOpts, localeOpts = {}) {
    const tokenList = formatOptsToTokens(formatOpts, Locale.fromObject(localeOpts));
    return !tokenList ? null : tokenList.map(t => t ? t.val : null).join("");
  }

  /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */
  static expandFormat(fmt, localeOpts = {}) {
    const expanded = expandMacroTokens(Formatter.parseFormat(fmt), Locale.fromObject(localeOpts));
    return expanded.map(t => t.val).join("");
  }
  static resetCache() {
    zoneOffsetTs = undefined;
    zoneOffsetGuessCache = {};
  }

  // INFO

  /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */
  get(unit) {
    return this[unit];
  }

  /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */
  get isValid() {
    return this.invalid === null;
  }

  /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidReason() {
    return this.invalid ? this.invalid.reason : null;
  }

  /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */
  get invalidExplanation() {
    return this.invalid ? this.invalid.explanation : null;
  }

  /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */
  get locale() {
    return this.isValid ? this.loc.locale : null;
  }

  /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */
  get numberingSystem() {
    return this.isValid ? this.loc.numberingSystem : null;
  }

  /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */
  get outputCalendar() {
    return this.isValid ? this.loc.outputCalendar : null;
  }

  /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */
  get zone() {
    return this._zone;
  }

  /**
   * Get the name of the time zone.
   * @type {string}
   */
  get zoneName() {
    return this.isValid ? this.zone.name : null;
  }

  /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */
  get year() {
    return this.isValid ? this.c.year : NaN;
  }

  /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */
  get quarter() {
    return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
  }

  /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */
  get month() {
    return this.isValid ? this.c.month : NaN;
  }

  /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */
  get day() {
    return this.isValid ? this.c.day : NaN;
  }

  /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */
  get hour() {
    return this.isValid ? this.c.hour : NaN;
  }

  /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */
  get minute() {
    return this.isValid ? this.c.minute : NaN;
  }

  /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */
  get second() {
    return this.isValid ? this.c.second : NaN;
  }

  /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */
  get millisecond() {
    return this.isValid ? this.c.millisecond : NaN;
  }

  /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */
  get weekYear() {
    return this.isValid ? possiblyCachedWeekData(this).weekYear : NaN;
  }

  /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */
  get weekNumber() {
    return this.isValid ? possiblyCachedWeekData(this).weekNumber : NaN;
  }

  /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */
  get weekday() {
    return this.isValid ? possiblyCachedWeekData(this).weekday : NaN;
  }

  /**
   * Returns true if this date is on a weekend according to the locale, false otherwise
   * @returns {boolean}
   */
  get isWeekend() {
    return this.isValid && this.loc.getWeekendDays().includes(this.weekday);
  }

  /**
   * Get the day of the week according to the locale.
   * 1 is the first day of the week and 7 is the last day of the week.
   * If the locale assigns Sunday as the first day of the week, then a date which is a Sunday will return 1,
   * @returns {number}
   */
  get localWeekday() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekday : NaN;
  }

  /**
   * Get the week number of the week year according to the locale. Different locales assign week numbers differently,
   * because the week can start on different days of the week (see localWeekday) and because a different number of days
   * is required for a week to count as the first week of a year.
   * @returns {number}
   */
  get localWeekNumber() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekNumber : NaN;
  }

  /**
   * Get the week year according to the locale. Different locales assign week numbers (and therefor week years)
   * differently, see localWeekNumber.
   * @returns {number}
   */
  get localWeekYear() {
    return this.isValid ? possiblyCachedLocalWeekData(this).weekYear : NaN;
  }

  /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */
  get ordinal() {
    return this.isValid ? gregorianToOrdinal(this.c).ordinal : NaN;
  }

  /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */
  get monthShort() {
    return this.isValid ? Info.months("short", {
      locObj: this.loc
    })[this.month - 1] : null;
  }

  /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */
  get monthLong() {
    return this.isValid ? Info.months("long", {
      locObj: this.loc
    })[this.month - 1] : null;
  }

  /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */
  get weekdayShort() {
    return this.isValid ? Info.weekdays("short", {
      locObj: this.loc
    })[this.weekday - 1] : null;
  }

  /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */
  get weekdayLong() {
    return this.isValid ? Info.weekdays("long", {
      locObj: this.loc
    })[this.weekday - 1] : null;
  }

  /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */
  get offset() {
    return this.isValid ? +this.o : NaN;
  }

  /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameShort() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "short",
        locale: this.locale
      });
    } else {
      return null;
    }
  }

  /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */
  get offsetNameLong() {
    if (this.isValid) {
      return this.zone.offsetName(this.ts, {
        format: "long",
        locale: this.locale
      });
    } else {
      return null;
    }
  }

  /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */
  get isOffsetFixed() {
    return this.isValid ? this.zone.isUniversal : null;
  }

  /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */
  get isInDST() {
    if (this.isOffsetFixed) {
      return false;
    } else {
      return this.offset > this.set({
        month: 1,
        day: 1
      }).offset || this.offset > this.set({
        month: 5
      }).offset;
    }
  }

  /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */
  getPossibleOffsets() {
    if (!this.isValid || this.isOffsetFixed) {
      return [this];
    }
    const dayMs = 86400000;
    const minuteMs = 60000;
    const localTS = objToLocalTS(this.c);
    const oEarlier = this.zone.offset(localTS - dayMs);
    const oLater = this.zone.offset(localTS + dayMs);
    const o1 = this.zone.offset(localTS - oEarlier * minuteMs);
    const o2 = this.zone.offset(localTS - oLater * minuteMs);
    if (o1 === o2) {
      return [this];
    }
    const ts1 = localTS - o1 * minuteMs;
    const ts2 = localTS - o2 * minuteMs;
    const c1 = tsToObj(ts1, o1);
    const c2 = tsToObj(ts2, o2);
    if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) {
      return [clone(this, {
        ts: ts1
      }), clone(this, {
        ts: ts2
      })];
    }
    return [this];
  }

  /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */
  get isInLeapYear() {
    return isLeapYear(this.year);
  }

  /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */
  get daysInMonth() {
    return daysInMonth(this.year, this.month);
  }

  /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */
  get daysInYear() {
    return this.isValid ? daysInYear(this.year) : NaN;
  }

  /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */
  get weeksInWeekYear() {
    return this.isValid ? weeksInWeekYear(this.weekYear) : NaN;
  }

  /**
   * Returns the number of weeks in this DateTime's local week year
   * @example DateTime.local(2020, 6, {locale: 'en-US'}).weeksInLocalWeekYear //=> 52
   * @example DateTime.local(2020, 6, {locale: 'de-DE'}).weeksInLocalWeekYear //=> 53
   * @type {number}
   */
  get weeksInLocalWeekYear() {
    return this.isValid ? weeksInWeekYear(this.localWeekYear, this.loc.getMinDaysInFirstWeek(), this.loc.getStartOfWeek()) : NaN;
  }

  /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */
  resolvedLocaleOptions(opts = {}) {
    const {
      locale,
      numberingSystem,
      calendar
    } = Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this);
    return {
      locale,
      numberingSystem,
      outputCalendar: calendar
    };
  }

  // TRANSFORM

  /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */
  toUTC(offset = 0, opts = {}) {
    return this.setZone(FixedOffsetZone.instance(offset), opts);
  }

  /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */
  toLocal() {
    return this.setZone(Settings.defaultZone);
  }

  /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */
  setZone(zone, {
    keepLocalTime = false,
    keepCalendarTime = false
  } = {}) {
    zone = normalizeZone(zone, Settings.defaultZone);
    if (zone.equals(this.zone)) {
      return this;
    } else if (!zone.isValid) {
      return DateTime.invalid(unsupportedZone(zone));
    } else {
      let newTS = this.ts;
      if (keepLocalTime || keepCalendarTime) {
        const offsetGuess = zone.offset(this.ts);
        const asObj = this.toObject();
        [newTS] = objToTS(asObj, offsetGuess, zone);
      }
      return clone(this, {
        ts: newTS,
        zone
      });
    }
  }

  /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */
  reconfigure({
    locale,
    numberingSystem,
    outputCalendar
  } = {}) {
    const loc = this.loc.clone({
      locale,
      numberingSystem,
      outputCalendar
    });
    return clone(this, {
      loc
    });
  }

  /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */
  setLocale(locale) {
    return this.reconfigure({
      locale
    });
  }

  /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   *
   * This method also supports setting locale-based week units, i.e. `localWeekday`, `localWeekNumber` and `localWeekYear`.
   * They cannot be mixed with ISO-week units like `weekday`.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */
  set(values) {
    if (!this.isValid) return this;
    const normalized = normalizeObject(values, normalizeUnitWithLocalWeeks);
    const {
      minDaysInFirstWeek,
      startOfWeek
    } = usesLocalWeekValues(normalized, this.loc);
    const settingWeekStuff = !isUndefined(normalized.weekYear) || !isUndefined(normalized.weekNumber) || !isUndefined(normalized.weekday),
      containsOrdinal = !isUndefined(normalized.ordinal),
      containsGregorYear = !isUndefined(normalized.year),
      containsGregorMD = !isUndefined(normalized.month) || !isUndefined(normalized.day),
      containsGregor = containsGregorYear || containsGregorMD,
      definiteWeekDef = normalized.weekYear || normalized.weekNumber;
    if ((containsGregor || containsOrdinal) && definiteWeekDef) {
      throw new ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
    }
    if (containsGregorMD && containsOrdinal) {
      throw new ConflictingSpecificationError("Can't mix ordinal dates with month/day");
    }
    let mixed;
    if (settingWeekStuff) {
      mixed = weekToGregorian({
        ...gregorianToWeek(this.c, minDaysInFirstWeek, startOfWeek),
        ...normalized
      }, minDaysInFirstWeek, startOfWeek);
    } else if (!isUndefined(normalized.ordinal)) {
      mixed = ordinalToGregorian({
        ...gregorianToOrdinal(this.c),
        ...normalized
      });
    } else {
      mixed = {
        ...this.toObject(),
        ...normalized
      };

      // if we didn't set the day but we ended up on an overflow date,
      // use the last day of the right month
      if (isUndefined(normalized.day)) {
        mixed.day = Math.min(daysInMonth(mixed.year, mixed.month), mixed.day);
      }
    }
    const [ts, o] = objToTS(mixed, this.o, this.zone);
    return clone(this, {
      ts,
      o
    });
  }

  /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */
  plus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration);
    return clone(this, adjustTime(this, dur));
  }

  /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */
  minus(duration) {
    if (!this.isValid) return this;
    const dur = Duration.fromDurationLike(duration).negate();
    return clone(this, adjustTime(this, dur));
  }

  /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */
  startOf(unit, {
    useLocaleWeeks = false
  } = {}) {
    if (!this.isValid) return this;
    const o = {},
      normalizedUnit = Duration.normalizeUnit(unit);
    switch (normalizedUnit) {
      case "years":
        o.month = 1;
      // falls through
      case "quarters":
      case "months":
        o.day = 1;
      // falls through
      case "weeks":
      case "days":
        o.hour = 0;
      // falls through
      case "hours":
        o.minute = 0;
      // falls through
      case "minutes":
        o.second = 0;
      // falls through
      case "seconds":
        o.millisecond = 0;
        break;
      // no default, invalid units throw in normalizeUnit()
    }

    if (normalizedUnit === "weeks") {
      if (useLocaleWeeks) {
        const startOfWeek = this.loc.getStartOfWeek();
        const {
          weekday
        } = this;
        if (weekday < startOfWeek) {
          o.weekNumber = this.weekNumber - 1;
        }
        o.weekday = startOfWeek;
      } else {
        o.weekday = 1;
      }
    }
    if (normalizedUnit === "quarters") {
      const q = Math.ceil(this.month / 3);
      o.month = (q - 1) * 3 + 1;
    }
    return this.set(o);
  }

  /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */
  endOf(unit, opts) {
    return this.isValid ? this.plus({
      [unit]: 1
    }).startOf(unit, opts).minus(1) : this;
  }

  // OUTPUT

  /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */
  toFormat(fmt, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : INVALID;
  }

  /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */
  toLocaleString(formatOpts = DATE_SHORT, opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : INVALID;
  }

  /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */
  toLocaleParts(opts = {}) {
    return this.isValid ? Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */
  toISO({
    format = "extended",
    suppressSeconds = false,
    suppressMilliseconds = false,
    includeOffset = true,
    extendedZone = false
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    const ext = format === "extended";
    let c = toISODate(this, ext);
    c += "T";
    c += toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    return c;
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */
  toISODate({
    format = "extended"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, format === "extended");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */
  toISOWeekDate() {
    return toTechFormat(this, "kkkk-'W'WW-c");
  }

  /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */
  toISOTime({
    suppressMilliseconds = false,
    suppressSeconds = false,
    includeOffset = true,
    includePrefix = false,
    extendedZone = false,
    format = "extended"
  } = {}) {
    if (!this.isValid) {
      return null;
    }
    let c = includePrefix ? "T" : "";
    return c + toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
  }

  /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */
  toRFC2822() {
    return toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */
  toHTTP() {
    return toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */
  toSQLDate() {
    if (!this.isValid) {
      return null;
    }
    return toISODate(this, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */
  toSQLTime({
    includeOffset = true,
    includeZone = false,
    includeOffsetSpace = true
  } = {}) {
    let fmt = "HH:mm:ss.SSS";
    if (includeZone || includeOffset) {
      if (includeOffsetSpace) {
        fmt += " ";
      }
      if (includeZone) {
        fmt += "z";
      } else if (includeOffset) {
        fmt += "ZZ";
      }
    }
    return toTechFormat(this, fmt, true);
  }

  /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */
  toSQL(opts = {}) {
    if (!this.isValid) {
      return null;
    }
    return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
  }

  /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */
  toString() {
    return this.isValid ? this.toISO() : INVALID;
  }

  /**
   * Returns a string representation of this DateTime appropriate for the REPL.
   * @return {string}
   */
  [Symbol.for("nodejs.util.inspect.custom")]() {
    if (this.isValid) {
      return `DateTime { ts: ${this.toISO()}, zone: ${this.zone.name}, locale: ${this.locale} }`;
    } else {
      return `DateTime { Invalid, reason: ${this.invalidReason} }`;
    }
  }

  /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */
  valueOf() {
    return this.toMillis();
  }

  /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */
  toMillis() {
    return this.isValid ? this.ts : NaN;
  }

  /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */
  toSeconds() {
    return this.isValid ? this.ts / 1000 : NaN;
  }

  /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */
  toUnixInteger() {
    return this.isValid ? Math.floor(this.ts / 1000) : NaN;
  }

  /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */
  toJSON() {
    return this.toISO();
  }

  /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */
  toBSON() {
    return this.toJSDate();
  }

  /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */
  toObject(opts = {}) {
    if (!this.isValid) return {};
    const base = {
      ...this.c
    };
    if (opts.includeConfig) {
      base.outputCalendar = this.outputCalendar;
      base.numberingSystem = this.loc.numberingSystem;
      base.locale = this.loc.locale;
    }
    return base;
  }

  /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */
  toJSDate() {
    return new Date(this.isValid ? this.ts : NaN);
  }

  // COMPARE

  /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */
  diff(otherDateTime, unit = "milliseconds", opts = {}) {
    if (!this.isValid || !otherDateTime.isValid) {
      return Duration.invalid("created by diffing an invalid DateTime");
    }
    const durOpts = {
      locale: this.locale,
      numberingSystem: this.numberingSystem,
      ...opts
    };
    const units = maybeArray(unit).map(Duration.normalizeUnit),
      otherIsLater = otherDateTime.valueOf() > this.valueOf(),
      earlier = otherIsLater ? this : otherDateTime,
      later = otherIsLater ? otherDateTime : this,
      diffed = diff(earlier, later, units, durOpts);
    return otherIsLater ? diffed.negate() : diffed;
  }

  /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */
  diffNow(unit = "milliseconds", opts = {}) {
    return this.diff(DateTime.now(), unit, opts);
  }

  /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */
  until(otherDateTime) {
    return this.isValid ? Interval.fromDateTimes(this, otherDateTime) : this;
  }

  /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @param {Object} opts - options
   * @param {boolean} [opts.useLocaleWeeks=false] - If true, use weeks based on the locale, i.e. use the locale-dependent start of the week; only the locale of this DateTime is used
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */
  hasSame(otherDateTime, unit, opts) {
    if (!this.isValid) return false;
    const inputMs = otherDateTime.valueOf();
    const adjustedToZone = this.setZone(otherDateTime.zone, {
      keepLocalTime: true
    });
    return adjustedToZone.startOf(unit, opts) <= inputMs && inputMs <= adjustedToZone.endOf(unit, opts);
  }

  /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */
  equals(other) {
    return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
  }

  /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */
  toRelative(options = {}) {
    if (!this.isValid) return null;
    const base = options.base || DateTime.fromObject({}, {
        zone: this.zone
      }),
      padding = options.padding ? this < base ? -options.padding : options.padding : 0;
    let units = ["years", "months", "days", "hours", "minutes", "seconds"];
    let unit = options.unit;
    if (Array.isArray(options.unit)) {
      units = options.unit;
      unit = undefined;
    }
    return diffRelative(base, this.plus(padding), {
      ...options,
      numeric: "always",
      units,
      unit
    });
  }

  /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */
  toRelativeCalendar(options = {}) {
    if (!this.isValid) return null;
    return diffRelative(options.base || DateTime.fromObject({}, {
      zone: this.zone
    }), this, {
      ...options,
      numeric: "auto",
      units: ["years", "months", "days"],
      calendary: true
    });
  }

  /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */
  static min(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("min requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, i => i.valueOf(), Math.min);
  }

  /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */
  static max(...dateTimes) {
    if (!dateTimes.every(DateTime.isDateTime)) {
      throw new InvalidArgumentError("max requires all arguments be DateTimes");
    }
    return bestBy(dateTimes, i => i.valueOf(), Math.max);
  }

  // MISC

  /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */
  static fromFormatExplain(text, fmt, options = {}) {
    const {
        locale = null,
        numberingSystem = null
      } = options,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true
      });
    return explainFromTokens(localeToUse, text, fmt);
  }

  /**
   * @deprecated use fromFormatExplain instead
   */
  static fromStringExplain(text, fmt, options = {}) {
    return DateTime.fromFormatExplain(text, fmt, options);
  }

  /**
   * Build a parser for `fmt` using the given locale. This parser can be passed
   * to {@link DateTime.fromFormatParser} to a parse a date in this format. This
   * can be used to optimize cases where many dates need to be parsed in a
   * specific format.
   *
   * @param {String} fmt - the format the string is expected to be in (see
   * description)
   * @param {Object} options - options used to set locale and numberingSystem
   * for parser
   * @returns {TokenParser} - opaque object to be used
   */
  static buildFormatParser(fmt, options = {}) {
    const {
        locale = null,
        numberingSystem = null
      } = options,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true
      });
    return new TokenParser(localeToUse, fmt);
  }

  /**
   * Create a DateTime from an input string and format parser.
   *
   * The format parser must have been created with the same locale as this call.
   *
   * @param {String} text - the string to parse
   * @param {TokenParser} formatParser - parser from {@link DateTime.buildFormatParser}
   * @param {Object} opts - options taken by fromFormat()
   * @returns {DateTime}
   */
  static fromFormatParser(text, formatParser, opts = {}) {
    if (isUndefined(text) || isUndefined(formatParser)) {
      throw new InvalidArgumentError("fromFormatParser requires an input string and a format parser");
    }
    const {
        locale = null,
        numberingSystem = null
      } = opts,
      localeToUse = Locale.fromOpts({
        locale,
        numberingSystem,
        defaultToEN: true
      });
    if (!localeToUse.equals(formatParser.locale)) {
      throw new InvalidArgumentError(`fromFormatParser called with a locale of ${localeToUse}, ` + `but the format parser was created for ${formatParser.locale}`);
    }
    const {
      result,
      zone,
      specificOffset,
      invalidReason
    } = formatParser.explainFromTokens(text);
    if (invalidReason) {
      return DateTime.invalid(invalidReason);
    } else {
      return parseDataToDateTime(result, zone, opts, `format ${formatParser.format}`, text, specificOffset);
    }
  }

  // FORMAT PRESETS

  /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */
  static get DATE_SHORT() {
    return DATE_SHORT;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED() {
    return DATE_MED;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */
  static get DATE_MED_WITH_WEEKDAY() {
    return DATE_MED_WITH_WEEKDAY;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */
  static get DATE_FULL() {
    return DATE_FULL;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */
  static get DATE_HUGE() {
    return DATE_HUGE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_SIMPLE() {
    return TIME_SIMPLE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SECONDS() {
    return TIME_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_SHORT_OFFSET() {
    return TIME_WITH_SHORT_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get TIME_WITH_LONG_OFFSET() {
    return TIME_WITH_LONG_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_SIMPLE() {
    return TIME_24_SIMPLE;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SECONDS() {
    return TIME_24_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_SHORT_OFFSET() {
    return TIME_24_WITH_SHORT_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */
  static get TIME_24_WITH_LONG_OFFSET() {
    return TIME_24_WITH_LONG_OFFSET;
  }

  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT() {
    return DATETIME_SHORT;
  }

  /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_SHORT_WITH_SECONDS() {
    return DATETIME_SHORT_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED() {
    return DATETIME_MED;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_SECONDS() {
    return DATETIME_MED_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_MED_WITH_WEEKDAY() {
    return DATETIME_MED_WITH_WEEKDAY;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL() {
    return DATETIME_FULL;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_FULL_WITH_SECONDS() {
    return DATETIME_FULL_WITH_SECONDS;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE() {
    return DATETIME_HUGE;
  }

  /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */
  static get DATETIME_HUGE_WITH_SECONDS() {
    return DATETIME_HUGE_WITH_SECONDS;
  }
}

/**
 * @private
 */
function friendlyDateTime(dateTimeish) {
  if (DateTime.isDateTime(dateTimeish)) {
    return dateTimeish;
  } else if (dateTimeish && dateTimeish.valueOf && isNumber(dateTimeish.valueOf())) {
    return DateTime.fromJSDate(dateTimeish);
  } else if (dateTimeish && typeof dateTimeish === "object") {
    return DateTime.fromObject(dateTimeish);
  } else {
    throw new InvalidArgumentError(`Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`);
  }
}

const VERSION = "3.5.0";

exports.DateTime = DateTime;
exports.Duration = Duration;
exports.FixedOffsetZone = FixedOffsetZone;
exports.IANAZone = IANAZone;
exports.Info = Info;
exports.Interval = Interval;
exports.InvalidZone = InvalidZone;
exports.Settings = Settings;
exports.SystemZone = SystemZone;
exports.VERSION = VERSION;
exports.Zone = Zone;


/***/ }),

/***/ "../node_modules/object-assign/index.js":
/*!**********************************************!*\
  !*** ../node_modules/object-assign/index.js ***!
  \**********************************************/
/***/ ((module) => {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ "../node_modules/query-string/index.js":
/*!*********************************************!*\
  !*** ../node_modules/query-string/index.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


const strictUriEncode = __webpack_require__(/*! strict-uri-encode */ "../node_modules/strict-uri-encode/index.js");
const decodeComponent = __webpack_require__(/*! decode-uri-component */ "../node_modules/decode-uri-component/index.js");
const splitOnFirst = __webpack_require__(/*! split-on-first */ "../node_modules/split-on-first/index.js");
const filterObject = __webpack_require__(/*! filter-obj */ "../node_modules/filter-obj/index.js");

const isNullOrUndefined = value => value === null || value === undefined;

const encodeFragmentIdentifier = Symbol('encodeFragmentIdentifier');

function encoderForArrayFormat(options) {
	switch (options.arrayFormat) {
		case 'index':
			return key => (result, value) => {
				const index = result.length;

				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[', index, ']'].join('')];
				}

				return [
					...result,
					[encode(key, options), '[', encode(index, options), ']=', encode(value, options)].join('')
				];
			};

		case 'bracket':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), '[]'].join('')];
				}

				return [...result, [encode(key, options), '[]=', encode(value, options)].join('')];
			};

		case 'colon-list-separator':
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, [encode(key, options), ':list='].join('')];
				}

				return [...result, [encode(key, options), ':list=', encode(value, options)].join('')];
			};

		case 'comma':
		case 'separator':
		case 'bracket-separator': {
			const keyValueSep = options.arrayFormat === 'bracket-separator' ?
				'[]=' :
				'=';

			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				// Translate null to an empty string so that it doesn't serialize as 'null'
				value = value === null ? '' : value;

				if (result.length === 0) {
					return [[encode(key, options), keyValueSep, encode(value, options)].join('')];
				}

				return [[result, encode(value, options)].join(options.arrayFormatSeparator)];
			};
		}

		default:
			return key => (result, value) => {
				if (
					value === undefined ||
					(options.skipNull && value === null) ||
					(options.skipEmptyString && value === '')
				) {
					return result;
				}

				if (value === null) {
					return [...result, encode(key, options)];
				}

				return [...result, [encode(key, options), '=', encode(value, options)].join('')];
			};
	}
}

function parserForArrayFormat(options) {
	let result;

	switch (options.arrayFormat) {
		case 'index':
			return (key, value, accumulator) => {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return (key, value, accumulator) => {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'colon-list-separator':
			return (key, value, accumulator) => {
				result = /(:list)$/.exec(key);
				key = key.replace(/:list$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		case 'comma':
		case 'separator':
			return (key, value, accumulator) => {
				const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
				const isEncodedArray = (typeof value === 'string' && !isArray && decode(value, options).includes(options.arrayFormatSeparator));
				value = isEncodedArray ? decode(value, options) : value;
				const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map(item => decode(item, options)) : value === null ? value : decode(value, options);
				accumulator[key] = newValue;
			};

		case 'bracket-separator':
			return (key, value, accumulator) => {
				const isArray = /(\[\])$/.test(key);
				key = key.replace(/\[\]$/, '');

				if (!isArray) {
					accumulator[key] = value ? decode(value, options) : value;
					return;
				}

				const arrayValue = value === null ?
					[] :
					value.split(options.arrayFormatSeparator).map(item => decode(item, options));

				if (accumulator[key] === undefined) {
					accumulator[key] = arrayValue;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], arrayValue);
			};

		default:
			return (key, value, accumulator) => {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function validateArrayFormatSeparator(value) {
	if (typeof value !== 'string' || value.length !== 1) {
		throw new TypeError('arrayFormatSeparator must be single character string');
	}
}

function encode(value, options) {
	if (options.encode) {
		return options.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function decode(value, options) {
	if (options.decode) {
		return decodeComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	}

	if (typeof input === 'object') {
		return keysSorter(Object.keys(input))
			.sort((a, b) => Number(a) - Number(b))
			.map(key => input[key]);
	}

	return input;
}

function removeHash(input) {
	const hashStart = input.indexOf('#');
	if (hashStart !== -1) {
		input = input.slice(0, hashStart);
	}

	return input;
}

function getHash(url) {
	let hash = '';
	const hashStart = url.indexOf('#');
	if (hashStart !== -1) {
		hash = url.slice(hashStart);
	}

	return hash;
}

function extract(input) {
	input = removeHash(input);
	const queryStart = input.indexOf('?');
	if (queryStart === -1) {
		return '';
	}

	return input.slice(queryStart + 1);
}

function parseValue(value, options) {
	if (options.parseNumbers && !Number.isNaN(Number(value)) && (typeof value === 'string' && value.trim() !== '')) {
		value = Number(value);
	} else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) {
		value = value.toLowerCase() === 'true';
	}

	return value;
}

function parse(query, options) {
	options = Object.assign({
		decode: true,
		sort: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ',',
		parseNumbers: false,
		parseBooleans: false
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const formatter = parserForArrayFormat(options);

	// Create an object with no prototype
	const ret = Object.create(null);

	if (typeof query !== 'string') {
		return ret;
	}

	query = query.trim().replace(/^[?#&]/, '');

	if (!query) {
		return ret;
	}

	for (const param of query.split('&')) {
		if (param === '') {
			continue;
		}

		let [key, value] = splitOnFirst(options.decode ? param.replace(/\+/g, ' ') : param, '=');

		// Missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		value = value === undefined ? null : ['comma', 'separator', 'bracket-separator'].includes(options.arrayFormat) ? value : decode(value, options);
		formatter(decode(key, options), value, ret);
	}

	for (const key of Object.keys(ret)) {
		const value = ret[key];
		if (typeof value === 'object' && value !== null) {
			for (const k of Object.keys(value)) {
				value[k] = parseValue(value[k], options);
			}
		} else {
			ret[key] = parseValue(value, options);
		}
	}

	if (options.sort === false) {
		return ret;
	}

	return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key) => {
		const value = ret[key];
		if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) {
			// Sort object keys, not values
			result[key] = keysSorter(value);
		} else {
			result[key] = value;
		}

		return result;
	}, Object.create(null));
}

exports.extract = extract;
exports.parse = parse;

exports.stringify = (object, options) => {
	if (!object) {
		return '';
	}

	options = Object.assign({
		encode: true,
		strict: true,
		arrayFormat: 'none',
		arrayFormatSeparator: ','
	}, options);

	validateArrayFormatSeparator(options.arrayFormatSeparator);

	const shouldFilter = key => (
		(options.skipNull && isNullOrUndefined(object[key])) ||
		(options.skipEmptyString && object[key] === '')
	);

	const formatter = encoderForArrayFormat(options);

	const objectCopy = {};

	for (const key of Object.keys(object)) {
		if (!shouldFilter(key)) {
			objectCopy[key] = object[key];
		}
	}

	const keys = Object.keys(objectCopy);

	if (options.sort !== false) {
		keys.sort(options.sort);
	}

	return keys.map(key => {
		const value = object[key];

		if (value === undefined) {
			return '';
		}

		if (value === null) {
			return encode(key, options);
		}

		if (Array.isArray(value)) {
			if (value.length === 0 && options.arrayFormat === 'bracket-separator') {
				return encode(key, options) + '[]';
			}

			return value
				.reduce(formatter(key), [])
				.join('&');
		}

		return encode(key, options) + '=' + encode(value, options);
	}).filter(x => x.length > 0).join('&');
};

exports.parseUrl = (url, options) => {
	options = Object.assign({
		decode: true
	}, options);

	const [url_, hash] = splitOnFirst(url, '#');

	return Object.assign(
		{
			url: url_.split('?')[0] || '',
			query: parse(extract(url), options)
		},
		options && options.parseFragmentIdentifier && hash ? {fragmentIdentifier: decode(hash, options)} : {}
	);
};

exports.stringifyUrl = (object, options) => {
	options = Object.assign({
		encode: true,
		strict: true,
		[encodeFragmentIdentifier]: true
	}, options);

	const url = removeHash(object.url).split('?')[0] || '';
	const queryFromUrl = exports.extract(object.url);
	const parsedQueryFromUrl = exports.parse(queryFromUrl, {sort: false});

	const query = Object.assign(parsedQueryFromUrl, object.query);
	let queryString = exports.stringify(query, options);
	if (queryString) {
		queryString = `?${queryString}`;
	}

	let hash = getHash(object.url);
	if (object.fragmentIdentifier) {
		hash = `#${options[encodeFragmentIdentifier] ? encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
	}

	return `${url}${queryString}${hash}`;
};

exports.pick = (input, filter, options) => {
	options = Object.assign({
		parseFragmentIdentifier: true,
		[encodeFragmentIdentifier]: false
	}, options);

	const {url, query, fragmentIdentifier} = exports.parseUrl(input, options);
	return exports.stringifyUrl({
		url,
		query: filterObject(query, filter),
		fragmentIdentifier
	}, options);
};

exports.exclude = (input, filter, options) => {
	const exclusionFilter = Array.isArray(filter) ? key => !filter.includes(key) : (key, value) => !filter(key, value);

	return exports.pick(input, exclusionFilter, options);
};


/***/ }),

/***/ "../node_modules/react/cjs/react-jsx-runtime.development.js":
/*!******************************************************************!*\
  !*** ../node_modules/react/cjs/react-jsx-runtime.development.js ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (true) {
  (function() {
'use strict';

var React = __webpack_require__(/*! react */ "react");
var _assign = __webpack_require__(/*! object-assign */ "../node_modules/object-assign/index.js");

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
exports.Fragment = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_SCOPE_TYPE = 0xead7;
var REACT_OPAQUE_ID_TYPE = 0xeae0;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_OFFSCREEN_TYPE = 0xeae2;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  exports.Fragment = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  REACT_SCOPE_TYPE = symbolFor('react.scope');
  REACT_OPAQUE_ID_TYPE = symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  REACT_OFFSCREEN_TYPE = symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
function getIteratorFn(maybeIterable) {
  if (maybeIterable === null || typeof maybeIterable !== 'object') {
    return null;
  }

  var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];

  if (typeof maybeIterator === 'function') {
    return maybeIterator;
  }

  return null;
}

var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;

function error(format) {
  {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    printWarning('error', format, args);
  }
}

function printWarning(level, format, args) {
  // When changing this logic, you might want to also
  // update consoleWithStackDev.www.js as well.
  {
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var stack = ReactDebugCurrentFrame.getStackAddendum();

    if (stack !== '') {
      format += '%s';
      args = args.concat([stack]);
    }

    var argsWithFormat = args.map(function (item) {
      return '' + item;
    }); // Careful: RN currently depends on this prefix

    argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
    // breaks IE9: https://github.com/facebook/react/issues/13610
    // eslint-disable-next-line react-internal/no-production-logging

    Function.prototype.apply.call(console[level], console, argsWithFormat);
  }
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = innerType.displayName || innerType.name || '';
  return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
}

function getContextName(type) {
  return type.displayName || 'Context';
}

function getComponentName(type) {
  if (type == null) {
    // Host root, text node or just invalid type.
    return null;
  }

  {
    if (typeof type.tag === 'number') {
      error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
    }
  }

  if (typeof type === 'function') {
    return type.displayName || type.name || null;
  }

  if (typeof type === 'string') {
    return type;
  }

  switch (type) {
    case exports.Fragment:
      return 'Fragment';

    case REACT_PORTAL_TYPE:
      return 'Portal';

    case REACT_PROFILER_TYPE:
      return 'Profiler';

    case REACT_STRICT_MODE_TYPE:
      return 'StrictMode';

    case REACT_SUSPENSE_TYPE:
      return 'Suspense';

    case REACT_SUSPENSE_LIST_TYPE:
      return 'SuspenseList';
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_CONTEXT_TYPE:
        var context = type;
        return getContextName(context) + '.Consumer';

      case REACT_PROVIDER_TYPE:
        var provider = type;
        return getContextName(provider._context) + '.Provider';

      case REACT_FORWARD_REF_TYPE:
        return getWrappedName(type, type.render, 'ForwardRef');

      case REACT_MEMO_TYPE:
        return getComponentName(type.type);

      case REACT_BLOCK_TYPE:
        return getComponentName(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            return getComponentName(init(payload));
          } catch (x) {
            return null;
          }
        }
    }
  }

  return null;
}

// Helpers to patch console.logs to avoid logging during side-effect free
// replaying on render function. This currently only patches the object
// lazily which won't cover if the log function was extracted eagerly.
// We could also eagerly patch the method.
var disabledDepth = 0;
var prevLog;
var prevInfo;
var prevWarn;
var prevError;
var prevGroup;
var prevGroupCollapsed;
var prevGroupEnd;

function disabledLog() {}

disabledLog.__reactDisabledLog = true;
function disableLogs() {
  {
    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      prevLog = console.log;
      prevInfo = console.info;
      prevWarn = console.warn;
      prevError = console.error;
      prevGroup = console.group;
      prevGroupCollapsed = console.groupCollapsed;
      prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099

      var props = {
        configurable: true,
        enumerable: true,
        value: disabledLog,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        info: props,
        log: props,
        warn: props,
        error: props,
        group: props,
        groupCollapsed: props,
        groupEnd: props
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    disabledDepth++;
  }
}
function reenableLogs() {
  {
    disabledDepth--;

    if (disabledDepth === 0) {
      /* eslint-disable react-internal/no-production-logging */
      var props = {
        configurable: true,
        enumerable: true,
        writable: true
      }; // $FlowFixMe Flow thinks console is immutable.

      Object.defineProperties(console, {
        log: _assign({}, props, {
          value: prevLog
        }),
        info: _assign({}, props, {
          value: prevInfo
        }),
        warn: _assign({}, props, {
          value: prevWarn
        }),
        error: _assign({}, props, {
          value: prevError
        }),
        group: _assign({}, props, {
          value: prevGroup
        }),
        groupCollapsed: _assign({}, props, {
          value: prevGroupCollapsed
        }),
        groupEnd: _assign({}, props, {
          value: prevGroupEnd
        })
      });
      /* eslint-enable react-internal/no-production-logging */
    }

    if (disabledDepth < 0) {
      error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
    }
  }
}

var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
var prefix;
function describeBuiltInComponentFrame(name, source, ownerFn) {
  {
    if (prefix === undefined) {
      // Extract the VM specific prefix used by each line.
      try {
        throw Error();
      } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || '';
      }
    } // We use the prefix to ensure our stacks line up with native stack frames.


    return '\n' + prefix + name;
  }
}
var reentry = false;
var componentFrameCache;

{
  var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
  componentFrameCache = new PossiblyWeakMap();
}

function describeNativeComponentFrame(fn, construct) {
  // If something asked for a stack inside a fake render, it should get ignored.
  if (!fn || reentry) {
    return '';
  }

  {
    var frame = componentFrameCache.get(fn);

    if (frame !== undefined) {
      return frame;
    }
  }

  var control;
  reentry = true;
  var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.

  Error.prepareStackTrace = undefined;
  var previousDispatcher;

  {
    previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
    // for warnings.

    ReactCurrentDispatcher.current = null;
    disableLogs();
  }

  try {
    // This should throw.
    if (construct) {
      // Something should be setting the props in the constructor.
      var Fake = function () {
        throw Error();
      }; // $FlowFixMe


      Object.defineProperty(Fake.prototype, 'props', {
        set: function () {
          // We use a throwing setter instead of frozen or non-writable props
          // because that won't throw in a non-strict mode function.
          throw Error();
        }
      });

      if (typeof Reflect === 'object' && Reflect.construct) {
        // We construct a different control for this case to include any extra
        // frames added by the construct call.
        try {
          Reflect.construct(Fake, []);
        } catch (x) {
          control = x;
        }

        Reflect.construct(fn, [], Fake);
      } else {
        try {
          Fake.call();
        } catch (x) {
          control = x;
        }

        fn.call(Fake.prototype);
      }
    } else {
      try {
        throw Error();
      } catch (x) {
        control = x;
      }

      fn();
    }
  } catch (sample) {
    // This is inlined manually because closure doesn't do it for us.
    if (sample && control && typeof sample.stack === 'string') {
      // This extracts the first frame from the sample that isn't also in the control.
      // Skipping one frame that we assume is the frame that calls the two.
      var sampleLines = sample.stack.split('\n');
      var controlLines = control.stack.split('\n');
      var s = sampleLines.length - 1;
      var c = controlLines.length - 1;

      while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
        // We expect at least one stack frame to be shared.
        // Typically this will be the root most one. However, stack frames may be
        // cut off due to maximum stack limits. In this case, one maybe cut off
        // earlier than the other. We assume that the sample is longer or the same
        // and there for cut off earlier. So we should find the root most frame in
        // the sample somewhere in the control.
        c--;
      }

      for (; s >= 1 && c >= 0; s--, c--) {
        // Next we find the first one that isn't the same which should be the
        // frame that called our sample function and the control.
        if (sampleLines[s] !== controlLines[c]) {
          // In V8, the first line is describing the message but other VMs don't.
          // If we're about to return the first line, and the control is also on the same
          // line, that's a pretty good indicator that our sample threw at same line as
          // the control. I.e. before we entered the sample frame. So we ignore this result.
          // This can happen if you passed a class to function component, or non-function.
          if (s !== 1 || c !== 1) {
            do {
              s--;
              c--; // We may still have similar intermediate frames from the construct call.
              // The next one that isn't the same should be our match though.

              if (c < 0 || sampleLines[s] !== controlLines[c]) {
                // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');

                {
                  if (typeof fn === 'function') {
                    componentFrameCache.set(fn, _frame);
                  }
                } // Return the line we found.


                return _frame;
              }
            } while (s >= 1 && c >= 0);
          }

          break;
        }
      }
    }
  } finally {
    reentry = false;

    {
      ReactCurrentDispatcher.current = previousDispatcher;
      reenableLogs();
    }

    Error.prepareStackTrace = previousPrepareStackTrace;
  } // Fallback to just using the name if we couldn't make it throw.


  var name = fn ? fn.displayName || fn.name : '';
  var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';

  {
    if (typeof fn === 'function') {
      componentFrameCache.set(fn, syntheticFrame);
    }
  }

  return syntheticFrame;
}
function describeFunctionComponentFrame(fn, source, ownerFn) {
  {
    return describeNativeComponentFrame(fn, false);
  }
}

function shouldConstruct(Component) {
  var prototype = Component.prototype;
  return !!(prototype && prototype.isReactComponent);
}

function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {

  if (type == null) {
    return '';
  }

  if (typeof type === 'function') {
    {
      return describeNativeComponentFrame(type, shouldConstruct(type));
    }
  }

  if (typeof type === 'string') {
    return describeBuiltInComponentFrame(type);
  }

  switch (type) {
    case REACT_SUSPENSE_TYPE:
      return describeBuiltInComponentFrame('Suspense');

    case REACT_SUSPENSE_LIST_TYPE:
      return describeBuiltInComponentFrame('SuspenseList');
  }

  if (typeof type === 'object') {
    switch (type.$$typeof) {
      case REACT_FORWARD_REF_TYPE:
        return describeFunctionComponentFrame(type.render);

      case REACT_MEMO_TYPE:
        // Memo may contain any component type so we recursively resolve it.
        return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);

      case REACT_BLOCK_TYPE:
        return describeFunctionComponentFrame(type._render);

      case REACT_LAZY_TYPE:
        {
          var lazyComponent = type;
          var payload = lazyComponent._payload;
          var init = lazyComponent._init;

          try {
            // Lazy may contain any component type so we recursively resolve it.
            return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
          } catch (x) {}
        }
    }
  }

  return '';
}

var loggedTypeFailures = {};
var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
  }
}

function checkPropTypes(typeSpecs, values, location, componentName, element) {
  {
    // $FlowFixMe This is okay but Flow doesn't know it.
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
        } catch (ex) {
          error$1 = ex;
        }

        if (error$1 && !(error$1 instanceof Error)) {
          setCurrentlyValidatingElement(element);

          error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);

          setCurrentlyValidatingElement(null);
        }

        if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error$1.message] = true;
          setCurrentlyValidatingElement(element);

          error('Failed %s type: %s', location, error$1.message);

          setCurrentlyValidatingElement(null);
        }
      }
    }
  }
}

var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};
var specialPropKeyWarningShown;
var specialPropRefWarningShown;
var didWarnAboutStringRefs;

{
  didWarnAboutStringRefs = {};
}

function hasValidRef(config) {
  {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.ref !== undefined;
}

function hasValidKey(config) {
  {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;

      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }

  return config.key !== undefined;
}

function warnIfStringRefCannotBeAutoConverted(config, self) {
  {
    if (typeof config.ref === 'string' && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
      var componentName = getComponentName(ReactCurrentOwner.current.type);

      if (!didWarnAboutStringRefs[componentName]) {
        error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);

        didWarnAboutStringRefs[componentName] = true;
      }
    }
  }
}

function defineKeyPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingKey = function () {
      if (!specialPropKeyWarningShown) {
        specialPropKeyWarningShown = true;

        error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingKey.isReactWarning = true;
    Object.defineProperty(props, 'key', {
      get: warnAboutAccessingKey,
      configurable: true
    });
  }
}

function defineRefPropWarningGetter(props, displayName) {
  {
    var warnAboutAccessingRef = function () {
      if (!specialPropRefWarningShown) {
        specialPropRefWarningShown = true;

        error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
      }
    };

    warnAboutAccessingRef.isReactWarning = true;
    Object.defineProperty(props, 'ref', {
      get: warnAboutAccessingRef,
      configurable: true
    });
  }
}
/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */


var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allows us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,
    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,
    // Record the component responsible for creating this element.
    _owner: owner
  };

  {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.

    Object.defineProperty(element._store, 'validated', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: false
    }); // self and source are DEV only properties.

    Object.defineProperty(element, '_self', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: self
    }); // Two elements created in two different places should be considered
    // equal for testing purposes and therefore we hide it from enumeration.

    Object.defineProperty(element, '_source', {
      configurable: false,
      enumerable: false,
      writable: false,
      value: source
    });

    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};
/**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */

function jsxDEV(type, config, maybeKey, source, self) {
  {
    var propName; // Reserved names are extracted

    var props = {};
    var key = null;
    var ref = null; // Currently, key can be spread in as a prop. This causes a potential
    // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
    // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
    // but as an intermediary step, we will use jsxDEV for everything except
    // <div {...props} key="Hi" />, because we aren't currently able to tell if
    // key is explicitly declared to be undefined or not.

    if (maybeKey !== undefined) {
      key = '' + maybeKey;
    }

    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    if (hasValidRef(config)) {
      ref = config.ref;
      warnIfStringRefCannotBeAutoConverted(config, self);
    } // Remaining properties are added to a new props object


    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    } // Resolve default props


    if (type && type.defaultProps) {
      var defaultProps = type.defaultProps;

      for (propName in defaultProps) {
        if (props[propName] === undefined) {
          props[propName] = defaultProps[propName];
        }
      }
    }

    if (key || ref) {
      var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;

      if (key) {
        defineKeyPropWarningGetter(props, displayName);
      }

      if (ref) {
        defineRefPropWarningGetter(props, displayName);
      }
    }

    return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
  }
}

var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;

function setCurrentlyValidatingElement$1(element) {
  {
    if (element) {
      var owner = element._owner;
      var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
      ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
    } else {
      ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
  }
}

var propTypesMisspellWarningShown;

{
  propTypesMisspellWarningShown = false;
}
/**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */

function isValidElement(object) {
  {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  }
}

function getDeclarationErrorAddendum() {
  {
    if (ReactCurrentOwner$1.current) {
      var name = getComponentName(ReactCurrentOwner$1.current.type);

      if (name) {
        return '\n\nCheck the render method of `' + name + '`.';
      }
    }

    return '';
  }
}

function getSourceInfoErrorAddendum(source) {
  {
    if (source !== undefined) {
      var fileName = source.fileName.replace(/^.*[\\\/]/, '');
      var lineNumber = source.lineNumber;
      return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
    }

    return '';
  }
}
/**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */


var ownerHasKeyUseWarning = {};

function getCurrentComponentErrorInfo(parentType) {
  {
    var info = getDeclarationErrorAddendum();

    if (!info) {
      var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;

      if (parentName) {
        info = "\n\nCheck the top-level render call using <" + parentName + ">.";
      }
    }

    return info;
  }
}
/**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */


function validateExplicitKey(element, parentType) {
  {
    if (!element._store || element._store.validated || element.key != null) {
      return;
    }

    element._store.validated = true;
    var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);

    if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
      return;
    }

    ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
    // property, it may be the creator of the child that's responsible for
    // assigning it a key.

    var childOwner = '';

    if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
      // Give the component that originally created this child.
      childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
    }

    setCurrentlyValidatingElement$1(element);

    error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);

    setCurrentlyValidatingElement$1(null);
  }
}
/**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */


function validateChildKeys(node, parentType) {
  {
    if (typeof node !== 'object') {
      return;
    }

    if (Array.isArray(node)) {
      for (var i = 0; i < node.length; i++) {
        var child = node[i];

        if (isValidElement(child)) {
          validateExplicitKey(child, parentType);
        }
      }
    } else if (isValidElement(node)) {
      // This element was passed in a valid location.
      if (node._store) {
        node._store.validated = true;
      }
    } else if (node) {
      var iteratorFn = getIteratorFn(node);

      if (typeof iteratorFn === 'function') {
        // Entry iterators used to provide implicit keys,
        // but now we print a separate warning for them later.
        if (iteratorFn !== node.entries) {
          var iterator = iteratorFn.call(node);
          var step;

          while (!(step = iterator.next()).done) {
            if (isValidElement(step.value)) {
              validateExplicitKey(step.value, parentType);
            }
          }
        }
      }
    }
  }
}
/**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */


function validatePropTypes(element) {
  {
    var type = element.type;

    if (type === null || type === undefined || typeof type === 'string') {
      return;
    }

    var propTypes;

    if (typeof type === 'function') {
      propTypes = type.propTypes;
    } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
    // Inner props are checked in the reconciler.
    type.$$typeof === REACT_MEMO_TYPE)) {
      propTypes = type.propTypes;
    } else {
      return;
    }

    if (propTypes) {
      // Intentionally inside to avoid triggering lazy initializers:
      var name = getComponentName(type);
      checkPropTypes(propTypes, element.props, 'prop', name, element);
    } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
      propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:

      var _name = getComponentName(type);

      error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
    }

    if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
      error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
    }
  }
}
/**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */


function validateFragmentProps(fragment) {
  {
    var keys = Object.keys(fragment.props);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];

      if (key !== 'children' && key !== 'key') {
        setCurrentlyValidatingElement$1(fragment);

        error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);

        setCurrentlyValidatingElement$1(null);
        break;
      }
    }

    if (fragment.ref !== null) {
      setCurrentlyValidatingElement$1(fragment);

      error('Invalid attribute `ref` supplied to `React.Fragment`.');

      setCurrentlyValidatingElement$1(null);
    }
  }
}

function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
  {
    var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
    // succeed and there will likely be errors in render.

    if (!validType) {
      var info = '';

      if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
        info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
      }

      var sourceInfo = getSourceInfoErrorAddendum(source);

      if (sourceInfo) {
        info += sourceInfo;
      } else {
        info += getDeclarationErrorAddendum();
      }

      var typeString;

      if (type === null) {
        typeString = 'null';
      } else if (Array.isArray(type)) {
        typeString = 'array';
      } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
        typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
        info = ' Did you accidentally export a JSX literal instead of a component?';
      } else {
        typeString = typeof type;
      }

      error('React.jsx: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
    }

    var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
    // TODO: Drop this when these are no longer allowed as the type argument.

    if (element == null) {
      return element;
    } // Skip key warning if the type isn't valid since our key validation logic
    // doesn't expect a non-string/function type and can throw confusing errors.
    // We don't want exception behavior to differ between dev and prod.
    // (Rendering will throw with a helpful message and as soon as the type is
    // fixed, the key warnings will appear.)


    if (validType) {
      var children = props.children;

      if (children !== undefined) {
        if (isStaticChildren) {
          if (Array.isArray(children)) {
            for (var i = 0; i < children.length; i++) {
              validateChildKeys(children[i], type);
            }

            if (Object.freeze) {
              Object.freeze(children);
            }
          } else {
            error('React.jsx: Static children should always be an array. ' + 'You are likely explicitly calling React.jsxs or React.jsxDEV. ' + 'Use the Babel transform instead.');
          }
        } else {
          validateChildKeys(children, type);
        }
      }
    }

    if (type === exports.Fragment) {
      validateFragmentProps(element);
    } else {
      validatePropTypes(element);
    }

    return element;
  }
} // These two functions exist to still get child warnings in dev
// even with the prod transform. This means that jsxDEV is purely
// opt-in behavior for better messages but that we won't stop
// giving you warnings if you use production apis.

function jsxWithValidationStatic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, true);
  }
}
function jsxWithValidationDynamic(type, props, key) {
  {
    return jsxWithValidation(type, props, key, false);
  }
}

var jsx =  jsxWithValidationDynamic ; // we may want to special case jsxs internally to take advantage of static children.
// for now we can ship identical prod functions

var jsxs =  jsxWithValidationStatic ;

exports.jsx = jsx;
exports.jsxs = jsxs;
  })();
}


/***/ }),

/***/ "../node_modules/react/jsx-runtime.js":
/*!********************************************!*\
  !*** ../node_modules/react/jsx-runtime.js ***!
  \********************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



if (false) {} else {
  module.exports = __webpack_require__(/*! ./cjs/react-jsx-runtime.development.js */ "../node_modules/react/cjs/react-jsx-runtime.development.js");
}


/***/ }),

/***/ "../node_modules/split-on-first/index.js":
/*!***********************************************!*\
  !*** ../node_modules/split-on-first/index.js ***!
  \***********************************************/
/***/ ((module) => {



module.exports = (string, separator) => {
	if (!(typeof string === 'string' && typeof separator === 'string')) {
		throw new TypeError('Expected the arguments to be of type `string`');
	}

	if (separator === '') {
		return [string];
	}

	const separatorIndex = string.indexOf(separator);

	if (separatorIndex === -1) {
		return [string];
	}

	return [
		string.slice(0, separatorIndex),
		string.slice(separatorIndex + separator.length)
	];
};


/***/ }),

/***/ "../node_modules/strict-uri-encode/index.js":
/*!**************************************************!*\
  !*** ../node_modules/strict-uri-encode/index.js ***!
  \**************************************************/
/***/ ((module) => {


module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);


/***/ }),

/***/ "../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js":
/*!*****************************************************************************!*\
  !*** ../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js ***!
  \*****************************************************************************/
/***/ ((module) => {



var stylesInDOM = [];
function getIndexByIdentifier(identifier) {
  var result = -1;
  for (var i = 0; i < stylesInDOM.length; i++) {
    if (stylesInDOM[i].identifier === identifier) {
      result = i;
      break;
    }
  }
  return result;
}
function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];
  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var indexByIdentifier = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3],
      supports: item[4],
      layer: item[5]
    };
    if (indexByIdentifier !== -1) {
      stylesInDOM[indexByIdentifier].references++;
      stylesInDOM[indexByIdentifier].updater(obj);
    } else {
      var updater = addElementStyle(obj, options);
      options.byIndex = i;
      stylesInDOM.splice(i, 0, {
        identifier: identifier,
        updater: updater,
        references: 1
      });
    }
    identifiers.push(identifier);
  }
  return identifiers;
}
function addElementStyle(obj, options) {
  var api = options.domAPI(options);
  api.update(obj);
  var updater = function updater(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap && newObj.supports === obj.supports && newObj.layer === obj.layer) {
        return;
      }
      api.update(obj = newObj);
    } else {
      api.remove();
    }
  };
  return updater;
}
module.exports = function (list, options) {
  options = options || {};
  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];
    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDOM[index].references--;
    }
    var newLastIdentifiers = modulesToDom(newList, options);
    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];
      var _index = getIndexByIdentifier(_identifier);
      if (stylesInDOM[_index].references === 0) {
        stylesInDOM[_index].updater();
        stylesInDOM.splice(_index, 1);
      }
    }
    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),

/***/ "../node_modules/style-loader/dist/runtime/insertBySelector.js":
/*!*********************************************************************!*\
  !*** ../node_modules/style-loader/dist/runtime/insertBySelector.js ***!
  \*********************************************************************/
/***/ ((module) => {



var memo = {};

/* istanbul ignore next  */
function getTarget(target) {
  if (typeof memo[target] === "undefined") {
    var styleTarget = document.querySelector(target);

    // Special case to return head of iframe instead of iframe itself
    if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
      try {
        // This will throw an exception if access to iframe is blocked
        // due to cross-origin restrictions
        styleTarget = styleTarget.contentDocument.head;
      } catch (e) {
        // istanbul ignore next
        styleTarget = null;
      }
    }
    memo[target] = styleTarget;
  }
  return memo[target];
}

/* istanbul ignore next  */
function insertBySelector(insert, style) {
  var target = getTarget(insert);
  if (!target) {
    throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
  }
  target.appendChild(style);
}
module.exports = insertBySelector;

/***/ }),

/***/ "../node_modules/style-loader/dist/runtime/insertStyleElement.js":
/*!***********************************************************************!*\
  !*** ../node_modules/style-loader/dist/runtime/insertStyleElement.js ***!
  \***********************************************************************/
/***/ ((module) => {



/* istanbul ignore next  */
function insertStyleElement(options) {
  var element = document.createElement("style");
  options.setAttributes(element, options.attributes);
  options.insert(element, options.options);
  return element;
}
module.exports = insertStyleElement;

/***/ }),

/***/ "../node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js":
/*!***********************************************************************************!*\
  !*** ../node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js ***!
  \***********************************************************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



/* istanbul ignore next  */
function setAttributesWithoutAttributes(styleElement) {
  var nonce =  true ? __webpack_require__.nc : 0;
  if (nonce) {
    styleElement.setAttribute("nonce", nonce);
  }
}
module.exports = setAttributesWithoutAttributes;

/***/ }),

/***/ "../node_modules/style-loader/dist/runtime/styleDomAPI.js":
/*!****************************************************************!*\
  !*** ../node_modules/style-loader/dist/runtime/styleDomAPI.js ***!
  \****************************************************************/
/***/ ((module) => {



/* istanbul ignore next  */
function apply(styleElement, options, obj) {
  var css = "";
  if (obj.supports) {
    css += "@supports (".concat(obj.supports, ") {");
  }
  if (obj.media) {
    css += "@media ".concat(obj.media, " {");
  }
  var needLayer = typeof obj.layer !== "undefined";
  if (needLayer) {
    css += "@layer".concat(obj.layer.length > 0 ? " ".concat(obj.layer) : "", " {");
  }
  css += obj.css;
  if (needLayer) {
    css += "}";
  }
  if (obj.media) {
    css += "}";
  }
  if (obj.supports) {
    css += "}";
  }
  var sourceMap = obj.sourceMap;
  if (sourceMap && typeof btoa !== "undefined") {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  }

  // For old IE
  /* istanbul ignore if  */
  options.styleTagTransform(css, styleElement, options.options);
}
function removeStyleElement(styleElement) {
  // istanbul ignore if
  if (styleElement.parentNode === null) {
    return false;
  }
  styleElement.parentNode.removeChild(styleElement);
}

/* istanbul ignore next  */
function domAPI(options) {
  if (typeof document === "undefined") {
    return {
      update: function update() {},
      remove: function remove() {}
    };
  }
  var styleElement = options.insertStyleElement(options);
  return {
    update: function update(obj) {
      apply(styleElement, options, obj);
    },
    remove: function remove() {
      removeStyleElement(styleElement);
    }
  };
}
module.exports = domAPI;

/***/ }),

/***/ "../node_modules/style-loader/dist/runtime/styleTagTransform.js":
/*!**********************************************************************!*\
  !*** ../node_modules/style-loader/dist/runtime/styleTagTransform.js ***!
  \**********************************************************************/
/***/ ((module) => {



/* istanbul ignore next  */
function styleTagTransform(css, styleElement) {
  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css;
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild);
    }
    styleElement.appendChild(document.createTextNode(css));
  }
}
module.exports = styleTagTransform;

/***/ }),

/***/ "./components/RiskList/risk-card.css":
/*!*******************************************!*\
  !*** ./components/RiskList/risk-card.css ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! !../../../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js */ "../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! !../../../node_modules/style-loader/dist/runtime/styleDomAPI.js */ "../node_modules/style-loader/dist/runtime/styleDomAPI.js");
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! !../../../node_modules/style-loader/dist/runtime/insertBySelector.js */ "../node_modules/style-loader/dist/runtime/insertBySelector.js");
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! !../../../node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js */ "../node_modules/style-loader/dist/runtime/setAttributesWithoutAttributes.js");
/* harmony import */ var _node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! !../../../node_modules/style-loader/dist/runtime/insertStyleElement.js */ "../node_modules/style-loader/dist/runtime/insertStyleElement.js");
/* harmony import */ var _node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! !../../../node_modules/style-loader/dist/runtime/styleTagTransform.js */ "../node_modules/style-loader/dist/runtime/styleTagTransform.js");
/* harmony import */ var _node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_risk_card_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! !!../../../node_modules/css-loader/dist/cjs.js!./risk-card.css */ "../node_modules/css-loader/dist/cjs.js!./components/RiskList/risk-card.css");

      
      
      
      
      
      
      
      
      

var options = {};

options.styleTagTransform = (_node_modules_style_loader_dist_runtime_styleTagTransform_js__WEBPACK_IMPORTED_MODULE_5___default());
options.setAttributes = (_node_modules_style_loader_dist_runtime_setAttributesWithoutAttributes_js__WEBPACK_IMPORTED_MODULE_3___default());

      options.insert = _node_modules_style_loader_dist_runtime_insertBySelector_js__WEBPACK_IMPORTED_MODULE_2___default().bind(null, "head");
    
options.domAPI = (_node_modules_style_loader_dist_runtime_styleDomAPI_js__WEBPACK_IMPORTED_MODULE_1___default());
options.insertStyleElement = (_node_modules_style_loader_dist_runtime_insertStyleElement_js__WEBPACK_IMPORTED_MODULE_4___default());

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_risk_card_css__WEBPACK_IMPORTED_MODULE_6__["default"], options);




       /* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (_node_modules_css_loader_dist_cjs_js_risk_card_css__WEBPACK_IMPORTED_MODULE_6__["default"] && _node_modules_css_loader_dist_cjs_js_risk_card_css__WEBPACK_IMPORTED_MODULE_6__["default"].locals ? _node_modules_css_loader_dist_cjs_js_risk_card_css__WEBPACK_IMPORTED_MODULE_6__["default"].locals : undefined);


/***/ }),

/***/ "./actions/CoF.actions.ts":
/*!********************************!*\
  !*** ./actions/CoF.actions.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setCoFIsChanged = exports.deleteCoFCategory = exports.saveCoFRejected = exports.saveCoFResolved = exports.saveCoF = exports.setCoFComponents = exports.setCoFComponent = exports.addCoFComponent = exports.getCustomTableFieldsRejected = exports.getCustomTableFieldsResolved = exports.getCustomTableFields = exports.getProximityAttributeFieldsRejected = exports.getProximityAttributeFieldsResolved = exports.getProximityAttributeFields = exports.getCoFFieldsRejected = exports.getCoFFieldsResolved = exports.getCoFFields = exports.setCoFConfig = exports.addCoFConfig = exports.getCoFComponentsRejected = exports.getCoFComponentsResolved = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getCoFComponentsResolved = (0, toolkit_1.createAction)('CoF/getCoFComponentsResolved');
exports.getCoFComponentsRejected = (0, toolkit_1.createAction)('CoF/getCoFComponentsRejected');
exports.addCoFConfig = (0, toolkit_1.createAction)('CoF/addCoFConfig');
exports.setCoFConfig = (0, toolkit_1.createAction)('CoF/setCoFConfig');
exports.getCoFFields = (0, toolkit_1.createAction)('CoF/getCoFFields');
exports.getCoFFieldsResolved = (0, toolkit_1.createAction)('CoF/getCoFFieldsResolved');
exports.getCoFFieldsRejected = (0, toolkit_1.createAction)('CoF/getCoFFieldsRejected');
exports.getProximityAttributeFields = (0, toolkit_1.createAction)('ProximityAttribute/getProximityAttributeFields');
exports.getProximityAttributeFieldsResolved = (0, toolkit_1.createAction)('ProximityAttribute/getProximityAttributeFieldsResolved');
exports.getProximityAttributeFieldsRejected = (0, toolkit_1.createAction)('ProximityAttribute/getProximityAttributeFieldsRejected');
exports.getCustomTableFields = (0, toolkit_1.createAction)('CustomTable/getCustomTableFields');
exports.getCustomTableFieldsResolved = (0, toolkit_1.createAction)('CustomTable/getCustomTableFieldsResolved');
exports.getCustomTableFieldsRejected = (0, toolkit_1.createAction)('CustomTable/getCustomTableFieldsRejected');
exports.addCoFComponent = (0, toolkit_1.createAction)('CoF/addCoFComponent');
exports.setCoFComponent = (0, toolkit_1.createAction)('CoF/setCoFComponent');
exports.setCoFComponents = (0, toolkit_1.createAction)('CoF/setCoFComponents');
exports.saveCoF = (0, toolkit_1.createAction)('CoF/saveCoF');
exports.saveCoFResolved = (0, toolkit_1.createAction)('CoF/saveCoFResolved');
exports.saveCoFRejected = (0, toolkit_1.createAction)('CoF/saveCoFRejected');
exports.deleteCoFCategory = (0, toolkit_1.createAction)('CoF/deleteCoFCategory');
exports.setCoFIsChanged = (0, toolkit_1.createAction)('CoF/setCoFIsChanged');


/***/ }),

/***/ "./actions/LoF.actions.ts":
/*!********************************!*\
  !*** ./actions/LoF.actions.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setLofIsChanged = exports.deleteCategory = exports.saveLoFRejected = exports.saveLoFResolved = exports.saveLoF = exports.setLoFComponents = exports.setLoFComponent = exports.addLoFComponent = exports.getLoFFieldsRejected = exports.getLoFFieldsResolved = exports.getLoFFields = exports.getLoFInspectionFieldsRejected = exports.getLoFInspectionFieldsResolved = exports.getLoFInspectionFields = exports.setLoFConfig = exports.addLoFConfig = exports.getLoFConfigRejected = exports.getLoFConfigResolved = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getLoFConfigResolved = (0, toolkit_1.createAction)('LoF/getLoFConfigResolved');
exports.getLoFConfigRejected = (0, toolkit_1.createAction)('LoF/getLoFConfigRejected');
exports.addLoFConfig = (0, toolkit_1.createAction)('LoF/addLoFConfig');
exports.setLoFConfig = (0, toolkit_1.createAction)('LoF/setLoFConfig');
exports.getLoFInspectionFields = (0, toolkit_1.createAction)('LoF/getLoFInspectionFields');
exports.getLoFInspectionFieldsResolved = (0, toolkit_1.createAction)('LoF/getLoFInspectionFieldsResolved');
exports.getLoFInspectionFieldsRejected = (0, toolkit_1.createAction)('LoF/getLoFInspectionFieldsRejected');
exports.getLoFFields = (0, toolkit_1.createAction)('LoF/getLoFFields');
exports.getLoFFieldsResolved = (0, toolkit_1.createAction)('LoF/getLoFFieldsResolved');
exports.getLoFFieldsRejected = (0, toolkit_1.createAction)('LoF/getLoFFieldsRejected');
exports.addLoFComponent = (0, toolkit_1.createAction)('LoF/addLoFComponent');
exports.setLoFComponent = (0, toolkit_1.createAction)('LoF/setLoFComponent');
exports.setLoFComponents = (0, toolkit_1.createAction)('LoF/setLoFComponents');
exports.saveLoF = (0, toolkit_1.createAction)('LoF/saveLoF');
exports.saveLoFResolved = (0, toolkit_1.createAction)('LoF/saveLoFResolved');
exports.saveLoFRejected = (0, toolkit_1.createAction)('LoF/saveLoFRejected');
exports.deleteCategory = (0, toolkit_1.createAction)('LoF/deleteCategory');
exports.setLofIsChanged = (0, toolkit_1.createAction)('Lof/setLofIsChanged');


/***/ }),

/***/ "./actions/Risk.actions.ts":
/*!*********************************!*\
  !*** ./actions/Risk.actions.ts ***!
  \*********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.changeFilterSelect = exports.getTaskDataResolved = exports.getTaskData = exports.getSimulationDataResolved = exports.getSimulationData = exports.getLogRejected = exports.getLogResolved = exports.getLog = exports.setRiskCalcStatus = exports.setSaveRun = exports.setTab = exports.setRiskDetailsIsBusy = exports.currentRow = exports.clearSelected = exports.removeSelected = exports.addSelected = exports.setSelected = exports.changeSort = exports.clearScanId = exports.setSearchStartSaga = exports.setSearchStart = exports.changeSearch = exports.changePage = exports.changeSlice = exports.clearRiskScanId = exports.changePagination = exports.getRiskDetailsRejected = exports.getRiskDetailsResolved = exports.getRiskDetailsWSReseived = exports.reloadRiskDetails = exports.getRiskDetailsDefaulted = exports.resetRiskResolved = exports.resetRiskRejected = exports.resetRisk = exports.runRiskResolved = exports.runRiskRejected = exports.runRisk = exports.getRiskDetails = exports.saveRiskConfigAction = exports.renameRiskConfigAction = exports.setRiskConfigNameError = exports.setRiskConfigIsCreating = exports.duplicateRiskConfig = exports.changeRiskConfigPublishState = exports.createRiskConfig = exports.clearRiskConfig = exports.getRiskConfigRejected = exports.getRiskConfigResolved = exports.getRiskConfig = exports.paginationDefault = void 0;
exports.setOverallRisk = exports.clearMatrixUpdate = exports.setOnlyGradesUpdated = exports.setEditedCellsList = exports.setRefreshMatrixGrid = exports.setRiskMatrixAfterPreview = exports.setMatrixPreviewStatus = exports.setIsPreviewOnLoad = exports.setIsPreviewLoading = exports.setCancellPreview = exports.setEnablePreview = exports.getRiskMatrixPreview = exports.cancelRiskMatrixPreview = exports.initRiskMatrixPreview = exports.setRiskType = exports.setUpdatedScores = exports.setDidMatrixUpdate = exports.setUpdatedRanges = exports.renameRiskCount = exports.getRiskCountResolved = exports.getRiskCountScoreMatrix = exports.getRiskCountTask = exports.getRiskCountCustomTable = exports.getRiskCountProximityAttribute = exports.getRiskCountProximity = exports.getRiskCountObservation = exports.getRiskCountAttribute = exports.getRiskCountInspection = exports.setRiskCountIsLoading = exports.setRiskIsDeleting = exports.deleteRisk = exports.setRiskIsSaving = exports.setRefreshList = exports.setRunCompleteReload = exports.setRiskSetupDirty = exports.translate = exports.updateColumnFilterSelectOptions = exports.changeFiltersSelect = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies
var Reducers_1 = __webpack_require__(/*! @innovyze/lib-am-common/Reducers */ "@innovyze/lib-am-common/Reducers");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var paginationDefault = function () { return (__assign(__assign({}, Reducers_1.paginationInitialState), { sortKey: 'CURRENT_RISK', sortDescending: true })); };
exports.paginationDefault = paginationDefault;
exports.getRiskConfig = (0, toolkit_1.createAction)('Risk/getRiskConfig');
exports.getRiskConfigResolved = (0, toolkit_1.createAction)('Risk/getRiskConfigResolved');
exports.getRiskConfigRejected = (0, toolkit_1.createAction)('Risk/getRiskConfigRejected');
exports.clearRiskConfig = (0, toolkit_1.createAction)('Risk/clearRiskConfig');
exports.createRiskConfig = (0, toolkit_1.createAction)('Risk/createRiskConfig');
exports.changeRiskConfigPublishState = (0, toolkit_1.createAction)('Risk/changeRiskConfigPublishState');
exports.duplicateRiskConfig = (0, toolkit_1.createAction)('Risk/duplicateRiskConfig');
exports.setRiskConfigIsCreating = (0, toolkit_1.createAction)('riskSetup/setRiskConfigIsCreating');
exports.setRiskConfigNameError = (0, toolkit_1.createAction)('riskSetup/setRiskConfigNameError');
exports.renameRiskConfigAction = (0, toolkit_1.createAction)('Risk/renameRiskConfig');
exports.saveRiskConfigAction = (0, toolkit_1.createAction)('Risk/saveRiskConfig');
exports.getRiskDetails = (0, toolkit_1.createAction)('risk/getRiskDetails');
exports.runRisk = (0, toolkit_1.createAction)('risk/runRisk');
exports.runRiskRejected = (0, toolkit_1.createAction)('risk/runRiskRejected');
exports.runRiskResolved = (0, toolkit_1.createAction)('risk/runRiskResolved');
exports.resetRisk = (0, toolkit_1.createAction)('risk/resetRisk');
exports.resetRiskRejected = (0, toolkit_1.createAction)('risk/resetRiskRejected');
exports.resetRiskResolved = (0, toolkit_1.createAction)('risk/resetRiskResolved');
var getRiskDetailsDefaulted = function () {
    return (0, exports.getRiskDetails)((0, exports.paginationDefault)());
};
exports.getRiskDetailsDefaulted = getRiskDetailsDefaulted;
exports.reloadRiskDetails = (0, toolkit_1.createAction)('risk/reloadRiskDetails');
exports.getRiskDetailsWSReseived = (0, toolkit_1.createAction)('riskdetails/getRiskDetails/WSReseived');
exports.getRiskDetailsResolved = (0, toolkit_1.createAction)('riskdetails/getRiskDetails/resolved');
exports.getRiskDetailsRejected = (0, toolkit_1.createAction)('riskdetails/getRiskDetails/rejected');
exports.changePagination = (0, toolkit_1.createAction)('riskdetails/paginationModel');
exports.clearRiskScanId = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskdetails/clearRiskScanId'));
exports.changeSlice = (0, toolkit_1.createAction)('riskdetails/slice');
exports.changePage = (0, toolkit_1.createAction)('riskdetails/page');
exports.changeSearch = (0, toolkit_1.createAction)('riskdetails/changeSearch');
exports.setSearchStart = (0, toolkit_1.createAction)('riskdetails/setSearchStart');
exports.setSearchStartSaga = (0, toolkit_1.createAction)('riskdetails/setSearchStartSaga');
exports.clearScanId = (0, toolkit_1.createAction)('riskdetails/clearScanId');
exports.changeSort = (0, toolkit_1.createAction)('riskdetails/sort');
exports.setSelected = (0, toolkit_1.createAction)('riskdetails/selected/set');
exports.addSelected = (0, toolkit_1.createAction)('riskdetails/selected/add');
exports.removeSelected = (0, toolkit_1.createAction)('riskdetails/selected/remove');
exports.clearSelected = (0, toolkit_1.createAction)('riskdetails/selected/clear');
exports.currentRow = (0, toolkit_1.createAction)('riskdetails/current/row');
exports.setRiskDetailsIsBusy = (0, toolkit_1.createAction)('riskdetails/isBusy');
exports.setTab = (0, toolkit_1.createAction)('Risk/setTab');
exports.setSaveRun = (0, toolkit_1.createAction)('Risk/setSaveRun');
exports.setRiskCalcStatus = (0, toolkit_1.createAction)('Risk/setRiskCalcStatus');
exports.getLog = (0, toolkit_1.createAction)('Log/getLog');
exports.getLogResolved = (0, toolkit_1.createAction)('Log/getLogResolved');
exports.getLogRejected = (0, toolkit_1.createAction)('Log/getLogRejected');
exports.getSimulationData = (0, toolkit_1.createAction)('Risk/getSimulationData');
exports.getSimulationDataResolved = (0, toolkit_1.createAction)('Risk/getSimulationDataResolved');
exports.getTaskData = (0, toolkit_1.createAction)('Risk/getTaskData');
exports.getTaskDataResolved = (0, toolkit_1.createAction)('Risk/getTaskDataResolved');
exports.changeFilterSelect = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskDetails/filterSelect'));
exports.changeFiltersSelect = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskDetails/filtersSelect'));
exports.updateColumnFilterSelectOptions = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskDetails/filterSelect/column/options'));
exports.translate = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('riskDetails/translate'));
exports.setRiskSetupDirty = (0, toolkit_1.createAction)('riskSetup/setRiskSetupDirty');
exports.setRunCompleteReload = (0, toolkit_1.createAction)('Risk/riskCompleteReload');
exports.setRefreshList = (0, toolkit_1.createAction)('Risk/setRefreshList');
exports.setRiskIsSaving = (0, toolkit_1.createAction)('riskSetup/setRiskIsSaving');
exports.deleteRisk = (0, toolkit_1.createAction)('rehab/deleteRisk');
exports.setRiskIsDeleting = (0, toolkit_1.createAction)('risk/setRiskIsDeleting');
exports.setRiskCountIsLoading = (0, toolkit_1.createAction)('Risk/setRiskCountIsLoading');
exports.getRiskCountInspection = (0, toolkit_1.createAction)('Risk/getRiskCountInspection');
exports.getRiskCountAttribute = (0, toolkit_1.createAction)('Risk/getRiskCountAttribute');
exports.getRiskCountObservation = (0, toolkit_1.createAction)('Risk/getRiskCountObservation');
exports.getRiskCountProximity = (0, toolkit_1.createAction)('Risk/getRiskCountProximity');
exports.getRiskCountProximityAttribute = (0, toolkit_1.createAction)('Risk/getRiskCountProximityAttribute');
exports.getRiskCountCustomTable = (0, toolkit_1.createAction)('Risk/getRiskCountCustomTable');
exports.getRiskCountTask = (0, toolkit_1.createAction)('Risk/getRiskCountTask');
exports.getRiskCountScoreMatrix = (0, toolkit_1.createAction)('Risk/getRiskCountScoreMatrix');
exports.getRiskCountResolved = (0, toolkit_1.createAction)('Risk/getRiskCountResolved');
exports.renameRiskCount = (0, toolkit_1.createAction)('Risk/renameRiskCount');
//=== risk Matrix actions =====
exports.setUpdatedRanges = (0, toolkit_1.createAction)('Risk/setUpdatedRanges');
exports.setDidMatrixUpdate = (0, toolkit_1.createAction)('Risk/setDidMatrixUpdate');
exports.setUpdatedScores = (0, toolkit_1.createAction)('Risk/setUpdatedScores');
exports.setRiskType = (0, toolkit_1.createAction)('Risk/setRiskType'); //switch between linear and matrix
exports.initRiskMatrixPreview = (0, toolkit_1.createAction)('Risk/initRiskMatrixPreview');
exports.cancelRiskMatrixPreview = (0, toolkit_1.createAction)('Risk/cancelRiskMatrixPreview');
exports.getRiskMatrixPreview = (0, toolkit_1.createAction)('Risk/getRiskMatrixPreview');
exports.setEnablePreview = (0, toolkit_1.createAction)('Risk/setEnablePreview');
exports.setCancellPreview = (0, toolkit_1.createAction)('Risk/setCancellPreview');
exports.setIsPreviewLoading = (0, toolkit_1.createAction)('Risk/setIsPreviewLoading');
exports.setIsPreviewOnLoad = (0, toolkit_1.createAction)('Risk/setIsPreviewOnLoad');
exports.setMatrixPreviewStatus = (0, toolkit_1.createAction)('Risk/setmatrixPreviewStatus');
exports.setRiskMatrixAfterPreview = (0, toolkit_1.createAction)('Risk/setRiskMatrixAfterPreview');
exports.setRefreshMatrixGrid = (0, toolkit_1.createAction)('Risk/setRefreshMatrixGrid');
exports.setEditedCellsList = (0, toolkit_1.createAction)('Risk/updateEditedCellsList');
exports.setOnlyGradesUpdated = (0, toolkit_1.createAction)('Risk/setOnlyGradesUpdated');
exports.clearMatrixUpdate = (0, toolkit_1.createAction)('Risk/clearMatrixUpdate');
exports.setOverallRisk = (0, toolkit_1.createAction)('Risk/setOverallRisk');
//===================


/***/ }),

/***/ "./actions/asset.actions.ts":
/*!**********************************!*\
  !*** ./actions/asset.actions.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getSpatialLayerListRejected = exports.getSpatialLayerListResolved = exports.getSpatialLayerList = exports.getAssetFilterListResolved = exports.getAssetFilterListRejected = exports.getAssetFilterList = exports.clearAssetFields = exports.getAssetFieldsRejected = exports.getAssetFieldsResolved = exports.getAssetFields = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.getAssetFields = (0, toolkit_1.createAction)('asset/getAssetFields');
exports.getAssetFieldsResolved = (0, toolkit_1.createAction)('asset/getAssetFieldsResolved');
exports.getAssetFieldsRejected = (0, toolkit_1.createAction)('asset/getAssetFieldsRejected');
exports.clearAssetFields = (0, toolkit_1.createAction)('asset/clearAssetFields');
exports.getAssetFilterList = (0, toolkit_1.createAction)('asset/getAssetFilterList');
exports.getAssetFilterListRejected = (0, toolkit_1.createAction)('asset/getAssetFilterListRejected');
exports.getAssetFilterListResolved = (0, toolkit_1.createAction)('asset/getAssetFilterListResolved');
exports.getSpatialLayerList = (0, toolkit_1.createAction)('Asset/getSpatialLayerList');
exports.getSpatialLayerListResolved = (0, toolkit_1.createAction)('Asset/getSpatialLayerListResolved');
exports.getSpatialLayerListRejected = (0, toolkit_1.createAction)('Asset/getSpatialLayerListRejected');


/***/ }),

/***/ "./actions/component.actions.ts":
/*!**************************************!*\
  !*** ./actions/component.actions.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getComponentMetadataRejected = exports.getComponentMetadataResolved = exports.getCoFComponentTaskMetadata = exports.getLoFComponentTaskMetadata = exports.getCoFComponentCustomTableMetadata = exports.getLoFComponentCustomTableMetadata = exports.getCoFComponentProximityAttrMetadata = exports.getLoFComponentProximityAttrMetadata = exports.getCoFComponentProximityMetadata = exports.getLoFComponentProximityMetadata = exports.getCoFComponentAssetMetadata = exports.getLoFComponentInspectionMetadata = exports.getLoFComponentAssetMetadata = exports.clearComponentMetadata = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.clearComponentMetadata = (0, toolkit_1.createAction)('Comp/clearComponentMetadata');
exports.getLoFComponentAssetMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentAssetMetadata');
exports.getLoFComponentInspectionMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentInpsectionMetadata');
exports.getCoFComponentAssetMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentAssetMetadata');
exports.getLoFComponentProximityMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentProximityMetadata');
exports.getCoFComponentProximityMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentProximityMetadata');
exports.getLoFComponentProximityAttrMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentProximityAttrMetadata');
exports.getCoFComponentProximityAttrMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentProximityAttrMetadata');
exports.getLoFComponentCustomTableMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentCustomTableMetadata');
exports.getCoFComponentCustomTableMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentCustomTableMetadata');
exports.getLoFComponentTaskMetadata = (0, toolkit_1.createAction)('Comp/getLoFComponentTaskMetadata');
exports.getCoFComponentTaskMetadata = (0, toolkit_1.createAction)('Comp/getCoFComponentTaskMetadata');
exports.getComponentMetadataResolved = (0, toolkit_1.createAction)('Comp/getComponentMetadataResolved');
exports.getComponentMetadataRejected = (0, toolkit_1.createAction)('Comp/getComponentMetadataRejected');


/***/ }),

/***/ "./actions/index.ts":
/*!**************************!*\
  !*** ./actions/index.ts ***!
  \**************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./LoF.actions */ "./actions/LoF.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./CoF.actions */ "./actions/CoF.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./Risk.actions */ "./actions/Risk.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./asset.actions */ "./actions/asset.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./component.actions */ "./actions/component.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./util.actions */ "./actions/util.actions.ts"), exports);
__exportStar(__webpack_require__(/*! ./map.actions */ "./actions/map.actions.ts"), exports);


/***/ }),

/***/ "./actions/map.actions.ts":
/*!********************************!*\
  !*** ./actions/map.actions.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.changeSpatialProximity = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.changeSpatialProximity = (0, toolkit_1.createAction)('spatialProximity/changeDataSource');


/***/ }),

/***/ "./actions/util.actions.ts":
/*!*********************************!*\
  !*** ./actions/util.actions.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.setDataGridState = exports.setRiskLastRun = exports.setRiskRunning = exports.setRiskStatus = exports.setRiskNullScore = exports.updateRiskValuesDataGrid = exports.updateRiskScoreDataGrid = exports.updateRiskMultiScoreDataGridRow = exports.setRiskMultiScoreDataGrid = exports.setRiskScoreDataGrid = exports.setRiskScoreTable = exports.setRiskUnitScores = exports.setRiskEditScores = exports.setRiskScores = void 0;
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
exports.setRiskScores = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskScores'));
exports.setRiskEditScores = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskEditScores'));
exports.setRiskUnitScores = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskUnitScores'));
exports.setRiskScoreTable = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskScoreTable'));
exports.setRiskScoreDataGrid = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskScoreDataGrid'));
exports.setRiskMultiScoreDataGrid = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskMultiScoreDataGrid'));
exports.updateRiskMultiScoreDataGridRow = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/updateRiskMultiScoreDataGridRow'));
exports.updateRiskScoreDataGrid = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/updateRiskScoreDataGrid'));
exports.updateRiskValuesDataGrid = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/updateRiskValuesDataGrid'));
exports.setRiskNullScore = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskNullScore'));
exports.setRiskStatus = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskStatus'));
exports.setRiskRunning = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskRunning'));
exports.setRiskLastRun = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('Util/setRiskLastRun'));
exports.setDataGridState = (0, toolkit_1.createAction)((0, actions_1.addNamespace)('dataGrid/state'));


/***/ }),

/***/ "./apis/config.api.ts":
/*!****************************!*\
  !*** ./apis/config.api.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


var _a;
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.apiEnv = void 0;
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var config = (_a = {},
    // Sample config for overwritting service endpoints
    _a[lib_get_service_1.Environments.LOCAL] = {
        amRisk: 'https://saas-risk-management.info360-dev.com/dev',
        looker: 'http://localhost:3276/dev/looker',
        amUpload: 'https://saas-upload-service.info360-dev.com/dev',
        tiles: 'https://tiles-dev.info360-dev.com/dev',
        export: 'https://saas-export-service.info360-dev.com/dev',
    },
    _a);
exports.apiEnv = localStorage.getItem('apiEnv') || undefined;
exports["default"] = config;


/***/ }),

/***/ "./apis/risks.api.ts":
/*!***************************!*\
  !*** ./apis/risks.api.ts ***!
  \***************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.riskBaseUrl = void 0;
var config_api_1 = __importStar(__webpack_require__(/*! ./config.api */ "./apis/config.api.ts"));
var urlFormatting_1 = __webpack_require__(/*! @Utils/urlFormatting */ "./utils/urlFormatting.ts");
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var riskService = (0, lib_get_service_1.axiosWithHeaders)({
    config: config_api_1.default,
    service: 'amRisk',
    axiosCreateOpts: {
        timeout: 15000,
    },
});
exports.riskBaseUrl = (0, urlFormatting_1.formatUrlTrailing)((0, lib_get_service_1.getService)('amRisk', config_api_1.default, config_api_1.apiEnv));
exports["default"] = riskService;


/***/ }),

/***/ "./components/AddEditComponent/AddEditComponent.styles.ts":
/*!****************************************************************!*\
  !*** ./components/AddEditComponent/AddEditComponent.styles.ts ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStyles = void 0;
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
exports.useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        header: {
            '& div > div > div > h3': {
                fontSize: '1.125rem !important',
                padding: '8px 24px 8px 5px',
                display: 'flex',
                height: '55px',
                color: '#007CA0',
            },
        },
        headerWait: {
            '& div > div > div > h3': {
                fontSize: '1.125rem !important',
                padding: '8px 24px 8px 5px',
                display: 'flex',
                height: '55px',
                color: '#007CA0',
            },
            cursor: 'wait !important',
        },
        map: {
            height: '710px',
            padding: '20px',
        },
        defectRoot: {
            '& .MuiChip-root': {
                background: '#F1F4F4',
            },
            '& .MuiChip-label': {
                fontSize: '12px',
            },
        },
        codeListTag: {
            background: '#F1F4F4',
        },
        codeListOption: {
            '&[aria-selected="true"]': {
                background: '#007CA0',
                color: 'white',
            },
        },
    });
});


/***/ }),

/***/ "./components/AddEditComponent/AddEditComponent.tsx":
/*!**********************************************************!*\
  !*** ./components/AddEditComponent/AddEditComponent.tsx ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AddEditComponent = exports.fixupTaskField = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var Utils_1 = __webpack_require__(/*! @innovyze/lib-am-common/Utils */ "@innovyze/lib-am-common/Utils");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var AddEditComponent_styles_1 = __webpack_require__(/*! ./AddEditComponent.styles */ "./components/AddEditComponent/AddEditComponent.styles.ts");
var Components_1 = __webpack_require__(/*! @innovyze/lib-am-common/Components */ "@innovyze/lib-am-common/Components");
var Types_1 = __webpack_require__(/*! @innovyze/lib-am-common/Types */ "@innovyze/lib-am-common/Types");
var ScoreDataGrid_1 = __importStar(__webpack_require__(/*! ./ScoreDataGrid/ScoreDataGrid */ "./components/AddEditComponent/ScoreDataGrid/ScoreDataGrid.tsx"));
var system_1 = __webpack_require__(/*! @mui/system */ "@mui/system");
var MultiScoreDataGrid_1 = __importDefault(__webpack_require__(/*! ./MultiScoreDataGrid/MultiScoreDataGrid */ "./components/AddEditComponent/MultiScoreDataGrid/MultiScoreDataGrid.tsx"));
var ParameterDetails_1 = __importDefault(__webpack_require__(/*! ./ParameterDetails/ParameterDetails */ "./components/AddEditComponent/ParameterDetails/ParameterDetails.tsx"));
var observationFields_1 = __webpack_require__(/*! @Utils/observationFields */ "./utils/observationFields.ts");
var Utils_2 = __webpack_require__(/*! @innovyze/lib-am-common/Utils */ "@innovyze/lib-am-common/Utils");
var calculateRangeInterval_1 = __webpack_require__(/*! ./calculateRangeInterval */ "./components/AddEditComponent/calculateRangeInterval.ts");
var fixupTaskField = function (t, field) {
    switch (field) {
        case 'completedDate':
            return t('Completed Date');
        case 'scheduledDate':
            return t('Scheduled Date');
        case 'startChainage':
            return t('Start Chainage');
        case 'distance':
            return t('Distance');
        case 'direction':
            return t('Direction');
        default:
            return field;
    }
};
exports.fixupTaskField = fixupTaskField;
var AddEditComponent = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var countKey = _a.countKey, assetType = _a.assetType, assetFilterId = _a.assetFilterId, forLoF = _a.forLoF, observations = _a.observations, inspectionType = _a.inspectionType, isNew = _a.isNew, category = _a.category, component = _a.component, parentComponent = _a.parentComponent, parameterNumber = _a.parameterNumber, onApply = _a.onApply, onCancel = _a.onCancel, onChange = _a.onChange;
    var DEFECT_CODE_TYPE = 'PACP_CODE';
    var isSimulationEnabled = (0, stylovyze_1.useIsFeatureEnabled)('info-360-am-simulations');
    var isRiskSimulationEnabled = (0, stylovyze_1.useIsFeatureEnabled)('info-360-am-simulations-risk');
    var isRiskTaskComponentEnabled = (0, stylovyze_1.useIsFeatureEnabled)('info-360-risk-calc-tasks');
    var isRiskCountTaskEnabled = (0, stylovyze_1.useIsFeatureEnabled)('info-360-asset-risk-count-task');
    var isWebSocketEnabled = (0, stylovyze_1.useIsFeatureEnabled)('info-360-asset-risk-web-socket');
    var isRiskPACPObservationsEnabled = (0, stylovyze_1.useIsFeatureEnabled)('info-360-asset-risk-observations');
    var isSaveFilterOn = !!(0, stylovyze_1.useIsFeatureEnabled)('info-360-assets-save-filter');
    if (!isSaveFilterOn)
        assetFilterId = undefined;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var classes = (0, AddEditComponent_styles_1.useStyles)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _h = (0, stylovyze_1.useUnits)(), getSystemValueNoIntlFormat = _h.getSystemValueNoIntlFormat, getStandardisedValue = _h.getStandardisedValue, getSystemUnit = _h.getSystemUnit, system = _h.system;
    var changedRangesKey = "ChangedRanges".concat(parameterNumber !== null && parameterNumber !== void 0 ? parameterNumber : '');
    var lofStore = forLoF ? (0, _Selectors_1.selectLofStore)() : null;
    var cofStore = !forLoF ? (0, _Selectors_1.selectCofStore)() : null;
    var assetStore = (0, _Selectors_1.selectAssetStore)();
    var riskStore = (0, _Selectors_1.selectRiskStore)();
    var _j = (0, react_1.useState)(component ? component.name : ''), componentName = _j[0], setComponentName = _j[1];
    var _k = (0, react_1.useState)(component && component.field ? component.field : ''), field = _k[0], setField = _k[1];
    var _l = (0, react_1.useState)(component && component.fieldAlias ? component.fieldAlias : ''), fieldAlias = _l[0], setFieldAlias = _l[1];
    var _m = (0, react_1.useState)((_b = (component && component.simulationName)) !== null && _b !== void 0 ? _b : ''), simulationName = _m[0], setSimulationName = _m[1];
    var _o = (0, react_1.useState)((_c = component === null || component === void 0 ? void 0 : component.taskName) !== null && _c !== void 0 ? _c : ''), taskName = _o[0], setTaskName = _o[1];
    var _p = (0, react_1.useState)((_d = component === null || component === void 0 ? void 0 : component.uploadId) !== null && _d !== void 0 ? _d : ''), uploadId = _p[0], setUploadId = _p[1];
    var _q = (0, react_1.useState)((_e = (component && component.simulationUploadId)) !== null && _e !== void 0 ? _e : ''), simulationUploadId = _q[0], setSimulationUploadId = _q[1];
    var _r = (0, react_1.useState)(component && component.type
        ? component.type
        : _Types_1.ComponentType.Attribute), type = _r[0], setType = _r[1];
    var getTaskLayerName = function (taskName, uploadId) {
        return "".concat(uploadId);
    };
    var _s = (0, react_1.useState)(component && component.layer ? component.layer : ''), dataSource = _s[0], setDataSource = _s[1];
    var _t = (0, react_1.useState)(component && component.maxDistance ? component.maxDistance : 0), distance = _t[0], setDistance = _t[1];
    var _u = (0, react_1.useState)(component && component.metadata ? component.metadata : undefined), metadata = _u[0], setMetadata = _u[1];
    var _v = (0, react_1.useState)(component && component.metadataType ? component.metadataType : ''), metadataType = _v[0], setMetadataType = _v[1];
    var _w = (0, react_1.useState)(component && component.nullScore ? component.nullScore : 0), nullScore = _w[0], setNullScore = _w[1];
    var _x = (0, react_1.useState)(component && component.unitMetadata
        ? component.unitMetadata
        : undefined), unitMetadata = _x[0], setUnitMetadata = _x[1];
    var _y = (0, react_1.useState)(component && component.unitMetadataName
        ? component.unitMetadataName
        : ''), unitMetadataName = _y[0], setUnitMetadataName = _y[1];
    var _z = (0, react_1.useState)(false), componentChanged = _z[0], setComponentChanged = _z[1];
    var _0 = (0, react_1.useState)(''), validName = _0[0], setValidName = _0[1];
    var _1 = (0, react_1.useState)(false), validConfig = _1[0], setValidConfig = _1[1];
    var _2 = (0, react_1.useState)(false), showScoreTable = _2[0], setShowScoreTable = _2[1];
    var _3 = react_1.default.useState(true), isUnique = _3[0], setIsUnique = _3[1];
    var _4 = react_1.default.useState(component && ((_f = component.metadata) === null || _f === void 0 ? void 0 : _f.length)
        ? component.metadata.length -
            (parameterNumber !== undefined &&
                inspectionType === undefined
                ? 3
                : 2)
        : 5), rangeClasses = _4[0], setRangeClasses = _4[1];
    var _5 = react_1.default.useState(component &&
        (component.type === _Types_1.ComponentType.SpatialProximity ||
            component.type === _Types_1.ComponentType.SpatialAttribute)), hasMap = _5[0], setHasMap = _5[1];
    var _6 = react_1.default.useState(false), rangeChanged = _6[0], setRangeChanged = _6[1];
    var _7 = (0, react_1.useState)(false), fetchingMetadata = _7[0], setFetchingMetadata = _7[1];
    var _8 = (0, react_1.useState)(false), disableFieldSelect = _8[0], setDisableFieldSelect = _8[1];
    var _9 = (0, react_1.useState)(null), selectedCachedField = _9[0], setSelectedCachedField = _9[1];
    var scoreRows = (0, _Selectors_1.selectRiskScoreDataGrid)();
    var componentMetadataStore = (0, _Selectors_1.useComponentMetadataStore)();
    var metadataStore = (0, react_1.useMemo)(function () {
        switch (type) {
            case _Types_1.ComponentType.Simulation: {
                return __assign({ isLoading: false }, selectedCachedField);
            }
            default:
                return componentMetadataStore;
        }
    }, [type, selectedCachedField, componentMetadataStore]);
    var riskCounts = (0, _Selectors_1.selectRiskCount)(component.name.length !== 0 && rangeChanged
        ? changedRangesKey
        : countKey);
    var isRiskCountLoading = (0, _Selectors_1.useSelectIsCountLoading)(component.name.length !== 0 && rangeChanged
        ? changedRangesKey
        : countKey);
    var _10 = react_1.default.useState(), requestedCountMetadata = _10[0], setRequestedCountMetadata = _10[1];
    var _11 = (0, react_1.useState)(false), showMutliParam = _11[0], setShowMutliParam = _11[1];
    var _12 = (0, react_1.useState)(undefined), componentParameter1 = _12[0], setComponentParameter1 = _12[1];
    var _13 = (0, react_1.useState)(undefined), componentParameter2 = _13[0], setComponentParameter2 = _13[1];
    var _14 = (0, react_1.useState)(undefined), componentMatrix = _14[0], setComponentMatrix = _14[1];
    var _15 = (0, react_1.useState)(0), currentIndex = _15[0], setCurrentIndex = _15[1];
    var _16 = (0, react_1.useState)(undefined), moveToIndex = _16[0], setMoveToIndex = _16[1];
    var multiScoreEdit = (0, _Selectors_1.selectRiskMultiScoreEditDataGrid)();
    // map medtadata to defect code list
    var _17 = (0, react_1.useState)(((_g = component === null || component === void 0 ? void 0 : component.metadata) === null || _g === void 0 ? void 0 : _g.map(function (item) { return item.key; })) || []), defects = _17[0], setDefects = _17[1];
    // get defect code list by inspectionType
    var defectCodeList = (0, react_1.useMemo)(function () {
        if (field !== DEFECT_CODE_TYPE)
            return [];
        var inspectionStandard = inspectionType
            ? inspectionType.toLocaleUpperCase()
            : 'PACP';
        var codes = (0, Utils_1.getObservationCodes)(inspectionStandard, t);
        return Object.keys(codes).map(function (key) {
            return { code: key, label: codes[key] };
        });
    }, [type, field]);
    // filter for defect code auto complete
    var filterOptions = (0, material_1.createFilterOptions)({
        matchFrom: 'start',
    });
    var webSocket = (0, Utils_2.useWebSockets)();
    var riskCalCountCallBack = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var key, response, requestId, connectionId;
        return __generator(this, function (_a) {
            console.log('riskCalcCount', data);
            key = data.payload.key;
            response = data.payload.payload;
            requestId = data.requestId;
            connectionId = data.connectionId;
            console.log('riskCalcCount', connectionId, requestId);
            console.log('dispatch', {
                key: key,
                values: response,
            });
            dispatch((0, _Actions_1.getRiskCountResolved)({
                key: key,
                values: response,
            }));
            dispatch((0, _Actions_1.setRiskCountIsLoading)({
                key: key,
                loading: false,
            }));
            return [2 /*return*/];
        });
    }); };
    var riskCalCountErrorCallBack = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch((0, _Actions_1.setRiskCountIsLoading)({
                key: data.requestBody.key,
                loading: false,
            }));
            return [2 /*return*/];
        });
    }); };
    webSocket.setupRoutes('riskCalcCount', riskCalCountCallBack, riskCalCountErrorCallBack);
    var clearFields = function (changeType) {
        if (!changeType) {
            setComponentName('');
            setValidName(t('Enter a valid name'));
            setType(_Types_1.ComponentType.Attribute);
            if (onChange)
                onChange(false, true, false);
        }
        dispatch((0, _Actions_1.setRiskCountIsLoading)({
            key: countKey,
            loading: false,
        }));
        setField('');
        setFieldAlias('');
        setSelectedCachedField(null);
        setSimulationName('');
        setTaskName('');
        setUploadId('');
        setSimulationUploadId('');
        setDefects([]);
        setDistance(0);
        setDisableFieldSelect(false);
        dispatch((0, _Actions_1.setDataGridState)({
            key: countKey,
            initialState: undefined,
        }));
    };
    var menuItemsInspectionLoF = (0, react_1.useMemo)(function () {
        return lofStore === null || lofStore === void 0 ? void 0 : lofStore.componentInspectionFields.map(function (item, index) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: item.cachedField, disabled: !item.isCached }, { children: item.userFriendlyName }), index)); });
    }, [lofStore]);
    var menuItemsAssetLoF = (0, react_1.useMemo)(function () {
        return lofStore === null || lofStore === void 0 ? void 0 : lofStore.componentFields.map(function (item, index) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: item.cachedField, disabled: !item.isCached }, { children: item.userFriendlyName }), index)); });
    }, [lofStore]);
    var menuItemsCoF = (0, react_1.useMemo)(function () {
        return cofStore === null || cofStore === void 0 ? void 0 : cofStore.componentFields.map(function (item, index) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: item.cachedField, disabled: !item.isCached }, { children: item.userFriendlyName }), index)); });
    }, [cofStore]);
    var menuItemsType = (0, react_1.useMemo)(function () {
        var fieldTypes = [
            {
                value: _Types_1.ComponentType.Attribute,
                label: (0, _Types_1.getTypeDisplay)(_Types_1.ComponentType.Attribute, t),
            },
        ];
        if (inspectionType === undefined) {
            if (isRiskSimulationEnabled && isSimulationEnabled) {
                fieldTypes.push({
                    value: _Types_1.ComponentType.Simulation,
                    label: (0, _Types_1.getTypeDisplay)(_Types_1.ComponentType.Simulation, t),
                });
            }
            if (isRiskTaskComponentEnabled) {
                fieldTypes.push({
                    value: _Types_1.ComponentType.Task,
                    label: (0, _Types_1.getTypeDisplay)(_Types_1.ComponentType.Task, t),
                });
            }
            fieldTypes.push({
                value: _Types_1.ComponentType.SpatialProximity,
                label: (0, _Types_1.getTypeDisplay)(_Types_1.ComponentType.SpatialProximity, t),
            }, {
                value: _Types_1.ComponentType.SpatialAttribute,
                label: (0, _Types_1.getTypeDisplay)(_Types_1.ComponentType.SpatialAttribute, t),
            }, {
                value: _Types_1.ComponentType.CustomTable,
                label: (0, _Types_1.getTypeDisplay)(_Types_1.ComponentType.CustomTable, t),
            });
        }
        if (isRiskPACPObservationsEnabled && forLoF && observations) {
            fieldTypes.push({
                value: _Types_1.ComponentType.Observation,
                label: (0, _Types_1.getTypeDisplay)(_Types_1.ComponentType.Observation, t),
            });
        }
        // Keep MultiParam at the bottom for consistency
        if (parameterNumber === undefined) {
            fieldTypes.push({
                value: _Types_1.ComponentType.MultiParam,
                label: (0, _Types_1.getTypeDisplay)(_Types_1.ComponentType.MultiParam, t),
            });
        }
        return fieldTypes.map(function (item, index) {
            return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: item.value }, { children: item.label }), index));
        });
    }, [inspectionType, parameterNumber]);
    var menuItemsLayerList = (0, react_1.useMemo)(function () {
        if (assetStore.spatialLayerList &&
            assetStore.spatialLayerList.length > 0) {
            var layerList_1 = assetStore.spatialLayerList.map(function (layer) { return layer.LAYER_NAME; });
            var uniqLayer = layerList_1
                .filter(function (item, index) { return layerList_1.indexOf(item) === index; })
                .sort(function (a, b) {
                return a.localeCompare(b);
            });
            return uniqLayer.map(function (layer, index) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: layer }, { children: layer }), index)); });
        }
        else {
            return [];
        }
    }, [type, assetStore, dataSource]);
    var menuItemsSpatialAttrList = (0, react_1.useMemo)(function () {
        if (assetStore.spatialProximityAttr &&
            assetStore.spatialProximityAttr.length > 0) {
            var layerList_2 = assetStore.spatialProximityAttr.map(function (layer) { return layer.layerName; });
            var uniqLayer = layerList_2
                .filter(function (item, index) { return layerList_2.indexOf(item) === index; })
                .sort(function (a, b) {
                return a.localeCompare(b);
            });
            return uniqLayer.map(function (layer, index) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: layer }, { children: layer }), index)); });
        }
        else {
            return [];
        }
    }, [type, assetStore, dataSource]);
    var menuItemsSpatialAttrFieldList = (0, react_1.useMemo)(function () {
        if (assetStore.spatialProximityAttr &&
            assetStore.spatialProximityAttr.length > 0 &&
            dataSource != '') {
            var fieldList = assetStore.spatialProximityAttr
                .filter(function (layer) { return layer.layerName == dataSource; })
                .map(function (layer) { return layer.cachedField; })
                .sort(function (a, b) {
                return a.localeCompare(b);
            });
            return fieldList.map(function (field2, index) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: field2 }, { children: field2 }), index)); });
        }
        else {
            return [];
        }
    }, [type, assetStore, dataSource]);
    var menuItemsCustomTableList = (0, react_1.useMemo)(function () {
        if (assetStore.customTable && assetStore.customTable.length > 0) {
            var tableList_1 = assetStore.customTable.map(function (table) { return table.layerName; });
            var uniqTable = tableList_1
                .filter(function (item, index) { return tableList_1.indexOf(item) === index; })
                .sort(function (a, b) {
                return a.localeCompare(b);
            });
            return uniqTable.map(function (table, index) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: table }, { children: table }), index)); });
        }
        else {
            return [];
        }
    }, [type, assetStore, dataSource]);
    var menuItemsCustomTableFieldList = (0, react_1.useMemo)(function () {
        if (assetStore.customTable &&
            assetStore.customTable.length > 0 &&
            dataSource != '') {
            var fieldList = assetStore.customTable
                .filter(function (layer) { return layer.layerName == dataSource; })
                .sort(function (a, b) {
                return a.cachedField.localeCompare(b.cachedField);
            });
            return fieldList.map(function (layer, index) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: layer.cachedField }, { children: layer.userFriendlyName }), index)); });
        }
        else {
            return [];
        }
    }, [type, assetStore, dataSource]);
    var menuItemsObservationFieldList = (0, react_1.useMemo)(function () {
        if (type !== _Types_1.ComponentType.Observation)
            return [];
        return (0, observationFields_1.getObservationFields)(t).map(function (item) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: item.value, disabled: item.disabled }, { children: item.label }), item.value)); });
    }, [type]);
    var renderObservationFieldsForm = function () {
        if (isNew) {
            return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: t('Field') }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ id: 'fieldSelectOF', "data-cy": "fieldField", name: "field", defaultValue: field, disabled: isRiskCountLoading || disableFieldSelect, onChange: handleFieldSelectChangeObservation, label: t('Field') }, { children: menuItemsObservationFieldList }), "f".concat(dataSource).concat(Date.now))] })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, "data-cy": "fieldField", name: "field", label: t('Field'), variant: "outlined", defaultValue: field, disabled: true }) })));
        }
    };
    var renderObservationCodeValueForm = function () {
        if (field === DEFECT_CODE_TYPE) {
            return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, {}), (0, jsx_runtime_1.jsx)(material_1.Autocomplete, { className: classes.defectRoot, classes: {
                            tag: classes.codeListTag,
                            option: classes.codeListOption,
                        }, filterOptions: filterOptions, multiple: true, id: "defectCodes", freeSolo: true, options: defectCodeList.map(function (defect) { return defect.code; }), defaultValue: defects, getOptionLabel: function (option) {
                            var defectcode = defectCodeList.find(function (code) { return code.code == option; });
                            if (defectcode)
                                return "".concat(option, " - ").concat(defectcode.label);
                            else
                                return "".concat(option);
                        }, renderInput: function (params) { return ((0, jsx_runtime_1.jsx)(material_1.TextField, __assign({}, params, { variant: "outlined" }))); }, disabled: isRiskCountLoading || disableFieldSelect, onChange: handleObservationFieldInputChange, renderTags: function (values, getTagProps) {
                            return values.map(function (value, index) {
                                var _a, _b;
                                return ((0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: (_b = (_a = defectCodeList.find(function (code) { return code.code == value; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '' }, { children: (0, jsx_runtime_1.jsx)(material_1.Chip, __assign({}, getTagProps({ index: index }), { label: value })) }), value));
                            });
                        } })] })));
        }
    };
    var handleFieldSelectChangeObservation = function (event) {
        var target = event === null || event === void 0 ? void 0 : event.target;
        var observationfield = target.value;
        if (observationfield) {
            setField(observationfield);
            setFieldAlias(observationfield);
            setComponentChanged(true);
            if (onChange)
                onChange(true, false, false);
        }
    };
    var handleTypeSelectChange = function (event) {
        var target = event === null || event === void 0 ? void 0 : event.target;
        var type = target.value;
        setType(type);
        setValidConfig(false);
        setComponentChanged(true);
        if (onChange)
            onChange(true, false, false);
        clearFields(true);
        if (type === _Types_1.ComponentType.MultiParam) {
            var parameter1_1 = {
                name: '',
                select: false,
                weighting: 0,
                type: '',
                metadata: undefined,
                metadataType: undefined,
                maxDistance: undefined,
                field: undefined,
                fieldAlias: undefined,
                nullScore: undefined,
                parmeterComponent: undefined,
                scoreMatrix: undefined,
            };
            setComponentParameter1(parameter1_1);
            var parameter2_1 = {
                name: '',
                select: false,
                weighting: 0,
                type: '',
                metadata: undefined,
                metadataType: undefined,
                maxDistance: undefined,
                field: undefined,
                fieldAlias: undefined,
                nullScore: undefined,
                parmeterComponent: undefined,
                scoreMatrix: undefined,
            };
            setComponentParameter2(parameter2_1);
            setComponentMatrix(undefined);
            component.paramComponents = [parameter1_1, parameter2_1];
        }
        else if (componentParameter1) {
            setComponentParameter1(undefined);
            setComponentParameter2(undefined);
            setComponentMatrix(undefined);
            component.paramComponents = undefined;
        }
    };
    var handleDataSourceSelectChange = function (event) {
        var _a, _b, _c, _d, _e;
        var target = event === null || event === void 0 ? void 0 : event.target;
        setDataSource(target.value);
        setField('');
        setFieldAlias('');
        setDistance(0);
        setComponentChanged(true);
        if (onChange)
            onChange(true, false, false);
        var sl = assetStore.spatialLayerList.find(function (s) { return s.LAYER_NAME === target.value; });
        var slm = {
            _ID: (_a = sl === null || sl === void 0 ? void 0 : sl._ID) !== null && _a !== void 0 ? _a : '',
            TENANT_ID: (_b = sl === null || sl === void 0 ? void 0 : sl.TENANT_ID) !== null && _b !== void 0 ? _b : '',
            LAYER_NAME: (_c = sl === null || sl === void 0 ? void 0 : sl.LAYER_NAME) !== null && _c !== void 0 ? _c : '',
            EXTENT: (_d = sl === null || sl === void 0 ? void 0 : sl.EXTENT) !== null && _d !== void 0 ? _d : undefined,
            GEOMETRY_TYPE: (_e = sl === null || sl === void 0 ? void 0 : sl.GEOMETRY_TYPE) !== null && _e !== void 0 ? _e : undefined,
        };
        dispatch((0, _Actions_1.changeSpatialProximity)(slm));
    };
    var handleFieldSelectChangeCustomTable = function (event) {
        if (assetStore) {
            var target_1 = event === null || event === void 0 ? void 0 : event.target;
            var result = assetStore.customTable.find(function (_a) {
                var cachedField = _a.cachedField;
                return cachedField === target_1.value;
            });
            if (result) {
                setField(result.cachedField);
                setFieldAlias(result.userFriendlyName);
                setComponentChanged(true);
                if (onChange)
                    onChange(true, false, false);
                // This is a workaround to fix the MUI issue that disabling a select with focus does not correctly keep the focus when un-disabled
                setTimeout(function () {
                    var field = document.getElementById('fieldSelectCT');
                    if (field)
                        field.blur();
                    setDisableFieldSelect(true);
                }, 0);
            }
        }
    };
    var getSimulationDsplayName = function (sim) {
        return "".concat(sim.name, " - ").concat(sim.runDate);
    };
    var renderSimulationNames = function () {
        return riskStore.simulationData.map(function (sim) {
            var name = getSimulationDsplayName(sim);
            return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: sim.uploadId }, { children: name }), sim.uploadId));
        });
    };
    var renderTaskNames = function () {
        return riskStore.taskData.map(function (task) {
            return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: task.uploadId }, { children: task.name }), task.uploadId));
        });
    };
    var onSimulationChange = function (event) {
        var uploadId = event === null || event === void 0 ? void 0 : event.target.value;
        var simulation = riskStore.simulationData.find(function (sim) { return sim.uploadId === uploadId; });
        if (simulation) {
            var simName = getSimulationDsplayName(simulation);
            setSimulationName(simName);
            setSimulationUploadId(simulation.uploadId);
            setSelectedCachedField(null);
            setField('');
            setFieldAlias('');
            setComponentChanged(true);
            if (onChange)
                onChange(true, false, false);
        }
    };
    var onSelectedTaskNameChange = function (event) {
        var uploadId = event === null || event === void 0 ? void 0 : event.target.value;
        var task = riskStore.taskData.find(function (_) { return _.uploadId === uploadId; });
        if (task) {
            setTaskName(task.name);
            setUploadId(task.uploadId);
            setSelectedCachedField(null);
            setField('');
            setFieldAlias('');
            setComponentChanged(true);
            if (onChange)
                onChange(true, false, false);
        }
    };
    var handleFieldSelectChangeSpatialAttr = function (event) {
        if (assetStore) {
            var target_2 = event === null || event === void 0 ? void 0 : event.target;
            var result = assetStore.spatialProximityAttr.find(function (_a) {
                var cachedField = _a.cachedField;
                return cachedField === target_2.value;
            });
            if (result) {
                setField(result.cachedField);
                setFieldAlias(result.userFriendlyName);
                setDistance(0);
                setComponentChanged(true);
                if (onChange)
                    onChange(true, false, false);
                // This is a workaround to fix the MUI issue that disabling a select with focus does not correctly keep the focus when un-disabled
                setTimeout(function () {
                    var field = document.getElementById('fieldSelectSA');
                    if (field)
                        field.blur();
                    setDisableFieldSelect(true);
                }, 0);
            }
        }
    };
    var handleFieldSelectChangeSimulationAttr = function (event) {
        var target = event === null || event === void 0 ? void 0 : event.target;
        var result = simulationCachedFields.find(function (_a) {
            var userFriendlyName = _a.userFriendlyName;
            return userFriendlyName === target.value;
        });
        if (result) {
            setSelectedCachedField(result);
            setField(result.userFriendlyName);
            setFieldAlias(result.userFriendlyName);
            setComponentChanged(true);
            if (onChange)
                onChange(true, false, false);
        }
    };
    var handleTaskCachedFieldChange = function (event) {
        var value = event.target.value;
        var result = taskCachedFields.find(function (_a) {
            var cachedField = _a.cachedField;
            return cachedField === value;
        });
        if (result) {
            setSelectedCachedField(result);
            setField(result.cachedField);
            setFieldAlias(result.userFriendlyName);
            setComponentChanged(true);
            if (onChange)
                onChange(true, false, false);
        }
    };
    var handleFieldSelectChangeLoF = function (event) {
        if (lofStore) {
            var target_3 = event === null || event === void 0 ? void 0 : event.target;
            var result = (inspectionType
                ? lofStore.componentInspectionFields
                : lofStore.componentFields).find(function (_a) {
                var cachedField = _a.cachedField;
                return cachedField === target_3.value;
            });
            if (result) {
                setField(result.cachedField);
                setFieldAlias(result.userFriendlyName);
                setComponentChanged(true);
                if (onChange)
                    onChange(true, false, false);
                // This is a workaround to fix the MUI issue that disabling a select with focus does not correctly keep the focus when un-disabled
                setTimeout(function () {
                    var field = document.getElementById('fieldSelectA');
                    if (field)
                        field.blur();
                    setDisableFieldSelect(true);
                }, 0);
            }
        }
    };
    var handleFieldSelectChangeCoF = function (event) {
        if (cofStore) {
            var target_4 = event === null || event === void 0 ? void 0 : event.target;
            var result = cofStore.componentFields.find(function (_a) {
                var cachedField = _a.cachedField;
                return cachedField === target_4.value;
            });
            if (result) {
                setField(result.cachedField);
                setFieldAlias(result.userFriendlyName);
                setComponentChanged(true);
                if (onChange)
                    onChange(true, false, false);
                // This is a workaround to fix the MUI issue that disabling a select with focus does not correctly keep the focus when un-disabled
                setTimeout(function () {
                    var field = document.getElementById('fieldSelectA');
                    if (field)
                        field.blur();
                    setDisableFieldSelect(true);
                }, 0);
            }
        }
    };
    var handleDistanceChange = function (event) {
        var distance = parseFloat(event.target.value);
        setDistance(distance);
        setComponentChanged(true);
        if (onChange)
            onChange(true, false, false);
    };
    var validateName = function (event) {
        var name = event.target.value.toUpperCase();
        var error = '';
        if (name !== component.name.toUpperCase()) {
            if (name.trim().length == 0) {
                error = t('Enter a valid name');
            }
            else {
                var valid = true;
                if (parameterNumber === undefined) {
                    if (forLoF) {
                        valid =
                            (lofStore === null || lofStore === void 0 ? void 0 : lofStore.categories.find(function (cat) {
                                return cat.name === (category === null || category === void 0 ? void 0 : category.name)
                                    ? cat.components.find(function (component) {
                                        return component.name.toUpperCase() ==
                                            name;
                                    })
                                    : undefined;
                            })) === undefined;
                    }
                    else {
                        valid =
                            (cofStore === null || cofStore === void 0 ? void 0 : cofStore.categories.find(function (cat) {
                                return cat.name === (category === null || category === void 0 ? void 0 : category.name)
                                    ? cat.components.find(function (catComponent) {
                                        return catComponent.name.toUpperCase() ==
                                            name;
                                    })
                                    : undefined;
                            })) === undefined;
                    }
                }
                else if (parentComponent && parentComponent.paramComponents) {
                    valid =
                        parentComponent.paramComponents.find(function (component, index) {
                            return index !== parameterNumber &&
                                component.name.toUpperCase() == name;
                        }) === undefined;
                }
                if (!valid)
                    error = t('Enter a unique name');
            }
        }
        setValidName(error);
        setComponentName(error.length == 0 ? event.target.value : '');
        setComponentChanged(true);
        if (onChange)
            onChange(true, false, false);
    };
    var recalculateCount = function (scoreRows, isUnique, changedRange, metadataType) {
        if (scoreRows && !isRiskCountLoading) {
            // let requestMetadata = component.metadata ?? [];
            var requestMetadata = metadata !== null && metadata !== void 0 ? metadata : [];
            if (scoreRows && scoreRows.length !== 0) {
                if (isUnique) {
                    requestMetadata = scoreRows.map(function (row) { return ({
                        key: row.value,
                        value: row.score,
                        ix: row.id,
                    }); });
                }
                else {
                    requestMetadata = scoreRows
                        .filter(function (row) { return row.value !== '--'; })
                        .map(function (row) { return ({
                        key: row.value,
                        value: row.score,
                        ix: row.id,
                    }); });
                }
            }
            setRequestedCountMetadata(requestMetadata);
            // Use the name to check if the configuration has been saved and if so then we can use the changedRangesKey if changed
            var key = component.name.length !== 0 && changedRange
                ? changedRangesKey
                : countKey;
            if (isWebSocketEnabled) {
                dispatch((0, _Actions_1.getRiskCountResolved)({
                    key: key,
                    values: undefined,
                }));
                dispatch((0, _Actions_1.setRiskCountIsLoading)({
                    key: key,
                    loading: true,
                }));
            }
            switch (type) {
                case _Types_1.ComponentType.SpatialProximity:
                    if (isWebSocketEnabled) {
                        webSocket.sendMessage(JSON.stringify({
                            path: 'risk',
                            action: 'riskCalcCount',
                            key: key,
                            metadata: requestMetadata,
                            metadataType: metadataType !== null && metadataType !== void 0 ? metadataType : 'unique',
                            assetType: assetType,
                            assetFilterId: assetFilterId,
                            layerName: dataSource,
                            fieldType: 'proximity',
                        }));
                    }
                    else {
                        dispatch((0, _Actions_1.getRiskCountProximity)({
                            key: key,
                            metadata: requestMetadata,
                            metadataType: metadataType !== null && metadataType !== void 0 ? metadataType : 'unique',
                            assetType: assetType,
                            assetFilterId: assetFilterId,
                            layerName: dataSource,
                        }));
                    }
                    break;
                case _Types_1.ComponentType.SpatialAttribute:
                    if (isWebSocketEnabled) {
                        webSocket.sendMessage(JSON.stringify({
                            path: 'risk',
                            action: 'riskCalcCount',
                            key: key,
                            metadata: requestMetadata,
                            metadataType: metadataType !== null && metadataType !== void 0 ? metadataType : 'unique',
                            assetType: assetType,
                            assetFilterId: assetFilterId,
                            layerName: dataSource,
                            fieldName: field !== null && field !== void 0 ? field : '',
                            fieldType: 'proximityAttribute',
                            valueType: '',
                            maxDistance: distance,
                        }));
                    }
                    else {
                        dispatch((0, _Actions_1.getRiskCountProximityAttribute)({
                            key: key,
                            metadata: requestMetadata,
                            metadataType: metadataType !== null && metadataType !== void 0 ? metadataType : 'unique',
                            assetType: assetType,
                            assetFilterId: assetFilterId,
                            layerName: dataSource,
                            fieldName: field !== null && field !== void 0 ? field : '',
                            valueType: '',
                            distance: distance,
                        }));
                    }
                    break;
                case _Types_1.ComponentType.CustomTable:
                    if (isWebSocketEnabled) {
                        webSocket.sendMessage(JSON.stringify({
                            path: 'risk',
                            action: 'riskCalcCount',
                            key: key,
                            metadata: requestMetadata,
                            metadataType: metadataType !== null && metadataType !== void 0 ? metadataType : 'unique',
                            assetType: assetType,
                            assetFilterId: assetFilterId,
                            fieldName: field !== null && field !== void 0 ? field : '',
                            fieldType: 'customTable',
                            tableName: dataSource,
                            valueType: '', // TODO - NOT NEEDED??
                        }));
                    }
                    else {
                        dispatch((0, _Actions_1.getRiskCountCustomTable)({
                            key: key,
                            metadata: requestMetadata,
                            metadataType: metadataType !== null && metadataType !== void 0 ? metadataType : 'unique',
                            assetType: assetType,
                            assetFilterId: assetFilterId,
                            fieldName: field !== null && field !== void 0 ? field : '',
                            tableName: dataSource,
                            valueType: '', // TODO - NOT NEEDED??
                        }));
                    }
                    break;
                case _Types_1.ComponentType.Task:
                    if (isWebSocketEnabled) {
                        if (isRiskCountTaskEnabled) {
                            webSocket.sendMessage(JSON.stringify({
                                path: 'risk',
                                action: 'riskCalcCount',
                                key: key,
                                metadata: requestMetadata,
                                metadataType: metadataType !== null && metadataType !== void 0 ? metadataType : 'unique',
                                assetType: assetType,
                                assetFilterId: assetFilterId !== null && assetFilterId !== void 0 ? assetFilterId : '',
                                fieldName: field !== null && field !== void 0 ? field : '',
                                fieldType: 'task',
                                valueType: '',
                                uploadId: uploadId,
                            }));
                        }
                    }
                    else {
                        if (isRiskCountTaskEnabled) {
                            dispatch((0, _Actions_1.getRiskCountTask)({
                                key: key,
                                metadata: requestMetadata,
                                metadataType: metadataType !== null && metadataType !== void 0 ? metadataType : 'unique',
                                assetType: assetType,
                                assetFilterId: assetFilterId !== null && assetFilterId !== void 0 ? assetFilterId : '',
                                fieldName: field !== null && field !== void 0 ? field : '',
                                tableName: getTaskLayerName(taskName, uploadId),
                                valueType: '',
                                inspectionType: uploadId,
                            }));
                        }
                    }
                    break;
                case _Types_1.ComponentType.Simulation:
                case _Types_1.ComponentType.Observation:
                    // Dont do counts for these
                    dispatch((0, _Actions_1.setRiskCountIsLoading)({
                        key: key,
                        loading: false,
                    }));
                    break;
                default:
                    {
                        if (inspectionType) {
                            if (isWebSocketEnabled) {
                                webSocket.sendMessage(JSON.stringify({
                                    path: 'risk',
                                    action: 'riskCalcCount',
                                    key: key,
                                    metadata: requestMetadata,
                                    metadataType: metadataType !== null && metadataType !== void 0 ? metadataType : 'unique',
                                    assetType: assetType,
                                    assetFilterId: assetFilterId,
                                    fieldName: field !== null && field !== void 0 ? field : '',
                                    fieldType: 'inspection',
                                    inspectionType: inspectionType,
                                }));
                            }
                            else {
                                dispatch((0, _Actions_1.getRiskCountInspection)({
                                    key: key,
                                    metadata: requestMetadata,
                                    metadataType: metadataType !== null && metadataType !== void 0 ? metadataType : 'unique',
                                    assetType: assetType,
                                    assetFilterId: assetFilterId,
                                    fieldName: field !== null && field !== void 0 ? field : '',
                                    inspectionType: inspectionType,
                                }));
                            }
                        }
                        else {
                            if (isWebSocketEnabled) {
                                webSocket.sendMessage(JSON.stringify({
                                    path: 'risk',
                                    action: 'riskCalcCount',
                                    key: key,
                                    metadata: requestMetadata,
                                    metadataType: metadataType !== null && metadataType !== void 0 ? metadataType : 'unique',
                                    assetType: assetType,
                                    assetFilterId: assetFilterId,
                                    fieldName: field !== null && field !== void 0 ? field : '',
                                    fieldType: 'attribute',
                                }));
                            }
                            else {
                                dispatch((0, _Actions_1.getRiskCountAttribute)({
                                    key: key,
                                    metadata: requestMetadata,
                                    metadataType: metadataType !== null && metadataType !== void 0 ? metadataType : 'unique',
                                    assetType: assetType,
                                    assetFilterId: assetFilterId,
                                    fieldName: field !== null && field !== void 0 ? field : '',
                                }));
                            }
                        }
                    }
                    break;
            }
        }
    };
    var onRecalculateCount = function () {
        recalculateCount(scoreRows, isUnique, rangeChanged, metadataType);
    };
    var onRecalculateCountMatrix = function () {
        var _a;
        if (component.scoreMatrix &&
            componentParameter1 &&
            componentParameter1.metadata &&
            componentParameter2 &&
            componentParameter2.metadata) {
            var scoreComponents = [
                getComponentCount(componentParameter1),
                getComponentCount(componentParameter2),
            ];
            // Update the matrix with the current score
            if (multiScoreEdit.length !== 0) {
                var matrix = [];
                var index = 0;
                for (var i = 0; i < componentParameter2.metadata.length; i++) {
                    var row = {
                        id: i,
                        param2: componentParameter2.metadata[i].key,
                    };
                    for (var i2 = 0; i2 < componentParameter1.metadata.length; i2++) {
                        var score_1 = (_a = multiScoreEdit[i]["".concat(i2, "-score")]) !== null && _a !== void 0 ? _a : 0;
                        component.scoreMatrix[index].score = score_1;
                        row["".concat(i2, "-score")] = score_1;
                        row["".concat(i2, "-count")] = 0;
                        index++;
                    }
                    matrix.push(row);
                }
                setComponentMatrix(matrix);
            }
            // Get the counts for the matrix
            var key = 'ScoreMatrix';
            if (isWebSocketEnabled) {
                dispatch((0, _Actions_1.setRiskCountIsLoading)({
                    key: key,
                    loading: true,
                }));
                webSocket.sendMessage(JSON.stringify({
                    path: 'risk',
                    action: 'riskCalcCount',
                    key: key,
                    fieldType: 'multiParam',
                    scoreMatrix: component.scoreMatrix,
                    assetType: assetType,
                    assetFilterId: assetFilterId,
                    inspectionType: inspectionType,
                    paramComponents: scoreComponents,
                }));
            }
            else {
                dispatch((0, _Actions_1.getRiskCountScoreMatrix)({
                    key: key,
                    scoreMatrix: component.scoreMatrix,
                    assetType: assetType,
                    assetFilterId: assetFilterId,
                    inspectionType: inspectionType,
                    components: scoreComponents,
                }));
            }
        }
    };
    var createScoreRowsFromComponent = function (changeComponent, changedRange, metadataType, nullScore, metadata, unitMetadata) {
        var _a;
        if (metadata) {
            var newScoreRows_1 = [];
            var isUnique_1 = false;
            var fetchCounts = riskCounts === undefined ||
                riskCounts.length === 0 ||
                changeComponent ||
                component.name.length === 0;
            if (metadataType === 'unique') {
                isUnique_1 = true;
                var sorted = __spreadArray([], metadata, true);
                if (inspectionType === undefined) {
                    // Sort forcing the '--' (null entry) to the bottom
                    sorted.sort(function (a, b) {
                        if (a.key === '--')
                            return 1;
                        if (b.key === '--')
                            return -1;
                        return a.key.toString().localeCompare(b.key.toString());
                    });
                }
                newScoreRows_1 = sorted.map(function (row, index) { return ({
                    id: index,
                    score: row.value,
                    value: row.key,
                }); });
                if (riskCounts && !fetchCounts) {
                    // We cant verify spatial attribute data as the scores could not match the request due to items not being in range
                    // Or if we have missmatched lenghts, again because the server does not return some empty rows
                    if (type !== _Types_1.ComponentType.SpatialAttribute &&
                        riskCounts.length === newScoreRows_1.length) {
                        var _loop_1 = function (i) {
                            if (!riskCounts.find(function (_a) {
                                var key = _a.key;
                                return (key === undefined || key === null
                                    ? '--'
                                    : key.toString()) ===
                                    newScoreRows_1[i].value.toString();
                            })) {
                                fetchCounts = true;
                                return "break";
                            }
                        };
                        // But everything else  they actually match just in case
                        for (var i = 0; i < newScoreRows_1.length - 1; i++) {
                            var state_1 = _loop_1(i);
                            if (state_1 === "break")
                                break;
                        }
                    }
                    if (!fetchCounts) {
                        newScoreRows_1 = (0, ScoreDataGrid_1.updateRiskCounts)(newScoreRows_1, riskCounts, system == 'Metric', true);
                    }
                }
                dispatch((0, _Actions_1.setRiskScoreDataGrid)(newScoreRows_1));
                dispatch((0, _Actions_1.setRiskUnitScores)(undefined));
                dispatch((0, _Actions_1.setRiskEditScores)([]));
                dispatch((0, _Actions_1.setRiskScores)([]));
            }
            else if (metadata.length !== 0) {
                newScoreRows_1 = metadata.map(function (row, index) { return ({
                    id: index,
                    score: row.value,
                    value: row.key,
                }); });
                if (inspectionType === undefined &&
                    newScoreRows_1[newScoreRows_1.length - 1].value !== '--') {
                    // Add the null score
                    newScoreRows_1.push({
                        id: newScoreRows_1.length,
                        score: nullScore !== null && nullScore !== void 0 ? nullScore : 0,
                        value: '--',
                    });
                }
                if (riskCounts && !fetchCounts) {
                    var _loop_2 = function (i) {
                        if (!riskCounts.find(function (_a) {
                            var key = _a.key;
                            return (key === undefined || key === null
                                ? '--'
                                : key.toString()) ===
                                newScoreRows_1[i].value;
                        })) {
                            fetchCounts = true;
                            return "break";
                        }
                    };
                    // Veify they actually match just in case
                    for (var i = 0; i < newScoreRows_1.length - 1; i++) {
                        var state_2 = _loop_2(i);
                        if (state_2 === "break")
                            break;
                    }
                    if (!fetchCounts) {
                        newScoreRows_1 = (0, ScoreDataGrid_1.updateRiskCounts)(newScoreRows_1, riskCounts, system == 'Metric', true);
                    }
                }
                dispatch((0, _Actions_1.setRiskScoreDataGrid)(newScoreRows_1));
                // Extract the scores, ignoring the null score if needed
                var offset = inspectionType === undefined ? 1 : 0;
                var scores = [newScoreRows_1.length - offset];
                for (var i = 0; i < newScoreRows_1.length - offset; i++) {
                    var values = newScoreRows_1[i].value.split(' ');
                    if (values.length == 2)
                        scores[i] = parseFloat(values[1]);
                    else
                        scores[i] = parseFloat(values[2]);
                }
                // If we have a unit we may need to do some covnersion stuff later
                if (system !== 'Metric' &&
                    unitMetadata &&
                    unitMetadata.unit &&
                    unitMetadata.unit.length !== 0) {
                    var precision_1 = (_a = unitMetadata.precision) !== null && _a !== void 0 ? _a : 0;
                    // Create an array with the values in the system display value what ever that might be
                    var unitScores = scores.map(function (score) {
                        return parseFloat(parseFloat(getSystemValueNoIntlFormat("".concat(score, " ").concat(unitMetadata.unit))).toFixed(precision_1));
                    });
                    // Now convert the rounded conversion back to metric.... I know !!!
                    var internalUnit_1 = getSystemUnit(unitMetadata.unit);
                    var adjustment_1 = 1;
                    // mm -> in -> cm
                    if (unitMetadata.unit === 'mm')
                        adjustment_1 = 10;
                    scores = unitScores.map(function (score) {
                        return parseFloat((parseFloat(getStandardisedValue("".concat(score, " ").concat(internalUnit_1))) * adjustment_1).toFixed(precision_1));
                    });
                    dispatch((0, _Actions_1.setRiskUnitScores)(unitScores));
                }
                else {
                    dispatch((0, _Actions_1.setRiskUnitScores)(undefined));
                }
                var stringScores = scores.map(function (score) {
                    return score === null || score === void 0 ? void 0 : score.toString();
                });
                dispatch((0, _Actions_1.setRiskEditScores)(stringScores));
                dispatch((0, _Actions_1.setRiskScores)(scores));
            }
            // Fetch the counts and lengths
            if (fetchCounts) {
                recalculateCount(newScoreRows_1, isUnique_1, changedRange, metadataType);
            }
            setIsUnique(isUnique_1);
            setShowScoreTable(true);
        }
    };
    var updateComponent = function () {
        if (isNew || parameterNumber !== undefined) {
            component.type = type;
            component.field = field;
            component.fieldAlias = fieldAlias;
            component.simulationName = simulationName;
            component.taskName = taskName;
            component.uploadId = uploadId;
            component.simulationUploadId = simulationUploadId;
            component.layer =
                type === _Types_1.ComponentType.Task
                    ? getTaskLayerName(taskName, uploadId)
                    : dataSource;
        }
        component.maxDistance = distance;
        if (isUnique) {
            component.metadata = scoreRows.map(function (row) { return ({
                key: row.value,
                value: row.score,
                ix: row.id,
            }); });
        }
        else {
            if (parameterNumber === undefined) {
                component.metadata = scoreRows
                    .filter(function (row) { return row.value !== '--'; })
                    .map(function (row) { return ({
                    key: row.value,
                    value: row.score,
                    ix: row.id,
                }); });
            }
            else {
                // Dont filter out the '--' for multi param
                component.metadata = scoreRows.map(function (row) { return ({
                    key: row.value,
                    value: row.score,
                    ix: row.id,
                }); });
            }
        }
        component.metadataType = metadataType;
        if (type === _Types_1.ComponentType.MultiParam &&
            componentParameter1 &&
            componentParameter2) {
            component.paramComponents = [
                componentParameter1,
                componentParameter2,
            ];
        }
        // If we are saving components for the first time then move to the next tab
        var changeTab = component.name === '';
        if (component.name != componentName) {
            if (parameterNumber === undefined) {
                dispatch((0, _Actions_1.renameRiskCount)({
                    existingKey: countKey,
                    newKey: countKey.replace("-".concat(component.name), "-".concat(componentName)),
                }));
            }
            component.name = componentName;
        }
        component.unitMetadata = unitMetadata;
        component.unitMetadataName = unitMetadataName;
        var nullScore = scoreRows.find(function (row) { return row.value === '--'; });
        component.nullScore = nullScore ? nullScore.score : 0;
        dispatch((0, _Actions_1.renameRiskCount)({
            existingKey: changedRangesKey,
            newKey: countKey,
        }));
        setComponentChanged(false);
        if (onChange)
            onChange(false, true, changeTab);
    };
    (0, react_1.useEffect)(function () {
        if (type === _Types_1.ComponentType.MultiParam) {
            setShowScoreTable(false);
            setShowMutliParam(true);
        }
        else {
            var valid = false;
            switch (type) {
                case _Types_1.ComponentType.Attribute:
                    valid = field.length !== 0;
                    break;
                case _Types_1.ComponentType.SpatialProximity:
                    valid = dataSource.length !== 0;
                    break;
                case _Types_1.ComponentType.SpatialAttribute:
                    valid = field.length !== 0 && dataSource.length !== 0;
                    break;
                case _Types_1.ComponentType.CustomTable:
                    valid = field.length !== 0 && dataSource.length !== 0;
                    break;
                case _Types_1.ComponentType.Simulation:
                case _Types_1.ComponentType.Task:
                    valid = field.length !== 0;
                    break;
                case _Types_1.ComponentType.Observation:
                    valid = field.length !== 0 && defects.length !== 0;
                    break;
            }
            setValidConfig(valid);
            setShowScoreTable(false);
            setShowMutliParam(false);
            if ((isNew || parameterNumber !== undefined) && valid) {
                if (component.unitMetadataName !==
                    "".concat(field, "-").concat(type, "-").concat(dataSource)) {
                    component.unitMetadata = undefined;
                    component.unitMetadataName = undefined;
                    setRangeClasses(5);
                    setHasMap(type === _Types_1.ComponentType.SpatialProximity ||
                        type === _Types_1.ComponentType.SpatialAttribute);
                    fetchMetadata(false, parameterNumber !== undefined);
                }
            }
        }
    }, [field, type, dataSource, defects]);
    var fetchMetadata = function (disableField, multiParam) {
        var metaDataName = type === _Types_1.ComponentType.Task
            ? "".concat(field, "-").concat(type, "-").concat(uploadId)
            : "".concat(field, "-").concat(type, "-").concat(dataSource);
        if ((field || dataSource) && unitMetadataName !== metaDataName) {
            if (disableField)
                setDisableFieldSelect(true);
            switch (type) {
                case _Types_1.ComponentType.SpatialAttribute: {
                    setFetchingMetadata(true);
                    if (forLoF) {
                        dispatch((0, _Actions_1.getLoFComponentProximityAttrMetadata)({
                            assetType: assetType,
                            field: field !== null && field !== void 0 ? field : '',
                            fieldAlias: field !== null && field !== void 0 ? field : '',
                            layerName: dataSource,
                            multiParam: multiParam,
                        }));
                    }
                    else {
                        dispatch((0, _Actions_1.getCoFComponentProximityAttrMetadata)({
                            assetType: assetType,
                            field: field !== null && field !== void 0 ? field : '',
                            fieldAlias: field !== null && field !== void 0 ? field : '',
                            layerName: dataSource,
                            multiParam: multiParam,
                        }));
                    }
                    break;
                }
                case _Types_1.ComponentType.SpatialProximity: {
                    setFetchingMetadata(true);
                    if (forLoF) {
                        dispatch((0, _Actions_1.getLoFComponentAssetMetadata)({
                            assetType: assetType,
                            field: 'proximity',
                            fieldAlias: dataSource !== null && dataSource !== void 0 ? dataSource : '',
                            multiParam: multiParam,
                        }));
                    }
                    else {
                        dispatch((0, _Actions_1.getCoFComponentAssetMetadata)({
                            assetType: assetType,
                            field: 'proximity',
                            fieldAlias: dataSource !== null && dataSource !== void 0 ? dataSource : '',
                            multiParam: multiParam,
                        }));
                    }
                    break;
                }
                case _Types_1.ComponentType.CustomTable: {
                    setFetchingMetadata(true);
                    if (forLoF) {
                        dispatch((0, _Actions_1.getLoFComponentCustomTableMetadata)({
                            assetType: assetType,
                            field: field !== null && field !== void 0 ? field : '',
                            fieldAlias: fieldAlias !== null && fieldAlias !== void 0 ? fieldAlias : '',
                            layerName: dataSource,
                            multiParam: multiParam,
                        }));
                    }
                    else {
                        dispatch((0, _Actions_1.getCoFComponentCustomTableMetadata)({
                            assetType: assetType,
                            field: field !== null && field !== void 0 ? field : '',
                            fieldAlias: fieldAlias !== null && fieldAlias !== void 0 ? fieldAlias : '',
                            layerName: dataSource,
                            multiParam: multiParam,
                        }));
                    }
                    break;
                }
                case _Types_1.ComponentType.Task:
                    setFetchingMetadata(true);
                    if (forLoF) {
                        dispatch((0, _Actions_1.getLoFComponentTaskMetadata)({
                            assetType: assetType,
                            field: field !== null && field !== void 0 ? field : '',
                            fieldAlias: fieldAlias !== null && fieldAlias !== void 0 ? fieldAlias : '',
                            layerName: getTaskLayerName(taskName, uploadId),
                            multiParam: multiParam,
                        }));
                    }
                    else {
                        dispatch((0, _Actions_1.getCoFComponentTaskMetadata)({
                            assetType: assetType,
                            field: field !== null && field !== void 0 ? field : '',
                            fieldAlias: fieldAlias !== null && fieldAlias !== void 0 ? fieldAlias : '',
                            layerName: getTaskLayerName(taskName, uploadId),
                            multiParam: multiParam,
                        }));
                    }
                    break;
                case _Types_1.ComponentType.Observation:
                case _Types_1.ComponentType.Simulation: {
                    // Not needed for Simulation or Observation
                    break;
                }
                default: {
                    setFetchingMetadata(true);
                    if (forLoF) {
                        if (inspectionType) {
                            dispatch((0, _Actions_1.getLoFComponentInspectionMetadata)({
                                assetType: assetType,
                                field: field !== null && field !== void 0 ? field : '',
                                fieldAlias: fieldAlias !== null && fieldAlias !== void 0 ? fieldAlias : '',
                                multiParam: multiParam,
                            }));
                        }
                        else {
                            dispatch((0, _Actions_1.getLoFComponentAssetMetadata)({
                                assetType: assetType,
                                field: field !== null && field !== void 0 ? field : '',
                                fieldAlias: fieldAlias !== null && fieldAlias !== void 0 ? fieldAlias : '',
                                multiParam: multiParam,
                            }));
                        }
                    }
                    else {
                        dispatch((0, _Actions_1.getCoFComponentAssetMetadata)({
                            assetType: assetType,
                            field: field !== null && field !== void 0 ? field : '',
                            fieldAlias: fieldAlias !== null && fieldAlias !== void 0 ? fieldAlias : '',
                            multiParam: multiParam,
                        }));
                    }
                    break;
                }
            }
        }
    };
    var createDefaultRangeValues = function (newRangeClasses, unitMetadata) {
        var _a, _b;
        var metadata = undefined;
        if (unitMetadata) {
            if (unitMetadata.range) {
                metadata = new Array(newRangeClasses + 2);
                var defaultScore = [metadata.length];
                var rangeMin = unitMetadata.range.min;
                if (rangeMin == null || rangeMin == undefined) {
                    rangeMin = 0;
                }
                var rangeMax = unitMetadata.range.max;
                if (rangeMax == null || rangeMax == undefined) {
                    rangeMax = 0;
                }
                // Do we have to care about units at this point?
                if (unitMetadata.unit && system !== 'Metric') {
                    var precision = (_a = unitMetadata.precision) !== null && _a !== void 0 ? _a : 0;
                    // To make the ranges work we need to do a set in native unit and one in display units
                    // Otherwise the initial display can have too many decimal places until the user edits a value
                    var internalUnit = getSystemUnit(unitMetadata.unit);
                    var adjustment = unitMetadata.unit === 'mm' ? 10 : 1;
                    var unitMin = parseFloat(getSystemValueNoIntlFormat("".concat(rangeMin, " ").concat(unitMetadata.unit)));
                    var unitMax = parseFloat(getSystemValueNoIntlFormat("".concat(rangeMax, " ").concat(unitMetadata.unit)));
                    var unitRange = unitMax - unitMin;
                    var interval = (0, calculateRangeInterval_1.calculateRangeInterval)(unitRange, newRangeClasses, precision);
                    var first = unitMin;
                    var nativeFirst = rangeMin;
                    var pos = 0;
                    defaultScore[pos] = nativeFirst;
                    metadata[pos] = {
                        key: " <= ".concat(nativeFirst),
                        value: 0,
                        ix: pos++,
                    };
                    for (var i = 0; i < newRangeClasses - 1; i++) {
                        var next = +(first + interval).toFixed(precision);
                        var nativeNext = parseFloat(getStandardisedValue("".concat(next, " ").concat(internalUnit))) * adjustment;
                        metadata[pos] = {
                            key: "".concat(nativeFirst, " <= ").concat(nativeNext),
                            value: 0,
                            ix: pos++,
                        };
                        defaultScore[pos] = nativeNext;
                        nativeFirst = nativeNext;
                        first = next;
                    }
                    // Ignore the range max as it could be less than we need to make a unique range
                    var max = first + interval;
                    var nativeMax = parseFloat(getStandardisedValue("".concat(max, " ").concat(internalUnit))) * adjustment;
                    defaultScore[pos] = nativeMax;
                    metadata[pos] = {
                        key: "".concat(nativeFirst, " <= ").concat(nativeMax),
                        value: 0,
                        ix: pos++,
                    };
                    defaultScore[pos] = nativeMax;
                    metadata[pos] = {
                        key: "> ".concat(nativeMax),
                        value: 0,
                        ix: pos++,
                    };
                }
                else {
                    var precision = (_b = unitMetadata.precision) !== null && _b !== void 0 ? _b : 0;
                    var range = rangeMax - rangeMin;
                    var interval = (0, calculateRangeInterval_1.calculateRangeInterval)(range, newRangeClasses, precision);
                    var first = rangeMin;
                    var pos = 0;
                    defaultScore[pos] = first;
                    metadata[pos] = {
                        key: " <= ".concat(first),
                        value: 0,
                        ix: pos++,
                    };
                    for (var i = 0; i < newRangeClasses - 1; i++) {
                        var next = +(first + interval).toFixed(precision);
                        metadata[pos] = {
                            key: "".concat(first, " <= ").concat(next),
                            value: 0,
                            ix: pos++,
                        };
                        defaultScore[pos] = next;
                        first = next;
                    }
                    // Ignore the range max as it could be less than we need to make a unique range
                    var max = first + interval;
                    defaultScore[pos] = max;
                    metadata[pos] = {
                        key: "".concat(first, " <= ").concat(max),
                        value: 0,
                        ix: pos++,
                    };
                    defaultScore[pos] = max;
                    metadata[pos] = {
                        key: "> ".concat(max),
                        value: 0,
                        ix: pos++,
                    };
                }
                setMetadata(metadata);
                setMetadataType('range');
                setNullScore(0);
                var stringScores = defaultScore.map(function (score) {
                    return score === null || score === void 0 ? void 0 : score.toString();
                });
                dispatch((0, _Actions_1.setRiskEditScores)(stringScores));
                dispatch((0, _Actions_1.setRiskScores)(defaultScore));
                setRangeClasses(newRangeClasses);
            }
        }
        return metadata;
    };
    var typeInputs = function () {
        if (isNew) {
            return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: t('Type') }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ "data-cy": "typeField", name: "type", onChange: handleTypeSelectChange, disabled: isRiskCountLoading || fetchingMetadata, defaultValue: type, label: t('Type') }, { children: menuItemsType }))] })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, "data-cy": "typeField", name: "type", label: t('Type'), variant: "outlined", defaultValue: (0, _Types_1.getTypeDisplay)(type, t), disabled: true }) })));
        }
    };
    var attrInputs = function () {
        if (isNew) {
            return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: t('Field') }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ id: 'fieldSelectA', "data-cy": "fieldField", name: "field", defaultValue: field, onChange: forLoF
                            ? handleFieldSelectChangeLoF
                            : handleFieldSelectChangeCoF, disabled: isRiskCountLoading || disableFieldSelect, label: t('Field') }, { children: forLoF
                            ? inspectionType
                                ? menuItemsInspectionLoF
                                : menuItemsAssetLoF
                            : menuItemsCoF }), "f".concat(dataSource).concat(Date.now))] })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, "data-cy": "fieldField", name: "field", label: t('Field'), variant: "outlined", defaultValue: fieldAlias, disabled: true }) })));
        }
    };
    var handleObservationFieldInputChange = function (_event, values) {
        setDefects(values);
        setComponentChanged(true);
        if (onChange)
            onChange(true, false, false);
    };
    var dataSourceSelect = (0, react_1.useMemo)(function () {
        switch (type) {
            case _Types_1.ComponentType.SpatialProximity:
                return menuItemsLayerList;
            case _Types_1.ComponentType.SpatialAttribute:
                return menuItemsSpatialAttrList;
            case _Types_1.ComponentType.CustomTable:
                return menuItemsCustomTableList;
        }
    }, [type]);
    var dataSourceInputs = function () {
        if (isNew) {
            return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true, disabled: isRiskCountLoading || fetchingMetadata }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: t('Data Source') }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ "data-cy": "dataSourceField", name: "dataSource", defaultValue: dataSource, onChange: handleDataSourceSelectChange, label: t('Data Source') }, { children: dataSourceSelect }), "ds".concat(type).concat(Date.now))] })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, "data-cy": "dataSourceField", name: "dataSource", label: t('Data Source'), variant: "outlined", defaultValue: dataSource, disabled: true }) })));
        }
    };
    var spatialAttriFieldInputs = function () {
        if (isNew) {
            return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: t('Field') }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ id: 'fieldSelectSA', "data-cy": "fieldField", name: "saField", defaultValue: field, onChange: handleFieldSelectChangeSpatialAttr, disabled: isRiskCountLoading || disableFieldSelect, label: t('Field') }, { children: menuItemsSpatialAttrFieldList }), "f".concat(dataSource).concat(Date.now))] })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, "data-cy": "fieldField", name: "safield", label: t('Field'), variant: "outlined", defaultValue: field, disabled: true }) })));
        }
    };
    var distanceInputs = function () {
        // Distance is always editable
        return ((0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.UnitField, { fullWidth: true, "data-cy": "distanceField", name: "distance", unit: "m", step: "1", min: 0, defaultValue: distance.toString(), label: t('Distance'), variant: "outlined", onChange: handleDistanceChange, disabled: isRiskCountLoading ||
                    fetchingMetadata ||
                    disableFieldSelect }, "dis".concat(field)) })));
    };
    var customTableInputs = function () {
        if (isNew) {
            return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: t('Field') }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ id: 'fieldSelectCT', "data-cy": "fieldField", name: "ctfield", defaultValue: field, onChange: handleFieldSelectChangeCustomTable, disabled: isRiskCountLoading || disableFieldSelect, label: t('Field') }, { children: menuItemsCustomTableFieldList }), "f".concat(dataSource).concat(Date.now))] })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, "data-cy": "fieldField", name: "ctfield", label: t('Field'), variant: "outlined", defaultValue: fieldAlias, disabled: true }) })));
        }
    };
    var simulationCachedFields = (0, react_1.useMemo)(function () {
        var _a, _b;
        return ((_b = (_a = riskStore.simulationData.find(function (sim) { return sim.uploadId === simulationUploadId; })) === null || _a === void 0 ? void 0 : _a.cachedFields) !== null && _b !== void 0 ? _b : []);
    }, [simulationUploadId]);
    var menuItemsSimulationFieldList = (0, react_1.useMemo)(function () {
        return simulationCachedFields.map(function (field, index) {
            return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: field.userFriendlyName }, { children: field.userFriendlyName }), field.cachedField + index));
        });
    }, [simulationCachedFields]);
    var taskCachedFields = (0, react_1.useMemo)(function () {
        var _a, _b;
        return ((_b = (_a = riskStore.taskData.find(function (_) { return _.uploadId === uploadId; })) === null || _a === void 0 ? void 0 : _a.cachedFields) !== null && _b !== void 0 ? _b : []);
    }, [uploadId]);
    var taskCachedFieldListItems = (0, react_1.useMemo)(function () {
        return taskCachedFields.map(function (field) {
            return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: field.cachedField }, { children: (0, exports.fixupTaskField)(t, field.userFriendlyName) }), field.cachedField));
        });
    }, [taskCachedFields]);
    var renderThirdFormControl = function (_a) {
        var title = _a.title, onChange = _a.onChange, renderValues = _a.renderValues, defaultValue = _a.defaultValue, valueWhenDisabled = _a.valueWhenDisabled;
        if (isNew) {
            return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: title }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ id: "fieldSelect".concat(title), "data-cy": "thirdFormControl".concat(title), name: "thirdFormControl".concat(title), onChange: onChange, defaultValue: defaultValue, disabled: isRiskCountLoading || disableFieldSelect, label: t(title) }, { children: renderValues() }), "f".concat(dataSource).concat(Date.now))] })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, "data-cy": "fieldNameField", name: "fnfield", label: t(title), variant: "outlined", defaultValue: valueWhenDisabled, disabled: true }) })));
        }
    };
    var renderSimulationNameControl = function () {
        if (isNew) {
            return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: t('Simulation') }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ id: 'fieldSelectSimulation', "data-cy": "simulationFieldField", name: "simulationField", defaultValue: simulationUploadId, onChange: onSimulationChange, disabled: isRiskCountLoading || disableFieldSelect, label: t('Simulation') }, { children: renderSimulationNames() }), "f".concat(dataSource))] })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, "data-cy": "fieldField", name: "ctfield", label: t('Field'), variant: "outlined", defaultValue: simulationName, disabled: true }) })));
        }
    };
    var rendersimulationCachedFieldControl = function () {
        if (isNew) {
            return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: t('Field') }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ id: 'fieldSelectSIM', "data-cy": "fieldField", name: "field", defaultValue: field, onChange: handleFieldSelectChangeSimulationAttr, disabled: isRiskCountLoading || disableFieldSelect, label: t('Field') }, { children: menuItemsSimulationFieldList }), "f".concat(simulationName).concat(Date.now))] })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, "data-cy": "fieldField", name: "field", label: t('Field'), variant: "outlined", defaultValue: fieldAlias, disabled: true }) })));
        }
    };
    var renderTaskCachedFieldControl = function () {
        if (isNew) {
            return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: t('Field') }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ id: 'fieldSelectSIM', "data-cy": "fieldField", name: "field", defaultValue: field, onChange: handleTaskCachedFieldChange, disabled: isRiskCountLoading || disableFieldSelect, label: t('Field') }, { children: taskCachedFieldListItems }), "f".concat(taskName).concat(Date.now))] })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, "data-cy": "fieldField", name: "field", label: t('Field'), variant: "outlined", defaultValue: (0, exports.fixupTaskField)(t, fieldAlias), disabled: true }) })));
        }
    };
    var componentSetup = function () {
        var setup = (0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 10 });
        var nextButton;
        if (parameterNumber !== undefined) {
            nextButton = ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px', display: "flex", justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ style: { marginTop: '16px' }, disabled: (metadataStore === null || metadataStore === void 0 ? void 0 : metadataStore.isLoading) ||
                            isRiskCountLoading ||
                            fetchingMetadata ||
                            !showScoreTable ||
                            validName.length !== 0 ||
                            !componentChanged, variant: "outlined", onClick: updateComponent }, { children: component.name === ''
                            ? t('Set Parameter')
                            : t('Update Parameter') })) }) })));
        }
        switch (type) {
            case _Types_1.ComponentType.Attribute:
                setup = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: typeInputs() })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: attrInputs() })), (0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 4 }), nextButton] }));
                break;
            case _Types_1.ComponentType.SpatialProximity:
                setup = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: typeInputs() })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: dataSourceInputs() })), (0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 4 }), nextButton] }));
                break;
            case _Types_1.ComponentType.SpatialAttribute:
                setup = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: typeInputs() })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: dataSourceInputs() })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: dataSource && spatialAttriFieldInputs() })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: dataSource && distanceInputs() })), nextButton] }));
                break;
            case _Types_1.ComponentType.CustomTable:
                setup = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: typeInputs() })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: dataSourceInputs() })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: dataSource && customTableInputs() })), (0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 2 }), nextButton] }));
                break;
            case _Types_1.ComponentType.Observation:
                setup = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: typeInputs() })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: renderObservationFieldsForm() })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4, paddingLeft: '20px' }, { children: renderObservationCodeValueForm() })), nextButton] }));
                break;
            case _Types_1.ComponentType.MultiParam:
                setup = ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: typeInputs() })) }));
                break;
            case _Types_1.ComponentType.Simulation:
                if (isRiskSimulationEnabled && isSimulationEnabled) {
                    setup = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: typeInputs() })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: renderSimulationNameControl() })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: simulationName &&
                                    rendersimulationCachedFieldControl() })), (0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 2 }), nextButton] }));
                }
                break;
            case _Types_1.ComponentType.Task:
                setup = ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: typeInputs() })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: renderThirdFormControl({
                                title: t('Task Name'),
                                onChange: onSelectedTaskNameChange,
                                renderValues: renderTaskNames,
                                defaultValue: uploadId,
                                valueWhenDisabled: taskName,
                            }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, paddingLeft: '20px' }, { children: taskName && renderTaskCachedFieldControl() })), (0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 2 }), nextButton] }));
                break;
        }
        return setup;
    };
    (0, react_1.useEffect)(function () {
        if (isNew && component.name.length === 0) {
            // New component to clean up as required
            clearFields(false);
            dispatch((0, _Actions_1.clearComponentMetadata)());
            dispatch((0, _Actions_1.setRiskScoreDataGrid)([]));
            dispatch((0, _Actions_1.setRiskUnitScores)(undefined));
            dispatch((0, _Actions_1.setRiskEditScores)([]));
            dispatch((0, _Actions_1.setRiskScores)([]));
            setShowScoreTable(false);
        }
        else if (type == _Types_1.ComponentType.MultiParam) {
            // Load up the parameters
            if (component.paramComponents) {
                // Load the parameters
                setComponentParameter1(__assign({}, component.paramComponents[0]));
                setComponentParameter2(__assign({}, component.paramComponents[1]));
                // Now process the scoreMatrix
                updateComponentMatrix();
                setCurrentIndex(2);
            }
            else {
                //Something is not right.. tell the user and cancel out
                dispatch((0, stylovyze_1.error)(t('Invalid Multi Parameter Component!')));
                onCancel();
            }
        }
        else if (field || dataSource || defects) {
            fetchMetadata(true, parameterNumber !== undefined);
            createScoreRowsFromComponent(component.name.length === 0, rangeChanged, metadataType, nullScore, metadata, unitMetadata);
        }
    }, [component]);
    (0, react_1.useEffect)(function () {
        if (riskCounts &&
            riskCounts.length !== 0 &&
            // scoreRows can get updated AFTER the risk count is updated so we need to verify they actually match
            (metadata === undefined ||
                (scoreRows.length ==
                    metadata.length +
                        (inspectionType !== undefined ||
                            metadataType === 'unique' ||
                            metadata[metadata.length - 1].key === '--'
                            ? 0
                            : 1) &&
                    scoreRows.find(function (row) {
                        var _a;
                        return row.value ===
                            ((_a = requestedCountMetadata === null || requestedCountMetadata === void 0 ? void 0 : requestedCountMetadata[0].key) !== null && _a !== void 0 ? _a : '');
                    })))) {
            var rows = (0, ScoreDataGrid_1.updateRiskCounts)(scoreRows, riskCounts, system === 'Metric', isUnique);
            dispatch((0, _Actions_1.setRiskScoreDataGrid)(rows));
        }
    }, [riskCounts]);
    (0, react_1.useEffect)(function () {
        var metaDataName = type === _Types_1.ComponentType.Task
            ? "".concat(field, "-").concat(type, "-").concat(uploadId)
            : "".concat(field, "-").concat(type, "-").concat(dataSource);
        if ((isNew || unitMetadata === undefined) &&
            metadataStore &&
            !metadataStore.isLoading &&
            (fetchingMetadata || type === _Types_1.ComponentType.Simulation)) {
            // We will get this back for saved muili param components if the user swaps back but we dont need to reset the data just need the units
            if (isNew &&
                (component.name.length === 0 ||
                    unitMetadataName !== metaDataName)) {
                if ((metadataStore.unique && metadataStore.unique.length) ||
                    metadataStore.range) {
                    setUnitMetadata({
                        unique: metadataStore.unique,
                        precision: metadataStore.precision,
                        range: metadataStore.range,
                        unit: metadataStore.unit,
                        currency: metadataStore.currency,
                    });
                    setUnitMetadataName(metaDataName);
                    if (metadataStore.unique &&
                        metadataStore.unique.length > 0) {
                        // Convert the default settings into the component version
                        var newMetadata = metadataStore.unique.map(function (item) { return ({
                            key: item,
                            value: 0,
                        }); });
                        // Add the out of range if required
                        if (inspectionType === undefined &&
                            newMetadata.find(function (value) { return value.key === '--'; }) ===
                                undefined) {
                            newMetadata = __spreadArray([
                                { key: '--', value: 0 }
                            ], newMetadata, true);
                        }
                        setRangeChanged(true);
                        setMetadata(newMetadata);
                        setMetadataType('unique');
                        setNullScore(0);
                        createScoreRowsFromComponent(true, true, 'unique', 0, newMetadata, metadataStore);
                    }
                    else if (metadataStore.range) {
                        if (isNew ||
                            (metadata && metadata.length - 2 != rangeClasses)) {
                            var newMetadata = createDefaultRangeValues(rangeClasses, metadataStore);
                            setRangeChanged(true);
                            createScoreRowsFromComponent(true, true, 'range', 0, newMetadata, metadataStore);
                        }
                    }
                }
                else {
                    // There is an issue with the data, possibly too many unique values
                    setValidConfig(false);
                }
            }
            else {
                setUnitMetadata({
                    unique: metadataStore.unique,
                    precision: metadataStore.precision,
                    range: metadataStore.range,
                    unit: metadataStore.unit,
                    currency: metadataStore.currency,
                });
                setUnitMetadataName(metaDataName);
                setIsUnique(metadataType === 'unique');
                setShowScoreTable(true);
            }
            setFetchingMetadata(false);
            setDisableFieldSelect(false);
        }
    }, [metadataStore]);
    (0, react_1.useEffect)(function () {
        if (isNew && type === _Types_1.ComponentType.Observation && (defects === null || defects === void 0 ? void 0 : defects.length)) {
            if (!componentChanged) {
                setDisableFieldSelect(false);
                return;
            }
            var newMetadata = defects.map(function (code) {
                return { key: "".concat(code), value: 0 };
            });
            setMetadata(newMetadata);
            setMetadataType('unique');
            setNullScore(0);
            setDisableFieldSelect(false);
            createScoreRowsFromComponent(true, false, 'unique', 0, newMetadata, metadataStore);
        }
    }, [defects]);
    var onRangeValuesChanged = function () {
        setRangeChanged(true);
        setComponentChanged(true);
        if (onChange)
            onChange(true, false, false);
    };
    var onSetRangeClasses = function (classes) {
        setRangeChanged(true);
        setComponentChanged(true);
        if (onChange)
            onChange(true, false, false);
        setRangeClasses(classes);
        var newMetadata = createDefaultRangeValues(classes, unitMetadata);
        createScoreRowsFromComponent(false, true, 'range', 0, newMetadata, unitMetadata);
    };
    var onUpdateCreate = function () {
        var _a;
        // Use the scoreMatrix and the multiScoreEdit to creat the scoreMatrix for the compoent
        if (parameterNumber === undefined &&
            multiScoreEdit.length !== 0 &&
            component.scoreMatrix &&
            componentParameter1 &&
            componentParameter1.metadata &&
            componentParameter2 &&
            componentParameter2.metadata) {
            var index = 0;
            for (var i = 0; i < componentParameter2.metadata.length; i++) {
                for (var i2 = 0; i2 < componentParameter1.metadata.length; i2++) {
                    component.scoreMatrix[index].score =
                        (_a = multiScoreEdit[i]["".concat(i2, "-score")]) !== null && _a !== void 0 ? _a : 0;
                    index++;
                }
            }
        }
        if (forLoF && category) {
            var originalLofName = component.name;
            updateComponent();
            if (isNew) {
                dispatch((0, _Actions_1.addLoFComponent)({
                    categoryName: category.name,
                    component: component,
                }));
            }
            else {
                dispatch((0, _Actions_1.setLoFComponent)({
                    categoryName: category.name,
                    componentName: originalLofName,
                    component: component,
                }));
            }
            if (onApply)
                onApply(category);
        }
        else if (!forLoF && category) {
            var originalCofName = component.name;
            updateComponent();
            if (isNew) {
                dispatch((0, _Actions_1.addCoFComponent)({
                    categoryName: category.name,
                    component: component,
                }));
            }
            else {
                dispatch((0, _Actions_1.setCoFComponent)({
                    categoryName: category.name,
                    componentName: originalCofName,
                    component: component,
                }));
            }
            if (onApply)
                onApply(undefined);
        }
    };
    var onComponentChanged = function (changed, clearMatrix, nextTab) {
        setComponentChanged(changed);
        if (clearMatrix)
            setComponentMatrix(undefined);
        if (nextTab)
            setCurrentIndex(currentIndex + 1);
    };
    var mapInsert = ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 4, item: true, paddingLeft: '20px' }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Map'), applyBodyPadding: false }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.map }, { children: (0, jsx_runtime_1.jsx)(Components_1.MapInsertSpatial, { layerName: dataSource, showSystemTypeLayers: true, logLevel: Types_1.MapStatusType.WARN }) })) })) })));
    var title = (0, react_1.useMemo)(function () {
        if (parameterNumber === 1)
            return t('Parameter 1 Setup');
        else if (parameterNumber === 2)
            return t('Parameter 2 Setup');
        else if (isNew)
            return t('Add New Component');
        else
            return t('Edit Component');
    }, [parameterNumber, isNew]);
    var secondary = function () {
        if (parameterNumber === undefined)
            return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ variant: "contained", color: "secondary", style: { marginRight: 16 }, onClick: function () {
                            if (onCancel)
                                onCancel();
                        } }, { children: t('Cancel') })), (0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ variant: "contained", color: "primary", disabled: !validConfig ||
                            componentName.length === 0 ||
                            validName.length !== 0 ||
                            isRiskCountLoading ||
                            fetchingMetadata, onClick: onUpdateCreate }, { children: isNew ? t('Create') : t('Update') }))] }));
    };
    var parameter1 = function () {
        if (componentParameter1) {
            return ((0, jsx_runtime_1.jsx)(system_1.Stack, __assign({ paddingTop: '20px' }, { children: (0, jsx_runtime_1.jsx)(exports.AddEditComponent, { countKey: isNew ? 'NewConfig1' : "".concat(countKey, "-param1"), forLoF: forLoF, observations: observations, inspectionType: inspectionType, isNew: isNew, assetType: assetType, assetFilterId: assetFilterId, category: category, component: componentParameter1, parentComponent: component, parameterNumber: 1, onApply: function () {
                        // Not Needed
                    }, onCancel: function () {
                        // Not Needed
                    }, onChange: onComponentChanged }, 'param1') })));
        }
    };
    var parameter2 = function () {
        if (componentParameter2) {
            return ((0, jsx_runtime_1.jsx)(system_1.Stack, __assign({ paddingTop: '20px' }, { children: (0, jsx_runtime_1.jsx)(exports.AddEditComponent, { countKey: isNew ? 'NewConfig2' : "".concat(countKey, "-param2"), forLoF: forLoF, observations: observations, inspectionType: inspectionType, isNew: isNew, assetType: assetType, assetFilterId: assetFilterId, category: category, component: componentParameter2, parentComponent: component, parameterNumber: 2, onApply: function () {
                        // Not Needed
                    }, onCancel: function () {
                        // Not Needed
                    }, onChange: onComponentChanged }, 'param2') })));
        }
    };
    var score = function () {
        return ((0, jsx_runtime_1.jsxs)(system_1.Stack, __assign({ paddingTop: '20px', spacing: '20px' }, { children: [(0, jsx_runtime_1.jsx)(ParameterDetails_1.default, { componentParameter1: componentParameter1, componentParameter2: componentParameter2 }), (0, jsx_runtime_1.jsx)(MultiScoreDataGrid_1.default, { dataGridKey: countKey, componentParameter1: componentParameter1, componentParameter2: componentParameter2, componentMatrix: componentMatrix, onRecalculateCount: onRecalculateCountMatrix })] })));
    };
    var beforeChangeCurrentStep = function (event) {
        if (componentChanged) {
            setMoveToIndex(event.toIndex);
            return __assign(__assign({}, event), { cancelled: true });
        }
        else {
            setCurrentIndex(event.toIndex);
            return __assign(__assign({}, event), { cancelled: false });
        }
    };
    var onKeepChanges = function () {
        setMoveToIndex(undefined);
    };
    var onLoseChanges = function () {
        if (moveToIndex !== undefined) {
            setCurrentIndex(moveToIndex);
        }
        setMoveToIndex(undefined);
        setComponentChanged(false);
        dispatch((0, _Actions_1.getRiskCountResolved)({
            key: changedRangesKey,
            values: undefined,
        }));
    };
    (0, react_1.useEffect)(function () {
        if (currentIndex === 2) {
            updateComponentMatrix();
            if (componentParameter1 &&
                componentParameter1.metadata &&
                componentParameter2 &&
                componentParameter2.metadata)
                setValidConfig(true);
        }
    }, [currentIndex]);
    var getComponentCount = function (component) {
        var type = component.type;
        if (inspectionType && !observations)
            type = 'inspection';
        else if (type === _Types_1.ComponentType.Observation)
            type = 'observation';
        else if (type === _Types_1.ComponentType.SpatialProximity)
            type = 'proximity';
        else if (type === _Types_1.ComponentType.SpatialAttribute)
            type = 'proximityAttribute';
        return {
            name: component.name,
            type: type,
            field: component.field,
            layer: component.layer,
            uploadId: component.uploadId,
            maxDistance: component.maxDistance,
            metadataType: component.metadataType,
        };
    };
    var updateComponentMatrix = function () {
        if (componentParameter1 &&
            componentParameter1.metadata &&
            componentParameter2 &&
            componentParameter2.metadata &&
            componentMatrix === undefined) {
            var matrix = [];
            var scoreMatrix = [];
            var scoreComponents = [
                getComponentCount(componentParameter1),
                getComponentCount(componentParameter2),
            ];
            var existingScoreMatix = isNew ||
                (component.scoreMatrix &&
                    componentParameter2.metadata.length *
                        componentParameter1.metadata.length !==
                        component.scoreMatrix.length)
                ? undefined
                : component.scoreMatrix;
            var index = 0;
            for (var i = 0; i < componentParameter2.metadata.length; i++) {
                var row = {
                    id: i,
                    param2: componentParameter2.metadata[i].key,
                };
                for (var i2 = 0; i2 < componentParameter1.metadata.length; i2++) {
                    var score_2 = existingScoreMatix
                        ? existingScoreMatix[index++].score
                        : 0;
                    row["".concat(i2, "-score")] = score_2;
                    row["".concat(i2, "-count")] = 0;
                    scoreMatrix.push({
                        params: [
                            {
                                index: 0,
                                meta: {
                                    key: componentParameter1.metadata[i2].key,
                                    ix: i2,
                                    value: 0,
                                },
                            },
                            {
                                index: 1,
                                meta: {
                                    key: componentParameter2.metadata[i].key,
                                    ix: i,
                                    value: 0,
                                },
                            },
                        ],
                        score: score_2,
                    });
                }
                matrix.push(row);
            }
            setComponentMatrix(matrix);
            component.scoreMatrix = scoreMatrix;
            // Get the counts for the matrix
            var key = 'ScoreMatrix';
            if (isWebSocketEnabled) {
                dispatch((0, _Actions_1.setRiskCountIsLoading)({
                    key: key,
                    loading: true,
                }));
                webSocket.sendMessage(JSON.stringify({
                    path: 'risk',
                    action: 'riskCalcCount',
                    key: key,
                    fieldType: 'multiParam',
                    scoreMatrix: scoreMatrix,
                    assetType: assetType,
                    assetFilterId: assetFilterId,
                    inspectionType: inspectionType,
                    paramComponents: scoreComponents,
                }));
            }
            else {
                dispatch((0, _Actions_1.getRiskCountScoreMatrix)({
                    key: key,
                    scoreMatrix: scoreMatrix,
                    assetType: assetType,
                    assetFilterId: assetFilterId,
                    inspectionType: inspectionType,
                    components: scoreComponents,
                }));
            }
        }
    };
    return ((0, jsx_runtime_1.jsx)(styles_1.FullPageWrapper, __assign({ title: title, applyPadding: parameterNumber === undefined, headerUnderline: parameterNumber === undefined, className: metadataStore.isLoading ||
            fetchingMetadata ||
            isRiskCountLoading
            ? classes.headerWait
            : classes.header, secondary: secondary() }, { children: (0, jsx_runtime_1.jsxs)(styles_1.FullPage, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2 }, { children: (0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, name: "ComponentName", defaultValue: componentName, label: parameterNumber === undefined
                                        ? t('Component Name')
                                        : t('Parameter Name'), variant: "outlined", onChange: validateName, helperText: validName, error: validName.length != 0 }, parameterNumber) })) })), componentSetup()] })), showScoreTable && ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, paddingTop: '20px' }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: hasMap ? 8 : 12 }, { children: (0, jsx_runtime_1.jsx)(ScoreDataGrid_1.default, { forComponent: parameterNumber === undefined, forInspection: !observations &&
                                        inspectionType !== undefined, isLoading: metadataStore === null || metadataStore === void 0 ? void 0 : metadataStore.isLoading, isLoadingCount: isRiskCountLoading, dataGridKey: countKey, countKey: component.name.length !== 0 &&
                                        rangeChanged
                                        ? changedRangesKey
                                        : countKey, isUnique: isUnique, isNew: isNew, rangeClasses: rangeClasses, distance: type === _Types_1.ComponentType.SpatialAttribute
                                        ? distance
                                        : undefined, unit: unitMetadata === null || unitMetadata === void 0 ? void 0 : unitMetadata.unit, currency: unitMetadata === null || unitMetadata === void 0 ? void 0 : unitMetadata.currency, precision: unitMetadata === null || unitMetadata === void 0 ? void 0 : unitMetadata.precision, hideCounts: type === _Types_1.ComponentType.Simulation ||
                                        type === _Types_1.ComponentType.Observation, onSetRangeClasses: onSetRangeClasses, onRangeValuesChanged: onRangeValuesChanged, onRecalculateCount: onRecalculateCount }) })), hasMap ? mapInsert : []] })) })), showMutliParam && ((0, jsx_runtime_1.jsxs)(system_1.Stack, __assign({ paddingTop: '20px' }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.SecondaryNav, { itemIndex: currentIndex, beforeItemIndexChanged: beforeChangeCurrentStep, items: [
                                {
                                    title: t('Parameter 1'),
                                    content: parameter1(),
                                },
                                {
                                    title: t('Parameter 2'),
                                    content: parameter2(),
                                },
                                {
                                    title: t('Scores'),
                                    content: score(),
                                },
                            ] }), (0, jsx_runtime_1.jsx)(stylovyze_1.WarningDialog, __assign({ title: t('Lose Changes'), open: moveToIndex !== undefined, onCancel: onKeepChanges, onConfirm: onLoseChanges, confirmText: t('OK'), cancelText: t('Cancel') }, { children: t('This will lose any changes made.') }))] })))] }) }), countKey));
};
exports.AddEditComponent = AddEditComponent;


/***/ }),

/***/ "./components/AddEditComponent/MultiScoreDataGrid/MultiScoreDataGrid.styles.ts":
/*!*************************************************************************************!*\
  !*** ./components/AddEditComponent/MultiScoreDataGrid/MultiScoreDataGrid.styles.ts ***!
  \*************************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledMultiScoreDataGrid = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
exports.StyledMultiScoreDataGrid = (0, styles_1.styled)(stylovyze_1.DataGrid)(function () { return ({
    height: '100%',
    width: '100%',
    '& .titleCell': {
        backgroundColor: '#f7f7f7',
        color: '#272833',
        fontWeight: '600',
        borderRight: '2px solid #e7e7ed',
    },
    '& .scoreCell': {
        borderLeft: '2px solid #e7e7ed',
    },
}); });


/***/ }),

/***/ "./components/AddEditComponent/MultiScoreDataGrid/MultiScoreDataGrid.tsx":
/*!*******************************************************************************!*\
  !*** ./components/AddEditComponent/MultiScoreDataGrid/MultiScoreDataGrid.tsx ***!
  \*******************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var TabelColumns_1 = __webpack_require__(/*! ./TabelColumns */ "./components/AddEditComponent/MultiScoreDataGrid/TabelColumns.tsx");
var MultiScoreDataGrid_styles_1 = __webpack_require__(/*! ./MultiScoreDataGrid.styles */ "./components/AddEditComponent/MultiScoreDataGrid/MultiScoreDataGrid.styles.ts");
var TableToolbar_1 = __webpack_require__(/*! ./TableToolbar */ "./components/AddEditComponent/MultiScoreDataGrid/TableToolbar.tsx");
var util_actions_1 = __webpack_require__(/*! @Actions/util.actions */ "./actions/util.actions.ts");
var NoParameters_component_1 = __webpack_require__(/*! ./NoParameters.component */ "./components/AddEditComponent/MultiScoreDataGrid/NoParameters.component.tsx");
var MultiScoreDataGrid = function (_a) {
    var dataGridKey = _a.dataGridKey, componentParameter1 = _a.componentParameter1, componentParameter2 = _a.componentParameter2, componentMatrix = _a.componentMatrix, onRecalculateCount = _a.onRecalculateCount;
    var dispatch = (0, react_redux_1.useDispatch)();
    var apiRef = (0, stylovyze_1.useGridApiRef)();
    var dataGridState = (0, _Selectors_1.selectDataGridState)(dataGridKey);
    var scoreRows = (0, _Selectors_1.selectRiskMultiScoreDataGrid)();
    var riskCount = (0, _Selectors_1.selectRiskCount)('ScoreMatrix');
    var isRiskCountLoading = (0, _Selectors_1.useSelectIsCountLoading)('ScoreMatrix');
    var scoreMax = 1000;
    var _b = react_1.default.useState({}), cellModesModel = _b[0], setCellModesModel = _b[1];
    var _c = react_1.default.useState(undefined), currentCellId = _c[0], setCurrenCellId = _c[1];
    var _d = react_1.default.useState(undefined), currentCellField = _d[0], setCurrenCellField = _d[1];
    var handleCellClick = react_1.default.useCallback(function (params, event) {
        if (!params.isEditable) {
            return;
        }
        // Ignore portal
        if (!event.currentTarget.contains(event.target)) {
            return;
        }
        setCurrenCellId(params.id);
        setCurrenCellField(params.field);
        setCellModesModel(function (prevModel) {
            var _a, _b;
            return __assign(__assign({}, Object.keys(prevModel).reduce(function (acc, id) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[id] = Object.keys(prevModel[id]).reduce(function (acc2, field) {
                    var _a;
                    return (__assign(__assign({}, acc2), (_a = {}, _a[field] = { mode: stylovyze_1.GridCellModes.View }, _a)));
                }, {}), _a)));
            }, {})), (_a = {}, _a[params.id] = __assign(__assign({}, Object.keys(prevModel[params.id] || {}).reduce(function (acc, field) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[field] = { mode: stylovyze_1.GridCellModes.View }, _a)));
            }, {})), (_b = {}, _b[params.field] = { mode: stylovyze_1.GridCellModes.Edit }, _b)), _a));
        });
    }, []);
    var handleCellModesModelChange = react_1.default.useCallback(function (newModel) {
        setCellModesModel(newModel);
    }, []);
    var onCellEditStop = function () {
        setCurrenCellId(undefined);
        setCurrenCellField(undefined);
    };
    (0, react_1.useEffect)(function () {
        if (componentMatrix &&
            componentParameter1 &&
            componentParameter1.metadata &&
            componentParameter2 &&
            componentParameter2.metadata) {
            var dataGridRows = Array();
            var index_1 = 0;
            if (riskCount && riskCount.length !== 0) {
                for (var i = 0; i < componentParameter2.metadata.length; i++) {
                    var row = __assign({}, componentMatrix[i]);
                    for (var i2 = 0; i2 < componentParameter1.metadata.length; i2++) {
                        var cell = riskCount.find(function (value) { return value.i === index_1; });
                        if (cell) {
                            row["".concat(i2, "-count")] = cell.count;
                        }
                        index_1++;
                    }
                    dataGridRows.push(row);
                }
            }
            else {
                // For an empty count put a blank count so they can still score but it's more obvious that the count has now worked
                for (var i = 0; i < componentParameter2.metadata.length; i++) {
                    var row = __assign({}, componentMatrix[i]);
                    for (var i2 = 0; i2 < componentParameter1.metadata.length; i2++) {
                        row["".concat(i2, "-count")] = '';
                        index_1++;
                    }
                    dataGridRows.push(row);
                }
            }
            dispatch((0, util_actions_1.setRiskMultiScoreDataGrid)(dataGridRows));
        }
    }, [
        componentParameter1,
        componentParameter2,
        componentMatrix,
        riskCount,
        isRiskCountLoading,
    ]);
    var processRowUpdate = react_1.default.useCallback(function (newRow) { return __awaiter(void 0, void 0, void 0, function () {
        var validRow, keys;
        return __generator(this, function (_a) {
            validRow = __assign({}, newRow);
            keys = Object.keys(validRow);
            // Validate the score range
            keys.forEach(function (key) {
                if (key.endsWith('-score')) {
                    var score = validRow[key];
                    if (!score || score < 0)
                        validRow[key] = 0;
                    else if (score > scoreMax)
                        validRow[key] = scoreMax;
                }
            });
            // Update the redux
            dispatch((0, util_actions_1.updateRiskMultiScoreDataGridRow)(validRow));
            return [2 /*return*/, validRow];
        });
    }); }, []);
    var onStateChange = react_1.default.useCallback(function () {
        // We dont want to use the individual states that could be passed but just export the whole state to keep it all in sync
        var state = apiRef.current.exportState();
        dispatch((0, util_actions_1.setDataGridState)({
            key: dataGridKey,
            initialState: state,
        }));
    }, [dataGridKey]);
    var onRecalculateCountMatrix = function () {
        if (currentCellId && currentCellField)
            apiRef.current.stopCellEditMode({
                id: currentCellId,
                field: currentCellField,
            });
        onRecalculateCount();
    };
    if (componentParameter1 &&
        componentParameter1.metadata &&
        componentParameter2 &&
        componentParameter2.metadata) {
        var rows = componentParameter2.metadata.length +
            (componentParameter2.metadataType === 'range' ? 1 : 0);
        return ((0, jsx_runtime_1.jsx)(MultiScoreDataGrid_styles_1.StyledMultiScoreDataGrid, { apiRef: apiRef, experimentalFeatures: { columnGrouping: true }, disableColumnMenu: true, disableColumnReorder: true, loading: scoreRows.length === 0, skeletonRowCount: rows, columns: (0, TabelColumns_1.tableColumns)(componentParameter1, componentParameter2, 'ScoreMatrix', dataGridState), columnGroupingModel: (0, TabelColumns_1.tableColumnsGrouping)(componentParameter1), rows: scoreRows, processRowUpdate: processRowUpdate, slots: {
                toolbar: TableToolbar_1.TableToolbar,
            }, slotProps: {
                toolbar: {
                    isLoading: scoreRows.length === 0 || isRiskCountLoading,
                    onRecalculateCount: onRecalculateCountMatrix,
                },
            }, cellModesModel: cellModesModel, onCellModesModelChange: handleCellModesModelChange, onCellClick: handleCellClick, onCellEditStop: onCellEditStop, 
            // DONT USE onStateChange={onStateChange} AS THIS GETS CALLED FOR EVERY USER ACTION... SO PROBABLY BEST TO AVOID !!
            onColumnWidthChange: onStateChange, dataCy: "multiscore-table" }));
    }
    else {
        return (0, jsx_runtime_1.jsx)(NoParameters_component_1.NoParameters, {});
    }
};
exports["default"] = MultiScoreDataGrid;


/***/ }),

/***/ "./components/AddEditComponent/MultiScoreDataGrid/NoParameters.component.tsx":
/*!***********************************************************************************!*\
  !*** ./components/AddEditComponent/MultiScoreDataGrid/NoParameters.component.tsx ***!
  \***********************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoParameters = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var Scales_1 = __importDefault(__webpack_require__(/*! @Components/Utils/icons/Scales */ "./components/Utils/icons/Scales.tsx"));
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var NoParameters = function () {
    var t = (0, useGlobalization_1.useGlobalization)().t;
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: { paddingTop: '40px' } }, { children: (0, jsx_runtime_1.jsx)(Scales_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "heading-medium-strong" }, { children: t('You do not have both parameters configured.') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "caption-medium" }, { children: t('Configure Parameter 1 and Parameter 2 to set up scores.') })) }))] })));
};
exports.NoParameters = NoParameters;


/***/ }),

/***/ "./components/AddEditComponent/MultiScoreDataGrid/TabelColumns.tsx":
/*!*************************************************************************!*\
  !*** ./components/AddEditComponent/MultiScoreDataGrid/TabelColumns.tsx ***!
  \*************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.tableColumnsGrouping = exports.tableColumns = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var x_data_grid_premium_1 = __webpack_require__(/*! @mui/x-data-grid-premium */ "@mui/x-data-grid-premium");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var RangeCell_1 = __webpack_require__(/*! ../ScoreDataGrid/RangeCell */ "./components/AddEditComponent/ScoreDataGrid/RangeCell.tsx");
var TabelColumns_1 = __webpack_require__(/*! ../ScoreDataGrid/TabelColumns */ "./components/AddEditComponent/ScoreDataGrid/TabelColumns.tsx");
var SkeletonCell_1 = __webpack_require__(/*! ../ScoreDataGrid/SkeletonCell */ "./components/AddEditComponent/ScoreDataGrid/SkeletonCell.tsx");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var tableColumns = function (componentParameter1, componentParameter2, countKey, dataGridState) {
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var header = new Array();
    var scoreMax = 1000;
    var isRiskCountLoading = (0, _Selectors_1.useSelectIsCountLoading)(countKey);
    if (componentParameter2.metadataType === 'unique') {
        header.push({
            field: 'param2',
            headerName: componentParameter2.name,
            sortable: false,
            hideable: false,
            align: 'left',
            flex: (0, TabelColumns_1.getFlex)('param2', 1, dataGridState),
            width: (0, TabelColumns_1.getWidth)('param2', dataGridState),
            minWidth: 200,
            cellClassName: 'titleCell',
        });
    }
    else {
        header.push({
            field: 'param2',
            headerName: componentParameter2.name,
            sortable: false,
            hideable: false,
            align: 'left',
            flex: (0, TabelColumns_1.getFlex)('param2', 1, dataGridState),
            width: (0, TabelColumns_1.getWidth)('param2', dataGridState),
            minWidth: 200,
            cellClassName: 'titleCell',
            renderCell: function (params) {
                var _a, _b, _c;
                return (0, RangeCell_1.getRangeDisplayTitle)((_a = params.value) !== null && _a !== void 0 ? _a : '', (_b = componentParameter2.unitMetadata) === null || _b === void 0 ? void 0 : _b.unit, (_c = componentParameter2.unitMetadata) === null || _c === void 0 ? void 0 : _c.currency);
            },
        });
    }
    if (componentParameter1.metadata) {
        for (var i = 0; i < componentParameter1.metadata.length; i++) {
            header.push({
                field: "".concat(i, "-score"),
                headerName: t('Score'),
                sortable: false,
                hideable: false,
                align: 'center',
                headerAlign: 'center',
                flex: (0, TabelColumns_1.getFlex)("".concat(i, "-score"), 0.5, dataGridState),
                width: (0, TabelColumns_1.getWidth)("".concat(i, "-score"), dataGridState),
                minWidth: 100,
                type: 'number',
                editable: true,
                cellClassName: i == 0 ? '' : 'scoreCell',
                valueFormatter: function (params) {
                    var _a;
                    // Stop the default formatting adding , to numbers
                    return (_a = params.value) === null || _a === void 0 ? void 0 : _a.toString();
                },
                renderEditCell: function (params) { return ((0, jsx_runtime_1.jsx)(x_data_grid_premium_1.GridEditInputCell, __assign({}, params, { inputProps: {
                        max: scoreMax,
                        min: 0,
                        disabled: isRiskCountLoading,
                    } }))); },
            }, {
                field: "".concat(i, "-count"),
                headerName: t('Count'),
                sortable: false,
                hideable: false,
                align: 'center',
                headerAlign: 'center',
                flex: (0, TabelColumns_1.getFlex)("".concat(i, "-count"), 0.5, dataGridState),
                width: (0, TabelColumns_1.getWidth)("".concat(i, "-count"), dataGridState),
                minWidth: 100,
                renderCell: function (params) {
                    return ((0, jsx_runtime_1.jsx)(SkeletonCell_1.SkeletonCell, { id: params.id, countKey: countKey, value: params.value, percent: false }));
                },
            });
        }
    }
    return header;
};
exports.tableColumns = tableColumns;
var tableColumnsGrouping = function (componentParameter1) {
    var _a, _b;
    var headerGroup = new Array();
    if (componentParameter1.metadata) {
        headerGroup.push({
            groupId: componentParameter1.name,
            headerAlign: 'right',
            children: [{ field: 'param2' }],
        });
        var range = componentParameter1.metadataType === 'range';
        for (var i = 0; i < componentParameter1.metadata.length; i++) {
            var field = componentParameter1.metadata[i];
            var headerName = range
                ? (0, RangeCell_1.getRangeDisplayTitle)(field.key, (_a = componentParameter1.unitMetadata) === null || _a === void 0 ? void 0 : _a.unit, (_b = componentParameter1.unitMetadata) === null || _b === void 0 ? void 0 : _b.currency)
                : field.key;
            headerGroup.push({
                groupId: "group-".concat(i),
                headerName: headerName,
                headerAlign: 'center',
                children: [{ field: "".concat(i, "-score") }, { field: "".concat(i, "-count") }],
            });
        }
    }
    return headerGroup;
};
exports.tableColumnsGrouping = tableColumnsGrouping;


/***/ }),

/***/ "./components/AddEditComponent/MultiScoreDataGrid/TableToolbar.tsx":
/*!*************************************************************************!*\
  !*** ./components/AddEditComponent/MultiScoreDataGrid/TableToolbar.tsx ***!
  \*************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TableToolbar = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var TableToolbar = function (_a) {
    var isLoading = _a.isLoading, onRecalculateCount = _a.onRecalculateCount;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledGrid, __assign({ container: true, style: {
            width: '100%',
            marginTop: '1rem',
            marginBottom: '1rem',
        } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 8 }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "heading-large-strong" }, { children: t('Score Setup') })), (0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "caption-medium" }, { children: t('Set your scores below to complete the component setup.') })), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: 'row' }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "caption-medium" }, { children: t('To edit ranges, go back to the parameter setup.') })), "\u00A0", (0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "caption-medium-strong" }, { children: t('This will reset all scores.') }))] }))] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4, display: "flex", justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ direction: 'column' }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ disabled: isLoading, variant: "outlined", onClick: function () {
                            onRecalculateCount();
                        } }, { children: t('Recalculate Asset Count') })) })) }))] })));
};
exports.TableToolbar = TableToolbar;


/***/ }),

/***/ "./components/AddEditComponent/ParameterDetails/ParameterDetails.tsx":
/*!***************************************************************************!*\
  !*** ./components/AddEditComponent/ParameterDetails/ParameterDetails.tsx ***!
  \***************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __webpack_require__(/*! react */ "react");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var TabelColumns_1 = __webpack_require__(/*! ./TabelColumns */ "./components/AddEditComponent/ParameterDetails/TabelColumns.tsx");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var TableToolbar_1 = __webpack_require__(/*! ./TableToolbar */ "./components/AddEditComponent/ParameterDetails/TableToolbar.tsx");
var AddEditComponent_1 = __webpack_require__(/*! ../AddEditComponent */ "./components/AddEditComponent/AddEditComponent.tsx");
var ParameterDetails = function (_a) {
    var componentParameter1 = _a.componentParameter1, componentParameter2 = _a.componentParameter2;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var getSystemValueFormatted = (0, stylovyze_1.useUnits)().getSystemValueFormatted;
    var getParamDetails = function (index, parameter) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        switch (parameter.type) {
            case _Types_1.ComponentType.SpatialProximity: {
                return {
                    id: index,
                    name: parameter.name,
                    type: (0, _Types_1.getTypeDisplay)(parameter.type, t),
                    dataSource: (_a = parameter.layer) !== null && _a !== void 0 ? _a : '',
                    field: (_b = parameter.fieldAlias) !== null && _b !== void 0 ? _b : '',
                    distance: '',
                };
            }
            case _Types_1.ComponentType.SpatialAttribute: {
                var distance = '';
                if (parameter.maxDistance !== undefined) {
                    if (parameter.unitMetadata) {
                        distance =
                            (_c = getSystemValueFormatted("".concat(parameter.maxDistance, "m"))) !== null && _c !== void 0 ? _c : '';
                    }
                    else {
                        distance = parameter.maxDistance.toString();
                    }
                }
                return {
                    id: index,
                    name: parameter.name,
                    type: (0, _Types_1.getTypeDisplay)(parameter.type, t),
                    dataSource: (_d = parameter.layer) !== null && _d !== void 0 ? _d : '',
                    field: (_e = parameter.field) !== null && _e !== void 0 ? _e : '',
                    distance: distance,
                };
            }
            case _Types_1.ComponentType.CustomTable: {
                return {
                    id: index,
                    name: parameter.name,
                    type: (0, _Types_1.getTypeDisplay)(parameter.type, t),
                    dataSource: (_f = parameter.layer) !== null && _f !== void 0 ? _f : '',
                    field: (_g = parameter.fieldAlias) !== null && _g !== void 0 ? _g : '',
                    distance: '',
                };
            }
            case _Types_1.ComponentType.Task: {
                return {
                    id: index,
                    name: parameter.name,
                    type: (0, _Types_1.getTypeDisplay)(parameter.type, t),
                    dataSource: (_h = parameter.taskName) !== null && _h !== void 0 ? _h : '',
                    field: (0, AddEditComponent_1.fixupTaskField)(t, (_j = parameter.fieldAlias) !== null && _j !== void 0 ? _j : ''),
                    distance: '',
                };
            }
            case _Types_1.ComponentType.Simulation: {
                return {
                    id: index,
                    name: parameter.name,
                    type: (0, _Types_1.getTypeDisplay)(parameter.type, t),
                    dataSource: (_k = parameter.simulationName) !== null && _k !== void 0 ? _k : '',
                    field: (_l = parameter.fieldAlias) !== null && _l !== void 0 ? _l : '',
                    distance: '',
                };
            }
            default: {
                return {
                    id: index,
                    name: parameter.name,
                    type: (0, _Types_1.getTypeDisplay)(parameter.type, t),
                    dataSource: '',
                    field: (_m = parameter.fieldAlias) !== null && _m !== void 0 ? _m : '',
                    distance: '',
                };
            }
        }
    };
    var rows = (0, react_1.useMemo)(function () {
        var rows = Array();
        if (componentParameter1 !== undefined &&
            componentParameter1.name !== '') {
            rows.push(getParamDetails(1, componentParameter1));
        }
        if (componentParameter2 !== undefined &&
            componentParameter2.name !== '') {
            rows.push(getParamDetails(2, componentParameter2));
        }
        return rows;
    }, [componentParameter1, componentParameter2]);
    if (componentParameter1 &&
        componentParameter1.metadata &&
        componentParameter2 &&
        componentParameter2.metadata) {
        return ((0, jsx_runtime_1.jsx)(stylovyze_1.DataGrid, { experimentalFeatures: { columnGrouping: true }, disableColumnMenu: true, disableColumnReorder: true, disableRowSelectionOnClick: true, columns: (0, TabelColumns_1.tableColumns)(), rows: rows, slots: {
                toolbar: TableToolbar_1.TableToolbar,
            } }));
    }
    else {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
};
exports["default"] = ParameterDetails;


/***/ }),

/***/ "./components/AddEditComponent/ParameterDetails/TabelColumns.tsx":
/*!***********************************************************************!*\
  !*** ./components/AddEditComponent/ParameterDetails/TabelColumns.tsx ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.tableColumns = void 0;
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var tableColumns = function () {
    var t = (0, useGlobalization_1.useGlobalization)().t;
    return [
        {
            field: 'name',
            headerName: t('Name'),
            sortable: false,
            hideable: false,
            align: 'left',
            flex: 1,
        },
        {
            field: 'type',
            headerName: t('Type'),
            sortable: false,
            hideable: false,
            align: 'left',
            flex: 1,
        },
        {
            field: 'dataSource',
            headerName: t('Data Source'),
            sortable: false,
            hideable: false,
            align: 'left',
            flex: 1,
        },
        {
            field: 'field',
            headerName: t('Field'),
            sortable: false,
            hideable: false,
            align: 'left',
            flex: 1,
        },
        {
            field: 'distance',
            headerName: t('Distance'),
            sortable: false,
            hideable: false,
            align: 'left',
            flex: 1,
        },
    ];
};
exports.tableColumns = tableColumns;


/***/ }),

/***/ "./components/AddEditComponent/ParameterDetails/TableToolbar.tsx":
/*!***********************************************************************!*\
  !*** ./components/AddEditComponent/ParameterDetails/TableToolbar.tsx ***!
  \***********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TableToolbar = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var TableToolbar = function () {
    var t = (0, useGlobalization_1.useGlobalization)().t;
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledGrid, __assign({ container: true, style: {
            width: '100%',
            marginTop: '1rem',
            marginBottom: '1rem',
        } }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 8 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "heading-large-strong" }, { children: t('Parameter Details') })) })) })));
};
exports.TableToolbar = TableToolbar;


/***/ }),

/***/ "./components/AddEditComponent/ScoreDataGrid/RangeCell.tsx":
/*!*****************************************************************!*\
  !*** ./components/AddEditComponent/ScoreDataGrid/RangeCell.tsx ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRangeDisplayTitle = exports.RangeCell = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var ScoreDataGrid_styles_1 = __webpack_require__(/*! ./ScoreDataGrid.styles */ "./components/AddEditComponent/ScoreDataGrid/ScoreDataGrid.styles.ts");
var RangeEditCell_1 = __webpack_require__(/*! ./RangeEditCell */ "./components/AddEditComponent/ScoreDataGrid/RangeEditCell.tsx");
var RangeDisplayCell_1 = __webpack_require__(/*! ./RangeDisplayCell */ "./components/AddEditComponent/ScoreDataGrid/RangeDisplayCell.tsx");
var RangeCell = function (_a) {
    var id = _a.id, value = _a.value, onRangeChange = _a.onRangeChange, disabled = _a.disabled, unit = _a.unit, currency = _a.currency, precision = _a.precision;
    // Ignore the null value row
    if (value !== '--') {
        var values = value.split(' ');
        if (values[0] === '<') {
            return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 4, alignSelf: 'center' }), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, alignSelf: 'center', textAlign: 'center' }, { children: (0, jsx_runtime_1.jsx)(ScoreDataGrid_styles_1.TextOverflowWrapper, __assign({ title: values[0] }, { children: values[0] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsx)(RangeEditCell_1.RangeEditCell, { id: id, value: values[1], onRangeChange: onRangeChange, disabled: disabled, unit: unit, currency: currency, precision: precision }) }))] })));
        }
        else if (values[0] === '') {
            return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 4, alignSelf: 'center' }), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, alignSelf: 'center', textAlign: 'center' }, { children: (0, jsx_runtime_1.jsx)(ScoreDataGrid_styles_1.TextOverflowWrapper, __assign({ title: values[1] }, { children: values[1] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsx)(RangeEditCell_1.RangeEditCell, { id: id, value: values[2], onRangeChange: onRangeChange, disabled: disabled, unit: unit, currency: currency, precision: precision }) }))] })));
        }
        else if (values[0] === '>') {
            return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 4, alignSelf: 'center' }), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, alignSelf: 'center', textAlign: 'center' }, { children: (0, jsx_runtime_1.jsx)(ScoreDataGrid_styles_1.TextOverflowWrapper, __assign({ title: values[0] }, { children: values[0] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsx)(RangeDisplayCell_1.RangeDisplayCell, { id: id, value: values[1], unit: unit, currency: currency }) }))] })));
        }
        else {
            return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 4, alignSelf: 'center' }, { children: (0, jsx_runtime_1.jsx)(RangeDisplayCell_1.RangeDisplayCell, { id: id, value: values[0], unit: unit, currency: currency }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, alignSelf: 'center', textAlign: 'center' }, { children: (0, jsx_runtime_1.jsx)(ScoreDataGrid_styles_1.TextOverflowWrapper, __assign({ title: values[0] }, { children: values[1] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6 }, { children: (0, jsx_runtime_1.jsx)(RangeEditCell_1.RangeEditCell, { id: id, value: values[2], onRangeChange: onRangeChange, disabled: disabled, unit: unit, currency: currency, precision: precision }) }))] })));
        }
    }
    else {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: value });
    }
};
exports.RangeCell = RangeCell;
var getRangeDisplayTitle = function (value, unit, currency) {
    // Ignore the null value row
    var result = value;
    if (value && value !== '--') {
        var values = value.split(' ');
        if (values[0] == '<') {
            result = "< ".concat((0, RangeDisplayCell_1.getRangeDisplayValue)(values[1], unit, currency));
        }
        else if (values[0] == '>') {
            result = "> ".concat((0, RangeDisplayCell_1.getRangeDisplayValue)(values[1], unit, currency));
        }
        else {
            result = "".concat((0, RangeDisplayCell_1.getRangeDisplayValue)(values[0], unit, currency), " ").concat(values[1], " ").concat((0, RangeDisplayCell_1.getRangeDisplayValue)(values[2], unit, currency));
        }
    }
    return result;
};
exports.getRangeDisplayTitle = getRangeDisplayTitle;


/***/ }),

/***/ "./components/AddEditComponent/ScoreDataGrid/RangeDisplayCell.tsx":
/*!************************************************************************!*\
  !*** ./components/AddEditComponent/ScoreDataGrid/RangeDisplayCell.tsx ***!
  \************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRangeDisplayValue = exports.RangeDisplayCell = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var RangeDisplayCell = function (_a) {
    var id = _a.id, value = _a.value, unit = _a.unit, currency = _a.currency;
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    if (unit && unit.length != 0) {
        return (0, jsx_runtime_1.jsx)(stylovyze_1.UnitDisplay, { cy: "score-".concat(id), value: "".concat(value, " ").concat(unit) });
    }
    else if (currency !== undefined && companySettings) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, stylovyze_1.getCurrency)(+value, companySettings) });
    }
    else {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: value });
    }
};
exports.RangeDisplayCell = RangeDisplayCell;
var getRangeDisplayValue = function (value, unit, currency) {
    var companySettings = (0, stylovyze_1.useSettings)().companySettings;
    var getSystemValueFormatted = (0, stylovyze_1.useUnits)().getSystemValueFormatted;
    if (unit && unit.length != 0) {
        return getSystemValueFormatted("".concat(value).concat(unit));
    }
    else if (currency !== undefined && companySettings) {
        return (0, stylovyze_1.getCurrency)(+value, companySettings);
    }
    else {
        return value;
    }
};
exports.getRangeDisplayValue = getRangeDisplayValue;


/***/ }),

/***/ "./components/AddEditComponent/ScoreDataGrid/RangeEditCell.tsx":
/*!*********************************************************************!*\
  !*** ./components/AddEditComponent/ScoreDataGrid/RangeEditCell.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RangeEditCell = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __webpack_require__(/*! react */ "react");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var RangeEditCell = function (_a) {
    var id = _a.id, value = _a.value, onRangeChange = _a.onRangeChange, disabled = _a.disabled, unit = _a.unit, currency = _a.currency, precision = _a.precision;
    var _b = (0, react_1.useState)(false), changed = _b[0], setChanged = _b[1];
    var step = precision === undefined || precision === 0
        ? '1'
        : (1.0 / Math.pow(10, precision)).toFixed(precision);
    if (unit && unit.length !== 0) {
        return ((0, jsx_runtime_1.jsx)(stylovyze_1.UnitField, { "data-cy": "range-".concat(id), style: { width: '100%' }, unit: unit, defaultValue: value, disabled: disabled, step: step, onChange: function () {
                setChanged(true);
                // Dont do anything else on change otherwise it will adjust the ranges as they type the first character
            }, onBlur: function (e) {
                if (changed) {
                    var newValue = parseFloat(e.target.value);
                    var valueUnit = e.target.originalValue
                        ? parseFloat(e.target.originalValue)
                        : undefined;
                    if (!isNaN(newValue)) {
                        onRangeChange(+id, newValue, valueUnit);
                        setChanged(false);
                    }
                }
            }, size: "small" }));
    }
    else if (currency !== undefined) {
        return ((0, jsx_runtime_1.jsx)(stylovyze_1.CurrencyField, { "data-cy": "score-".concat(id), style: { width: '100%' }, 
            // For the moment just use the default system currency... this MIGHT be used later
            // currency={currency}
            defaultValue: value, disabled: disabled, onChange: function () {
                setChanged(true);
                // Dont do anything else on change otherwise it will adjust the ranges as they type the first character
            }, onBlur: function (e) {
                if (changed) {
                    onRangeChange(+id, +e.target.value);
                    setChanged(false);
                }
            }, step: step, variant: "outlined", size: "small" }));
    }
    else {
        return ((0, jsx_runtime_1.jsx)(material_1.TextField, { "data-cy": "range-".concat(id), style: { width: '100%' }, defaultValue: value, disabled: disabled, onChange: function () {
                setChanged(true);
                // Dont do anything else on change otherwise it will adjust the ranges as they type the first character
            }, onBlur: function (e) {
                if (changed) {
                    onRangeChange(+id, +e.target.value);
                    setChanged(false);
                }
            }, inputProps: {
                step: step,
            }, variant: "outlined", type: "number", size: "small" }, "range-".concat(id, "-").concat(value)));
    }
};
exports.RangeEditCell = RangeEditCell;


/***/ }),

/***/ "./components/AddEditComponent/ScoreDataGrid/ScoreCell.tsx":
/*!*****************************************************************!*\
  !*** ./components/AddEditComponent/ScoreDataGrid/ScoreCell.tsx ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ScoreCell = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var ScoreCell = function (_a) {
    var id = _a.id, value = _a.value, onScoreChange = _a.onScoreChange, scoreMax = _a.scoreMax;
    return ((0, jsx_runtime_1.jsx)(material_1.TextField, { "data-cy": "score-".concat(id), style: { width: '100%' }, value: value, onChange: function (e) {
            var newValue = +e.target.value;
            if (newValue !== value) {
                if (newValue < 0)
                    newValue = 0;
                else if (scoreMax && newValue > scoreMax)
                    newValue = scoreMax;
                onScoreChange(+id, newValue);
            }
        }, onBlur: function (e) {
            var newValue = +e.target.value;
            if (newValue !== value) {
                if (newValue < 0)
                    newValue = 0;
                else if (scoreMax && newValue > scoreMax)
                    newValue = scoreMax;
                onScoreChange(+id, newValue);
            }
        }, inputProps: {
            step: 1,
            min: 0,
            max: scoreMax,
        }, variant: "outlined", type: "number", size: "small" }));
};
exports.ScoreCell = ScoreCell;


/***/ }),

/***/ "./components/AddEditComponent/ScoreDataGrid/ScoreDataGrid.styles.ts":
/*!***************************************************************************!*\
  !*** ./components/AddEditComponent/ScoreDataGrid/ScoreDataGrid.styles.ts ***!
  \***************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TextOverflowWrapper = exports.useStyles = void 0;
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
exports.useStyles = (0, styles_1.makeStyles)(function () { return ({
    ScoreDataGrid: {
        height: '100%',
        width: '100%',
        '& > div > div': {
            overflow: 'auto',
            height: '100%',
            width: '100%',
        },
        '& > div ': {
            overflow: 'auto',
            height: '100%',
            width: '100%',
        },
    },
}); });
exports.TextOverflowWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n"], ["\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n"])));
var templateObject_1;


/***/ }),

/***/ "./components/AddEditComponent/ScoreDataGrid/ScoreDataGrid.tsx":
/*!*********************************************************************!*\
  !*** ./components/AddEditComponent/ScoreDataGrid/ScoreDataGrid.tsx ***!
  \*********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.updateRiskCounts = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var TabelColumns_1 = __webpack_require__(/*! ./TabelColumns */ "./components/AddEditComponent/ScoreDataGrid/TabelColumns.tsx");
var TableToolbar_1 = __webpack_require__(/*! ./TableToolbar */ "./components/AddEditComponent/ScoreDataGrid/TableToolbar.tsx");
var updateRiskCounts = function (scoreRows, riskCounts, isMetric, isUnique) {
    if (riskCounts === undefined || riskCounts.length == 0) {
        var newScoreRows = [];
        for (var i = 0; i < scoreRows.length; i++) {
            newScoreRows.push(__assign(__assign({}, scoreRows[i]), { count: undefined, length: undefined, countPercent: undefined, lengthPercent: undefined }));
        }
        return newScoreRows;
    }
    else {
        var conversion = isMetric ? 1 : 0.06213712;
        var newScoreRows = [];
        if (isUnique) {
            var _loop_1 = function (i) {
                var count = riskCounts.find(function (_a) {
                    var key = _a.key;
                    return (key === undefined || key === null
                        ? '--'
                        : key.toString()) === scoreRows[i].value.toString();
                });
                if (count) {
                    newScoreRows.push(__assign(__assign({}, scoreRows[i]), { count: count.count, length: Math.round(count.length * conversion) / 100, countPercent: Math.round(count.count_percent * 1000) / 10, lengthPercent: Math.round(count.length_percent * 1000) / 10 }));
                }
                else {
                    newScoreRows.push(__assign(__assign({}, scoreRows[i]), { count: 0, length: 0, countPercent: 0, lengthPercent: 0 }));
                }
            };
            for (var i = 0; i < scoreRows.length; i++) {
                _loop_1(i);
            }
        }
        else if (riskCounts) {
            for (var i = 0; i < scoreRows.length; i++) {
                newScoreRows.push(__assign(__assign({}, scoreRows[i]), { count: riskCounts[i].count, length: Math.round(riskCounts[i].length * conversion) / 100, countPercent: Math.round(riskCounts[i].count_percent * 1000) / 10, lengthPercent: Math.round(riskCounts[i].length_percent * 1000) / 10 }));
            }
        }
        else {
            for (var i = 0; i < scoreRows.length; i++) {
                newScoreRows.push(__assign(__assign({}, scoreRows[i]), { count: 0, length: 0, countPercent: 0, lengthPercent: 0 }));
            }
        }
        return newScoreRows;
    }
};
exports.updateRiskCounts = updateRiskCounts;
// This ensure we remove any extranious decimal places caused by javascript
var toFixedDP = function (value, precision) {
    return +value.toFixed(precision);
};
var ScoreDataGrid = function (_a) {
    var forComponent = _a.forComponent, forInspection = _a.forInspection, isLoading = _a.isLoading, isLoadingCount = _a.isLoadingCount, dataGridKey = _a.dataGridKey, countKey = _a.countKey, isUnique = _a.isUnique, rangeClasses = _a.rangeClasses, distance = _a.distance, unit = _a.unit, currency = _a.currency, precision = _a.precision, hideCounts = _a.hideCounts, onSetRangeClasses = _a.onSetRangeClasses, onRangeValuesChanged = _a.onRangeValuesChanged, onRecalculateCount = _a.onRecalculateCount;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, stylovyze_1.useUnits)(), getSystemUnit = _b.getSystemUnit, getStandardisedValue = _b.getStandardisedValue, system = _b.system;
    var _c = (0, react_1.useState)(distance), currentDistance = _c[0], setCurrentDistance = _c[1];
    var apiRef = (0, stylovyze_1.useGridApiRef)();
    var dataGridState = (0, _Selectors_1.selectDataGridState)(dataGridKey);
    var scoreRows = (0, _Selectors_1.selectRiskScoreDataGrid)();
    var riskScore = (0, _Selectors_1.selectRiskScores)();
    var riskUnitScore = (0, _Selectors_1.selectRiskUnitScores)();
    var scoreMax = 1000;
    (0, react_1.useEffect)(function () {
        if (distance !== currentDistance) {
            setCurrentDistance(distance);
            if (scoreRows[0].count !== undefined) {
                onRangeValuesChanged();
                var newScoreRows = (0, exports.updateRiskCounts)(scoreRows, undefined, system === 'Metric', isUnique);
                dispatch((0, _Actions_1.setRiskScoreDataGrid)(newScoreRows));
            }
        }
    }, [distance]);
    var onScoreChange = function (index, value) {
        dispatch((0, _Actions_1.updateRiskScoreDataGrid)({ index: index, score: value }));
    };
    var onRangeChange = function (index, value, valueUnit) {
        if (riskScore[index] !== value) {
            onRangeValuesChanged();
            // Clear the existing counts so they have to manual request them
            if (scoreRows[0].count !== undefined) {
                var newScoreRows = (0, exports.updateRiskCounts)(scoreRows, undefined, system === 'Metric', isUnique);
                dispatch((0, _Actions_1.setRiskScoreDataGrid)(newScoreRows));
            }
            var decimalPt = precision !== undefined ? precision : 1;
            var minDiff = toFixedDP(1 / Math.pow(10, decimalPt), decimalPt);
            var workingValue = value;
            var newScore = __spreadArray([], riskScore, true);
            // We need to work out if we need do this next bit in native or system units
            if (system === 'Imperial' &&
                riskUnitScore &&
                unit &&
                valueUnit != undefined) {
                workingValue = valueUnit;
                newScore = __spreadArray([], riskUnitScore, true);
            }
            // Has the user decremented or incremented the value?
            if (workingValue < newScore[index]) {
                newScore[index] = workingValue;
                // Decrementing so we only need to worry about the items BEFORE this index and if it's the first item we dont need to do anything at all
                if (index !== 0) {
                    // Have we overlapped the previous value?
                    var nextValue = workingValue;
                    for (var i = index - 1; i >= 0; i--) {
                        if (newScore[i] >= nextValue) {
                            nextValue = toFixedDP(nextValue - minDiff, decimalPt);
                            newScore[i] = nextValue;
                        }
                    }
                }
            }
            else {
                newScore[index] = workingValue;
                // Incremeting so we only need to worry about the items AFTER this index and if it's the last item we just need to update the last entry
                if (index == newScore.length - 2)
                    newScore[index + 1] = workingValue;
                else {
                    // Have we overlapped the next value?
                    var nextValue = workingValue;
                    for (var i = index + 1; i <= newScore.length - 2; i++) {
                        if (newScore[i] <= nextValue) {
                            nextValue = toFixedDP(nextValue + minDiff, decimalPt);
                            newScore[i] = nextValue;
                        }
                    }
                }
            }
            // Ensure the last two values are the same
            newScore[newScore.length - 1] = newScore[newScore.length - 2];
            // Are we running a different display unit?
            if (system === 'Imperial' &&
                riskUnitScore &&
                unit &&
                valueUnit != undefined) {
                var internalUnit_1 = getSystemUnit(unit);
                var adjustment_1 = 1;
                if (valueUnit !== undefined && value != valueUnit) {
                    // mm -> in -> cm
                    if (unit === 'mm')
                        adjustment_1 = 10;
                }
                var nativeScores = newScore.map(function (score) {
                    return (parseFloat(getStandardisedValue("".concat(score, " ").concat(internalUnit_1))) * adjustment_1);
                });
                var stringScores = nativeScores.map(function (score) {
                    return score.toString();
                });
                dispatch((0, _Actions_1.setRiskEditScores)(stringScores));
                dispatch((0, _Actions_1.setRiskScores)(nativeScores));
                dispatch((0, _Actions_1.setRiskUnitScores)(newScore));
                // Now switch back to the native scores for the next bit as thats in native units
                newScore = nativeScores;
            }
            else {
                var stringScores = newScore.map(function (score) {
                    return score.toString();
                });
                dispatch((0, _Actions_1.setRiskEditScores)(stringScores));
                dispatch((0, _Actions_1.setRiskScores)(newScore));
            }
            var newValues = [];
            for (var i = 0; i < newScore.length; i++) {
                if (i == 0) {
                    newValues.push({
                        index: i,
                        value: " <= ".concat(newScore[0]),
                    });
                }
                else if (i < newScore.length - 1) {
                    newValues.push({
                        index: i,
                        value: "".concat(newScore[i - 1], " <= ").concat(newScore[i]),
                    });
                }
                else {
                    newValues.push({
                        index: i,
                        value: "> ".concat(newScore[i]),
                    });
                }
            }
            dispatch((0, _Actions_1.updateRiskValuesDataGrid)(newValues));
        }
    };
    var onStateChange = react_1.default.useCallback(function () {
        // We dont want to use the individual states that could be passed but just export the whole state to keep it all in sync
        var state = apiRef.current.exportState();
        dispatch((0, _Actions_1.setDataGridState)({
            key: dataGridKey,
            initialState: state,
        }));
    }, [dataGridKey]);
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.DataGrid, { apiRef: apiRef, disableColumnMenu: true, disableColumnReorder: true, loading: isLoading, skeletonRowCount: rangeClasses + (isUnique ? 0 : forInspection ? 2 : 3), columns: (0, TabelColumns_1.tableColumns)(forComponent, onScoreChange, onRangeChange, isUnique, countKey, scoreMax, unit, currency, precision, dataGridState, hideCounts), rows: scoreRows, slots: {
            toolbar: isUnique && currentDistance === undefined
                ? TableToolbar_1.TableToolbarUnique
                : TableToolbar_1.TableToolbar,
        }, slotProps: {
            toolbar: {
                isLoading: isLoading || isLoadingCount,
                isUnique: isUnique,
                hideCounts: hideCounts,
                onSetRangeClasses: onSetRangeClasses,
                onRecalculateCount: onRecalculateCount,
                rangeClasses: rangeClasses,
                recalculateOnly: isUnique,
                forComponent: forComponent,
            },
        }, 
        // DONT USE onStateChange={onStateChange} AS THIS GETS CALLED FOR EVERY USER ACTION... SO PROBABLY BEST TO AVOID !!
        onColumnWidthChange: onStateChange, dataCy: "score-table" }));
};
exports["default"] = ScoreDataGrid;


/***/ }),

/***/ "./components/AddEditComponent/ScoreDataGrid/SkeletonCell.tsx":
/*!********************************************************************!*\
  !*** ./components/AddEditComponent/ScoreDataGrid/SkeletonCell.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.SkeletonCell = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var SkeletonCell = function (_a) {
    var id = _a.id, countKey = _a.countKey, value = _a.value, percent = _a.percent;
    var isRiskCountLoading = (0, Risk_selectors_1.useSelectIsCountLoading)(countKey);
    var result;
    if (isRiskCountLoading) {
        result = ((0, jsx_runtime_1.jsx)(material_1.Skeleton, { sx: { mx: 1 }, width: '90%', height: '100%' }, id));
    }
    else {
        result = value !== undefined && percent ? "".concat(value, " %") : value !== null && value !== void 0 ? value : '';
    }
    return result;
};
exports.SkeletonCell = SkeletonCell;


/***/ }),

/***/ "./components/AddEditComponent/ScoreDataGrid/TabelColumns.tsx":
/*!********************************************************************!*\
  !*** ./components/AddEditComponent/ScoreDataGrid/TabelColumns.tsx ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.tableColumns = exports.getFlex = exports.getWidth = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
/* eslint-disable react/display-name */
var react_1 = __webpack_require__(/*! react */ "react");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var ScoreCell_1 = __webpack_require__(/*! ./ScoreCell */ "./components/AddEditComponent/ScoreDataGrid/ScoreCell.tsx");
var RangeCell_1 = __webpack_require__(/*! ./RangeCell */ "./components/AddEditComponent/ScoreDataGrid/RangeCell.tsx");
var SkeletonCell_1 = __webpack_require__(/*! ./SkeletonCell */ "./components/AddEditComponent/ScoreDataGrid/SkeletonCell.tsx");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var getWidth = function (field, dataGridState) {
    var _a;
    // Get the width of the column from the saved state if available
    if (dataGridState &&
        ((_a = dataGridState.columns) === null || _a === void 0 ? void 0 : _a.dimensions) &&
        dataGridState.columns.dimensions[field]) {
        return dataGridState.columns.dimensions[field].width;
    }
    else
        return undefined;
};
exports.getWidth = getWidth;
var getFlex = function (field, flex, dataGridState) {
    var _a;
    // If there is a saved width then return undefined
    // We dont want to specify both flex and width since flex will override the width
    if (dataGridState &&
        ((_a = dataGridState.columns) === null || _a === void 0 ? void 0 : _a.dimensions) &&
        dataGridState.columns.dimensions[field] &&
        dataGridState.columns.dimensions[field].width) {
        return undefined;
    }
    else
        return flex;
};
exports.getFlex = getFlex;
var tableColumns = function (forComponent, onScoreChange, onRangeChange, isUnique, countKey, scoreMax, unit, currency, precision, dataGridState, hideCounts) {
    var _a, _b, _c;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var system = (0, react_1.useContext)(stylovyze_1.UnitsContext).system;
    var lengthUnit = system === 'Metric' ? t('Kilometers') : t('Miles');
    var isRiskCountLoading = (0, Risk_selectors_1.useSelectIsCountLoading)(countKey);
    var header = new Array();
    if (t) {
        if (forComponent) {
            header.push({
                field: 'score',
                headerName: t('Score'),
                sortable: false,
                hideable: false,
                align: 'left',
                flex: hideCounts
                    ? undefined
                    : (0, exports.getFlex)('score', 0.5, dataGridState),
                width: ((_a = (0, exports.getWidth)('score', dataGridState)) !== null && _a !== void 0 ? _a : hideCounts)
                    ? 150
                    : undefined,
                minWidth: 100,
                renderCell: function (params) {
                    return ((0, jsx_runtime_1.jsx)(ScoreCell_1.ScoreCell, { id: params.id, value: params.value, onScoreChange: onScoreChange, scoreMax: scoreMax }));
                },
            });
        }
        if (isUnique) {
            header.push({
                field: 'value',
                headerName: t('Value'),
                sortable: false,
                hideable: false,
                align: 'left',
                flex: hideCounts
                    ? undefined
                    : (0, exports.getFlex)('value', 1, dataGridState),
                width: ((_b = (0, exports.getWidth)('value', dataGridState)) !== null && _b !== void 0 ? _b : hideCounts)
                    ? 300
                    : undefined,
                minWidth: 100,
            });
        }
        else {
            header.push({
                field: 'value',
                headerName: t('Value'),
                sortable: false,
                hideable: false,
                align: 'left',
                flex: hideCounts
                    ? undefined
                    : (0, exports.getFlex)('value', 1.5, dataGridState),
                width: ((_c = (0, exports.getWidth)('value', dataGridState)) !== null && _c !== void 0 ? _c : hideCounts)
                    ? 500
                    : undefined,
                minWidth: 200,
                renderCell: function (params) {
                    return ((0, jsx_runtime_1.jsx)(RangeCell_1.RangeCell, { id: params.id, value: params.value, onRangeChange: onRangeChange, disabled: isRiskCountLoading, unit: unit, currency: currency, precision: precision }));
                },
            });
        }
        if (!hideCounts) {
            header.push({
                field: 'count',
                headerName: t('Asset Count'),
                sortable: false,
                hideable: false,
                align: 'left',
                headerAlign: 'left',
                type: 'number',
                flex: (0, exports.getFlex)('count', 1, dataGridState),
                width: (0, exports.getWidth)('count', dataGridState),
                renderCell: function (params) {
                    return ((0, jsx_runtime_1.jsx)(SkeletonCell_1.SkeletonCell, { id: params.id, countKey: countKey, value: params.value, percent: false }));
                },
            }, {
                field: 'countPercent',
                headerName: t('Asset Count (%)'),
                sortable: false,
                hideable: false,
                align: 'left',
                headerAlign: 'left',
                flex: (0, exports.getFlex)('countPercent', 1, dataGridState),
                width: (0, exports.getWidth)('countPercent', dataGridState),
                renderCell: function (params) {
                    return ((0, jsx_runtime_1.jsx)(SkeletonCell_1.SkeletonCell, { id: params.id, countKey: countKey, value: params.value, percent: false }));
                },
            }, {
                field: 'length',
                headerName: t('Length ({{unit}})', { unit: lengthUnit }),
                sortable: false,
                hideable: false,
                align: 'left',
                headerAlign: 'left',
                type: 'number',
                flex: (0, exports.getFlex)('length', 1, dataGridState),
                width: (0, exports.getWidth)('length', dataGridState),
                renderCell: function (params) {
                    return ((0, jsx_runtime_1.jsx)(SkeletonCell_1.SkeletonCell, { id: params.id, countKey: countKey, value: params.value, percent: false }));
                },
            }, {
                field: 'lengthPercent',
                headerName: t('Length (%)'),
                sortable: false,
                hideable: false,
                align: 'left',
                headerAlign: 'left',
                flex: (0, exports.getFlex)('lengthPercent', 1, dataGridState),
                width: (0, exports.getWidth)('lengthPercent', dataGridState),
                renderCell: function (params) {
                    return ((0, jsx_runtime_1.jsx)(SkeletonCell_1.SkeletonCell, { id: params.id, countKey: countKey, value: params.value, percent: false }));
                },
            });
        }
    }
    return header;
};
exports.tableColumns = tableColumns;


/***/ }),

/***/ "./components/AddEditComponent/ScoreDataGrid/TableToolbar.tsx":
/*!********************************************************************!*\
  !*** ./components/AddEditComponent/ScoreDataGrid/TableToolbar.tsx ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TableToolbarUnique = exports.TableToolbar = exports.ClassesButton = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var ClassesButton = function (isLoading, onSetRangeClasses, rangeClasses) {
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var classOptions = function () {
        var options = [];
        var _loop_1 = function (i) {
            options.push({
                onClick: function () {
                    onSetRangeClasses(i);
                },
                name: t('{{classes}} Classes', { classes: i + 2 }),
            });
        };
        for (var i = 1; i <= 10; ++i) {
            _loop_1(i);
        }
        return options;
    };
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.DropDownButton, { options: classOptions(), initialSelectedIndex: rangeClasses - 1, color: "primary", variant: "outlined", fitMenuToContent: true, fitButtonToContent: true, disabled: isLoading, popupZIndex: stylovyze_1.ZIndex.DropDownButtonMenu }, Date.now()));
};
exports.ClassesButton = ClassesButton;
var TableToolbar = function (_a) {
    var isLoading = _a.isLoading, isUnique = _a.isUnique, hideCounts = _a.hideCounts, onSetRangeClasses = _a.onSetRangeClasses, onRecalculateCount = _a.onRecalculateCount, rangeClasses = _a.rangeClasses, recalculateOnly = _a.recalculateOnly, forComponent = _a.forComponent;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var heading = '';
    var subHeading = '';
    if (forComponent) {
        heading = t('Score Setup');
        subHeading = t('Set your scores below to complete the component setup.');
    }
    else {
        heading = t('Parameter Values');
        if (isUnique) {
            subHeading = t('These are the unique values that will be used in the score setup.');
        }
        else {
            subHeading = t('These are the ranges that will be used in the score setup. You can edit the number of classes shown and the values in the table.');
        }
    }
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledGrid, __assign({ container: true, style: {
            width: '100%',
            marginTop: '1rem',
            marginBottom: '1rem',
        } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 6 }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "heading-large-strong" }, { children: heading })), (0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "caption-medium" }, { children: subHeading }))] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6, display: "flex", justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: 'row', spacing: '20px' }, { children: [hideCounts ? ([]) : ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ disabled: isLoading, variant: "outlined", onClick: function () {
                                    onRecalculateCount();
                                } }, { children: t('Recalculate Asset Count') })) })), !recalculateOnly &&
                            !isUnique &&
                            (0, exports.ClassesButton)(isLoading, onSetRangeClasses, rangeClasses)] })) }))] })));
};
exports.TableToolbar = TableToolbar;
var TableToolbarUnique = function (_a) {
    var forComponent = _a.forComponent;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var heading = '';
    var subHeading = '';
    if (forComponent) {
        heading = t('Score Setup');
        subHeading = t('Set your scores below to complete the component setup.');
    }
    else {
        heading = t('Parameter Values');
        subHeading = t('These are the unique values that will be used in the score setup.');
    }
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledGrid, __assign({ container: true, style: {
            width: '100%',
            marginTop: '1rem',
            marginBottom: '1rem',
        } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 8 }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "heading-large-strong" }, { children: heading })), (0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "caption-medium" }, { children: subHeading }))] })), (0, jsx_runtime_1.jsx)(material_1.Grid, { item: true, xs: 4, display: "flex", justifyContent: "flex-end" })] })));
};
exports.TableToolbarUnique = TableToolbarUnique;


/***/ }),

/***/ "./components/AddEditComponent/calculateRangeInterval.ts":
/*!***************************************************************!*\
  !*** ./components/AddEditComponent/calculateRangeInterval.ts ***!
  \***************************************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.calculateRangeInterval = void 0;
function calculateRangeInterval(unitRange, newRangeClasses, precision) {
    var interval = unitRange / newRangeClasses;
    // If the interval is 0 then make it the minimum increment
    if (interval === 0) {
        interval = +(1 / Math.pow(10, precision)).toFixed(precision);
    }
    else {
        interval = +interval.toFixed(precision);
    }
    // If the precision is 0 then make sure the interval is at least 1
    if (precision === 0) {
        interval = Math.max(interval, 1);
    }
    return interval;
}
exports.calculateRangeInterval = calculateRangeInterval;


/***/ }),

/***/ "./components/AddEditComponent/index.ts":
/*!**********************************************!*\
  !*** ./components/AddEditComponent/index.ts ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./AddEditComponent */ "./components/AddEditComponent/AddEditComponent.tsx"), exports);


/***/ }),

/***/ "./components/Category/Category.component.tsx":
/*!****************************************************!*\
  !*** ./components/Category/Category.component.tsx ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Category = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __webpack_require__(/*! react */ "react");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var Component_component_1 = __webpack_require__(/*! ./Component/Component.component */ "./components/Category/Component/Component.component.tsx");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var Category_styles_1 = __webpack_require__(/*! ./Category.styles */ "./components/Category/Category.styles.ts");
var stylovyze_2 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var Scales_1 = __importDefault(__webpack_require__(/*! @Components/Utils/icons/Scales */ "./components/Utils/icons/Scales.tsx"));
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var useNoConditionData_1 = __webpack_require__(/*! @Hooks/useNoConditionData */ "./hooks/useNoConditionData.ts");
var Category = function (_a) {
    var _b, _c;
    var isLoading = _a.isLoading, forLoF = _a.forLoF, LoFCategoryIndex = _a.LoFCategoryIndex, _d = _a.isWeightingInvalid, isWeightingInvalid = _d === void 0 ? false : _d, _e = _a.canBeDiscarded, canBeDiscarded = _e === void 0 ? true : _e, onCategoryWeightingChanged = _a.onCategoryWeightingChanged, onAddComponent = _a.onAddComponent, onEditComponent = _a.onEditComponent;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var classes = (0, Category_styles_1.useStyle)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _f = (0, react_1.useState)(false), open = _f[0], setOpen = _f[1];
    var riskStore = (0, _Selectors_1.selectRiskStore)();
    var lofStore = forLoF ? (0, _Selectors_1.selectLofStore)() : null;
    var cofStore = !forLoF ? (0, _Selectors_1.selectCofStore)() : null;
    var category = undefined;
    var components = undefined;
    if (forLoF) {
        if (LoFCategoryIndex !== undefined &&
            lofStore != undefined &&
            ((_b = lofStore.categories) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            category = lofStore === null || lofStore === void 0 ? void 0 : lofStore.categories[LoFCategoryIndex];
            components = category === null || category === void 0 ? void 0 : category.components;
        }
    }
    else {
        if (LoFCategoryIndex !== undefined &&
            cofStore != undefined &&
            ((_c = cofStore.categories) === null || _c === void 0 ? void 0 : _c.length) > 0) {
            category = cofStore === null || cofStore === void 0 ? void 0 : cofStore.categories[LoFCategoryIndex];
            components = category === null || category === void 0 ? void 0 : category.components;
        }
    }
    var handleUseExclusivelyChange = function (event) {
        if (lofStore) {
            dispatch((0, _Actions_1.setLoFConfig)(lofStore.categories.map(function (cat, index) {
                return index === LoFCategoryIndex
                    ? __assign(__assign({}, cat), { useThisOnly: event.target.checked, weighting: event.target.checked
                            ? 100
                            : cat.weighting }) : cat;
            })));
        }
    };
    var handleUseHighestChange = function (event) {
        if (!forLoF) {
            if (cofStore) {
                dispatch((0, _Actions_1.setCoFConfig)(cofStore.categories.map(function (cat, index) {
                    return index === LoFCategoryIndex
                        ? __assign(__assign({}, cat), { useHighestScore: event.target.checked }) : cat;
                })));
            }
        }
        else {
            if (lofStore) {
                dispatch((0, _Actions_1.setLoFConfig)(lofStore.categories.map(function (cat, index) {
                    return index === LoFCategoryIndex
                        ? __assign(__assign({}, cat), { useHighestScore: event.target.checked }) : cat;
                })));
            }
        }
    };
    var onDeleteComponent = function (title) {
        if (category && components) {
            if (forLoF) {
                dispatch((0, _Actions_1.setLoFComponents)({
                    categoryName: category.name,
                    components: components.filter(function (component) { return component.name !== title; }),
                }));
            }
            else {
                dispatch((0, _Actions_1.setCoFComponents)({
                    categoryName: category.name,
                    components: components.filter(function (component) { return component.name !== title; }),
                }));
            }
        }
    };
    var isInvalid = function () {
        var _a, _b;
        var value = (_b = (_a = components === null || components === void 0 ? void 0 : components.filter(function (comp) { return comp.select; })) === null || _a === void 0 ? void 0 : _a.map(function (comp) { return comp.weighting; })) === null || _b === void 0 ? void 0 : _b.reduce(function (pre, current) { return pre + current; }, 0);
        return value !== undefined && value > 0 && value !== 100;
    };
    var allComponents = function () {
        return components === null || components === void 0 ? void 0 : components.map(function (comp, index) { return ((0, jsx_runtime_1.jsx)(Component_component_1.Component, { title: comp.name, value: comp.weighting, enabledChecked: comp.select, invalid: isInvalid(), disableSlider: (category === null || category === void 0 ? void 0 : category.weighting) === 0, checkBox: category === null || category === void 0 ? void 0 : category.useHighestScore, onSliderValueChanged: function (value) {
                if (lofStore && components && category) {
                    var newCat_1 = __assign(__assign({}, category), { components: components.map(function (onChangeComp, onChangeIndex) {
                            if (onChangeIndex === index) {
                                return __assign(__assign({}, onChangeComp), { weighting: value, select: value !== 0 });
                            }
                            else {
                                return onChangeComp;
                            }
                        }) });
                    dispatch((0, _Actions_1.setLoFConfig)(lofStore.categories.map(function (category) {
                        return category.name === newCat_1.name
                            ? newCat_1
                            : category;
                    })));
                }
                else if (cofStore && category && components) {
                    var newCat_2 = __assign(__assign({}, category), { components: components.map(function (onChangeComp, onChangeIndex) {
                            if (onChangeIndex === index) {
                                return __assign(__assign({}, onChangeComp), { weighting: value, select: value !== 0 });
                            }
                            else {
                                return onChangeComp;
                            }
                        }) });
                    dispatch((0, _Actions_1.setCoFConfig)(cofStore.categories.map(function (cof) {
                        return cof.name === newCat_2.name ? newCat_2 : cof;
                    })));
                }
            }, onSelectChecked: function (checked) {
                if (lofStore && category) {
                    var newCat_3 = __assign(__assign({}, category), { components: category.components.map(function (onChangeComp, onChangeIndex) {
                            if (onChangeIndex === index) {
                                return __assign(__assign({}, onChangeComp), { weighting: 0, select: checked });
                            }
                            else {
                                return onChangeComp;
                            }
                        }) });
                    dispatch((0, _Actions_1.setLoFConfig)(lofStore.categories.map(function (category) {
                        return category.name === newCat_3.name
                            ? newCat_3
                            : category;
                    })));
                }
                else if (cofStore && components && category) {
                    var newCat_4 = __assign(__assign({}, category), { components: category.components.map(function (onChangeComp, onChangeIndex) {
                            if (onChangeIndex === index) {
                                return __assign(__assign({}, onChangeComp), { weighting: 0, select: checked });
                            }
                            else {
                                return onChangeComp;
                            }
                        }) });
                    dispatch((0, _Actions_1.setCoFConfig)(cofStore.categories.map(function (cat) {
                        return cat.name === newCat_4.name ? newCat_4 : cat;
                    })));
                }
            }, onEdit: function (title) {
                if (components) {
                    var targetComponent = components.find(function (o) { return o.name == title; });
                    if (targetComponent && onEditComponent) {
                        onEditComponent(forLoF, category, __assign({}, targetComponent));
                    }
                }
            }, onDelete: onDeleteComponent }, comp.name)); });
    };
    var ifLoadingTrue = ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: { paddingTop: '20px', paddingBottom: '20px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) })));
    var ifLoadingFalse = components && components.length > 0 ? (allComponents()) : ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: { paddingTop: '40px' } }, { children: (0, jsx_runtime_1.jsx)(Scales_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6" }, { children: t('You do not have any components added') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption" }, { children: t('Add components to set up weighting.') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: {
                    paddingTop: '20px',
                    paddingBottom: '20px',
                } }, { children: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "outlined", color: "primary", onClick: function () { return onAddComponent === null || onAddComponent === void 0 ? void 0 : onAddComponent(forLoF, category); } }, { children: t('Add Component') })) }))] })));
    var noConditionData = (0, useNoConditionData_1.useNoConditionData)(riskStore.riskConfig.riskSetting.assetType);
    var getCatWeightingDesc = function () {
        if (forLoF && !noConditionData) {
            return (category === null || category === void 0 ? void 0 : category.isCondition)
                ? t('Uncheck box above to adjust category weighting')
                : t('When there is no condition data');
        }
        else {
            return '';
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(stylovyze_2.WarningDialog, { open: open, title: t('Discard category?'), content: t('Are you sure you want to discard this category?'), cancelText: t('Cancel'), confirmText: t('Confirm'), onCancel: function () { return setOpen(false); }, onConfirm: function () {
                    var _a, _b;
                    return dispatch(forLoF
                        ? (0, _Actions_1.deleteCategory)({
                            forLoF: forLoF,
                            categoryName: (_a = category === null || category === void 0 ? void 0 : category.name) !== null && _a !== void 0 ? _a : '',
                        })
                        : (0, _Actions_1.deleteCoFCategory)({
                            forLoF: forLoF,
                            categoryName: (_b = category === null || category === void 0 ? void 0 : category.name) !== null && _b !== void 0 ? _b : '',
                        }));
                } }), (0, jsx_runtime_1.jsxs)(stylovyze_1.InfoCard, __assign({ title: "", className: isLoading ? 'wait' : '', titleArea: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, className: isLoading ? 'wait' : '' }, { children: [(0, jsx_runtime_1.jsx)("div", { className: classes.vl }), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 6, item: true, container: true }, { children: (category === null || category === void 0 ? void 0 : category.isCondition) ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6", style: { marginTop: '-5px' } }, { children: category.name })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, style: { display: 'flex' } }, { children: (0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { style: {
                                                marginLeft: '0px',
                                                marginTop: '-7px',
                                            }, control: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { style: { padding: '0px' }, sx: {
                                                    '& .MuiSvgIcon-root': {
                                                        fontSize: 14,
                                                    },
                                                }, checked: category === null || category === void 0 ? void 0 : category.useThisOnly, onChange: handleUseExclusivelyChange, inputProps: {
                                                    'aria-label': 'secondary checkbox',
                                                } }), label: (0, jsx_runtime_1.jsx)("div", __assign({ title: t('When selected you are choosing to override all general LoF components when condition is available for the asset.') }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2", style: {
                                                        marginLeft: '6px',
                                                    } }, { children: t("If condition data is\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tpresent, use it\n\t\t\t\t\t\t\t\t\t\t\t\t\t\texclusively for LoF") })) })) }) }))] })) : ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6" }, { children: category
                                        ? category.name
                                        : forLoF
                                            ? t('Category')
                                            : t('Components') })) }))) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 6, item: true, container: true, justifyContent: "flex-end", style: { paddingTop: '2px' } }, { children: [!canBeDiscarded ||
                                    isLoading ||
                                    (category === null || category === void 0 ? void 0 : category.isCondition) ? null : ((0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "outlined", color: "primary", onClick: function () { return setOpen(true); }, style: {
                                        marginRight: '8px',
                                    } }, { children: t('Discard') }))), isLoading ? null : ((0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "outlined", color: "primary", onClick: function () {
                                        return onAddComponent === null || onAddComponent === void 0 ? void 0 : onAddComponent(forLoF, category);
                                    } }, { children: t('Add Component') })))] }))] })) }, { children: [!isLoading ? ((0, jsx_runtime_1.jsx)(Component_component_1.Component, { title: t('Category Weighting'), invalid: (!(category === null || category === void 0 ? void 0 : category.isCondition) && isWeightingInvalid) ||
                            ((category === null || category === void 0 ? void 0 : category.isCondition) &&
                                !category.useThisOnly &&
                                isWeightingInvalid), subTitle: getCatWeightingDesc(), value: category ? category.weighting : 0, onSliderValueChanged: onCategoryWeightingChanged, needMenu: false, disableSlider: (category === null || category === void 0 ? void 0 : category.isCondition) && category.useThisOnly, enabledChecked: true })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, className: classes.columnHeaderBreaker, style: { display: 'flex' }, alignItems: "center" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 2, item: true }, { children: t('Name') })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 4, item: true }, { children: t((category === null || category === void 0 ? void 0 : category.useHighestScore) ? 'Enabled' : 'Weight') })), !isLoading ? ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 6, item: true, container: true, style: { justifyContent: 'flex-end' } }, { children: (0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { control: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { style: { padding: '0px' }, sx: {
                                            '& .MuiSvgIcon-root': {
                                                fontSize: 14,
                                            },
                                        }, disabled: (category === null || category === void 0 ? void 0 : category.weighting) === 0, checked: category === null || category === void 0 ? void 0 : category.useHighestScore, onChange: handleUseHighestChange }), label: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "body2", style: {
                                            marginRight: '6px',
                                        } }, { children: t("Use highest score from components as\n\t\t\t\t\t\t\t\t\t\toverall category score") })), labelPlacement: "start" }) }))) : ((0, jsx_runtime_1.jsx)(material_1.Grid, { xs: 6, item: true }))] })), isLoading ? ifLoadingTrue : ifLoadingFalse, (0, jsx_runtime_1.jsx)("hr", { className: classes.divider })] }))] }));
};
exports.Category = Category;


/***/ }),

/***/ "./components/Category/Category.styles.ts":
/*!************************************************!*\
  !*** ./components/Category/Category.styles.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStyle = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
exports.useStyle = (0, styles_1.makeStyles)(function () { return ({
    header: {
        fontSize: '1.125rem',
        padding: '8px 24px 8px 24px',
        display: 'flex',
        height: '55px',
    },
    vl: {
        borderLeft: '5px solid ' + stylovyze_1.palette.primary.dark,
        height: '45px',
        //position: 'absolute',
        margin: '-3px 0 0 -19px',
        paddingLeft: '10px',
    },
    helpIcon: {
        width: '15px',
        color: 'rgb(218, 218, 218)',
        height: '15px',
        margin: '0px 0 0 5px',
        top: '4px',
        position: 'relative',
    },
    columnHelpIcon: {
        width: '15px',
        color: 'rgb(218, 218, 218)',
        height: '15px',
        margin: '-4px 0 0 3px',
    },
    columnHeaderBreaker: {
        width: 'calc( 100% + 48px)',
        marginLeft: '-24px',
        padding: '0 24px',
        backgroundColor: '#F7F7F7',
        height: '46px',
        '& div:nth-child(-n+2)': {
            fontsize: '14px',
            fontStyle: 'normal',
            fontWeight: 600,
            lineHeight: '20px',
            letterSpacing: '0px',
        },
        '& div:last-child': {
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '16px',
            letterSpacing: '0px',
        },
    },
    root: {
        width: '100%',
        '& hr': {
            display: 'block',
            unicodeBidi: 'isolate',
            marginBlockStart: '0.5em',
            marginBlockEnd: '0.5em',
            marginInlineStart: 'auto',
            marginInlineEnd: 'auto',
            overflow: 'hidden',
            borderWidth: '1px',
        },
    },
    paper: {
        boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
        color: 'rgba(0, 0, 0, 0.87)',
        transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        backgroundColor: '#fff',
    },
    divider: {
        border: 'none',
        height: '1px',
        margin: 0,
        flexShrink: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
    },
    cardBody: {
        padding: '12px 1.5rem',
    },
}); });


/***/ }),

/***/ "./components/Category/Component/Component.component.tsx":
/*!***************************************************************!*\
  !*** ./components/Category/Component/Component.component.tsx ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Component = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var material_2 = __webpack_require__(/*! @mui/material */ "@mui/material");
var icons_material_1 = __webpack_require__(/*! @mui/icons-material */ "@mui/icons-material");
var PercentSlider_1 = __webpack_require__(/*! @Components/PercentSlider */ "./components/PercentSlider/index.ts");
var Component_styles_1 = __webpack_require__(/*! ./Component.styles */ "./components/Category/Component/Component.styles.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var Component = function (_a) {
    var title = _a.title, subTitle = _a.subTitle, value = _a.value, _b = _a.disableSlider, disableSlider = _b === void 0 ? false : _b, _c = _a.invalid, invalid = _c === void 0 ? false : _c, onSliderValueChanged = _a.onSliderValueChanged, onSelectChecked = _a.onSelectChecked, _d = _a.needMenu, needMenu = _d === void 0 ? true : _d, onEdit = _a.onEdit, onDelete = _a.onDelete, _e = _a.checkBox, checkBox = _e === void 0 ? false : _e, enabledChecked = _a.enabledChecked;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var classes = (0, Component_styles_1.useStyles)();
    var getLabel = function () { return ((0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ gutterBottom: subTitle != undefined, style: {
            marginLeft: '0px',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '20px',
        } }, { children: title }))); };
    return ((0, jsx_runtime_1.jsxs)(material_2.Grid, __assign({ container: true, alignItems: "center", className: classes.root }, { children: [(0, jsx_runtime_1.jsxs)(material_2.Grid, __assign({ item: true, xs: 2, container: true }, { children: [(0, jsx_runtime_1.jsx)(material_2.Grid, __assign({ item: true, xs: 12 }, { children: getLabel() })), subTitle ? ((0, jsx_runtime_1.jsx)(material_2.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ gutterBottom: true, style: {
                                fontWeight: 400,
                                fontSize: '10px',
                                lineHeight: '12px',
                                marginTop: '-7px',
                            } }, { children: subTitle })) }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] })), (0, jsx_runtime_1.jsxs)(material_2.Grid, __assign({ item: true, xs: 10, container: true, justifyContent: "space-between", style: { paddingLeft: checkBox ? '18px' : '40px' } }, { children: [checkBox ? ((0, jsx_runtime_1.jsx)("div", __assign({ style: { width: 'calc( 100% - 48px )' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { disabled: disableSlider, checked: enabledChecked, onChange: function (_, checked) {
                                if (onSelectChecked)
                                    onSelectChecked(checked);
                            } }) }))) : ((0, jsx_runtime_1.jsx)("div", __assign({ style: { width: 'calc( 100% - 48px )' } }, { children: (0, jsx_runtime_1.jsx)(PercentSlider_1.PercentSlider, { value: enabledChecked ? value : 0, onSliderChanged: onSliderValueChanged, disabled: disableSlider, invalid: invalid, marks: 'minmaxticks', valueLabelDisplay: 'on' }) }))), needMenu ? ((0, jsx_runtime_1.jsx)(stylovyze_1.MenuListButton, { menuItems: [
                            {
                                text: t('Edit'),
                                icon: (0, jsx_runtime_1.jsx)(icons_material_1.Edit, {}),
                                onClick: function () {
                                    if (onEdit)
                                        onEdit(title);
                                },
                            },
                            {
                                text: t('Delete'),
                                icon: (0, jsx_runtime_1.jsx)(icons_material_1.Delete, {}),
                                onClick: function () {
                                    if (onDelete)
                                        onDelete(title);
                                },
                            },
                        ], buttonCy: "actions" })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] }))] })));
};
exports.Component = Component;


/***/ }),

/***/ "./components/Category/Component/Component.styles.ts":
/*!***********************************************************!*\
  !*** ./components/Category/Component/Component.styles.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStyles = void 0;
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
exports.useStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        root: {
            height: '70px',
        },
        margin: {
            height: '3rem',
        },
        titleWCheckbox: {
            maxWidth: 'calc( 100% - 20px)',
        },
    });
});


/***/ }),

/***/ "./components/CoFSetup/CoFSetup.component.tsx":
/*!****************************************************!*\
  !*** ./components/CoFSetup/CoFSetup.component.tsx ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.CoFSetup = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var _Components_1 = __webpack_require__(/*! @Components */ "./components/index.ts");
var Scales_1 = __importDefault(__webpack_require__(/*! @Components/Utils/icons/Scales */ "./components/Utils/icons/Scales.tsx"));
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var CoF_selectors_1 = __webpack_require__(/*! @Selectors/CoF.selectors */ "./selectors/CoF.selectors.ts");
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var react_1 = __webpack_require__(/*! react */ "react");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var CoFSetup = function (_a) {
    var _b, _c;
    var onAddComponent = _a.onAddComponent, onEditComponent = _a.onEditComponent;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var _d = (0, react_1.useState)(false), open = _d[0], setOpen = _d[1];
    var _e = (0, react_1.useState)(''), newCategoryName = _e[0], setNewCategoryName = _e[1];
    var _f = (0, react_1.useState)(''), validCategoryName = _f[0], setValidCategoryName = _f[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var history = (0, react_router_dom_1.useHistory)();
    var riskSettings = (0, Risk_selectors_1.selectRiskSetting)();
    var cofStore = (0, CoF_selectors_1.selectCofStore)();
    var categories = (cofStore === null || cofStore === void 0 ? void 0 : cofStore.categories) || [];
    var isLoading = (cofStore === null || cofStore === void 0 ? void 0 : cofStore.isLoadingCategories) || (cofStore === null || cofStore === void 0 ? void 0 : cofStore.isLoadingFields);
    (0, react_1.useEffect)(function () {
        dispatch((0, _Actions_1.setTab)('cof'));
    }, []);
    var totalWeight = (_c = (_b = cofStore === null || cofStore === void 0 ? void 0 : cofStore.categories) === null || _b === void 0 ? void 0 : _b.map(function (cat) { return cat.weighting; })) === null || _c === void 0 ? void 0 : _c.reduce(function (pre, current) { return pre + current; }, 0);
    var handleAddCategoryClicked = function () {
        if (!isLoading)
            setOpen(true);
    };
    var handleClose = function () {
        setNewCategoryName('');
        setValidCategoryName('');
        setOpen(false);
    };
    var handleAdd = function () {
        if (newCategoryName !== '') {
            dispatch((0, _Actions_1.addCoFConfig)({
                name: newCategoryName,
                isCondition: false,
                useThisOnly: false,
                weighting: 0,
                useHighestScore: false,
                components: [],
            }));
            setOpen(false);
            setNewCategoryName('');
            setValidCategoryName('');
        }
    };
    var validateCategoryName = function (event) {
        var _a;
        var name = event.target.value.toUpperCase();
        var valid = true;
        valid =
            ((_a = cofStore === null || cofStore === void 0 ? void 0 : cofStore.categories) === null || _a === void 0 ? void 0 : _a.find(function (category) { return category.name.toUpperCase() == name; })) === undefined;
        setValidCategoryName(valid ? '' : t('Enter a unique name'));
        setNewCategoryName(valid ? event.target.value : '');
    };
    var isConfigValid = function () {
        var categories = cofStore.categories;
        if (!categories)
            return false;
        var categoriesTotalWeight = categories
            .map(function (category) { return category.weighting; })
            .reduce(function (prev, current) { return prev + current; }, 0);
        if (categoriesTotalWeight !== 100 && categories.length > 0)
            return false;
        for (var _i = 0, categories_1 = categories; _i < categories_1.length; _i++) {
            var category = categories_1[_i];
            if (!category.useHighestScore &&
                category.components &&
                category.components.length != 0) {
                var total = category.components
                    .map(function (component) {
                    return component.select ? component.weighting : 0;
                })
                    .reduce(function (prev, current) { return prev + current; }, 0);
                // We want a total of 0 or 100 to be valid
                return total === 0 || total === 100;
            }
        }
        return true;
    };
    var noCoFCategories = function () {
        return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: { paddingTop: '40px' } }, { children: (0, jsx_runtime_1.jsx)(Scales_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6" }, { children: t('No CoF Categories') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption", style: { textAlign: 'center' } }, { children: t('You have no CoF categories created.') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: {
                        paddingTop: '20px',
                        paddingBottom: '20px',
                    } }, { children: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "contained", color: "primary", onClick: handleAddCategoryClicked }, { children: t('Add Category') })) }))] })));
    };
    var navMsg = isConfigValid()
        ? t('You have modified your COF configuration and have unsaved changes.  You can save your configuration changes, discard changes, or cancel to continue editing.')
        : t('You have modified your COF configuration and have unsaved changes.  You can discard changes, or cancel to continue editing.');
    var refresh = function () {
        dispatch((0, _Actions_1.getRiskConfig)(riskSettings.configId));
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.NavigationPrompt, { when: cofStore.isChanged, navigate: function (nextLocation) {
                    history.push(nextLocation);
                }, confirmText: isConfigValid() ? t('Save') : t('Discard'), onNavigateAway: function () {
                    if (isConfigValid()) {
                        dispatch((0, _Actions_1.saveCoF)({ refresh: refresh }));
                        dispatch((0, _Actions_1.setRefreshList)(true));
                    }
                    else {
                        dispatch((0, _Actions_1.getRiskConfig)(riskSettings.configId));
                        dispatch((0, _Actions_1.setCoFIsChanged)(false));
                    }
                }, secondaryConfirmText: isConfigValid() ? t('Discard') : undefined, onSecondaryNavigateAway: function () {
                    dispatch((0, _Actions_1.getRiskConfig)(riskSettings.configId));
                    dispatch((0, _Actions_1.setCoFIsChanged)(false));
                }, shouldBlockNavigation: function () { return true; }, shouldBlockReload: cofStore.isChanged, content: navMsg }), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 12, item: true, container: true }, { children: [isLoading ? null : ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, container: true, justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ style: { margin: '12px 0px' }, variant: "contained", color: "primary", onClick: handleAddCategoryClicked }, { children: t('Add Category') })) }))), isLoading ? ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: {
                                paddingTop: '20px',
                                paddingBottom: '20px',
                            } }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) }))) : categories.length == 0 ? (noCoFCategories()) : (categories.map(function (cat, index) { return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, style: { paddingBottom: '12px' } }, { children: (0, jsx_runtime_1.jsx)(_Components_1.Category, { isLoading: false, forLoF: false, LoFCategoryIndex: index, isWeightingInvalid: totalWeight != 100, onCategoryWeightingChanged: function (value) {
                                    dispatch((0, _Actions_1.setCoFConfig)(categories.map(function (onChangeCat, onChangeIndex) {
                                        return onChangeIndex === index
                                            ? __assign(__assign({}, onChangeCat), { weighting: value }) : onChangeCat;
                                    })));
                                }, onAddComponent: function (forLoF, targetCat) {
                                    onAddComponent(false, false, targetCat);
                                }, onEditComponent: function (forLoF, targetCat, component) {
                                    onEditComponent(false, false, targetCat, component);
                                } }) }), cat.name)); }))] })) })), (0, jsx_runtime_1.jsxs)(material_1.Dialog, __assign({ open: open, onClose: handleClose, "aria-labelledby": "form-dialog-title" }, { children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, __assign({ id: "form-dialog-title", style: { width: '481px' } }, { children: "Add Category" })), (0, jsx_runtime_1.jsx)(material_1.DialogContent, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { margin: "dense", id: "name", label: t('Category Name'), type: "text", fullWidth: true, variant: "outlined", defaultValue: newCategoryName, helperText: validCategoryName, error: validCategoryName !== '', onChange: validateCategoryName }) }), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, __assign({ onClick: handleClose, color: "secondary", variant: "contained" }, { children: t('Cancel') })), (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ "data-testid": "cof-setup-add-category-dialog-add-category-btn", onClick: handleAdd, color: "primary", variant: "contained" }, { children: t('Add Category') }))] })] }))] }));
};
exports.CoFSetup = CoFSetup;


/***/ }),

/***/ "./components/CoFSetup/index.ts":
/*!**************************************!*\
  !*** ./components/CoFSetup/index.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./CoFSetup.component */ "./components/CoFSetup/CoFSetup.component.tsx"), exports);


/***/ }),

/***/ "./components/FieldInspectionSummary/FieldInspectionSummary.component.tsx":
/*!********************************************************************************!*\
  !*** ./components/FieldInspectionSummary/FieldInspectionSummary.component.tsx ***!
  \********************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.FieldInspectionSummary = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var FieldInspectionSummary_styles_1 = __webpack_require__(/*! ./FieldInspectionSummary.styles */ "./components/FieldInspectionSummary/FieldInspectionSummary.styles.ts");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var FieldInspectionSummary = function () {
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var classes = (0, FieldInspectionSummary_styles_1.useStyle)();
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Field Inspection Summary'), className: classes.root }, { children: (0, jsx_runtime_1.jsx)("img", { alt: "summary", src: __webpack_require__(/*! ./summary.png */ "./components/FieldInspectionSummary/summary.png") }) })));
};
exports.FieldInspectionSummary = FieldInspectionSummary;


/***/ }),

/***/ "./components/FieldInspectionSummary/FieldInspectionSummary.styles.ts":
/*!****************************************************************************!*\
  !*** ./components/FieldInspectionSummary/FieldInspectionSummary.styles.ts ***!
  \****************************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useStyle = void 0;
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
exports.useStyle = (0, styles_1.makeStyles)(function () { return ({
    root: {
        width: '100%',
        // overflow: 'hidden',
        '& .InfoCard--body': {
            overflow: 'hidden',
        },
    },
}); });


/***/ }),

/***/ "./components/FieldInspectionSummary/index.ts":
/*!****************************************************!*\
  !*** ./components/FieldInspectionSummary/index.ts ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./FieldInspectionSummary.component */ "./components/FieldInspectionSummary/FieldInspectionSummary.component.tsx"), exports);


/***/ }),

/***/ "./components/LoFSetup/LoFSetup.component.tsx":
/*!****************************************************!*\
  !*** ./components/LoFSetup/LoFSetup.component.tsx ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.LoFSetup = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var NoLoFCategories_1 = __webpack_require__(/*! ./NoLoFCategories */ "./components/LoFSetup/NoLoFCategories.tsx");
var RenderedCategories_1 = __webpack_require__(/*! ./RenderedCategories */ "./components/LoFSetup/RenderedCategories.tsx");
var LoFSetup = function (_a) {
    var _b, _c, _d;
    var onAddComponent = _a.onAddComponent, onEditComponent = _a.onEditComponent;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var _e = react_1.default.useState(false), open = _e[0], setOpen = _e[1];
    var _f = (0, react_1.useState)(''), newCategoryName = _f[0], setNewCategoryName = _f[1];
    var _g = (0, react_1.useState)(''), validCategoryName = _g[0], setValidCategoryName = _g[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var history = (0, react_router_dom_1.useHistory)();
    var riskSettings = (0, _Selectors_1.selectRiskSetting)();
    var lofStore = (0, _Selectors_1.selectLofStore)();
    var categories = lofStore === null || lofStore === void 0 ? void 0 : lofStore.categories;
    var isLoading = (lofStore === null || lofStore === void 0 ? void 0 : lofStore.isLoadingCategories) ||
        (lofStore === null || lofStore === void 0 ? void 0 : lofStore.isLoadingFields) ||
        (lofStore === null || lofStore === void 0 ? void 0 : lofStore.isLoadingInspectionFields);
    (0, react_1.useEffect)(function () {
        dispatch((0, _Actions_1.setTab)('lof'));
    }, []);
    var handleClose = function () {
        setNewCategoryName('');
        setValidCategoryName('');
        setOpen(false);
    };
    var handleAddCategoryClicked = function () {
        if (!isLoading)
            setOpen(true);
    };
    var handleAdd = function () {
        if (newCategoryName !== '') {
            dispatch((0, _Actions_1.addLoFConfig)({
                name: newCategoryName,
                isCondition: false,
                useThisOnly: false,
                weighting: 0,
                useHighestScore: false,
                components: [],
            }));
            setOpen(false);
            setNewCategoryName('');
            setValidCategoryName('');
        }
    };
    var totalWeight = (_d = (_c = (_b = lofStore === null || lofStore === void 0 ? void 0 : lofStore.categories) === null || _b === void 0 ? void 0 : _b.filter(function (cat) { return !cat.useThisOnly; })) === null || _c === void 0 ? void 0 : _c.map(function (cat) { return cat.weighting; })) === null || _d === void 0 ? void 0 : _d.reduce(function (pre, current) { return pre + current; }, 0);
    var validateCategoryName = function (event) {
        var name = event.target.value.toUpperCase();
        var valid = true;
        valid =
            (lofStore === null || lofStore === void 0 ? void 0 : lofStore.categories.find(function (category) { return category.name.toUpperCase() == name; })) === undefined;
        setValidCategoryName(valid ? '' : t('Enter a unique name'));
        setNewCategoryName(valid ? event.target.value : '');
    };
    var isConfigValid = function () {
        var categories = lofStore.categories;
        if (!categories)
            return false;
        if (categories.length === 0) {
            return false;
        }
        var categoriesTotalWeight = categories
            .filter(function (category) { return !category.useThisOnly; })
            .map(function (category) { return category.weighting; })
            .reduce(function (prev, current) { return prev + current; }, 0);
        if (categoriesTotalWeight !== 100 &&
            categories.filter(function (category) { return !category.useThisOnly; }).length > 0)
            return false;
        for (var _i = 0, categories_1 = categories; _i < categories_1.length; _i++) {
            var category = categories_1[_i];
            if (!category.useHighestScore &&
                category.components &&
                category.components.length != 0) {
                var total = category.components
                    .map(function (component) {
                    return component.select ? component.weighting : 0;
                })
                    .reduce(function (prev, current) { return prev + current; }, 0);
                // We want a total of 0 or 100 to be valid
                return total === 0 || total === 100;
            }
        }
        return true;
    };
    var navMsg = isConfigValid()
        ? t('You have modified your LOF configuration and have unsaved changes.  You can save your configuration changes, discard changes, or cancel to continue editing.')
        : t('You have modified your LOF configuration and have unsaved changes.  You can discard changes, or cancel to continue editing.');
    var refresh = function () {
        dispatch((0, _Actions_1.getRiskConfig)(riskSettings.configId));
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.NavigationPrompt, { when: lofStore.isChanged, navigate: function (nextLocation) {
                    history.push(nextLocation);
                }, confirmText: isConfigValid() ? t('Save') : t('Discard'), onNavigateAway: function () {
                    if (isConfigValid()) {
                        dispatch((0, _Actions_1.saveLoF)({ refresh: refresh }));
                        dispatch((0, _Actions_1.setRefreshList)(true));
                    }
                    else {
                        dispatch((0, _Actions_1.getRiskConfig)(riskSettings.configId));
                        dispatch((0, _Actions_1.setLofIsChanged)(false));
                    }
                }, secondaryConfirmText: isConfigValid() ? t('Discard') : undefined, onSecondaryNavigateAway: function () {
                    dispatch((0, _Actions_1.getRiskConfig)(riskSettings.configId));
                    dispatch((0, _Actions_1.setLofIsChanged)(false));
                }, shouldBlockNavigation: function () { return true; }, shouldBlockReload: lofStore.isChanged, content: navMsg }), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ xs: 12, item: true, container: true }, { children: [isLoading && categories.length === 0 && ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: {
                                    paddingTop: '20px',
                                    paddingBottom: '20px',
                                } }, { children: (0, jsx_runtime_1.jsx)(material_1.CircularProgress, {}) }))), !isLoading && categories.length === 0 && ((0, jsx_runtime_1.jsx)(NoLoFCategories_1.NoLoFCategories, { handleAddCategoryClicked: handleAddCategoryClicked })), (0, jsx_runtime_1.jsx)(RenderedCategories_1.RenderedCategories, { isLoading: isLoading, categories: categories, totalWeight: totalWeight, onAddComponent: onAddComponent, onEditComponent: onEditComponent, handleAddCategoryClicked: handleAddCategoryClicked })] })), (0, jsx_runtime_1.jsx)(material_1.Grid, { xs: 4, item: true, container: true })] })), (0, jsx_runtime_1.jsxs)(material_1.Dialog, __assign({ open: open, onClose: handleClose, "aria-labelledby": "form-dialog-title" }, { children: [(0, jsx_runtime_1.jsx)(material_1.DialogTitle, __assign({ id: "form-dialog-title", style: { width: '481px' } }, { children: t('Add Category') })), (0, jsx_runtime_1.jsx)(material_1.DialogContent, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { margin: "dense", id: "name", label: t('Category Name'), type: "text", fullWidth: true, variant: "outlined", defaultValue: newCategoryName, helperText: validCategoryName, error: validCategoryName !== '', onChange: validateCategoryName }) }), (0, jsx_runtime_1.jsxs)(material_1.DialogActions, { children: [(0, jsx_runtime_1.jsx)(material_1.Button, __assign({ onClick: handleClose, color: "secondary", variant: "contained" }, { children: t('Cancel') })), (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ onClick: handleAdd, color: "primary", variant: "contained" }, { children: t('Add Category') }))] })] }))] }));
};
exports.LoFSetup = LoFSetup;


/***/ }),

/***/ "./components/LoFSetup/NoLoFCategories.tsx":
/*!*************************************************!*\
  !*** ./components/LoFSetup/NoLoFCategories.tsx ***!
  \*************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoLoFCategories = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var Scales_1 = __importDefault(__webpack_require__(/*! @Components/Utils/icons/Scales */ "./components/Utils/icons/Scales.tsx"));
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var NoLoFCategories = function (_a) {
    var handleAddCategoryClicked = _a.handleAddCategoryClicked;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: { paddingTop: '40px' } }, { children: (0, jsx_runtime_1.jsx)(Scales_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6" }, { children: t('No LoF Categories') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption", style: { textAlign: 'center' } }, { children: t('You have no LoF categories created.') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: {
                    paddingTop: '20px',
                    paddingBottom: '20px',
                } }, { children: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ variant: "contained", color: "primary", onClick: handleAddCategoryClicked }, { children: t('Add Category') })) }))] })));
};
exports.NoLoFCategories = NoLoFCategories;


/***/ }),

/***/ "./components/LoFSetup/RenderedCategories.tsx":
/*!****************************************************!*\
  !*** ./components/LoFSetup/RenderedCategories.tsx ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RenderedCategories = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __webpack_require__(/*! react */ "react");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var Category_component_1 = __webpack_require__(/*! @Components/Category/Category.component */ "./components/Category/Category.component.tsx");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var RenderedCategories = function (_a) {
    var categories = _a.categories, totalWeight = _a.totalWeight, isLoading = _a.isLoading, onAddComponent = _a.onAddComponent, onEditComponent = _a.onEditComponent, handleAddCategoryClicked = _a.handleAddCategoryClicked;
    var dispatch = (0, react_redux_1.useDispatch)();
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var onCategoryWeightingChanged = function (index) { return function (value) {
        dispatch((0, _Actions_1.setLoFConfig)(categories.map(function (onChangeCat, onChangeIndex) {
            return onChangeIndex === index
                ? __assign(__assign({}, onChangeCat), { weighting: value }) : onChangeCat;
        })));
    }; };
    var addComponentToLoF = function (forInspection) {
        return function (forLoF, targetCat) {
            onAddComponent(true, forInspection, targetCat);
        };
    };
    var editComponentForLoF = function (forInspection) {
        return function (forLoF, targetCat, component) {
            onEditComponent(true, forInspection, targetCat, component);
        };
    };
    if (isLoading) {
        return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, style: { paddingBottom: '12px' } }, { children: (0, jsx_runtime_1.jsx)(Category_component_1.Category, { isLoading: true, forLoF: true, LoFCategoryIndex: 0, isWeightingInvalid: false }) })));
    }
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: categories.map(function (cat, index) { return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, style: { paddingBottom: '12px' } }, { children: (0, jsx_runtime_1.jsx)(Category_component_1.Category, { isLoading: false, forLoF: true, LoFCategoryIndex: index, isWeightingInvalid: totalWeight != 100, onCategoryWeightingChanged: onCategoryWeightingChanged(index), onAddComponent: addComponentToLoF(cat.isCondition), onEditComponent: editComponentForLoF(cat.isCondition) }) })), index === 0 && ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, container: true, justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ style: { margin: '12px 0px' }, variant: "contained", color: "primary", onClick: handleAddCategoryClicked }, { children: t('Add Category') })) })))] }, cat.name)); }) }));
};
exports.RenderedCategories = RenderedCategories;


/***/ }),

/***/ "./components/LoFSetup/index.ts":
/*!**************************************!*\
  !*** ./components/LoFSetup/index.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./LoFSetup.component */ "./components/LoFSetup/LoFSetup.component.tsx"), exports);


/***/ }),

/***/ "./components/NewRisk/NewRisk.component.tsx":
/*!**************************************************!*\
  !*** ./components/NewRisk/NewRisk.component.tsx ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NewRisk = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var Risk_actions_1 = __webpack_require__(/*! @Actions/Risk.actions */ "./actions/Risk.actions.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var react_1 = __webpack_require__(/*! react */ "react");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var riskConfig_types_1 = __webpack_require__(/*! @Types/riskConfig.types */ "./types/riskConfig.types.ts");
var InspectionStandardType_1 = __webpack_require__(/*! @Types/InspectionStandardType */ "./types/InspectionStandardType.ts");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var Selectors_1 = __webpack_require__(/*! @innovyze/lib-am-common/Selectors */ "@innovyze/lib-am-common/Selectors");
var lib_asset_schema_store_1 = __webpack_require__(/*! @innovyze/lib_asset_schema_store */ "@innovyze/lib_asset_schema_store");
var useSystemTypes_1 = __webpack_require__(/*! @Hooks/useSystemTypes */ "./hooks/useSystemTypes.ts");
var useAssetSchemaFF_1 = __webpack_require__(/*! @Hooks/useAssetSchemaFF */ "./hooks/useAssetSchemaFF.ts");
var NewRisk = function (_a) {
    var _b;
    var open = _a.open, onClose = _a.onClose, duplicate = _a.duplicate;
    var isSaveFilterOn = (0, stylovyze_1.useIsFeatureEnabled)('info-360-assets-save-filter');
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var history = (0, react_router_dom_1.useHistory)();
    var riskPage = (0, Selectors_1.selectRiskConfigsPage)();
    var systemTypes = (0, useSystemTypes_1.useSystemTypes)();
    var isValidAssetType = (0, useAssetSchemaFF_1.useAssetSchemaFF)().isValidAssetType;
    var _c = (0, react_1.useState)(''), newName = _c[0], setNewName = _c[1];
    var _d = (0, react_1.useState)(''), systemType = _d[0], setSystemType = _d[1];
    var _e = (0, react_1.useState)(''), assetType = _e[0], setAssetType = _e[1];
    var _f = (0, react_1.useState)(''), assetFilterId = _f[0], setAssetFilterId = _f[1];
    var _g = (0, react_1.useState)(''), inspectionStandard = _g[0], setInspectionStandard = _g[1];
    var _h = (0, react_1.useState)(true), disableStandardTypes = _h[0], setDisableStandardTypes = _h[1];
    var configNameError = (0, Risk_selectors_1.selectRiskConfigNameError)();
    var isCreating = (0, Risk_selectors_1.selectRiskConfigIsCreating)();
    var assetStore = (0, _Selectors_1.selectAssetStore)();
    var assetSchemaByType = (0, react_redux_1.useSelector)(function (state) {
        if (assetType) {
            return (0, lib_asset_schema_store_1.assetSchemaSelectorByType)(state, assetType);
        }
    });
    (0, react_1.useEffect)(function () {
        dispatch((0, lib_asset_schema_store_1.getAllSystemsSchemaAction)());
    }, []);
    (0, react_1.useEffect)(function () {
        if (systemType) {
            dispatch((0, lib_asset_schema_store_1.getAssetSchemaBySystemTypeAction)(systemType));
        }
    }, [systemType]);
    (0, react_1.useEffect)(function () {
        if (assetType) {
            setDisableStandardTypes((assetSchemaByType === null || assetSchemaByType === void 0 ? void 0 : assetSchemaByType.getInspectionTypes().length) === 0);
        }
    }, [assetType]);
    var assetTypes = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return (_a = (0, lib_asset_schema_store_1.assetSchemaSelectorBySystemType)(state, systemType)) === null || _a === void 0 ? void 0 : _a.filter(function (t) {
            return isValidAssetType(t.systemType.id, t.id);
        });
    });
    var handleCancelNewModel = function () {
        onClose();
    };
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        setNewName((duplicate === null || duplicate === void 0 ? void 0 : duplicate.name) ? "Copy of ".concat(duplicate.name) : '');
        dispatch((0, Risk_actions_1.setRiskConfigNameError)((duplicate === null || duplicate === void 0 ? void 0 : duplicate.name) ? '' : t('Name is required')));
        setSystemType((_a = duplicate === null || duplicate === void 0 ? void 0 : duplicate.systemType) !== null && _a !== void 0 ? _a : '');
        setAssetType((_b = duplicate === null || duplicate === void 0 ? void 0 : duplicate.assetType) !== null && _b !== void 0 ? _b : '');
        setAssetFilterId((_c = duplicate === null || duplicate === void 0 ? void 0 : duplicate.assetFilterId) !== null && _c !== void 0 ? _c : '');
        setInspectionStandard((_d = duplicate === null || duplicate === void 0 ? void 0 : duplicate.inspectionStandard) !== null && _d !== void 0 ? _d : '');
        setDisableStandardTypes(true);
    }, [open, duplicate]);
    var inspectionStandardOptions = (0, react_1.useMemo)(function () {
        var _a;
        setInspectionStandard((_a = duplicate === null || duplicate === void 0 ? void 0 : duplicate.inspectionStandard) !== null && _a !== void 0 ? _a : '');
        var inspectionTypes = [];
        if (assetSchemaByType === null || assetSchemaByType === void 0 ? void 0 : assetSchemaByType.hasInspectionType('PACP')) {
            inspectionTypes.push((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: InspectionStandardType_1.InspectionStandardType.PACP }, { children: t('PACP') }), InspectionStandardType_1.InspectionStandardType.PACP));
        }
        if (assetSchemaByType === null || assetSchemaByType === void 0 ? void 0 : assetSchemaByType.hasInspectionType('MACP')) {
            inspectionTypes.push((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: InspectionStandardType_1.InspectionStandardType.MACP }, { children: t('MACP') }), InspectionStandardType_1.InspectionStandardType.MACP));
        }
        // NOT SUPPORTED YET
        // if (schema?.hasInspectionType('MSCC')) {
        // 	inspectionTypes.push(
        // 		<MenuItem
        // 			key={InspectionStandardType.MSCC}
        // 			value={InspectionStandardType.MSCC}>
        // 			{t('MSCC')}
        // 		</MenuItem>,
        // 	);
        // }
        if (assetSchemaByType === null || assetSchemaByType === void 0 ? void 0 : assetSchemaByType.hasInspectionType('WSA05')) {
            inspectionTypes.push((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: InspectionStandardType_1.InspectionStandardType.WSA }, { children: t('WSA05') }), InspectionStandardType_1.InspectionStandardType.WSA));
        }
        return inspectionTypes;
    }, [assetType]);
    var handleCreateNewModel = function () {
        if (configNameError.length == 0) {
            if (duplicate === null || duplicate === void 0 ? void 0 : duplicate.configId)
                dispatch((0, Risk_actions_1.duplicateRiskConfig)({
                    history: history,
                    config: {
                        name: newName.trim(),
                        assetFilterId: assetFilterId || undefined,
                    },
                    configId: duplicate.configId,
                }));
            else
                dispatch((0, Risk_actions_1.createRiskConfig)({
                    history: history,
                    config: {
                        name: newName.trim(),
                        systemType: systemType,
                        assetType: assetType,
                        assetFilterId: assetFilterId || undefined,
                        publishState: riskConfig_types_1.ConfigPublishState.unpublished,
                        inspectionStandard: inspectionStandard ||
                            undefined,
                    },
                    page: riskPage.page,
                }));
        }
    };
    var handlelNameChangeValue = function (event) {
        var error = '';
        if (event.target && event.target.value !== '') {
            setNewName(event.target.value);
            var rexp = new RegExp('^[a-zA-Z0-9 ]+$');
            var test_1 = rexp.test(event.target.value);
            if (!test_1) {
                error = t('Only alphanumeric characters are allowed');
            }
            var rexp2 = new RegExp('^.{1,50}$');
            var test2 = rexp2.test(event.target.value);
            if (!test2) {
                error = t('Name cannot contain more than 50 characters');
            }
        }
        else {
            setNewName('');
            error = t('Name is required');
        }
        dispatch((0, Risk_actions_1.setRiskConfigNameError)(error));
    };
    var handleSystemTypeSelectChange = function (event) {
        setDisableStandardTypes(true);
        var target = event === null || event === void 0 ? void 0 : event.target;
        if (target != undefined) {
            setSystemType(target.value);
            dispatch((0, lib_asset_schema_store_1.getAssetSchemaBySystemTypeAction)(target.value));
        }
        else {
            setSystemType('');
        }
    };
    var handleAssetTypeSelectChange = function (event) {
        var target = event === null || event === void 0 ? void 0 : event.target;
        setAssetType(target.value);
        setAssetFilterId('');
    };
    var handleAssetFilterSelectChange = function (event) {
        var target = event === null || event === void 0 ? void 0 : event.target;
        setAssetFilterId(target.value);
    };
    var handleInspectionStandardSelectChange = function (event) {
        var target = event === null || event === void 0 ? void 0 : event.target;
        setInspectionStandard(target.value);
    };
    // This stops the dialog closing when clicked on the background
    var onCloseDialog = function () { return void {}; };
    var dialogProps = {
        open: open,
        maxWidth: 'md',
        onClose: onCloseDialog,
    };
    var isCreateButtonDisabled = function () {
        return isCreating ||
            configNameError.length !== 0 ||
            systemType.length === 0 ||
            assetType.length === 0 ||
            (inspectionStandardOptions.length !== 0 &&
                inspectionStandard.length === 0);
    };
    var adpAttrs = (0, stylovyze_1.decoratedAttributes)({
        name: newName,
        systemtype: systemType,
        inspectionstandard: inspectionStandard,
        assettype: assetType,
    });
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeDialog, __assign({ dialogProps: dialogProps, "data-cy": "new-dialog", title: duplicate ? t('Duplicate Risk Model') : t('New Risk Model'), open: open, cancelText: t('Cancel'), cancelButtonProps: {
            disabled: isCreating,
            dataCy: 'create-cancel',
        }, onCancel: handleCancelNewModel, confirmText: duplicate ? t('Duplicate') : t('Create Risk Model'), confirmButtonProps: __assign(__assign({ disabled: isCreateButtonDisabled(), dataCy: 'create-confirm', 'adp-click': 'true' }, adpAttrs), { 'adp-component-id': 'create-risk-model-confirm', 'adp-component-name': 'Create Risk Model' }), onConfirm: handleCreateNewModel }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ style: { width: '400px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "dense", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, error: configNameError.length !== 0, name: "name", label: t('Enter Name'), variant: "outlined", value: newName, onChange: handlelNameChangeValue, helperText: configNameError.length !== 0 ? configNameError : ' ' }) })), (0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "dense", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ error: systemType.length === 0 }, { children: t('System Type') })), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ name: "systemType", value: systemType, error: systemType.length === 0, disabled: !!duplicate, onChange: handleSystemTypeSelectChange, label: t('System Type') }, { children: systemTypes.map(function (system) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: system.id }, { children: t(system.displayName) }), system.id)); }) })), (0, jsx_runtime_1.jsx)(material_1.FormHelperText, __assign({ error: true }, { children: systemType.length === 0
                                ? t('Select a System Type')
                                : ' ' }))] })), (0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "dense", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ error: systemType.length !== 0 && assetType.length === 0 }, { children: t('Asset Type') })), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ disabled: !!duplicate || systemType.length === 0, "data-cy": "assetTypeField", name: "assetType", value: assetType, error: systemType.length !== 0 && assetType.length === 0, onChange: handleAssetTypeSelectChange, label: t('Asset Type') }, { children: (assetTypes !== null && assetTypes !== void 0 ? assetTypes : []).map(function (assetType) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: assetType.id }, { children: t(assetType.displayName) }), assetType.id)); }) })), (0, jsx_runtime_1.jsx)(material_1.FormHelperText, __assign({ error: true }, { children: systemType.length !== 0 && assetType.length === 0
                                ? t('Select an asset type')
                                : ' ' }))] })), isSaveFilterOn && ((0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "dense", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: t('Asset Filter') }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ name: "assetFilter", onChange: handleAssetFilterSelectChange, value: assetFilterId, label: t('Asset Filter') }, { children: [
                                (0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: '' }, { children: t('(none)') }), ''),
                            ].concat((_b = assetStore.assetFilters) === null || _b === void 0 ? void 0 : _b.filter(function (f) { return f.assetType === assetType; }).map(function (f) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: f._id }, { children: t(f.name) }), f._id)); })) })), (0, jsx_runtime_1.jsx)(material_1.FormHelperText, { children: " " })] }))), (0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ variant: "outlined", margin: "dense", fullWidth: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, __assign({ error: !disableStandardTypes &&
                                inspectionStandard.length === 0 }, { children: t('Inspection Standard') })), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ disabled: !!duplicate ||
                                disableStandardTypes ||
                                assetType.length === 0, name: "inspectionStandard", value: inspectionStandard, error: !disableStandardTypes &&
                                inspectionStandard.length === 0, onChange: handleInspectionStandardSelectChange, label: t('Inspection Standard') }, { children: inspectionStandardOptions })), (0, jsx_runtime_1.jsx)(material_1.FormHelperText, __assign({ error: true }, { children: !disableStandardTypes &&
                                inspectionStandard.length === 0
                                ? t('Select an Inspection Standard')
                                : ' ' }))] }))] })) })));
};
exports.NewRisk = NewRisk;


/***/ }),

/***/ "./components/NewRisk/index.ts":
/*!*************************************!*\
  !*** ./components/NewRisk/index.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./NewRisk.component */ "./components/NewRisk/NewRisk.component.tsx"), exports);


/***/ }),

/***/ "./components/PercentSlider/PercentSlider.tsx":
/*!****************************************************!*\
  !*** ./components/PercentSlider/PercentSlider.tsx ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.PercentSlider = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var PercentSlider = function (_a) {
    var _b = _a.invalid, invalid = _b === void 0 ? false : _b, dataCy = _a.dataCy, onSliderChanged = _a.onSliderChanged, disabled = _a.disabled, marks = _a.marks, value = _a.value, valueLabelDisplay = _a.valueLabelDisplay, padLeft = _a.padLeft;
    // This needs to be done this way otherwise, for some reason, the slider stops sliding !
    var CustomSlider = (0, material_1.createTheme)({
        components: {
            MuiSlider: {
                styleOverrides: {
                    root: {
                        color: stylovyze_1.palette.primary.main,
                        height: 4,
                    },
                    thumb: {
                        height: 24,
                        width: 24,
                        backgroundColor: stylovyze_1.palette.primary.main,
                        color: stylovyze_1.palette.primary.main,
                        border: '2px solid currentColor',
                        '&:focus, &:hover, &$active': {
                            boxShadow: 'inherit',
                        },
                    },
                    markLabel: {},
                    marked: {
                        marginBottom: '0px',
                        marginTop: '7px',
                    },
                    active: {},
                    valueLabel: {
                        top: '23px',
                        backgroundColor: 'transparent',
                        fontSize: '11px',
                    },
                    track: {
                        marginTop: -1,
                        height: 4,
                        borderRadius: 4,
                    },
                    rail: {
                        height: 2,
                        borderRadius: 4,
                    },
                },
            },
        },
    });
    var InvalidSlider = (0, material_1.createTheme)({
        components: {
            MuiSlider: {
                styleOverrides: {
                    root: {
                        color: stylovyze_1.palette.error.dark,
                        height: 4,
                    },
                    thumb: {
                        height: 24,
                        width: 24,
                        backgroundColor: stylovyze_1.palette.error.dark,
                        color: stylovyze_1.palette.error.dark,
                        border: '2px solid currentColor',
                        '&:focus, &:hover, &$active': {
                            boxShadow: 'inherit',
                        },
                    },
                    markLabel: {},
                    marked: {
                        marginBottom: '0px',
                        marginTop: '7px',
                    },
                    active: {},
                    valueLabel: {
                        backgroundColor: 'transparent',
                        top: '23px',
                        fontSize: '11px',
                    },
                    track: {
                        marginTop: -1,
                        height: 4,
                        borderRadius: 4,
                    },
                    rail: {
                        height: 1,
                        borderRadius: 4,
                    },
                },
            },
        },
    });
    var DisabledSlider = (0, material_1.createTheme)({
        components: {
            MuiSlider: {
                styleOverrides: {
                    root: {
                        color: '#bdbdbd',
                        height: 4,
                    },
                    thumb: {
                        height: 24,
                        width: 24,
                        backgroundColor: '#bdbdbd',
                        color: '#bdbdbd',
                        border: '2px solid currentColor',
                        '&:focus, &:hover, &$active': {
                            boxShadow: 'inherit',
                        },
                    },
                    markLabel: {},
                    marked: {
                        marginBottom: '0px',
                        marginTop: '7px',
                    },
                    active: {},
                    valueLabel: {
                        backgroundColor: 'transparent',
                        top: '23px',
                        fontSize: '11px',
                    },
                    track: {
                        marginTop: -1,
                        height: 4,
                        borderRadius: 4,
                    },
                    rail: {
                        height: 2,
                        borderRadius: 4,
                    },
                },
            },
        },
    });
    var getMarks = function (marks) {
        switch (marks) {
            case 'off': {
                return;
            }
            case 'minmax': {
                return [
                    {
                        value: 0,
                        label: '0%',
                    },
                    {
                        value: 100,
                        label: '100%',
                    },
                ];
            }
            case 'minmaxticks': {
                return [
                    {
                        value: 0,
                        label: '0%',
                    },
                    {
                        value: 25,
                    },
                    {
                        value: 50,
                    },
                    {
                        value: 75,
                    },
                    {
                        value: 100,
                        label: '100%',
                    },
                ];
            }
            case '25': {
                return [
                    {
                        value: 0,
                        label: '0%',
                    },
                    {
                        value: 25,
                        label: '25%',
                    },
                    {
                        value: 50,
                        label: '50%',
                    },
                    {
                        value: 75,
                        label: '75%',
                    },
                    {
                        value: 100,
                        label: '100%',
                    },
                ];
            }
            case '50': {
                return [
                    {
                        value: 0,
                        label: '0%',
                    },
                    {
                        value: 50,
                        label: '50%',
                    },
                    {
                        value: 100,
                        label: '100%',
                    },
                ];
            }
        }
    };
    var handleSliderChange = function (_event, newValue) {
        if (typeof newValue === 'number') {
            onSliderChanged === null || onSliderChanged === void 0 ? void 0 : onSliderChanged(newValue);
        }
    };
    var handleSliderChangeCommitted = function (_event, newValue) {
        if (typeof newValue === 'number') {
            value = newValue;
            onSliderChanged === null || onSliderChanged === void 0 ? void 0 : onSliderChanged(newValue);
        }
    };
    var handleBlur = function () {
        if (value < 0) {
            onSliderChanged === null || onSliderChanged === void 0 ? void 0 : onSliderChanged(0);
        }
        else if (value > 100) {
            onSliderChanged === null || onSliderChanged === void 0 ? void 0 : onSliderChanged(100);
        }
    };
    var getTheme = function () {
        if (disabled)
            return DisabledSlider;
        else if (invalid)
            return InvalidSlider;
        else
            return CustomSlider;
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, alignItems: "center", alignContent: "center", wrap: "nowrap" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 11, style: {
                    paddingLeft: padLeft ? padLeft : 0,
                    paddingRight: '30px',
                } }, { children: (0, jsx_runtime_1.jsx)(material_1.ThemeProvider, __assign({ theme: getTheme() }, { children: (0, jsx_runtime_1.jsx)(material_1.Slider, { "data-cy": dataCy, valueLabelDisplay: valueLabelDisplay, value: value, disabled: disabled, onChange: handleSliderChange, onChangeCommitted: handleSliderChangeCommitted, min: 0, max: 100, marks: getMarks(marks), step: 1 }) })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 1, style: { minWidth: '85px' } }, { children: (0, jsx_runtime_1.jsx)(material_1.Input, { style: { width: '85px' }, value: value, disabled: disabled, margin: "dense", onChange: function (e) {
                        onSliderChanged === null || onSliderChanged === void 0 ? void 0 : onSliderChanged(e.target.value === '' ? 0 : Number(e.target.value));
                    }, onBlur: handleBlur, inputProps: {
                        step: 1,
                        min: 0,
                        max: 100,
                        type: 'number',
                        'aria-labelledby': 'input-slider',
                    }, endAdornment: '%' }) }))] })));
};
exports.PercentSlider = PercentSlider;


/***/ }),

/***/ "./components/PercentSlider/index.ts":
/*!*******************************************!*\
  !*** ./components/PercentSlider/index.ts ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./PercentSlider */ "./components/PercentSlider/PercentSlider.tsx"), exports);


/***/ }),

/***/ "./components/RenameRisk/RenameRisk.component.tsx":
/*!********************************************************!*\
  !*** ./components/RenameRisk/RenameRisk.component.tsx ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RenameRisk = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var Risk_actions_1 = __webpack_require__(/*! @Actions/Risk.actions */ "./actions/Risk.actions.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var react_1 = __webpack_require__(/*! react */ "react");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var RenameRisk = function (_a) {
    var open = _a.open, onClose = _a.onClose;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var settings = (0, Risk_selectors_1.selectRiskSetting)();
    var riskConfig = (0, Risk_selectors_1.selectRiskConfig)();
    var _b = (0, react_1.useState)(''), newName = _b[0], setNewName = _b[1];
    var configNameError = (0, Risk_selectors_1.selectRiskConfigNameError)();
    var isSaving = (0, Risk_selectors_1.selectRiskIsSaving)();
    var handleCancelNewModel = function () {
        onClose(false);
    };
    (0, react_1.useEffect)(function () {
        dispatch((0, Risk_actions_1.setRiskConfigNameError)(''));
        setNewName(settings.name);
    }, [settings, open]);
    (0, react_1.useEffect)(function () {
        if (open && !isSaving && configNameError.length == 0) {
            onClose(true);
        }
    }, [isSaving]);
    var handleRenameModel = function () {
        if (configNameError.length == 0) {
            dispatch((0, Risk_actions_1.setRiskConfigIsCreating)(false));
            var newSettings = __assign({}, settings);
            newSettings.name = newName.trim();
            var newRiskConfig = __assign(__assign({}, riskConfig), { riskSetting: newSettings });
            dispatch((0, Risk_actions_1.renameRiskConfigAction)(newRiskConfig));
        }
    };
    var handlelNameChangeValue = function (event) {
        var error = '';
        if (event.target && event.target.value !== '') {
            setNewName(event.target.value);
            var rexp = new RegExp('^[a-zA-Z0-9 ]+$');
            var test_1 = rexp.test(event.target.value);
            if (!test_1) {
                error = t('Only alphanumeric characters are allowed');
            }
            var rexp2 = new RegExp('^.{1,50}$');
            var test2 = rexp2.test(event.target.value);
            if (!test2) {
                error = t('Name cannot contain more than 50 characters');
            }
        }
        else {
            setNewName('');
            error = t('Name is required');
        }
        dispatch((0, Risk_actions_1.setRiskConfigNameError)(error));
    };
    // This stops the dialog closing when clicked on the background
    var onCloseDialog = function () { return void {}; };
    var dialogProps = {
        open: open,
        fullWidth: true,
        maxWidth: 'sm',
        onClose: onCloseDialog,
    };
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeDialog, __assign({ dialogProps: dialogProps, "data-cy": "new-dialog", title: t('Rename Risk Model'), open: open, cancelText: t('Cancel'), cancelButtonProps: {
            disabled: isSaving,
            dataCy: 'rename-cancel',
        }, onCancel: handleCancelNewModel, confirmText: t('OK'), confirmButtonProps: {
            disabled: isSaving ||
                configNameError.length !== 0 ||
                settings.name.trim().toLowerCase() ===
                    newName.trim().toLowerCase(),
            dataCy: 'rename-confirm',
        }, onConfirm: handleRenameModel }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(material_1.FormControl, __assign({ variant: "outlined", margin: "normal", fullWidth: true }, { children: (0, jsx_runtime_1.jsx)(material_1.TextField, { fullWidth: true, defaultValue: settings.name, error: configNameError.length !== 0, required: true, name: "name", label: t('Edit Name'), variant: "outlined", onChange: handlelNameChangeValue, helperText: configNameError }) })) })) })) })));
};
exports.RenameRisk = RenameRisk;


/***/ }),

/***/ "./components/RenameRisk/index.ts":
/*!****************************************!*\
  !*** ./components/RenameRisk/index.ts ***!
  \****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./RenameRisk.component */ "./components/RenameRisk/RenameRisk.component.tsx"), exports);


/***/ }),

/***/ "./components/RiskCalcStatus/RiskCalcStatus.ts":
/*!*****************************************************!*\
  !*** ./components/RiskCalcStatus/RiskCalcStatus.ts ***!
  \*****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var Risk_services_1 = __importDefault(__webpack_require__(/*! @Services/Risk/Risk.services */ "./services/Risk/Risk.services.ts"));
var RiskCalcStatus = /** @class */ (function () {
    function RiskCalcStatus() {
    }
    var _a;
    _a = RiskCalcStatus;
    RiskCalcStatus.CalcStatusPollingInterval = 5 * 1000;
    RiskCalcStatus.cancelPollForCalcStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(_a, function (_b) {
            if (RiskCalcStatus.timerId) {
                __webpack_require__.g.clearTimeout(RiskCalcStatus.timerId);
                RiskCalcStatus.timerId = undefined;
            }
            return [2 /*return*/];
        });
    }); };
    RiskCalcStatus.pollForCalcStatus = function (token, configId, update, start, previousStatus) { return __awaiter(void 0, void 0, void 0, function () {
        var oldTimerId, calcStatusService, statusResponse, carryOn, e_1;
        return __generator(_a, function (_b) {
            switch (_b.label) {
                case 0:
                    oldTimerId = RiskCalcStatus.timerId;
                    if (oldTimerId)
                        clearTimeout(oldTimerId);
                    if (!start) {
                        start = new Date().getTime();
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    calcStatusService = new Risk_services_1.default(token, configId);
                    return [4 /*yield*/, calcStatusService.getProcessStatus()];
                case 2:
                    statusResponse = _b.sent();
                    carryOn = update(statusResponse.calcStatus, previousStatus);
                    // Check another timer has not been started while we are waiting.
                    if (carryOn &&
                        (!oldTimerId || oldTimerId === RiskCalcStatus.timerId)) {
                        RiskCalcStatus.timerId = __webpack_require__.g.setTimeout(RiskCalcStatus.pollForCalcStatus, RiskCalcStatus.CalcStatusPollingInterval, token, configId, update, start, statusResponse.calcStatus);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _b.sent();
                    update('error');
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return RiskCalcStatus;
}());
exports["default"] = RiskCalcStatus;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/NoResultsRiskDatagrid.component.tsx":
/*!*****************************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/NoResultsRiskDatagrid.component.tsx ***!
  \*****************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoReasultsRisk = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
// eslint-disable-next-line @typescript-eslint/naming-convention
var NoReasultsRisk = function (_a) {
    var adminFullAccess = _a.adminFullAccess, configId = _a.configId;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var history = (0, react_router_dom_1.useHistory)();
    var lofClicked = function () {
        history.push('/risk/lofSetup/' + configId);
    };
    var cofClicked = function () {
        history.push('/risk/cofSetup/' + configId);
    };
    var riskClicked = function () {
        history.push('/risk/riskSetup/' + configId);
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: adminFullAccess ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption" }, { children: t('To generate model results, you will first need to configure your risk model and run it.') })) }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ variant: "caption" }, { children: [t('Risk models consist of '), (0, jsx_runtime_1.jsx)(material_1.Link, __assign({ underline: "hover", style: {
                                    cursor: 'pointer',
                                    width: '100%',
                                    whiteSpace: 'nowrap',
                                }, title: t('Likelihood of Failure'), onClick: function () {
                                    lofClicked();
                                }, "data-cy": "lofLink" }, { children: t('Likelihood of Failure') })), ', ', (0, jsx_runtime_1.jsx)(material_1.Link, __assign({ underline: "hover", style: {
                                    cursor: 'pointer',
                                    width: '100%',
                                    whiteSpace: 'nowrap',
                                }, title: t('Consequence of Failure'), onClick: function () {
                                    cofClicked();
                                }, "data-cy": "cofLink" }, { children: t('Consequence of Failure') })), t(', and '), (0, jsx_runtime_1.jsx)(material_1.Link, __assign({ underline: "hover", style: {
                                    cursor: 'pointer',
                                    width: '100%',
                                    whiteSpace: 'nowrap',
                                }, title: t('Risk Setup'), onClick: function () {
                                    riskClicked();
                                }, "data-cy": "riskLink" }, { children: t('Risk Setup') })), t(' configuration')] })) }), (0, jsx_runtime_1.jsx)("p", { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption" }, { children: t('You can create these in any order.') })) })] })) : ([]) }));
};
exports.NoReasultsRisk = NoReasultsRisk;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/RenderCell/AssetIdCell.tsx":
/*!********************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/RenderCell/AssetIdCell.tsx ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.AssetIdCell = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var AssetIdCell = function (_a) {
    var assetId = _a.assetId;
    var history = (0, react_router_dom_1.useHistory)();
    return ((0, jsx_runtime_1.jsx)(material_1.Link, __assign({ underline: "hover", style: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            cursor: 'pointer',
        }, title: assetId, onClick: function () {
            history.push((0, actions_1.addRouteNamespace)("riskAssetDetails/".concat(assetId)));
        } }, { children: assetId })));
};
exports.AssetIdCell = AssetIdCell;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/RenderCell/ConditionCell.tsx":
/*!**********************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/RenderCell/ConditionCell.tsx ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ConditionCell = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var icons_material_1 = __webpack_require__(/*! @mui/icons-material */ "@mui/icons-material");
var ConditionCell = function (_a) {
    var condition = _a.condition;
    if (condition === '1' || condition === 'true') {
        return ((0, jsx_runtime_1.jsx)(icons_material_1.CheckCircle, { style: {
                color: stylovyze_1.riskGradePalette.low.dark,
                verticalAlign: 'middle',
            } }));
    }
    else {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
};
exports.ConditionCell = ConditionCell;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/RenderCell/MenuCell.tsx":
/*!*****************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/RenderCell/MenuCell.tsx ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MenuCell = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var Actions_1 = __webpack_require__(/*! @innovyze/lib-am-common/Actions */ "@innovyze/lib-am-common/Actions");
var Utils_1 = __webpack_require__(/*! @innovyze/lib-am-common/Utils */ "@innovyze/lib-am-common/Utils");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var icons_material_1 = __webpack_require__(/*! @mui/icons-material */ "@mui/icons-material");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var useRiskDetailsSelectors_1 = __webpack_require__(/*! ../useRiskDetailsSelectors */ "./components/RiskDetails/Datagrid/useRiskDetailsSelectors.tsx");
var react_1 = __webpack_require__(/*! react */ "react");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var MenuCell = function (_a) {
    var assetId = _a.assetId, assetType = _a.assetType;
    var t = (0, stylovyze_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var history = (0, react_router_dom_1.useHistory)();
    var _b = (0, useRiskDetailsSelectors_1.useRiskDetailsSelectors)(), setFindAsset = _b.setFindAsset, findAsset = _b.findAsset, assetLocation = _b.assetLocation;
    (0, react_1.useEffect)(function () {
        if (findAsset &&
            assetLocation &&
            assetLocation.assetId === findAsset.assetId) {
            var url = (0, Utils_1.makeMapURL)(findAsset.assetType, findAsset.assetId, assetLocation.position);
            if (url)
                history.push(url);
            setFindAsset(undefined);
        }
    }, [assetLocation, findAsset]);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ role: "menu", tabIndex: 0 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.MenuListButton, { menuItems: [
                {
                    text: t('Find Asset in Network'),
                    icon: (0, jsx_runtime_1.jsx)(icons_material_1.Map, {}),
                    onClick: function () {
                        var mapAsset = {
                            assetId: assetId,
                            assetType: assetType,
                        };
                        setFindAsset(mapAsset);
                        dispatch((0, Actions_1.getAssetLocation)(mapAsset));
                    },
                },
            ], buttonCy: "actions" }) }), 'findAsset'));
};
exports.MenuCell = MenuCell;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/RenderCell/StatusCell.tsx":
/*!*******************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/RenderCell/StatusCell.tsx ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StatusCell = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var StatusCell = function (_a) {
    var status = _a.status;
    var t = (0, stylovyze_1.useGlobalization)().t;
    var value = parseInt(status);
    switch (value) {
        case 0:
            return ((0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Negligible'), color: "negligible", width: (0, stylovyze_1.rem)(92) }));
        case 1:
            return (0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Low'), color: "low", width: (0, stylovyze_1.rem)(92) });
        case 2:
            return ((0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Medium'), color: "medium", width: (0, stylovyze_1.rem)(92) }));
        case 3:
            return (0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('High'), color: "high", width: (0, stylovyze_1.rem)(92) });
        case 4:
            return ((0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Extreme'), color: "extreme", width: (0, stylovyze_1.rem)(92) }));
        default:
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
};
exports.StatusCell = StatusCell;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/RenderCell/TrendCell.tsx":
/*!******************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/RenderCell/TrendCell.tsx ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TrendCell = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var TrendCell = function (_a) {
    var trend = _a.trend;
    var value = parseFloat(trend);
    if (isNaN(value)) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: trend });
    }
    else if (parseFloat(trend) < 0) {
        return (0, jsx_runtime_1.jsx)("b", __assign({ style: { color: 'green' } }, { children: trend }));
    }
    else if (parseFloat(trend) > 0) {
        return (0, jsx_runtime_1.jsxs)("b", __assign({ style: { color: 'red' } }, { children: ["+", trend] }));
    }
    else {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: trend });
    }
};
exports.TrendCell = TrendCell;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/RiskDetailsDatagrid.component.tsx":
/*!***************************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/RiskDetailsDatagrid.component.tsx ***!
  \***************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskDetails = exports.constructValidFilterModel = exports.isValidFilterItem = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var Scales_1 = __importDefault(__webpack_require__(/*! @Components/Utils/icons/Scales */ "./components/Utils/icons/Scales.tsx"));
var NoResultsRiskDatagrid_component_1 = __webpack_require__(/*! ./NoResultsRiskDatagrid.component */ "./components/RiskDetails/Datagrid/NoResultsRiskDatagrid.component.tsx");
var TableToolbar_component_1 = __webpack_require__(/*! ./TableToolbar.component */ "./components/RiskDetails/Datagrid/TableToolbar.component.tsx");
var useRiskDetailsSelectors_1 = __webpack_require__(/*! ./useRiskDetailsSelectors */ "./components/RiskDetails/Datagrid/useRiskDetailsSelectors.tsx");
var TableColumns_1 = __webpack_require__(/*! ./TableColumns */ "./components/RiskDetails/Datagrid/TableColumns.tsx");
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var useRiskDetailsStates_1 = __webpack_require__(/*! ./useRiskDetailsStates */ "./components/RiskDetails/Datagrid/useRiskDetailsStates.tsx");
var useRiskDetailsRows_1 = __importDefault(__webpack_require__(/*! ./useRiskDetailsRows */ "./components/RiskDetails/Datagrid/useRiskDetailsRows.ts"));
var useRiskDetailsColumnOrder_1 = __importDefault(__webpack_require__(/*! ./useRiskDetailsColumnOrder */ "./components/RiskDetails/Datagrid/useRiskDetailsColumnOrder.ts"));
var useGetRiskDetailsColumnVisibility_1 = __importDefault(__webpack_require__(/*! ./useGetRiskDetailsColumnVisibility */ "./components/RiskDetails/Datagrid/useGetRiskDetailsColumnVisibility.ts"));
var validFilterValues = {
    CONDITION_DATA: ['0', '1'],
    GRADE: ['0', '1', '2', '3', '4'],
};
function isValidFilterItem(item) {
    return validFilterValues[item.field].includes(item.value) && item.value;
}
exports.isValidFilterItem = isValidFilterItem;
function constructValidFilterModel(model) {
    var modelCopy = __assign({}, model);
    modelCopy.items.map(function (item) {
        return __assign(__assign({}, item), { value: isValidFilterItem(item) ? item.value : '' });
    });
    return modelCopy;
}
exports.constructValidFilterModel = constructValidFilterModel;
var RiskDetails = function (_a) {
    var configId = _a.configId, refreshRiskScore = _a.refreshRiskScore;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = (0, useRiskDetailsSelectors_1.useRiskDetailsSelectors)(), tablePage = _b.tablePage, hasFullAccess = _b.hasFullAccess, isLoading = _b.isLoading, isWaiting = _b.isWaiting, riskConfig = _b.riskConfig, canReload = _b.canReload, runCompleteReload = _b.runCompleteReload, riskDetailsPagination = _b.riskDetailsPagination, isWaitingAssetLocation = _b.isWaitingAssetLocation, isRiskStoreLoading = _b.isRiskStoreLoading, isSearching = _b.isSearching;
    var apiRef = (0, stylovyze_1.useGridApiRef)();
    var _c = (0, useRiskDetailsStates_1.useRiskDetailsStates)(), setAssetHighlight = _c.setAssetHighlight, selectionModel = _c.selectionModel, setSelectionModel = _c.setSelectionModel, sortModel = _c.sortModel, setSortModel = _c.setSortModel, filterModel = _c.filterModel, setFilterModel = _c.setFilterModel, paginationModel = _c.paginationModel, setPaginationModel = _c.setPaginationModel;
    var selectedAssets = (0, react_redux_1.useSelector)(function (state) {
        return (0, Risk_selectors_1.selectSelectedRiskRows)(state, selectionModel);
    });
    (0, react_1.useEffect)(function () {
        dispatch((0, _Actions_1.setTab)('details'));
    }, []);
    (0, react_1.useEffect)(function () {
        if (canReload && runCompleteReload) {
            refreshRiskScore();
            (0, _Actions_1.setRunCompleteReload)(false);
        }
    }, [runCompleteReload]);
    (0, react_1.useEffect)(function () {
        setAssetHighlight === null || setAssetHighlight === void 0 ? void 0 : setAssetHighlight(selectedAssets);
    }, [selectedAssets]);
    var rows = (0, useRiskDetailsRows_1.default)();
    var _d = (0, useRiskDetailsColumnOrder_1.default)(), columnOrder = _d.columnOrder, setColumnOrder = _d.setColumnOrder;
    var dispatchSortFn = function (name, desc) {
        var sortPayload = {
            key: name,
            descending: desc,
        };
        setPaginationModel(function (pm) { return (__assign(__assign({}, pm), { page: 0 })); });
        dispatch((0, _Actions_1.changeSort)(sortPayload));
    };
    var columns = (0, TableColumns_1.useRiskDetailsColumns)(riskConfig);
    var _e = (0, useGetRiskDetailsColumnVisibility_1.default)(configId), columnVisibilityModel = _e.columnVisibilityModel, setColumnVisibilityModel = _e.setColumnVisibilityModel;
    var filterRef = (0, react_1.useMemo)(function () { return react_1.default.createRef(); }, []);
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.DataGrid, { apiRef: apiRef, rows: rows, onColumnOrderChange: function (co) {
            var field = co.column.field;
            var targetIndex = co.targetIndex;
            setColumnOrder(function (prev) {
                var newOrder = __spreadArray([], prev, true);
                newOrder.splice(prev.indexOf(field), 1);
                newOrder.splice(targetIndex, 0, field);
                return newOrder;
            });
        }, columns: columnOrder
            .map(function (field) { return columns.find(function (c) { return c.field === field; }); })
            .filter(function (c) { return c; }), "data-cy": "risk-details-table", pinnedColumns: { left: ['ASSET_ID'], right: ['GRADE', 'Menu'] }, className: isWaiting || isWaitingAssetLocation ? 'wait' : 'ScrollTable', emptyState: {
            title: 'No results to show',
            subtitle: ((0, jsx_runtime_1.jsx)(NoResultsRiskDatagrid_component_1.NoReasultsRisk, { adminFullAccess: hasFullAccess, configId: configId })),
            icon: (0, jsx_runtime_1.jsx)(Scales_1.default, {}),
            color: '#4A6067',
        }, loading: isLoading || isWaiting || isRiskStoreLoading || isSearching, skeletonRowCount: 10, pageSizeOptions: [5, 10, 15, 25, 50, 100], paginationMode: "server", paginationModel: paginationModel, onPaginationModelChange: function (_paginationModel) {
            if (paginationModel.pageSize != _paginationModel.pageSize) {
                _paginationModel.page = 0;
            }
            setPaginationModel(_paginationModel);
            dispatch((0, _Actions_1.changePagination)({
                page: _paginationModel.page + 1,
                slice: _paginationModel.pageSize,
            }));
        }, columnVisibilityModel: columnVisibilityModel, onColumnVisibilityModelChange: setColumnVisibilityModel, footerHelper: isLoading
            ? ''
            : t('{{from}}-{{to}} of {{total}}', {
                from: (riskDetailsPagination.page - 1) *
                    riskDetailsPagination.slice +
                    1,
                to: riskDetailsPagination.page ==
                    riskDetailsPagination.pages
                    ? riskDetailsPagination.total
                    : riskDetailsPagination.page *
                        riskDetailsPagination.slice,
                total: riskDetailsPagination.total,
            }), slots: {
            toolbar: TableToolbar_component_1.TableToolbar,
        }, slotProps: {
            panel: {
            // anchorEl: filterRef.current, // Bug 155409: MUI data grids filter anchoring
            },
            toolbar: {
                disable: isLoading || isWaiting || isWaitingAssetLocation,
                hasFullAccess: hasFullAccess,
                showFilterPanel: apiRef.current.showFilterPanel,
                refreshRiskScore: refreshRiskScore,
                filterRef: filterRef,
                lastRunCompleted: riskConfig.riskSetting.lastRunCompleted,
            },
            filterPanel: {
                logicOperators: [stylovyze_1.GridLogicOperator.And],
            },
        }, rowCount: tablePage.total, pagination: true, onRowSelectionModelChange: setSelectionModel, disableMultipleColumnsSorting: true, onSortModelChange: function (sm) {
            if (!sm.length) {
                if (!sortModel.length) {
                    return sm.push({ field: 'CURRENT_RISK', sort: 'desc' });
                }
                else {
                    var sortedField = sortModel === null || sortModel === void 0 ? void 0 : sortModel[0];
                    sortedField.sort =
                        sortedField.sort === 'asc' ? 'desc' : 'asc';
                    sm.push(sortModel[0]);
                }
            }
            sm.forEach(function (sort) {
                var key = sort === null || sort === void 0 ? void 0 : sort.field;
                var descending = (sort === null || sort === void 0 ? void 0 : sort.sort) !== 'asc';
                dispatchSortFn(key, descending);
            });
            if (!sm.length)
                dispatchSortFn('CURRENT_RISK', true);
            setSortModel(sm);
        }, sortingMode: "server", sortingOrder: ['desc', 'asc'], sortModel: sortModel, filterToolbar: true, filterModel: filterModel, filterMode: "server", onFilterModelChange: function (model) {
            var tmpModel = constructValidFilterModel(model);
            setFilterModel(tmpModel);
            var filterValueModel = tmpModel.items
                .map(function (item) { return ({
                colKey: item.field,
                value: item.value,
            }); })
                .filter(function (item) { return item.value && item.colKey; });
            dispatch((0, _Actions_1.changeFiltersSelect)(filterValueModel));
        } }));
};
exports.RiskDetails = RiskDetails;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/TableColumns.tsx":
/*!**********************************************************!*\
  !*** ./components/RiskDetails/Datagrid/TableColumns.tsx ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useRiskDetailsColumns = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var AssetIdCell_1 = __webpack_require__(/*! ./RenderCell/AssetIdCell */ "./components/RiskDetails/Datagrid/RenderCell/AssetIdCell.tsx");
var ConditionCell_1 = __webpack_require__(/*! ./RenderCell/ConditionCell */ "./components/RiskDetails/Datagrid/RenderCell/ConditionCell.tsx");
var MenuCell_1 = __webpack_require__(/*! ./RenderCell/MenuCell */ "./components/RiskDetails/Datagrid/RenderCell/MenuCell.tsx");
var StatusCell_1 = __webpack_require__(/*! ./RenderCell/StatusCell */ "./components/RiskDetails/Datagrid/RenderCell/StatusCell.tsx");
var TrendCell_1 = __webpack_require__(/*! ./RenderCell/TrendCell */ "./components/RiskDetails/Datagrid/RenderCell/TrendCell.tsx");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var useGetWeightedScores_1 = __importDefault(__webpack_require__(/*! ./useGetWeightedScores */ "./components/RiskDetails/Datagrid/useGetWeightedScores.ts"));
var useNoConditionData_1 = __webpack_require__(/*! @Hooks/useNoConditionData */ "./hooks/useNoConditionData.ts");
/* eslint-disable react/display-name */
function useRiskDetailsColumns(riskConfig) {
    var _a, _b;
    var t = (0, stylovyze_1.useGlobalization)().t;
    var weightedScores = (0, useGetWeightedScores_1.default)();
    var isIndividualScoresEnabled = (0, stylovyze_1.useIsFeatureEnabled)('info-360-risk-datagrid-individual-scores');
    var formatTrendValue = function (value) {
        if (value == null)
            return '';
        var numValue = Number(value);
        return isNaN(numValue) ? String(value) || '' : numValue.toFixed(3);
    };
    var columns = [
        {
            field: 'ASSET_ID',
            headerName: t('Asset ID'),
            align: 'left',
            renderCell: function (params) { return ((0, jsx_runtime_1.jsx)(AssetIdCell_1.AssetIdCell, { assetId: params.value })); },
            minWidth: 150,
            flex: 1,
            sortable: true,
            filterable: false,
            hideable: false,
        },
        {
            field: 'RISK_CHANGE',
            align: 'left',
            headerName: t('Risk Trend'),
            renderCell: function (params) {
                return (0, jsx_runtime_1.jsx)(TrendCell_1.TrendCell, { trend: formatTrendValue(params.value) });
            },
            minWidth: 150,
            flex: 1,
            sortable: true,
            filterable: false,
        },
        {
            field: 'CURRENT_RISK',
            align: 'left',
            headerName: t('Risk Score'),
            valueFormatter: function (params) {
                formatTrendValue(params.value);
            },
            minWidth: 150,
            flex: 1,
            sortable: true,
            filterable: false,
        },
        {
            field: 'CURRENT_LOF',
            align: 'left',
            headerName: t('Total LoF'),
            valueFormatter: function (params) {
                formatTrendValue(params.value);
            },
            minWidth: 150,
            flex: 1,
            sortable: true,
            filterable: false,
        },
        {
            field: 'CURRENT_COF',
            align: 'left',
            headerName: t('Total CoF'),
            valueFormatter: function (params) {
                formatTrendValue(params.value);
            },
            minWidth: 150,
            flex: 1,
            sortable: true,
            filterable: false,
        },
    ];
    var noConditionData = (0, useNoConditionData_1.useNoConditionData)(riskConfig.riskSetting.assetType);
    if (!noConditionData) {
        columns.push({
            field: 'CONDITION_DATA',
            align: 'left',
            headerName: t('Condition Data'),
            renderCell: function (params) { return ((0, jsx_runtime_1.jsx)(ConditionCell_1.ConditionCell, { condition: params.value })); },
            minWidth: 150,
            flex: 1,
            sortable: false,
            type: 'singleSelect',
            valueOptions: [
                {
                    label: t('No'),
                    value: '0',
                },
                {
                    label: t('Yes'),
                    value: '1',
                },
            ],
            filterable: !noConditionData,
            filterOperators: (0, stylovyze_1.getGridSingleSelectOperators)().filter(function (operator) {
                return operator.value == 'is';
            }),
        });
    }
    columns.push({
        field: 'GRADE',
        align: 'left',
        headerName: t('Grade'),
        renderCell: function (params) { return ((0, jsx_runtime_1.jsx)(StatusCell_1.StatusCell, { status: params.value })); },
        minWidth: 150,
        width: 150,
        sortable: true,
        filterable: true,
        type: 'singleSelect',
        valueOptions: [
            {
                label: t('Negligible'),
                value: '0',
            },
            {
                label: t('Low'),
                value: '1',
            },
            {
                label: t('Medium'),
                value: '2',
            },
            {
                label: t('High'),
                value: '3',
            },
            {
                label: t('Extreme'),
                value: '4',
            },
        ],
        filterOperators: (0, stylovyze_1.getGridSingleSelectOperators)().filter(function (operator) {
            return (operator.value == 'is' || operator.value == 'isAnyOf');
        }),
    }, {
        field: 'Menu',
        headerName: '',
        sortable: false,
        filterable: false,
        hideable: false,
        disableColumnMenu: true,
        width: 68,
        maxWidth: 68,
        minWidth: 68,
        renderCell: function (params) { return ((0, jsx_runtime_1.jsx)(MenuCell_1.MenuCell, { assetId: params.value, assetType: riskConfig.riskSetting.assetType })); },
    });
    if (isIndividualScoresEnabled) {
        if ((_a = weightedScores === null || weightedScores === void 0 ? void 0 : weightedScores.lofScores) === null || _a === void 0 ? void 0 : _a.length) {
            columns.push.apply(columns, weightedScores.lofScores);
        }
        if ((_b = weightedScores === null || weightedScores === void 0 ? void 0 : weightedScores.cofScores) === null || _b === void 0 ? void 0 : _b.length) {
            columns.push.apply(columns, weightedScores.cofScores);
        }
    }
    return columns;
}
exports.useRiskDetailsColumns = useRiskDetailsColumns;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/TableToolbar.component.tsx":
/*!********************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/TableToolbar.component.tsx ***!
  \********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TableToolbar = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var query_string_1 = __webpack_require__(/*! query-string */ "../node_modules/query-string/index.js");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var Risk_actions_1 = __webpack_require__(/*! @Actions/Risk.actions */ "./actions/Risk.actions.ts");
var Utils_1 = __webpack_require__(/*! @innovyze/lib-am-common/Utils */ "@innovyze/lib-am-common/Utils");
var TableToolbar = function (_a) {
    var _b;
    var disable = _a.disable, hasFullAccess = _a.hasFullAccess, refreshRiskScore = _a.refreshRiskScore, showFilterPanel = _a.showFilterPanel, lastRunCompleted = _a.lastRunCompleted, filterRef = _a.filterRef;
    var t = (0, stylovyze_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    var csvLimit = (_b = (0, stylovyze_1.useIsFeatureEnabled)('info-360-risk-csv-export-limit')) !== null && _b !== void 0 ? _b : '100000';
    var queryString = (0, Risk_selectors_1.selectRiskDetailsQuery)();
    var tablePage = (0, Risk_selectors_1.selectRiskDetailsTablePage)();
    var requestParams = __assign(__assign({}, (0, query_string_1.parse)(queryString.substring(1))), { slice: csvLimit });
    var dispatchSearchFn = function (text) { return dispatch((0, Risk_actions_1.changeSearch)(text)); };
    var lastRunCompletedDiv = function () {
        if (lastRunCompleted && lastRunCompleted.length != 0)
            return ((0, jsx_runtime_1.jsx)("div", __assign({ style: { paddingTop: '6px' } }, { children: t('Results below were created on {{datetime}}', {
                    datetime: (0, Utils_1.formatDateTimeWithFormatDate)(lastRunCompleted, formatDate),
                }) })));
        else
            return [];
    };
    return ((0, jsx_runtime_1.jsxs)(styles_1.StyledGrid, __assign({ alignItems: "center", justifyContent: "space-between", container: true, style: {
            width: '100%',
            marginTop: '1rem',
            marginBottom: '1rem',
        } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, xs: 4 }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeSearchBar, { onChange: function (query) {
                                dispatchSearchFn(query);
                            }, onRequestSearch: function () {
                                dispatch((0, Risk_actions_1.setSearchStart)(true));
                            }, onCancelSearch: function () {
                                dispatchSearchFn('');
                            }, placeholder: t('Search'), value: (0, Risk_selectors_1.selectRiskDetailsSearch)(), dataCy: 'search-01' }), lastRunCompletedDiv()] }) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 8, container: true, alignItems: "center", justifyContent: "flex-end", "data-cy": "grid-actionbutton", wrap: "nowrap" }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.DataGridButton, { type: stylovyze_1.DataGridButtonType.FILTER, onClick: function () { return showFilterPanel(); }, disabled: disable, "data-cy": "filterButton", ref: filterRef }), (0, jsx_runtime_1.jsx)(stylovyze_1.DataGridButton, { type: stylovyze_1.DataGridButtonType.REFRESH, onClick: refreshRiskScore, disabled: disable, "data-cy": "refreshButton" }), hasFullAccess && ((0, jsx_runtime_1.jsx)(stylovyze_1.ExportButtonWithDialogAndText, { total: tablePage.total, requestParams: requestParams, disabled: disable, source: 'risk.export.create', title: t('Export'), maxRows: +csvLimit, dialogDataCy: "export-dialog", iconDataCy: "export-icon", maxPollAttempts: 60, iterationTime: 5000 }))] }))] })));
};
exports.TableToolbar = TableToolbar;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/useGetRiskDetailsColumnVisibility.ts":
/*!******************************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/useGetRiskDetailsColumnVisibility.ts ***!
  \******************************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var react_1 = __webpack_require__(/*! react */ "react");
var useGetWeightedScores_1 = __importDefault(__webpack_require__(/*! ./useGetWeightedScores */ "./components/RiskDetails/Datagrid/useGetWeightedScores.ts"));
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var useRiskDetailsSelectors_1 = __webpack_require__(/*! ./useRiskDetailsSelectors */ "./components/RiskDetails/Datagrid/useRiskDetailsSelectors.tsx");
function useGetRiskDetailsColumnVisibility(configId) {
    var _a;
    var weightedScores = (0, useGetWeightedScores_1.default)();
    var _b = (0, useRiskDetailsSelectors_1.useRiskDetailsSelectors)(), tenantId = _b.tenantId, userId = _b.userId;
    var _c = (0, react_1.useState)(true), cofFirstRender = _c[0], setCofFirstRender = _c[1];
    var isIndividualScoresEnabled = (0, stylovyze_1.useIsFeatureEnabled)('info-360-risk-datagrid-individual-scores');
    var _d = (0, stylovyze_1.useLocalStorage)("".concat(userId, ".").concat(tenantId, ".riskTable.columnVisibilityModel.").concat(configId), undefined), columnVisibilityModel = _d[0], setColumnVisibilityModel = _d[1];
    var weightedCofColumnNames = (_a = weightedScores.cofScores) === null || _a === void 0 ? void 0 : _a.map(function (cof) { return (cof.field.includes('Raw') ? cof.field : null); }).filter(Boolean);
    var weightedLofColumnNames = weightedScores.lofScores
        .map(function (lof) { return lof.field; })
        .filter(Boolean);
    (0, react_1.useEffect)(function () {
        if (isIndividualScoresEnabled &&
            !columnVisibilityModel &&
            cofFirstRender &&
            (weightedCofColumnNames.length > 0 ||
                weightedLofColumnNames.length > 0)) {
            var cof = weightedCofColumnNames
                .filter(function (el) { return el === null || el === void 0 ? void 0 : el.includes('Raw'); })
                .map(function (el) {
                var _a;
                return (_a = {}, _a[el !== null && el !== void 0 ? el : ''] = false, _a);
            });
            var lof = weightedLofColumnNames
                .filter(function (el) { return el === null || el === void 0 ? void 0 : el.includes('Raw'); })
                .map(function (el) {
                var _a;
                return (_a = {}, _a[el.toString()] = false, _a);
            });
            var joined_1 = __spreadArray(__spreadArray([], cof, true), lof, true).reduce(function (acc, val) { return (__assign(__assign({}, acc), val)); }, {});
            setColumnVisibilityModel(function (cvm) { return (__assign(__assign({}, cvm), joined_1)); });
            setCofFirstRender(false);
        }
    }, [weightedScores.cofScores, weightedScores.lofScores]);
    return { columnVisibilityModel: columnVisibilityModel, setColumnVisibilityModel: setColumnVisibilityModel };
}
exports["default"] = useGetRiskDetailsColumnVisibility;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/useGetWeightedScores.ts":
/*!*****************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/useGetWeightedScores.ts ***!
  \*****************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var react_1 = __webpack_require__(/*! react */ "react");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var createComponentScoreGridRow = function (scoreType, categoryName, componentName, scoreTypeFE) { return ({
    field: "".concat(scoreType, "_").concat(categoryName, "_").concat(componentName),
    headerName: "".concat(scoreTypeFE, " ").concat(categoryName, "-").concat(componentName),
    flex: 1,
    minWidth: 150,
    sortable: true,
    filterable: false,
}); };
var createCategoryComponents = function (category, scoreType, scoreTypeFE) {
    var _a, _b;
    return (_b = (_a = category === null || category === void 0 ? void 0 : category.components) === null || _a === void 0 ? void 0 : _a.filter(function (component) { return component.name; })) === null || _b === void 0 ? void 0 : _b.map(function (component) { return [
        createComponentScoreGridRow(scoreType, category.name, component.name, scoreTypeFE),
        createComponentScoreGridRow("".concat(scoreType, "Raw"), category.name, component.name, "".concat(scoreTypeFE, "Raw")),
    ]; }).flat();
};
function useGetWeightedScores() {
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var lofCategories = (0, Risk_selectors_1.useSelectLofCategories)();
    var cofCategories = (0, Risk_selectors_1.useSelectCofCategories)();
    var lofScores = (0, react_1.useMemo)(function () {
        return lofCategories
            .filter(function (category) { return category.components.length > 0; })
            .map(function (category) {
            return createCategoryComponents(category, 'LOF', t('LoF'));
        })
            .flat();
    }, [lofCategories]);
    var cofScores = (0, react_1.useMemo)(function () {
        return cofCategories
            .filter(function (category) { return category.components.length > 0; })
            .map(function (category) {
            return createCategoryComponents(category, 'COF', t('CoF'));
        })
            .flat();
    }, [cofCategories]);
    return { lofScores: lofScores, cofScores: cofScores };
}
exports["default"] = useGetWeightedScores;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/useRiskDetailsColumnOrder.ts":
/*!**********************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/useRiskDetailsColumnOrder.ts ***!
  \**********************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var useGetWeightedScores_1 = __importDefault(__webpack_require__(/*! ./useGetWeightedScores */ "./components/RiskDetails/Datagrid/useGetWeightedScores.ts"));
var react_1 = __webpack_require__(/*! react */ "react");
var useNoConditionData_1 = __webpack_require__(/*! @Hooks/useNoConditionData */ "./hooks/useNoConditionData.ts");
function useRiskDetailsColumnOrder() {
    var _a;
    var riskConfig = (0, Risk_selectors_1.selectRiskConfig)();
    var _b = (0, react_1.useState)(false), cofFilled = _b[0], setCofFilled = _b[1];
    var _c = (0, react_1.useState)(false), lofFilled = _c[0], setLofFilled = _c[1];
    var weightedScores = (0, useGetWeightedScores_1.default)();
    var weightedCofColumnNames = (_a = weightedScores.cofScores) === null || _a === void 0 ? void 0 : _a.map(function (cof) { return cof.field; });
    var weightedLofColumnNames = weightedScores.lofScores.map(function (lof) { return lof.field; });
    var isIndividualScoresEnabled = (0, stylovyze_1.useIsFeatureEnabled)('info-360-risk-datagrid-individual-scores');
    var noConditionData = (0, useNoConditionData_1.useNoConditionData)(riskConfig.riskSetting.assetType);
    var _d = (0, react_1.useState)(__spreadArray(__spreadArray([
        'ASSET_ID',
        'RISK_CHANGE',
        'CURRENT_RISK',
        'CURRENT_COF',
        'CURRENT_LOF'
    ], (!noConditionData ? ['CONDITION_DATA'] : []), true), [
        'GRADE',
        'Menu',
    ], false)), columnOrder = _d[0], setColumnOrder = _d[1];
    (0, react_1.useEffect)(function () {
        setColumnOrder(function (co) {
            if (noConditionData) {
                return co.filter(function (col) { return col != 'CONDITION_DATA'; });
            }
            else {
                if (!co.includes('CONDITION_DATA')) {
                    var lofIndex = co.findIndex(function (col) { return col === 'CURRENT_LOF'; });
                    if (lofIndex !== -1) {
                        var newOrder = __spreadArray([], co, true);
                        newOrder.splice(lofIndex + 1, 0, 'CONDITION_DATA');
                        return newOrder;
                    }
                    return __spreadArray(__spreadArray([], co, true), ['CONDITION_DATA'], false);
                }
                return co;
            }
        });
    }, [noConditionData]);
    (0, react_1.useEffect)(function () {
        if (isIndividualScoresEnabled &&
            !cofFilled &&
            weightedCofColumnNames.length > 0) {
            setColumnOrder(function (co) { return __spreadArray(__spreadArray([], co, true), weightedCofColumnNames, true); });
            setCofFilled(true);
        }
    }, [weightedCofColumnNames]);
    (0, react_1.useEffect)(function () {
        if (isIndividualScoresEnabled &&
            !lofFilled &&
            weightedLofColumnNames.length > 0) {
            setColumnOrder(function (co) { return __spreadArray(__spreadArray([], co, true), weightedLofColumnNames, true); });
            setLofFilled(true);
        }
    }, [weightedLofColumnNames]);
    return { columnOrder: columnOrder, setColumnOrder: setColumnOrder };
}
exports["default"] = useRiskDetailsColumnOrder;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/useRiskDetailsRows.ts":
/*!***************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/useRiskDetailsRows.ts ***!
  \***************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
function useRiskDetailsRows() {
    var tablePage = (0, Risk_selectors_1.selectRiskDetailsTablePage)();
    var isIndividualScoresEnabled = (0, stylovyze_1.useIsFeatureEnabled)('info-360-risk-datagrid-individual-scores');
    var risks = (0, react_redux_1.useSelector)(Risk_selectors_1.selectorRiskDetailsRows);
    var rows = tablePage.cells.map(function (row, nRow) {
        var WEIGHTED_SCORES = risks[nRow].WEIGHTED_SCORES;
        return __assign({ id: nRow, ASSET_ID: row[0], RISK_CHANGE: row[1], CURRENT_RISK: row[2], CURRENT_LOF: row[3], CURRENT_COF: row[4], CONDITION_DATA: row[5], GRADE: row[6], Menu: row[0] }, (isIndividualScoresEnabled && WEIGHTED_SCORES));
    }) || [];
    return rows;
}
exports["default"] = useRiskDetailsRows;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/useRiskDetailsSelectors.tsx":
/*!*********************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/useRiskDetailsSelectors.tsx ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useRiskDetailsSelectors = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var Selectors_1 = __webpack_require__(/*! @innovyze/lib-am-common/Selectors */ "@innovyze/lib-am-common/Selectors");
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var react_1 = __webpack_require__(/*! react */ "react");
function useRiskDetailsSelectors() {
    var subscriptions = (0, stylovyze_1.getSubscriptions)();
    var hasFullAccess = (0, shared_utils_1.fullAccess)(subscriptions);
    var riskConfig = (0, Risk_selectors_1.selectRiskConfig)();
    var canReload = (0, Risk_selectors_1.selectCanReload)();
    var runCompleteReload = (0, Risk_selectors_1.selectRunCompleteReload)();
    var isLoading = (0, Risk_selectors_1.selectRiskDetailsIsLoading)();
    var isWaiting = (0, Risk_selectors_1.selectRiskDetailsIsWaiting)();
    var isRiskStoreLoading = (0, Risk_selectors_1.selectRiskStore)().isLoading;
    var isSearching = (0, Risk_selectors_1.selectRiskStore)().startSearch > 0;
    var tablePage = (0, Risk_selectors_1.selectRiskDetailsTablePage)();
    var tenantId = (0, react_redux_1.useSelector)(Selectors_1.getTenant);
    var userId = (0, stylovyze_1.useSelectUserContext)().id;
    var riskDetailsPagination = (0, react_redux_1.useSelector)(Risk_selectors_1.selectorRiskDetailsPagination);
    var assetLocation = (0, Selectors_1.useSelectAssetLocation)();
    var isWaitingAssetLocation = (0, Selectors_1.useSelectAssetLocationIsWaiting)();
    var _a = (0, react_1.useState)(undefined), findAsset = _a[0], setFindAsset = _a[1];
    return {
        tablePage: tablePage,
        hasFullAccess: hasFullAccess,
        isLoading: isLoading,
        isWaiting: isWaiting,
        assetLocation: assetLocation,
        riskConfig: riskConfig,
        canReload: canReload,
        runCompleteReload: runCompleteReload,
        tenantId: tenantId,
        userId: userId,
        riskDetailsPagination: riskDetailsPagination,
        isWaitingAssetLocation: isWaitingAssetLocation,
        isRiskStoreLoading: isRiskStoreLoading,
        findAsset: findAsset,
        setFindAsset: setFindAsset,
        isSearching: isSearching,
    };
}
exports.useRiskDetailsSelectors = useRiskDetailsSelectors;


/***/ }),

/***/ "./components/RiskDetails/Datagrid/useRiskDetailsStates.tsx":
/*!******************************************************************!*\
  !*** ./components/RiskDetails/Datagrid/useRiskDetailsStates.tsx ***!
  \******************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useRiskDetailsStates = void 0;
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var useRiskDetailsSelectors_1 = __webpack_require__(/*! ./useRiskDetailsSelectors */ "./components/RiskDetails/Datagrid/useRiskDetailsSelectors.tsx");
function useRiskDetailsStates() {
    var _a;
    var _b = (0, useRiskDetailsSelectors_1.useRiskDetailsSelectors)(), tablePage = _b.tablePage, riskDetailsPagination = _b.riskDetailsPagination;
    var _c = (0, react_1.useState)([]), assetHighlight = _c[0], setAssetHighlight = _c[1];
    var _d = (0, react_1.useState)([]), selectionModel = _d[0], setSelectionModel = _d[1];
    var initialSortModel = [
        {
            field: 'CURRENT_RISK',
            sort: 'desc',
        },
    ];
    var _e = (0, react_1.useState)(initialSortModel), sortModel = _e[0], setSortModel = _e[1];
    var initialFilterModel = { items: [] };
    var _f = react_1.default.useState(initialFilterModel), filterModel = _f[0], setFilterModel = _f[1];
    var _g = react_1.default.useState({
        page: (tablePage === null || tablePage === void 0 ? void 0 : tablePage.page) ? (tablePage === null || tablePage === void 0 ? void 0 : tablePage.page) - 1 : 0,
        pageSize: (_a = riskDetailsPagination === null || riskDetailsPagination === void 0 ? void 0 : riskDetailsPagination.slice) !== null && _a !== void 0 ? _a : 10,
    }), paginationModel = _g[0], setPaginationModel = _g[1];
    return {
        assetHighlight: assetHighlight,
        setAssetHighlight: setAssetHighlight,
        selectionModel: selectionModel,
        setSelectionModel: setSelectionModel,
        initialSortModel: initialSortModel,
        sortModel: sortModel,
        setSortModel: setSortModel,
        initialFilterModel: initialFilterModel,
        filterModel: filterModel,
        setFilterModel: setFilterModel,
        paginationModel: paginationModel,
        setPaginationModel: setPaginationModel,
    };
}
exports.useRiskDetailsStates = useRiskDetailsStates;


/***/ }),

/***/ "./components/RiskDetails/NoResultsRisk.component.tsx":
/*!************************************************************!*\
  !*** ./components/RiskDetails/NoResultsRisk.component.tsx ***!
  \************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NoReasultsRisk = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var Scales_1 = __importDefault(__webpack_require__(/*! @Components/Utils/icons/Scales */ "./components/Utils/icons/Scales.tsx"));
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
// eslint-disable-next-line @typescript-eslint/naming-convention
var NoReasultsRisk = function (_a) {
    var adminFullAccess = _a.adminFullAccess, configId = _a.configId;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var history = (0, react_router_dom_1.useHistory)();
    var lofClicked = function () {
        history.push('/risk/lofSetup/' + configId);
    };
    var cofClicked = function () {
        history.push('/risk/cofSetup/' + configId);
    };
    var riskClicked = function () {
        history.push('/risk/riskSetup/' + configId);
    };
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, style: { height: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: { paddingTop: '80px' } }, { children: (0, jsx_runtime_1.jsx)(Scales_1.default, {}) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h6" }, { children: t('No results to show') })) })), adminFullAccess ? ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center", style: { paddingBottom: '80px' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption" }, { children: t('To generate model results, you will first need to configure your risk model and run it.') })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ variant: "caption" }, { children: [t('Risk models consist of '), (0, jsx_runtime_1.jsx)(material_1.Link, __assign({ underline: "hover", style: {
                                        cursor: 'pointer',
                                        width: '100%',
                                        whiteSpace: 'nowrap',
                                    }, title: t('Likelihood of Failure'), onClick: function () {
                                        lofClicked();
                                    }, "data-cy": "lofLink" }, { children: t('Likelihood of Failure') })), ', ', (0, jsx_runtime_1.jsx)(material_1.Link, __assign({ underline: "hover", style: {
                                        cursor: 'pointer',
                                        width: '100%',
                                        whiteSpace: 'nowrap',
                                    }, title: t('Consequence of Failure'), onClick: function () {
                                        cofClicked();
                                    }, "data-cy": "cofLink" }, { children: t('Consequence of Failure') })), t(', and '), (0, jsx_runtime_1.jsx)(material_1.Link, __assign({ underline: "hover", style: {
                                        cursor: 'pointer',
                                        width: '100%',
                                        whiteSpace: 'nowrap',
                                    }, title: t('Risk Setup'), onClick: function () {
                                        riskClicked();
                                    }, "data-cy": "riskLink" }, { children: t('Risk Setup') })), t(' configuration')] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, xs: 12, justifyContent: "center" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "caption" }, { children: t('You can create these in any order.') })) }))] }))) : ([])] })));
};
exports.NoReasultsRisk = NoReasultsRisk;


/***/ }),

/***/ "./components/RiskDetails/RiskDetails.component.tsx":
/*!**********************************************************!*\
  !*** ./components/RiskDetails/RiskDetails.component.tsx ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskDetails = void 0;
var react_1 = __webpack_require__(/*! react */ "react");
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var icons_material_1 = __webpack_require__(/*! @mui/icons-material */ "@mui/icons-material");
var riskDetailsPagination_1 = __webpack_require__(/*! @Reducers/riskDetailsPagination */ "./reducers/riskDetailsPagination.ts");
var Actions_1 = __webpack_require__(/*! @innovyze/lib-am-common/Actions */ "@innovyze/lib-am-common/Actions");
var Utils_1 = __webpack_require__(/*! @innovyze/lib-am-common/Utils */ "@innovyze/lib-am-common/Utils");
var Selectors_1 = __webpack_require__(/*! @innovyze/lib-am-common/Selectors */ "@innovyze/lib-am-common/Selectors");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_2 = __webpack_require__(/*! react */ "react");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var Components_1 = __webpack_require__(/*! @innovyze/lib-am-common/Components */ "@innovyze/lib-am-common/Components");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var query_string_1 = __webpack_require__(/*! query-string */ "../node_modules/query-string/index.js");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var translations_1 = __webpack_require__(/*! @Utils/translations */ "./utils/translations.ts");
var NoResultsRisk_component_1 = __webpack_require__(/*! ./NoResultsRisk.component */ "./components/RiskDetails/NoResultsRisk.component.tsx");
var useNoConditionData_1 = __webpack_require__(/*! @Hooks/useNoConditionData */ "./hooks/useNoConditionData.ts");
var RiskDetails = function (_a) {
    var configId = _a.configId;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var history = (0, react_router_dom_1.useHistory)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var subscriptions = (0, stylovyze_1.getSubscriptions)();
    var hasFullAccess = (0, shared_utils_1.fullAccess)(subscriptions);
    var showFindAsset = (0, stylovyze_1.useIsFeatureEnabled)('info-360-navigate-to-asset')
        ? true
        : false;
    var riskConfig = (0, Risk_selectors_1.selectRiskConfig)();
    var canReload = (0, Risk_selectors_1.selectCanReload)();
    var runCompleteReload = (0, Risk_selectors_1.selectRunCompleteReload)();
    var filters = (0, Risk_selectors_1.selectRiskDetailsFilterProps)();
    var isLoading = (0, Risk_selectors_1.selectRiskDetailsIsLoading)();
    var isWaiting = (0, Risk_selectors_1.selectRiskDetailsIsWaiting)();
    var status = (0, Risk_selectors_1.selectRiskDetailsStatus)();
    var queryString = (0, Risk_selectors_1.selectRiskDetailsQuery)();
    var tablePage = (0, Risk_selectors_1.selectRiskDetailsTablePage)();
    var pagination = (0, Risk_selectors_1.selectRiskDetailsPagination)();
    var requestParams = __assign(__assign({}, (0, query_string_1.parse)(queryString)), { slice: '100000', page: '1' });
    var assetLocation = (0, Selectors_1.useSelectAssetLocation)();
    var isWaitingAssetLocation = (0, Selectors_1.useSelectAssetLocationIsWaiting)();
    var _b = (0, react_2.useState)(undefined), findAsset = _b[0], setFindAsset = _b[1];
    (0, react_2.useEffect)(function () {
        dispatch((0, _Actions_1.setTab)('details'));
    }, []);
    (0, react_2.useEffect)(function () {
        if (canReload && runCompleteReload) {
            refreshList();
            (0, _Actions_1.setRunCompleteReload)(false);
        }
    }, [runCompleteReload]);
    var dispatchSliceFn = function (slice) { return dispatch((0, _Actions_1.changeSlice)(slice)); };
    var dispatchSearchFn = function (text) { return dispatch((0, _Actions_1.changeSearch)(text)); };
    var dispatchSortFn = function (_e, name, order) {
        var sortPayload = {
            key: name.toString(),
            descending: order !== 'asc',
        };
        dispatch((0, _Actions_1.changeSort)(sortPayload));
    };
    var statusCell = function (status) {
        switch (status) {
            case '0':
                return ((0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Negligible'), color: "negligible", width: (0, stylovyze_1.rem)(92) }));
            case '1':
                return ((0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Low'), color: "low", width: (0, stylovyze_1.rem)(92) }));
            case '2':
                return ((0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Medium'), color: "medium", width: (0, stylovyze_1.rem)(92) }));
            case '3':
                return ((0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('High'), color: "high", width: (0, stylovyze_1.rem)(92) }));
            case '4':
                return ((0, jsx_runtime_1.jsx)(stylovyze_1.StatusTag, { text: t('Extreme'), color: "extreme", width: (0, stylovyze_1.rem)(92) }));
            default:
                return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    var trendCell = function (trend) {
        var value = parseFloat(trend);
        if (isNaN(value)) {
            return trend;
        }
        else {
            if (parseFloat(trend) < 0)
                return (0, jsx_runtime_1.jsx)("b", __assign({ style: { color: 'green' } }, { children: trend }));
            else if (parseFloat(trend) > 0)
                return (0, jsx_runtime_1.jsxs)("b", __assign({ style: { color: 'red' } }, { children: ["+", trend] }));
            else
                return trend;
        }
    };
    var conditionCell = function (condition) {
        if (condition === '1' || condition === 'true') {
            return ((0, jsx_runtime_1.jsx)(icons_material_1.CheckCircle, { style: {
                    color: stylovyze_1.riskGradePalette.low.dark,
                    verticalAlign: 'middle',
                } }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    var menuCell = function (assetId) {
        return ((0, jsx_runtime_1.jsx)("div", __assign({ role: "button", tabIndex: 0 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.MenuListButton, { menuItems: [
                    {
                        text: t('Find Asset in Network'),
                        icon: (0, jsx_runtime_1.jsx)(icons_material_1.Map, {}),
                        onClick: function () {
                            var mapAsset = {
                                assetId: assetId,
                                assetType: riskConfig.riskSetting.assetType,
                            };
                            setFindAsset(mapAsset);
                            dispatch((0, Actions_1.getAssetLocation)(mapAsset));
                        },
                    },
                ], buttonCy: "actions" }) }), 'findAsset'));
    };
    (0, react_2.useEffect)(function () {
        if (findAsset &&
            assetLocation &&
            assetLocation.assetId === findAsset.assetId) {
            var url = (0, Utils_1.makeMapURL)(findAsset.assetType, findAsset.assetId, assetLocation.position);
            if (url)
                history.push(url);
            setFindAsset(undefined);
        }
    }, [assetLocation, findAsset]);
    var noConditionData = (0, useNoConditionData_1.useNoConditionData)(riskConfig.riskSetting.assetType);
    var rowReactNodes = function (row) {
        if (showFindAsset) {
            if (noConditionData) {
                return row.map(function (cell, nCol) {
                    switch (nCol) {
                        case riskDetailsPagination_1.ColumnNoCDFindAsset.AssetId:
                            return ((0, jsx_runtime_1.jsx)(material_1.Link, __assign({ underline: "hover", style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    cursor: 'pointer',
                                }, title: cell, onClick: function () {
                                    history.push((0, actions_1.addRouteNamespace)("riskAssetDetails/".concat(cell)));
                                } }, { children: cell })));
                        case riskDetailsPagination_1.ColumnNoCDFindAsset.RiskTrend:
                            return trendCell(cell);
                        case riskDetailsPagination_1.ColumnNoCDFindAsset.Grade:
                            return statusCell(cell === null || cell === void 0 ? void 0 : cell.toString());
                        case riskDetailsPagination_1.ColumnNoCDFindAsset.Menu:
                            return menuCell(row[riskDetailsPagination_1.Column.AssetId]);
                        default:
                            return cell;
                    }
                });
            }
            else {
                return row.map(function (cell, nCol) {
                    switch (nCol) {
                        case riskDetailsPagination_1.ColumnFindAsset.AssetId:
                            return ((0, jsx_runtime_1.jsx)(material_1.Link, __assign({ underline: "hover", style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    cursor: 'pointer',
                                }, title: cell, onClick: function () {
                                    history.push((0, actions_1.addRouteNamespace)("riskAssetDetails/".concat(cell)));
                                } }, { children: cell })));
                        case riskDetailsPagination_1.ColumnFindAsset.RiskTrend:
                            return trendCell(cell);
                        case riskDetailsPagination_1.ColumnFindAsset.ConditionData:
                            return conditionCell(cell === null || cell === void 0 ? void 0 : cell.toString());
                        case riskDetailsPagination_1.ColumnFindAsset.Grade:
                            return statusCell(cell === null || cell === void 0 ? void 0 : cell.toString());
                        case riskDetailsPagination_1.ColumnFindAsset.Menu:
                            return menuCell(row[riskDetailsPagination_1.Column.AssetId]);
                        default:
                            return cell;
                    }
                });
            }
        }
        else {
            if (noConditionData) {
                return row.map(function (cell, nCol) {
                    switch (nCol) {
                        case riskDetailsPagination_1.ColumnNoCD.AssetId:
                            return ((0, jsx_runtime_1.jsx)(material_1.Link, __assign({ underline: "hover", style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    cursor: 'pointer',
                                }, title: cell, onClick: function () {
                                    history.push((0, actions_1.addRouteNamespace)("riskAssetDetails/".concat(cell)));
                                } }, { children: cell })));
                        case riskDetailsPagination_1.ColumnNoCD.RiskTrend:
                            return trendCell(cell);
                        case riskDetailsPagination_1.ColumnNoCD.Grade:
                            return statusCell(cell === null || cell === void 0 ? void 0 : cell.toString());
                        default:
                            return cell;
                    }
                });
            }
            else {
                return row.map(function (cell, nCol) {
                    switch (nCol) {
                        case riskDetailsPagination_1.Column.AssetId:
                            return ((0, jsx_runtime_1.jsx)(material_1.Link, __assign({ underline: "hover", style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    cursor: 'pointer',
                                }, title: cell, onClick: function () {
                                    history.push((0, actions_1.addRouteNamespace)("riskAssetDetails/".concat(cell)));
                                } }, { children: cell })));
                        case riskDetailsPagination_1.Column.RiskTrend:
                            return trendCell(cell);
                        case riskDetailsPagination_1.Column.ConditionData:
                            return conditionCell(cell === null || cell === void 0 ? void 0 : cell.toString());
                        case riskDetailsPagination_1.Column.Grade:
                            return statusCell(cell === null || cell === void 0 ? void 0 : cell.toString());
                        default:
                            return cell;
                    }
                });
            }
        }
    };
    var rows = tablePage.cells.map(function (row, nRow) { return ({
        key: nRow,
        cells: rowReactNodes(row),
    }); }) || [];
    var filterChange = function (value) {
        dispatch((0, _Actions_1.changeFilterSelect)(value));
    };
    var refreshList = function () {
        dispatch((0, _Actions_1.changePage)(tablePage.page));
    };
    var getTitleArea = function () {
        return ((0, jsx_runtime_1.jsxs)(styles_1.StyledGrid, __assign({ alignItems: "center", container: true, style: { width: '70%' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, item: true, justifyContent: "space-evenly", alignItems: "center", "data-cy": "grid-filters", xs: 6 }, { children: (0, translations_1.translatedFilters)(filters, t).map(function (filterProps, index) { return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, alignItems: "center", xs: 6, style: {
                            paddingLeft: '20px',
                            paddingRight: '20px',
                        } }, { children: (0, react_1.createElement)(Components_1.FilterSelect, __assign({}, filterProps, { key: filterProps.column.id, onFilterChange: filterChange, fullWidth: true })) }), index)); }) })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 6, container: true, justifyContent: "flex-end", "data-cy": "grid-actionbutton" }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.DataGridButton, { type: stylovyze_1.DataGridButtonType.REFRESH, disabled: isLoading || isWaiting, "data-cy": "refreshButton", onClick: refreshList }), hasFullAccess && ((0, jsx_runtime_1.jsx)(stylovyze_1.ExportButtonWithDialog, { total: tablePage.total, requestParams: requestParams, disabled: isLoading || isWaiting, source: 'risk.export.create', title: t('Export'), maxRows: 100000, dialogDataCy: "export-dialog", iconDataCy: "export-icon", maxPollAttempts: 60, iterationTime: 5000 }))] }))] })));
    };
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { className: isLoading || isWaiting || isWaitingAssetLocation
            ? 'ScrollTable wait'
            : 'ScrollTable', dataCy: "risk-details-table", titleArea: getTitleArea(), headers: (0, riskDetailsPagination_1.headerReactNodes)(noConditionData !== null && noConditionData !== void 0 ? noConditionData : false, showFindAsset, t), search: {
            onChange: function (query) {
                dispatchSearchFn(query);
                dispatch((0, _Actions_1.reloadRiskDetails)(configId));
            },
            onRequestSearch: function () {
                dispatch((0, _Actions_1.reloadRiskDetails)(configId));
            },
            onCancelSearch: function () {
                dispatchSearchFn('');
                dispatch((0, _Actions_1.reloadRiskDetails)(configId));
            },
            placeholder: t('Search'),
            value: (0, Risk_selectors_1.selectRiskDetailsSearch)(),
            dataCy: 'search-01',
        }, sort: {
            name: tablePage.sortKey,
            order: tablePage.sortDescending ? 'desc' : 'asc',
            onRequestSort: function (_e, name, order) {
                dispatchSortFn(_e, name, order);
            },
        }, rows: rows, rowsPerPage: (0, Risk_selectors_1.selectRowsPerPage)(dispatchSliceFn), rowHeight: (0, stylovyze_1.rem)(40), pagination: {
            totalNumberOfPages: tablePage.pages,
            dataCy: 'pagination-01',
            currentPage: tablePage.page,
            onChange: function (_e, page) {
                dispatch((0, _Actions_1.changePage)(page));
            },
            extraInfo: t('{{from}}-{{to}} of {{total}}', {
                from: (pagination.page - 1) * pagination.slice + 1,
                to: pagination.page == pagination.pages
                    ? pagination.total
                    : pagination.page * pagination.slice,
                total: pagination.total,
            }),
        }, initialized: !isLoading && status.code !== 800, useSkeleton: { rowCount: 10 }, emptyTableBody: (0, jsx_runtime_1.jsx)(NoResultsRisk_component_1.NoReasultsRisk, { adminFullAccess: hasFullAccess, configId: configId }) }));
};
exports.RiskDetails = RiskDetails;


/***/ }),

/***/ "./components/RiskDetails/index.ts":
/*!*****************************************!*\
  !*** ./components/RiskDetails/index.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskDetailsDatagrid = exports.RiskDetails = void 0;
var RiskDetails_component_1 = __webpack_require__(/*! ./RiskDetails.component */ "./components/RiskDetails/RiskDetails.component.tsx");
Object.defineProperty(exports, "RiskDetails", ({ enumerable: true, get: function () { return RiskDetails_component_1.RiskDetails; } }));
var RiskDetailsDatagrid_component_1 = __webpack_require__(/*! ./Datagrid/RiskDetailsDatagrid.component */ "./components/RiskDetails/Datagrid/RiskDetailsDatagrid.component.tsx");
Object.defineProperty(exports, "RiskDetailsDatagrid", ({ enumerable: true, get: function () { return RiskDetailsDatagrid_component_1.RiskDetails; } }));


/***/ }),

/***/ "./components/RiskGrade/RiskGrade.tsx":
/*!********************************************!*\
  !*** ./components/RiskGrade/RiskGrade.tsx ***!
  \********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskGrade = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var react_1 = __webpack_require__(/*! react */ "react");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var _Components_1 = __webpack_require__(/*! @Components */ "./components/index.ts");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var RiskMatrixDataGrid_1 = __webpack_require__(/*! ./RiskMatrixDataGrid */ "./components/RiskGrade/RiskMatrixDataGrid.tsx");
var utils_RiskMatrix_1 = __webpack_require__(/*! ./utils.RiskMatrix */ "./components/RiskGrade/utils.RiskMatrix.ts");
var Star_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/Star */ "@mui/icons-material/Star"));
var RiskNormalize_component_1 = __webpack_require__(/*! ./RiskNormalize.component */ "./components/RiskGrade/RiskNormalize.component.tsx");
var RiskGrade = function (_a) {
    var _b;
    var isLoading = _a.isLoading;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var riskMatrixFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-risk-setup-matrix');
    var riskNormalizeFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-asset-risk-normalize');
    var overallRows = [
        [t('LoF'), '', '10'],
        [t('CoF'), '', '10'],
    ];
    var gradeRows = [
        ['negligible', t('Negligible'), '<', ''],
        ['low', t('Low'), '>=', ''],
        ['medium', t('Medium'), '>=', ''],
        ['high', t('High'), '>=', ''],
        ['extreme', t('Extreme'), '>=', ''],
    ];
    var settings = (0, _Selectors_1.selectRiskSetting)();
    var riskConfig = (0, _Selectors_1.selectRiskConfig)();
    var saveRunSettings = (0, _Selectors_1.selectSaveRunSettings)();
    var riskType = (0, _Selectors_1.selectRiskType)();
    var previewStatus = (0, _Selectors_1.selectPreviewStatus)();
    var previewOnLoad = (0, _Selectors_1.selectIsPreviewOnLoad)();
    var enablePreview = (0, _Selectors_1.selectEnablePreview)();
    var isOnlyGradesUpdated = (0, _Selectors_1.selectOnlyGradesUpdated)();
    var maxLoFValue = (0, _Selectors_1.selectMaxLoFValue)();
    var maxCoFValue = (0, _Selectors_1.selectMaxCoFValue)();
    var _c = (0, react_1.useState)(settings.LOFWeighting === 100 && settings.COFWeighting === 100), ignoreWeightings = _c[0], setIgnoreWeightings = _c[1];
    var _d = (0, react_1.useState)(settings.LOFWeighting === 100 && settings.COFWeighting === 100
        ? 50
        : settings.LOFWeighting), ignorePreviousValue = _d[0], setIgnorePreviousValue = _d[1];
    var _e = (0, react_1.useState)(settings.RiskMethod), riskMethod = _e[0], setRiskMethod = _e[1];
    var _f = (0, react_1.useState)(false), showMethodSwitchDialog = _f[0], setShowMethodSwitchDialog = _f[1];
    var _g = (0, react_1.useState)(settings.LOFWeighting), lofValue = _g[0], setLoFValue = _g[1];
    var _h = (0, react_1.useState)(maxLoFValue), lofScore = _h[0], setLofScore = _h[1];
    var _j = (0, react_1.useState)(settings.COFWeighting), cofValue = _j[0], setCoFValue = _j[1];
    var _k = (0, react_1.useState)(maxCoFValue), cofScore = _k[0], setCofScore = _k[1];
    // Before anyone starts I have tried this using an array but it just wont work, the controls just dont accept any input and stay as the value in the array.
    var _l = (0, react_1.useState)(settings.Grades.Low), gradeLow = _l[0], setGradeLow = _l[1];
    var _m = (0, react_1.useState)(settings.Grades.Medium), gradeMedium = _m[0], setGradeMedium = _m[1];
    var _o = (0, react_1.useState)(settings.Grades.High), gradeHigh = _o[0], setGradeHigh = _o[1];
    var _p = (0, react_1.useState)(settings.Grades.Extreme), gradeExtreme = _p[0], setGradeExtreme = _p[1];
    var _q = (0, react_1.useState)(settings.Grades.Max), gradeMax = _q[0], setGradeMax = _q[1];
    // For older configs maxOverallRiskScore will be undefined so get it from the grades
    var _r = (0, react_1.useState)((_b = settings.maxOverallRiskScore) !== null && _b !== void 0 ? _b : settings.Grades.Max), maxScore = _r[0], setMaxScore = _r[1];
    var _s = (0, react_1.useState)({ useNormalize: false, normalizeValue: 100 }), normalizeSettings = _s[0], setNormalizeSettings = _s[1];
    var setIsSetupDirty = function (state) {
        dispatch((0, _Actions_1.setRiskSetupDirty)(state));
    };
    var grid = (0, _Selectors_1.selectUpdatedRiskMatrixGrid)();
    (0, react_1.useEffect)(function () {
        setIsSetupDirty(false);
    }, []);
    (0, react_1.useEffect)(function () {
        var _a, _b, _c;
        setRiskMethod(settings.RiskMethod);
        setLoFValue(settings.LOFWeighting);
        setLofScore((settings.LOFWeighting / 100) * maxLoFValue);
        setCoFValue(settings.COFWeighting);
        setCofScore((settings.COFWeighting / 100) * maxCoFValue);
        setGradeLow(settings.Grades.Low);
        setGradeMedium(settings.Grades.Medium);
        setGradeHigh(settings.Grades.High);
        setGradeExtreme(settings.Grades.Extreme);
        setGradeMax(settings.Grades.Max);
        setMaxScore((_a = settings.maxOverallRiskScore) !== null && _a !== void 0 ? _a : settings.Grades.Max);
        setNormalizeSettings({ useNormalize: false, normalizeValue: 100 });
        if (settings.postProcessing) {
            var process_1 = settings.postProcessing.find(function (process) { return process.type === 'normalize'; });
            if (process_1) {
                setNormalizeSettings({
                    useNormalize: (_b = process_1.params.useNormalize) !== null && _b !== void 0 ? _b : false,
                    normalizeValue: (_c = process_1.params.normalizeValue) !== null && _c !== void 0 ? _c : 100,
                    maxRiskScore: process_1.params.maxRiskScore,
                });
            }
        }
        if (riskMatrixFlag &&
            riskType === 'matrix' &&
            settings.matrix &&
            !previewOnLoad &&
            previewStatus === '') {
            var previewObjPyld = {
                cofWeighting: settings.COFWeighting,
                lofWeighting: settings.LOFWeighting,
                riskMethod: settings.RiskMethod,
                grades: settings.matrix.grades,
                grid: grid,
                preview: {
                    grades: settings.matrix.grades,
                    grid: grid,
                },
                configId: settings.configId,
                initialLoad: true,
            };
            dispatch((0, _Actions_1.initRiskMatrixPreview)(previewObjPyld));
        }
    }, [settings]);
    (0, react_1.useEffect)(function () {
        var lScore = getScore(lofValue, true);
        var cScore = getScore(cofValue, false);
        var max = Math.round((riskMethod === 'multiplied'
            ? lScore * cScore
            : lScore + cScore) * 10) / 10;
        if (maxScore !== max) {
            maxScoreChanged(riskMethod, lScore, lofValue, cScore, cofValue);
            dispatch((0, stylovyze_1.success)(t('Max Overall Risk Score Updated')));
        }
    }, [settings, maxLoFValue, maxCoFValue]);
    (0, react_1.useEffect)(function () {
        if (saveRunSettings) {
            if (gradeMax != 0) {
                var newSettings = __assign({}, settings);
                newSettings.RiskMethod = riskMethod;
                newSettings.LOFWeighting = lofValue;
                newSettings.COFWeighting = cofValue;
                newSettings.Grades = {
                    Low: gradeLow,
                    Medium: gradeMedium,
                    High: gradeHigh,
                    Extreme: gradeExtreme,
                    Max: gradeMax,
                };
                newSettings.maxOverallRiskScore = maxScore;
                if (riskNormalizeFlag) {
                    var params = [
                        {
                            type: 'normalize',
                            params: {
                                useNormalize: normalizeSettings.useNormalize,
                                normalizeValue: normalizeSettings.normalizeValue,
                                maxRiskScore: normalizeSettings.maxRiskScore,
                            },
                        },
                    ];
                    newSettings.postProcessing = params;
                }
                var newMatrix = {
                    grades: __assign({}, riskStore.riskMatrix.grades),
                    grid: __spreadArray([], riskStore.riskMatrix.grid, true),
                };
                newSettings.matrix = newMatrix;
                var newRiskConfig = __assign(__assign({}, riskConfig), { riskSetting: newSettings });
                dispatch((0, _Actions_1.saveRiskConfigAction)(newRiskConfig));
                if (enablePreview && !isOnlyGradesUpdated)
                    dispatch((0, _Actions_1.clearMatrixUpdate)(false));
            }
            else {
                dispatch((0, stylovyze_1.error)(t('Invalid overall risk weighting')));
            }
            dispatch((0, _Actions_1.setSaveRun)(false));
        }
    }, [saveRunSettings]);
    var createRangeValues = function (start, end, precision, count) {
        var result = [count + 1];
        var range = end - start;
        var interval = range / count;
        if (precision === 0)
            interval = Math.floor(interval);
        else
            interval =
                Math.round(interval * (100 * precision)) / (100 * precision);
        var first = start;
        var pos = 0;
        result[pos++] = first;
        for (var i = 0; i < count - 1; i++) {
            result[pos++] =
                Math.round((first += interval) * (100 * precision)) /
                    (100 * precision);
        }
        result[pos++] = end;
        return result;
    };
    var getScore = function (value, lof) {
        var result = (value / 100) * (lof ? maxLoFValue : maxCoFValue);
        return Math.round(result * 10) / 10;
    };
    var maxScoreChanged = function (method, lof, lofWeighting, cof, cofWeighting) {
        var max = Math.round((method === 'multiplied' ? lof * cof : lof + cof) * 10) /
            10;
        setMaxScore(max);
        if (!normalizeSettings.useNormalize) {
            var range = createRangeValues(0, max, 1, 5);
            setGradeLow(range[1]);
            setGradeMedium(range[2]);
            setGradeHigh(range[3]);
            setGradeExtreme(range[4]);
            setGradeMax(max);
        }
        setRiskMethod(method === 'multiplied' ? 'multiplied' : 'added');
        setIsSetupDirty(true);
        dispatch((0, _Actions_1.setOverallRisk)({
            cofWeighting: cofWeighting,
            lofWeighting: lofWeighting,
            riskMethod: method === 'multiplied' ? 'multiplied' : 'added',
        }));
    };
    var lofSliderChanged = function (value) {
        if (!ignoreWeightings) {
            var lof = getScore(value, true);
            setLoFValue(value);
            setLofScore(lof);
            var cof = getScore(100 - value, false);
            setCoFValue(100 - value);
            setCofScore(cof);
            maxScoreChanged(riskMethod, lof, value, cof, 100 - value);
        }
        else {
            setLoFValue(100);
            setLofScore(maxLoFValue);
            setCoFValue(100);
            setCofScore(maxCoFValue);
            maxScoreChanged(riskMethod, maxLoFValue, value, maxCoFValue, 100);
        }
        setIsSetupDirty(true);
    };
    var cofSliderChanged = function (value) {
        if (!ignoreWeightings) {
            var cof = getScore(value, false);
            setCoFValue(value);
            setCofScore(cof);
            var lof = getScore(100 - value, true);
            setLoFValue(100 - value);
            setLofScore(lof);
            maxScoreChanged(riskMethod, lof, 100 - value, cof, value);
        }
        else {
            setLoFValue(100);
            setLofScore(maxLoFValue);
            setCoFValue(100);
            setCofScore(maxCoFValue);
            maxScoreChanged(riskMethod, maxLoFValue, value, maxCoFValue, 100);
        }
        setIsSetupDirty(true);
    };
    var overallHeaders = (0, react_1.useMemo)(function () {
        return [
            {
                key: 'risk',
                cell: t('Risk'),
                sortable: false,
                align: 'left',
                width: '50px',
            },
            {
                key: 'weighting',
                cell: t('Weighting'),
                sortable: false,
                align: 'left',
                padding: '0',
            },
            {
                key: 'maxScore',
                cell: t('Max Score'),
                sortable: false,
                align: 'left',
                width: '50px',
            },
        ];
    }, [settings]);
    var overallRowReactNodes = function (row, nRow) {
        return row.map(function (cell, nCol) {
            switch (nCol) {
                case 1:
                    return {
                        content: ((0, jsx_runtime_1.jsx)(_Components_1.PercentSlider, { disabled: isLoading || ignoreWeightings, dataCy: 'overall-risk-' + nRow, value: nRow === 0 ? lofValue : cofValue, marks: 'minmaxticks', onSliderChanged: nRow === 0
                                ? lofSliderChanged
                                : cofSliderChanged, padLeft: '15px', valueLabelDisplay: 'on', invalid: maxScore == 0 })),
                        props: {
                            padding: 'checkbox',
                        },
                    };
                case 2:
                    return {
                        content: nRow === 0
                            ? "".concat(lofScore.toFixed(1), " / ").concat(maxLoFValue)
                            : "".concat(cofScore.toFixed(1), " / ").concat(maxCoFValue),
                        props: {
                            size: 'small',
                        },
                    };
                default:
                    return {
                        content: cell,
                        props: {
                            size: 'small',
                        },
                    };
            }
        });
    };
    var gradeHeaders = (0, react_1.useMemo)(function () {
        return [
            {
                key: 'status',
                cell: '',
                sortable: false,
                maxWidth: '30px',
                padding: '0 20px 0 10px',
            },
            {
                key: 'riskGrade',
                cell: t('Risk Grade'),
                sortable: false,
                padding: "0 ".concat((0, stylovyze_1.rem)(24), " 0 0"),
            },
            {
                key: 'indicator',
                cell: '',
                align: 'right',
                sortable: false,
                padding: '0',
            },
            {
                key: 'range',
                cell: t('Score Range'),
                sortable: false,
                width: '100px',
            },
        ];
    }, [settings]);
    var onRangeChangedLow = function (value) {
        if (value < 0)
            value = 0;
        else if (value > gradeMax)
            value = gradeMax;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        if (value > gradeMedium)
            onRangeChangedMedium(value);
        setGradeLow(value);
        setIsSetupDirty(true);
    };
    var onRangeChangedMedium = function (value) {
        if (value < 0)
            value = 0;
        else if (value > gradeMax)
            value = gradeMax;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        if (value > gradeHigh)
            onRangeChangedHigh(value);
        else if (value < gradeLow)
            onRangeChangedLow(value);
        setGradeMedium(value);
        setIsSetupDirty(true);
    };
    var onRangeChangedHigh = function (value) {
        if (value < 0)
            value = 0;
        else if (value > gradeMax)
            value = gradeMax;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        if (value > gradeExtreme)
            onRangeChangedExtreme(value);
        else if (value < gradeMedium)
            onRangeChangedMedium(value);
        setGradeHigh(value);
        setIsSetupDirty(true);
    };
    var onRangeChangedExtreme = function (value) {
        if (value < 0)
            value = 0;
        else if (value > gradeMax)
            value = gradeMax;
        if (value < gradeHigh)
            onRangeChangedHigh(value);
        setGradeExtreme(value);
        setIsSetupDirty(true);
    };
    var gradeRowReactNodes = function (row, nRow) {
        return row.map(function (cell, nCol) {
            switch (nCol) {
                case 0: {
                    var cell_1;
                    var legend = utils_RiskMatrix_1.legends.find(function (item) { return item.name === row[0]; });
                    if (legend)
                        cell_1 = ((0, jsx_runtime_1.jsx)(Star_1.default, { style: {
                                width: '16px',
                                marginBottom: '2px',
                                color: legend.color,
                            } }));
                    else
                        cell_1 = '';
                    return {
                        content: cell_1,
                        props: {
                            padding: 'checkbox',
                            size: 'small',
                        },
                    };
                }
                case 3:
                    {
                        switch (nRow) {
                            case 0:
                                return isNaN(gradeLow) ? '' : gradeLow;
                            case 1:
                                return ((0, jsx_runtime_1.jsx)(material_1.TextField, { disabled: isLoading, style: { width: '100px' }, value: gradeLow, onChange: function (e) {
                                        var value = parseFloat(e.target.value);
                                        if (!isNaN(value)) {
                                            if (value < 0)
                                                value = 0;
                                            else if (value > gradeMax)
                                                value = gradeMax;
                                            value =
                                                Math.round(value * 100) /
                                                    100;
                                        }
                                        setGradeLow(value);
                                        setIsSetupDirty(true);
                                    }, onBlur: function (e) {
                                        var value = parseFloat(e.target.value);
                                        if (isNaN(value))
                                            value = 0;
                                        onRangeChangedLow(Math.round(value * 100) / 100);
                                    }, inputProps: {
                                        step: '0.01',
                                        min: 0,
                                        max: gradeMax,
                                    }, variant: "outlined", type: "number", size: "small" }));
                            case 2:
                                return ((0, jsx_runtime_1.jsx)(material_1.TextField, { disabled: isLoading, style: { width: '100px' }, value: gradeMedium, onChange: function (e) {
                                        var value = parseFloat(e.target.value);
                                        if (!isNaN(value)) {
                                            if (value < 0)
                                                value = 0;
                                            else if (value > gradeMax)
                                                value = gradeMax;
                                            value =
                                                Math.round(value * 100) /
                                                    100;
                                        }
                                        setGradeMedium(value);
                                        setIsSetupDirty(true);
                                    }, onBlur: function (e) {
                                        var value = parseFloat(e.target.value);
                                        if (isNaN(value))
                                            value = gradeLow;
                                        onRangeChangedMedium(Math.round(value * 100) / 100);
                                    }, inputProps: {
                                        step: '0.01',
                                        min: 0,
                                        max: gradeMax,
                                    }, variant: "outlined", type: "number", size: "small" }));
                            case 3:
                                return ((0, jsx_runtime_1.jsx)(material_1.TextField, { disabled: isLoading, style: { width: '100px' }, value: gradeHigh, onChange: function (e) {
                                        var value = parseFloat(e.target.value);
                                        if (!isNaN(value)) {
                                            if (value < 0)
                                                value = 0;
                                            else if (value > gradeMax)
                                                value = gradeMax;
                                            value =
                                                Math.floor(value * 100) /
                                                    100;
                                        }
                                        setGradeHigh(value);
                                        setIsSetupDirty(true);
                                    }, onBlur: function (e) {
                                        var value = parseFloat(e.target.value);
                                        if (isNaN(value))
                                            value = gradeMedium;
                                        onRangeChangedHigh(Math.round(value * 100) / 100);
                                    }, inputProps: {
                                        step: '0.01',
                                        min: 0,
                                        max: gradeMax,
                                    }, variant: "outlined", type: "number", size: "small" }));
                            case 4:
                                return ((0, jsx_runtime_1.jsx)(material_1.TextField, { disabled: isLoading, style: { width: '100px' }, value: gradeExtreme, onChange: function (e) {
                                        var value = parseFloat(e.target.value);
                                        if (!isNaN(value)) {
                                            if (value < 0)
                                                value = 0;
                                            else if (value > gradeMax)
                                                value = gradeMax;
                                            value =
                                                Math.round(value * 100) /
                                                    100;
                                        }
                                        setGradeExtreme(value);
                                        setIsSetupDirty(true);
                                    }, onBlur: function (e) {
                                        var value = parseFloat(e.target.value);
                                        if (isNaN(value))
                                            value = gradeHigh;
                                        onRangeChangedExtreme(Math.round(value * 100) / 100);
                                    }, inputProps: {
                                        step: '0.01',
                                        min: 0,
                                        max: gradeMax,
                                    }, variant: "outlined", type: "number", size: "small" }));
                        }
                    }
                    break;
                default:
                    return cell;
            }
        });
    };
    var onIgnoreWeightings = function (event) {
        setIgnoreWeightings(event.target.checked);
        if (event.target.checked) {
            setIgnorePreviousValue(lofValue);
            var lValue = 100;
            var lScore = getScore(lValue, true);
            setLoFValue(lValue);
            setLofScore(lScore);
            var cValue = 100;
            var cScore = getScore(cValue, false);
            setCoFValue(cValue);
            setCofScore(cScore);
            maxScoreChanged(riskMethod, lScore, lValue, cScore, cValue);
        }
        else {
            var lValue = ignorePreviousValue;
            var lScore = getScore(lValue, true);
            setLoFValue(lValue);
            setLofScore(lScore);
            var cValue = 100 - lValue;
            var cScore = getScore(cValue, false);
            setCoFValue(cValue);
            setCofScore(cScore);
            maxScoreChanged(riskMethod, lScore, lValue, cScore, cValue);
        }
        setIsSetupDirty(true);
    };
    var titleArea = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.RadioGroup, __assign({ row: true, value: riskMethod, onChange: function (event, value) {
                        maxScoreChanged(value, lofScore, lofValue, cofScore, cofValue);
                    } }, { children: [(0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { disabled: isLoading, value: "added", control: (0, jsx_runtime_1.jsx)(material_1.Radio, {}), label: t('Added') }), (0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { disabled: isLoading, value: "multiplied", control: (0, jsx_runtime_1.jsx)(material_1.Radio, {}), label: t('Multiplied') })] })), (0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { disabled: isLoading, control: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { checked: ignoreWeightings, onChange: onIgnoreWeightings }), label: t('100% LoF / 100% CoF') }), riskMatrixFlag && ((0, jsx_runtime_1.jsx)(RiskMatrixDataGrid_1.RiskModeDropdown, { setShowMethodSwitchDialog: setShowMethodSwitchDialog }))] }));
    };
    var riskStore = (0, _Selectors_1.selectRiskStore)();
    var didMatrixUpdate = (0, _Selectors_1.selectDidMatrixUpdate)();
    var onSaveRiskClicked = function (newRiskType) {
        dispatch((0, _Actions_1.setRiskType)(newRiskType));
        if (didMatrixUpdate) {
            var oldRiskConfig = __assign({}, riskStore.riskConfig);
            var oldRiskSetting = __assign({}, riskStore.riskConfig.riskSetting);
            var newMatrix = {
                grades: __assign({}, riskStore.riskMatrix.grades),
                grid: __spreadArray([], riskStore.riskMatrix.grid, true),
            };
            var newRiskTypeStr = newRiskType
                ? newRiskType
                : oldRiskSetting.riskType;
            var newSetting = __assign(__assign({}, oldRiskSetting), { matrix: newMatrix, riskType: newRiskTypeStr });
            var newRiskConfig = __assign(__assign({}, oldRiskConfig), { riskSetting: newSetting });
            dispatch((0, _Actions_1.saveRiskConfigAction)(newRiskConfig));
        }
        dispatch((0, _Actions_1.setOnlyGradesUpdated)(false));
        dispatch((0, _Actions_1.setDidMatrixUpdate)(false));
        dispatch((0, _Actions_1.setRiskSetupDirty)(false));
        dispatch((0, _Actions_1.setMatrixPreviewStatus)(''));
        dispatch((0, _Actions_1.setSaveRun)(true));
        dispatch((0, _Actions_1.setRefreshList)(true));
    };
    var onNormalizeChanged = function (useNormalize, normalizeValue) {
        if (useNormalize && gradeMax !== normalizeValue) {
            var range = createRangeValues(0, normalizeValue, 1, 5);
            setGradeLow(range[1]);
            setGradeMedium(range[2]);
            setGradeHigh(range[3]);
            setGradeExtreme(range[4]);
            setGradeMax(normalizeValue);
        }
        else if (useNormalize !== normalizeSettings.useNormalize) {
            var range = createRangeValues(0, maxScore, 1, 5);
            setGradeLow(range[1]);
            setGradeMedium(range[2]);
            setGradeHigh(range[3]);
            setGradeExtreme(range[4]);
            setGradeMax(maxScore);
        }
        setNormalizeSettings({
            useNormalize: useNormalize,
            normalizeValue: normalizeValue,
            maxRiskScore: normalizeSettings.maxRiskScore,
        });
        setIsSetupDirty(true);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { className: "ScrollTable", title: t('Overall Risk'), dataCy: "overallRisk-table", headers: overallHeaders, rows: overallRows.map(function (row, nRow) { return ({
                                key: nRow,
                                cells: overallRowReactNodes(row, nRow),
                            }); }) || [], rowHeight: '80px', titleArea: titleArea(), footerArea: t('Max Overall Risk Score = ') + maxScore }) })), riskMatrixFlag && riskType === 'matrix' ? ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, style: { paddingTop: '20px' } }, { children: (0, jsx_runtime_1.jsx)(RiskMatrixDataGrid_1.RiskMatrixGrid, {}) }))) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [riskNormalizeFlag ? ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, style: { paddingTop: '20px' } }, { children: (0, jsx_runtime_1.jsx)(RiskNormalize_component_1.RiskNormalize, { isLoading: isLoading, normalizeSettings: normalizeSettings, onNormalizeChanged: onNormalizeChanged }) }))) : ([]), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, style: { paddingTop: '20px' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { className: "ScrollTable", title: t('Risk Grade'), dataCy: "riskGrade-table", headers: gradeHeaders, rows: gradeRows.map(function (row, nRow) { return ({
                                        key: nRow,
                                        cells: gradeRowReactNodes(row, nRow),
                                    }); }) || [] }) }))] }))] })), (0, jsx_runtime_1.jsxs)(stylovyze_1.StylovyzeDialog, __assign({ "data-cy": "change-risk-type-dialog", title: t('Change Risk Method'), open: showMethodSwitchDialog, cancelText: t('Cancel'), cancelButtonProps: {
                    dataCy: 'switch-risk-type-cancel',
                }, onCancel: function () { return setShowMethodSwitchDialog(false); }, confirmText: t('Change Risk Method'), confirmButtonProps: {
                    dataCy: 'switch-risk-type-confirm',
                }, onConfirm: function () {
                    var newRiskType = riskType === 'linear' ? 'matrix' : 'linear';
                    onSaveRiskClicked(newRiskType);
                    setShowMethodSwitchDialog(false);
                } }, { children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { children: t('You are about to change the risk method to ') }), (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)("strong", { children: riskType === 'linear' ? 'matrix' : 'linear' }) }), (0, jsx_runtime_1.jsx)("span", { children: t('. The changes you have made will be saved.') })] }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("div", { children: t('Are you sure you want to do this?') })] }))] }));
};
exports.RiskGrade = RiskGrade;


/***/ }),

/***/ "./components/RiskGrade/RiskMatrixComponents.tsx":
/*!*******************************************************!*\
  !*** ./components/RiskGrade/RiskMatrixComponents.tsx ***!
  \*******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RangeEditorDialog = exports.RiskLegendMenu = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var utils_RiskMatrix_1 = __webpack_require__(/*! ./utils.RiskMatrix */ "./components/RiskGrade/utils.RiskMatrix.ts");
var DoneSharp_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/DoneSharp */ "@mui/icons-material/DoneSharp"));
var Star_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/Star */ "@mui/icons-material/Star"));
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var RiskMatrixStyles_1 = __webpack_require__(/*! ./RiskMatrixStyles */ "./components/RiskGrade/RiskMatrixStyles.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var Risk_actions_1 = __webpack_require__(/*! @Actions/Risk.actions */ "./actions/Risk.actions.ts");
var RiskLegendMenu = function (_a) {
    var anchorEl = _a.anchorEl, open = _a.open, handleClose = _a.handleClose, selectedGrade = _a.selectedGrade, handleGradeChange = _a.handleGradeChange;
    var t = (0, stylovyze_1.useGlobalization)().t;
    var classes = (0, RiskMatrixStyles_1.useRiskMatrixStyles)();
    return ((0, jsx_runtime_1.jsx)(material_1.Menu, __assign({ anchorEl: anchorEl, id: "risk-legend-menu", open: open, onClose: handleClose, onClick: handleClose, MenuListProps: {
            'aria-labelledby': 'gridcell-button',
        }, PaperProps: {
            elevation: 0,
            sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                minWidth: '183px',
                mt: 1.5,
                '& .Mui-selected': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
                },
            },
        }, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } }, { children: utils_RiskMatrix_1.legends.map(function (legend, key) { return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: selectedGrade, onClick: handleGradeChange, selected: selectedGrade.toUpperCase() ===
                legend.name.toUpperCase() }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.gridCellMenuItemContainer }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: classes.gridCellMenuItemIconContainer }, { children: (0, jsx_runtime_1.jsx)(material_1.ListItemIcon, { children: (0, jsx_runtime_1.jsx)(Star_1.default, { style: {
                                    width: '21px',
                                    color: legend.color,
                                } }) }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.gridCellMenuItemLegendName }, { children: t(legend.name) })), selectedGrade.toUpperCase() ===
                        legend.name.toUpperCase() ? ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.gridCellMenuItemDoneIconContainer }, { children: (0, jsx_runtime_1.jsx)(DoneSharp_1.default, { className: classes.gridCellMenuItemDoneIcon }) }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] })) }), key)); }) })));
};
exports.RiskLegendMenu = RiskLegendMenu;
var RangeEditorDialog = function (_a) {
    var showEditRangesDialog = _a.showEditRangesDialog, setShowEditRangesDialog = _a.setShowEditRangesDialog, cofRangeList = _a.cofRangeList, lofRangeList = _a.lofRangeList;
    var t = (0, stylovyze_1.useGlobalization)().t;
    var classes = (0, RiskMatrixStyles_1.useRiskMatrixStyles)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var _b = react_1.default.useState(true), disableSaveBtn = _b[0], setDisableSaveBtn = _b[1];
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeComposableDialog, __assign({ width: "700px", className: classes.dialogBoxStyle, open: showEditRangesDialog, onCancel: function () { return setShowEditRangesDialog(false); }, title: t('Change Ranges'), footer: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ variant: "contained", color: "secondary", onClick: function () { return setShowEditRangesDialog(false); } }, { children: "Cancel" })), (0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ disabled: disableSaveBtn, variant: "contained", color: "primary", onClick: function () {
                        dispatch((0, Risk_actions_1.setUpdatedRanges)({
                            lofRanges: __spreadArray([], lofRangeList, true),
                            cofRanges: __spreadArray([], cofRangeList, true),
                        }));
                        dispatch((0, Risk_actions_1.setOnlyGradesUpdated)(false));
                        dispatch((0, Risk_actions_1.setDidMatrixUpdate)(true));
                        dispatch((0, Risk_actions_1.setRiskSetupDirty)(true));
                        setDisableSaveBtn(false);
                        setShowEditRangesDialog(false);
                    } }, { children: t('OK') }))] }) }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                columnGap: '24px',
            } }, { children: [(0, jsx_runtime_1.jsx)(RangeEditor, { rangeName: "lof", rangeList: lofRangeList, setDisableSaveBtn: setDisableSaveBtn }), (0, jsx_runtime_1.jsx)(RangeEditor, { rangeName: "cof", rangeList: cofRangeList, setDisableSaveBtn: setDisableSaveBtn })] })) })));
};
exports.RangeEditorDialog = RangeEditorDialog;
var RangeEditor = function (_a) {
    var rangeName = _a.rangeName, rangeList = _a.rangeList, setDisableSaveBtn = _a.setDisableSaveBtn;
    var stepValue = 0.01;
    var arr = __spreadArray([], rangeList, true);
    var classes = (0, RiskMatrixStyles_1.useRiskMatrixStyles)();
    var t = (0, stylovyze_1.useGlobalization)().t;
    var getMinValue = function (val) {
        return (val + 0.01).toFixed(2);
    };
    var getMaxValue = function (val) {
        return (val - 0.01).toFixed(2);
    };
    var _b = react_1.default.useState(arr[0].toString()), val1 = _b[0], setVal1 = _b[1];
    var _c = react_1.default.useState(arr[1].toString()), val2 = _c[0], setVal2 = _c[1];
    var _d = react_1.default.useState(arr[2].toString()), val3 = _d[0], setVal3 = _d[1];
    var _e = react_1.default.useState(arr[3].toString()), val4 = _e[0], setVal4 = _e[1];
    var _f = react_1.default.useState(arr[4].toString()), val5 = _f[0], setVal5 = _f[1];
    var checkConditions = function () {
        if (parseFloat(val1) > parseFloat('0') &&
            parseFloat(val1) < parseFloat(val2) &&
            parseFloat(val2) < parseFloat(val3) &&
            parseFloat(val3) < parseFloat(val4) &&
            parseFloat(val4) < parseFloat(val5)) {
            return true;
        }
        else
            return false;
    };
    var switchBtn = function () {
        if (checkConditions())
            setDisableSaveBtn(false);
        else
            setDisableSaveBtn(true);
    };
    (0, react_1.useEffect)(function () {
        switchBtn();
    }, [val1, val2, val3, val4, val5]);
    (0, react_1.useEffect)(function () {
        setDisableSaveBtn(true);
    }, []);
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.contentBody }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ dataCy: "range-editor-inforcard-".concat(rangeName), title: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: rangeName === 'lof' ? ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { display: 'block' } }, { children: [(0, jsx_runtime_1.jsx)("div", { children: t('LoF') }), (0, jsx_runtime_1.jsx)("div", __assign({ style: { fontWeight: 400 } }, { children: t('(Likelihood of Failure)') }))] }))) : ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { display: 'block' } }, { children: [(0, jsx_runtime_1.jsx)("div", { children: t('CoF') }), (0, jsx_runtime_1.jsx)("div", __assign({ style: { fontWeight: 400 } }, { children: t('(Consequence of Failure)') }))] }))) }) }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ style: { width: '265px' }, id: "range-editor-textbox-list" }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                        '& .MuiTextField-root': { m: 1, width: '125px' },
                    } }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                } }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ style: { margin: '0 20px 0 5px' } }, { children: (0, jsx_runtime_1.jsx)("span", { children: "\u2264" }) })), (0, jsx_runtime_1.jsx)(material_1.TextField, { size: "small", id: "outlined-number", type: "number", error: parseFloat(val1) < parseFloat('0.01') ||
                                            parseFloat(val1) >= parseFloat(val2), InputLabelProps: {
                                            shrink: true,
                                        }, InputProps: {
                                            inputProps: {
                                                min: stepValue,
                                                max: getMaxValue(parseFloat(val2)),
                                                step: stepValue,
                                            },
                                        }, value: val1, onChange: function (e) {
                                            setVal1(e.target.value);
                                        }, onBlur: function (e) {
                                            var val = e.target.value;
                                            rangeList[0] = +val;
                                        } })] })), (0, jsx_runtime_1.jsx)(material_1.Divider, { className: classes.rangeEditorDivider }), (0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                } }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ style: { margin: '0 20px 0 5px' } }, { children: (0, jsx_runtime_1.jsx)("span", { children: "\u2264" }) })), (0, jsx_runtime_1.jsx)(material_1.TextField, { size: "small", id: "outlined-number", type: "number", error: parseFloat(val2) <= parseFloat(val1) ||
                                            parseFloat(val2) >= parseFloat(val3), InputLabelProps: {
                                            shrink: true,
                                        }, InputProps: {
                                            inputProps: {
                                                min: getMinValue(parseFloat(val1)),
                                                max: getMaxValue(parseFloat(val3)),
                                                step: stepValue,
                                            },
                                        }, value: val2, onChange: function (e) {
                                            setVal2(e.target.value);
                                        }, onBlur: function (e) {
                                            var val = e.target.value;
                                            rangeList[1] = +val;
                                        } })] })), (0, jsx_runtime_1.jsx)(material_1.Divider, { className: classes.rangeEditorDivider }), (0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                } }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ style: { margin: '0 20px 0 5px' } }, { children: (0, jsx_runtime_1.jsx)("span", { children: "\u2264" }) })), (0, jsx_runtime_1.jsx)(material_1.TextField, { size: "small", id: "outlined-number", type: "number", error: parseFloat(val3) <= parseFloat(val2) ||
                                            parseFloat(val3) >= parseFloat(val4), InputLabelProps: {
                                            shrink: true,
                                        }, InputProps: {
                                            inputProps: {
                                                min: getMinValue(parseFloat(val2)),
                                                max: getMaxValue(parseFloat(val4)),
                                                step: stepValue,
                                            },
                                        }, value: val3, onChange: function (e) {
                                            setVal3(e.target.value);
                                        }, onBlur: function (e) {
                                            var val = e.target.value;
                                            rangeList[2] = +val;
                                        } })] })), (0, jsx_runtime_1.jsx)(material_1.Divider, { className: classes.rangeEditorDivider }), (0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                } }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ style: { margin: '0 20px 0 5px' } }, { children: (0, jsx_runtime_1.jsx)("span", { children: "\u2264" }) })), (0, jsx_runtime_1.jsx)(material_1.TextField, { size: "small", id: "outlined-number", type: "number", error: parseFloat(val4) <= parseFloat(val3) ||
                                            parseFloat(val4) > parseFloat(val5), InputLabelProps: {
                                            shrink: true,
                                        }, InputProps: {
                                            inputProps: {
                                                min: getMinValue(parseFloat(val3)),
                                                max: getMaxValue(parseFloat(val5)),
                                                step: stepValue,
                                            },
                                        }, value: val4, onChange: function (e) {
                                            setVal4(e.target.value);
                                        }, onBlur: function (e) {
                                            var val = e.target.value;
                                            rangeList[3] = +val;
                                        } })] })), (0, jsx_runtime_1.jsx)(material_1.Divider, { className: classes.rangeEditorDivider }), (0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                } }, { children: [(0, jsx_runtime_1.jsx)("span", __assign({ style: { margin: '0 20px 0 5px' } }, { children: (0, jsx_runtime_1.jsx)("span", { children: "\u2264" }) })), (0, jsx_runtime_1.jsx)(material_1.TextField, { size: "small", id: "outlined-number", type: "number", error: parseFloat(val5) <= parseFloat(val4), InputLabelProps: {
                                            shrink: true,
                                        }, InputProps: {
                                            inputProps: {
                                                min: getMinValue(parseFloat(val4)),
                                                step: stepValue,
                                            },
                                        }, value: val5, onChange: function (e) {
                                            setVal5(e.target.value);
                                        }, onBlur: function (e) {
                                            var val = e.target.value;
                                            rangeList[4] = +val;
                                        } })] }))] }) })) })) })) })));
};


/***/ }),

/***/ "./components/RiskGrade/RiskMatrixDataGrid.tsx":
/*!*****************************************************!*\
  !*** ./components/RiskGrade/RiskMatrixDataGrid.tsx ***!
  \*****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskMatrixGrid = exports.GetRiskMatrixColumns = exports.RiskMatrixCell = exports.lofCell = exports.cofHeaderCell = exports.lofHeaderCell = exports.RiskModeDropdown = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __importStar(__webpack_require__(/*! react */ "react"));
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var DoneSharp_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/DoneSharp */ "@mui/icons-material/DoneSharp"));
var ArrowForward_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/ArrowForward */ "@mui/icons-material/ArrowForward"));
var ArrowDownward_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/ArrowDownward */ "@mui/icons-material/ArrowDownward"));
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var Star_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/Star */ "@mui/icons-material/Star"));
var RiskMatrixStyles_1 = __webpack_require__(/*! ./RiskMatrixStyles */ "./components/RiskGrade/RiskMatrixStyles.ts");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var utils_RiskMatrix_1 = __webpack_require__(/*! ./utils.RiskMatrix */ "./components/RiskGrade/utils.RiskMatrix.ts");
var Skeleton_1 = __importDefault(__webpack_require__(/*! @mui/material/Skeleton */ "@mui/material/Skeleton"));
var Risk_actions_1 = __webpack_require__(/*! @Actions/Risk.actions */ "./actions/Risk.actions.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var utils_RiskMatrix_2 = __webpack_require__(/*! ./utils.RiskMatrix */ "./components/RiskGrade/utils.RiskMatrix.ts");
var RiskMatrixComponents_1 = __webpack_require__(/*! ./RiskMatrixComponents */ "./components/RiskGrade/RiskMatrixComponents.tsx");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var RiskModeDropdown = function (_a) {
    var setShowMethodSwitchDialog = _a.setShowMethodSwitchDialog;
    var riskType = (0, _Selectors_1.selectRiskType)();
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var classes = (0, RiskMatrixStyles_1.useRiskMatrixStyles)();
    var isPreviewLoading = (0, _Selectors_1.selectIsPreviewLoading)();
    var isRiskRunning = (0, _Selectors_1.selectRiskRunning)();
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.DropDownButton, { fitButtonToContent: true, switchSelected: false, disabled: isPreviewLoading || isRiskRunning, options: __spreadArray([
            {
                name: t('Risk Method'),
                cy: 'risk-method-dropdown-btn',
            }
        ], [
            { name: t('Linear'), riskType: 'linear' },
            { name: "5x5 ".concat(t('Matrix')), riskType: 'matrix' },
        ].map(function (_a, index) {
            var itemName = _a.name, itemRiskType = _a.riskType;
            return ({
                name: itemName,
                key: index,
                cy: "risk-method-dropdown-item-".concat(itemRiskType),
                icon: riskType === itemRiskType ? ((0, jsx_runtime_1.jsx)(DoneSharp_1.default, { className: classes.doneIcon })) : ((0, jsx_runtime_1.jsx)("span", { className: classes.doneIcon })),
                disabled: riskType === itemRiskType,
                onClick: function () {
                    setShowMethodSwitchDialog(true);
                },
            });
        }), true) }));
};
exports.RiskModeDropdown = RiskModeDropdown;
var lofHeaderCell = function () {
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var classes = (0, RiskMatrixStyles_1.useRiskMatrixStyles)();
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.lofcofheadercell, id: "lofheadercell" }, { children: [(0, jsx_runtime_1.jsx)(ArrowDownward_1.default, { className: classes.downIcon }), (0, jsx_runtime_1.jsx)("div", { children: t('LoF / CoF') }), (0, jsx_runtime_1.jsx)(ArrowForward_1.default, { className: classes.fwdIcon })] })));
};
exports.lofHeaderCell = lofHeaderCell;
var cofHeaderCell = function (rangeItem) {
    var classes = (0, RiskMatrixStyles_1.useRiskMatrixStyles)();
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.lofcofheadercell, id: "cofheadercell" }, { children: (0, jsx_runtime_1.jsxs)("div", { children: ["\u2264 ", rangeItem] }) })));
};
exports.cofHeaderCell = cofHeaderCell;
var lofCell = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
props) {
    var classes = (0, RiskMatrixStyles_1.useRiskMatrixStyles)();
    var value = props.value;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ id: "lof-cell", className: classes.lofCell }, { children: (0, jsx_runtime_1.jsxs)("div", { children: [" ", value, " "] }) })));
};
exports.lofCell = lofCell;
var RiskMatrixCell = function (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
props) {
    var _a;
    var value = props.value;
    var classes = (0, RiskMatrixStyles_1.useRiskMatrixStyles)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var refreshMatrixGrid = (0, _Selectors_1.selectRefreshMatrixGrid)();
    var enablePreview = (0, _Selectors_1.selectEnablePreview)();
    var isLoading = (0, _Selectors_1.selectIsLoading)();
    var isPreviewLoading = (0, _Selectors_1.selectIsPreviewLoading)();
    var isDataLoading = isLoading || isPreviewLoading;
    var editedList = (0, _Selectors_1.selectEditedCellsList)();
    var isOnlyGradesUpdated = (0, _Selectors_1.selectOnlyGradesUpdated)();
    var riskRunning = (0, _Selectors_1.selectRiskRunning)();
    var cancellPreview = (0, _Selectors_1.selectPreviewCancelled)();
    var _b = react_1.default.useState(value === null || value === void 0 ? void 0 : value.grade), grade = _b[0], setGrade = _b[1];
    var origGrade = react_1.default.useState((_a = value === null || value === void 0 ? void 0 : value.grade) !== null && _a !== void 0 ? _a : 'medium')[0];
    var _c = react_1.default.useState(null), anchorEl = _c[0], setAnchorEl = _c[1];
    var open = Boolean(anchorEl);
    function containsObject(obj) {
        for (var i = 0; i < editedList.length; i++) {
            if (editedList[i].x === obj.x && editedList[i].y === obj.y) {
                return true;
            }
        }
        return false;
    }
    (0, react_1.useEffect)(function () {
        if (value &&
            containsObject({ x: value.position.x, y: value.position.y })) {
            setGrade(origGrade);
        }
    }, [refreshMatrixGrid]);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var temp = (0, _Selectors_1.selectUpdatedRiskMatrixGrid)();
    var handleGradeChange = function (event) {
        var newGradeValue = event.currentTarget.innerText.toLowerCase();
        if (newGradeValue !== grade) {
            setGrade(newGradeValue);
            if (value) {
                var newArray = temp.filter(function (el) {
                    return (el.position.x !== value.position.x ||
                        el.position.y !== value.position.y);
                });
                temp = __spreadArray([], newArray, true);
                temp.push(__assign(__assign({}, value), { grade: newGradeValue }));
                dispatch((0, Risk_actions_1.setEditedCellsList)({
                    x: value.position.x,
                    y: value.position.y,
                }));
            }
        }
        dispatch((0, Risk_actions_1.setUpdatedScores)(temp));
        dispatch((0, Risk_actions_1.setOnlyGradesUpdated)(true));
        dispatch((0, Risk_actions_1.setDidMatrixUpdate)(true));
        dispatch((0, Risk_actions_1.setRiskSetupDirty)(true));
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    if (isDataLoading) {
        return (0, jsx_runtime_1.jsx)(Skeleton_1.default, { width: '90%', height: '100%' });
    }
    else if (enablePreview && !isOnlyGradesUpdated) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    }
    else if (riskRunning) {
        return ((0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: "".concat(value === null || value === void 0 ? void 0 : value.pipeCount, " pipes"), placement: "top", PopperProps: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -5],
                        },
                    },
                ],
            }, arrow: true }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ id: "gridcell-container", className: classes.gridCellContainer }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ id: "gridcell-button", role: "button", tabIndex: 0, className: classes.cellButton }, { children: [(0, jsx_runtime_1.jsx)(Star_1.default, { style: {
                                color: grade
                                    ? utils_RiskMatrix_2.legendsColors[grade]
                                    : 'rgb(239, 179, 4)',
                                width: '20px',
                                margin: '0px 5px -6px -3px',
                            } }), cancellPreview ? '-' : value === null || value === void 0 ? void 0 : value.pipeCount] })) })) })));
    }
    else {
        return ((0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: "".concat(value === null || value === void 0 ? void 0 : value.pipeCount, " pipes"), placement: "top", PopperProps: {
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -5],
                        },
                    },
                ],
            }, arrow: true }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ id: "gridcell-container", className: classes.gridCellContainer }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ id: "gridcell-button", "aria-controls": open ? 'risk-legend-menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: handleClick, onKeyDown: function () {
                            return null;
                        }, role: "button", tabIndex: 0, className: classes.cellButton }, { children: [(0, jsx_runtime_1.jsx)(Star_1.default, { style: {
                                    color: grade
                                        ? utils_RiskMatrix_2.legendsColors[grade]
                                        : 'rgb(239, 179, 4)',
                                    width: '20px',
                                    margin: '0px 5px -6px -3px',
                                } }), cancellPreview ? '-' : value === null || value === void 0 ? void 0 : value.pipeCount] })), (0, jsx_runtime_1.jsx)(RiskMatrixComponents_1.RiskLegendMenu, { anchorEl: anchorEl, open: open, selectedGrade: grade !== null && grade !== void 0 ? grade : 'medium', handleClose: handleClose, handleGradeChange: handleGradeChange })] })) })));
    }
};
exports.RiskMatrixCell = RiskMatrixCell;
var GetRiskMatrixColumns = function () {
    var headersList = new Array();
    var ranges = (0, _Selectors_1.selectUpdatedRiskRanges)();
    var formattedCofRanges = (0, utils_RiskMatrix_2.generateRangeLabels)(ranges.cofRanges);
    //add first column header - always remains same
    headersList.push({
        field: 'lofCof',
        renderHeader: exports.lofHeaderCell,
        headerClassName: 'lofHeaderCellClass',
        sortable: false,
        hideable: false,
        align: 'right',
        headerAlign: 'center',
        type: 'string',
        flex: 1,
        minWidth: 118,
        renderCell: exports.lofCell,
        cellClassName: 'lofHeaderCellClass', //defined in StyledRiskMatrixDataGrid
    });
    //add rest of the column headers - comes from api data
    formattedCofRanges.forEach(function (rangeItem) {
        headersList.push({
            field: rangeItem,
            renderHeader: function () { return (0, exports.cofHeaderCell)(rangeItem); },
            sortable: false,
            hideable: false,
            align: 'left',
            headerAlign: 'left',
            flex: 1,
            minWidth: 95,
            renderCell: exports.RiskMatrixCell,
            cellClassName: 'scoreCell', //defined in StyledRiskMatrixDataGrid
        });
    });
    return headersList;
};
exports.GetRiskMatrixColumns = GetRiskMatrixColumns;
var GetRiskMatrixRows = function (matrixGrid) {
    var gridCellsList = (0, utils_RiskMatrix_1.getSortedGridData)(matrixGrid);
    var ranges = (0, _Selectors_1.selectUpdatedRiskRanges)();
    //get formatted values of API data -need to be flipped to correctly display data in Datagrid.
    var formattedLofRanges = (0, utils_RiskMatrix_2.generateRangeLabels)(ranges.cofRanges);
    var formattedCofRanges = (0, utils_RiskMatrix_2.generateRangeLabels)(ranges.lofRanges, true);
    var getCellValObjs = function (rowIndex) {
        var tempGridRow = gridCellsList[rowIndex];
        var mappedObj = formattedLofRanges.map(function (value, index) {
            return [formattedLofRanges[index], tempGridRow[index]];
        });
        var obj = Object.fromEntries(mappedObj);
        return obj;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var gridRowsList = [];
    formattedCofRanges.forEach(function (item, key) {
        var scores = getCellValObjs(key);
        var gridRow = __assign({ id: key, lofCof: item }, scores);
        gridRowsList.push(gridRow);
    });
    return gridRowsList;
};
//**** MAIN COMPONENT - DATAGRID for Risk Matrix ****************/
var RiskMatrixGrid = function () {
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var classes = (0, RiskMatrixStyles_1.useRiskMatrixStyles)();
    var _a = react_1.default.useState(false), showEditRangesDialog = _a[0], setShowEditRangesDialog = _a[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var riskSetting = (0, _Selectors_1.selectRiskSetting)();
    var configId = riskSetting.configId;
    var prevStatus = (0, _Selectors_1.selectPreviewStatus)();
    var matrixGrid = (0, _Selectors_1.selectUpdatedRiskMatrixGrid)();
    var isPreviewOnLoad = (0, _Selectors_1.selectIsPreviewOnLoad)();
    var cancellPreview = (0, _Selectors_1.selectPreviewCancelled)();
    //=========poll for preview=====//
    var _b = (0, react_1.useState)(), checkRiskPreviewStatusCounter = _b[0], setCheckRiskPreviewStatusCounter = _b[1];
    var _c = (0, react_1.useState)(), ticker = _c[0], setTicker = _c[1];
    var refreshRiskPreviewStatus = function () {
        dispatch((0, Risk_actions_1.getRiskMatrixPreview)({
            configId: configId,
            initialLoad: isPreviewOnLoad,
        }));
    };
    var isRiskConfigPreviewRunning = function (value) {
        return [
            'risk-calc-matrix-preview-in-progress',
            'risk-calc-matrix-preview-start',
            'risk-calc-matrix-preview-initiated',
        ].includes(value !== null && value !== void 0 ? value : prevStatus);
    };
    (0, react_1.useEffect)(function () {
        if (checkRiskPreviewStatusCounter && isRiskConfigPreviewRunning()) {
            setTicker(setTimeout(function () {
                setCheckRiskPreviewStatusCounter(checkRiskPreviewStatusCounter + 1);
            }, 5000));
        }
    }, [checkRiskPreviewStatusCounter]);
    (0, react_1.useEffect)(function () {
        if (ticker) {
            refreshRiskPreviewStatus();
        }
    }, [ticker]);
    (0, react_1.useEffect)(function () {
        if (cancellPreview) {
            clearTimeout(ticker);
            setTicker(undefined);
        }
        else if (prevStatus) {
            if (ticker) {
                if (!isRiskConfigPreviewRunning()) {
                    clearTimeout(ticker);
                    setTicker(undefined);
                }
            }
            else if (isRiskConfigPreviewRunning()) {
                setCheckRiskPreviewStatusCounter(1);
            }
        }
    }, [prevStatus, cancellPreview]);
    //======poller==============
    var RiskMatrixHeader = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: classes.matrixHeaderContainer }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.matrixHeaderText }, { children: '5x5 ' + t('Matrix') })) })), (0, jsx_runtime_1.jsx)(material_1.Divider, {})] }));
    };
    var RiskMatrixFooter = function () {
        var ranges = (0, _Selectors_1.selectUpdatedRiskRanges)();
        var cofRanges = __spreadArray([], ranges.cofRanges, true);
        var lofRanges = __spreadArray([], ranges.lofRanges, true);
        var isLoading = (0, _Selectors_1.selectIsLoading)();
        var isPreviewLoading = (0, _Selectors_1.selectIsPreviewLoading)();
        var isDataLoading = isLoading || isPreviewLoading;
        var riskRunning = (0, _Selectors_1.selectRiskRunning)();
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ id: "risk-grade-legends-list", className: classes.legendsList }, { children: utils_RiskMatrix_2.legends.map(function (legend, key) { return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.matrixFooterLegendDiv }, { children: [(0, jsx_runtime_1.jsx)(Star_1.default, { style: {
                                    width: '16px',
                                    marginBottom: '2px',
                                    color: legend.color,
                                } }), (0, jsx_runtime_1.jsx)("span", __assign({ className: classes.legendSpans }, { children: t(legend.name.toUpperCase()) }))] }), key)); }) })), (0, jsx_runtime_1.jsx)(material_1.Divider, {}), (0, jsx_runtime_1.jsx)("div", __assign({ id: "matrix-footer-container", className: classes.matrixFooterContainer }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ id: "matrix-footer-btn-edit-ranges", variant: "outlined", color: "primary", className: classes.matrixFooterEditBtn, disabled: isDataLoading || riskRunning, onClick: function () { return setShowEditRangesDialog(true); } }, { children: t('Edit Ranges') })) })), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(RiskMatrixComponents_1.RangeEditorDialog, { showEditRangesDialog: showEditRangesDialog, setShowEditRangesDialog: setShowEditRangesDialog, cofRangeList: cofRanges, lofRangeList: lofRanges }) })] }));
    };
    return ((0, jsx_runtime_1.jsx)(RiskMatrixStyles_1.StyledRiskMatrixDataGrid, { dataCy: "risk-matrix-data-grid", disableColumnMenu: true, disableColumnReorder: true, skeletonRowCount: 5, columns: (0, exports.GetRiskMatrixColumns)(), rows: GetRiskMatrixRows(matrixGrid), slots: {
            toolbar: RiskMatrixHeader,
            footer: RiskMatrixFooter,
        } }));
};
exports.RiskMatrixGrid = RiskMatrixGrid;


/***/ }),

/***/ "./components/RiskGrade/RiskMatrixStyles.ts":
/*!**************************************************!*\
  !*** ./components/RiskGrade/RiskMatrixStyles.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledRiskMatrixDataGrid = exports.useRiskMatrixStyles = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var styles_1 = __webpack_require__(/*! @mui/styles */ "@mui/styles");
exports.useRiskMatrixStyles = (0, styles_1.makeStyles)(function () {
    return (0, styles_1.createStyles)({
        header: {
            backgroundColor: '#f7f7f7',
            justifyContent: 'space-evenly',
        },
        lofcofheadercell: {
            display: 'flex',
            alignItems: 'center',
            padding: '10px 10px 0',
            fontWeight: 'bold',
        },
        lofCell: {
            fontWeight: 'bold',
            '&:before': { content: '"\\2264"' },
            '& > div:nth-of-type(1)': {
                width: '2.5rem',
                display: 'inline-block',
                textAlign: 'right',
            },
        },
        doneIcon: {
            width: '1.3rem',
            marginRight: '3px',
        },
        dummyIcon: {
            width: '1.3rem',
            marginRight: '3px',
            color: '#ffffff',
        },
        fwdIcon: { marginLeft: '0px', width: '16px' },
        downIcon: { width: '16px' },
        gridCellContainer: {
            overflow: 'hidden',
            cursor: 'pointer',
            padding: '0 10px',
        },
        cellButton: {
            color: '#3c3c3c',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
        },
        matrixHeaderContainer: {
            height: '60px',
            display: 'flex',
            backgroundColor: '#ffffff',
            padding: '0.9375rem 0.9375rem 0.9375rem 1.5rem',
            alignItems: 'center',
        },
        matrixHeaderText: {
            margin: '5px',
            fontStyle: 'normal',
            fontSize: '18px',
            fontWeight: '600',
            color: '#272833',
        },
        matrixFooterContainer: {
            backgroundColor: '#ffffff',
            height: '70px',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'row-reverse',
        },
        matrixFooterLegendDiv: { display: 'flex', alignItems: 'center' },
        matrixFooterEditBtn: { margin: '10px 10px 10px 0px' },
        matrixFooterPreviewBtn: { margin: '10px' },
        legendsList: {
            display: 'flex',
            alignItems: 'center',
            backgroundColor: '#ffffff',
            height: '50px',
            padding: '10px',
            borderTop: '2px solid #e7e7ed',
        },
        legendSpans: {
            fontSize: '11px',
            color: '#999999',
            margin: '0px 15px 0px 2px',
        },
        gridCellMenuItemContainer: {
            display: 'flex',
            justifyContent: 'flex-start',
        },
        gridCellMenuItemDoneIconContainer: {
            position: 'absolute',
            right: '12px',
        },
        gridCellMenuItemDoneIcon: {
            width: '1.5rem',
            margin: '0px 3px 4px 0px',
        },
        gridCellMenuItemLegendName: { textTransform: 'capitalize' },
        gridCellMenuItemIconContainer: { marginRight: '-8px' },
        dialogBoxStyle: {
            minWidth: '700px',
        },
        rangeEditorDivider: {
            margin: '10px 0px 5px 0px',
        },
        contentBody: {
            '& .ContentCard--body': {
                padding: '0.6rem 1.5rem 0.7rem 1.5rem',
            },
        },
    });
});
exports.StyledRiskMatrixDataGrid = (0, styles_1.styled)(stylovyze_1.DataGrid)(function () { return ({
    height: '100%',
    width: '100%',
    '& .lofHeaderCellClass': {
        backgroundColor: '#f7f7f7',
        borderRight: '2px solid #e7e7ed',
    },
    '& .scoreCell': {
        backgroundColor: '#ffffff',
    },
}); });


/***/ }),

/***/ "./components/RiskGrade/RiskNormalize.component.tsx":
/*!**********************************************************!*\
  !*** ./components/RiskGrade/RiskNormalize.component.tsx ***!
  \**********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskNormalize = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var Help_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/Help */ "@mui/icons-material/Help"));
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var RiskNormalize_styles_1 = __webpack_require__(/*! ./RiskNormalize.styles */ "./components/RiskGrade/RiskNormalize.styles.ts");
var RiskNormalize = function (_a) {
    var isLoading = _a.isLoading, normalizeSettings = _a.normalizeSettings, onNormalizeChanged = _a.onNormalizeChanged;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var contents = function () {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(RiskNormalize_styles_1.Heading, { children: t('What does it mean to Normalize Risk Scores?') }), (0, jsx_runtime_1.jsxs)(RiskNormalize_styles_1.Content, { children: [(0, jsx_runtime_1.jsx)("b", { children: t('Normalization Equation:') }), (0, jsx_runtime_1.jsx)("br", {}), t('( PRS / HCRS ) * NV'), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsxs)(RiskNormalize_styles_1.Key, { children: [t('    PRS = Pipe Risk Score'), (0, jsx_runtime_1.jsx)("br", {}), t('    HCRS  = Highest Calculated Risk Score'), (0, jsx_runtime_1.jsx)("br", {}), t('    NV = Normalization Value')] }), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("b", { children: t('Example:') }), (0, jsx_runtime_1.jsx)("br", {}), t('Pipe Risk Score = 233'), (0, jsx_runtime_1.jsx)("br", {}), t('Highest Calculated Risk Score = 545'), (0, jsx_runtime_1.jsx)("br", {}), t('Normalization Value = 100'), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), t('Normalized Score = (233/545)*100 = 42.75'), (0, jsx_runtime_1.jsx)("br", {})] })] }));
    };
    var onCheckUseNormalization = function () {
        onNormalizeChanged(!normalizeSettings.useNormalize, normalizeSettings.normalizeValue);
    };
    var onNormalizeValueChange = function (value) {
        onNormalizeChanged(normalizeSettings.useNormalize, value);
    };
    var cardTitle = function () {
        return ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: 'row', alignItems: 'center' }, { children: [t('Normalize Risk Scores'), (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTooltip, __assign({ title: contents(), padded: true }, { children: (0, jsx_runtime_1.jsx)(Help_1.default, { color: "secondary", style: { marginLeft: '10px' } }) }))] })));
    };
    return ((0, jsx_runtime_1.jsxs)(stylovyze_1.InfoCard, __assign({ title: cardTitle() }, { children: [(0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { disabled: isLoading, control: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { checked: normalizeSettings.useNormalize, onChange: onCheckUseNormalization }), label: t('Use Normalization 0 to') }), (0, jsx_runtime_1.jsx)(material_1.TextField, { disabled: isLoading || !normalizeSettings.useNormalize, style: {
                    width: '100px',
                    verticalAlign: 'text-top',
                }, value: normalizeSettings.normalizeValue, onChange: function (e) {
                    var value = parseFloat(e.target.value);
                    if (!isNaN(value)) {
                        if (value < 1)
                            value = 1;
                        value = Math.round(value * 100) / 100;
                    }
                    onNormalizeValueChange(value);
                }, onBlur: function (e) {
                    var value = parseFloat(e.target.value);
                    if (isNaN(value))
                        value = 1;
                    onNormalizeValueChange(Math.round(value * 100) / 100);
                }, inputProps: {
                    step: '1',
                    min: 1,
                }, variant: "standard", type: "number", size: "small" })] })));
};
exports.RiskNormalize = RiskNormalize;


/***/ }),

/***/ "./components/RiskGrade/RiskNormalize.styles.ts":
/*!******************************************************!*\
  !*** ./components/RiskGrade/RiskNormalize.styles.ts ***!
  \******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Key = exports.Content = exports.Heading = void 0;
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
exports.Heading = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tcolor: #252f33;\n\tmargin-bottom: ", ";\n"], ["\n\tcolor: #252f33;\n\tmargin-bottom: ", ";\n"])), (0, stylovyze_1.rem)(5));
exports.Content = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tcolor: ", ";\n"], ["\n\tcolor: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.secondary.dark;
});
exports.Key = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tbackground: rgba(217, 217, 217, 0.2);\n\tpadding: ", ";\n"], ["\n\tbackground: rgba(217, 217, 217, 0.2);\n\tpadding: ", ";\n"])), (0, stylovyze_1.rem)(10));
var templateObject_1, templateObject_2, templateObject_3;


/***/ }),

/***/ "./components/RiskGrade/index.ts":
/*!***************************************!*\
  !*** ./components/RiskGrade/index.ts ***!
  \***************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./RiskGrade */ "./components/RiskGrade/RiskGrade.tsx"), exports);


/***/ }),

/***/ "./components/RiskGrade/utils.RiskMatrix.ts":
/*!**************************************************!*\
  !*** ./components/RiskGrade/utils.RiskMatrix.ts ***!
  \**************************************************/
/***/ (function(__unused_webpack_module, exports) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getSortedGridData = exports.legends = exports.legendsColors = exports.generateRangeLabels = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
var generateRangeLabels = function (boundaryRanges, reverse) {
    var rangeLabels = [];
    if (boundaryRanges.length === 0) {
        return [];
    }
    for (var _i = 0, boundaryRanges_1 = boundaryRanges; _i < boundaryRanges_1.length; _i++) {
        var range = boundaryRanges_1[_i];
        var temp = range.toFixed(2);
        rangeLabels.push(temp);
    }
    if (!reverse)
        return rangeLabels;
    else
        return rangeLabels.reverse();
};
exports.generateRangeLabels = generateRangeLabels;
exports.legendsColors = {
    negligible: 'rgb(0, 124, 160)',
    low: 'rgb(74, 126, 4)',
    medium: 'rgb(239, 179, 4)',
    high: 'rgb(255, 122, 0)',
    extreme: 'rgb(170, 0, 0)',
};
exports.legends = [
    { name: 'negligible', color: exports.legendsColors.negligible },
    { name: 'low', color: exports.legendsColors.low },
    { name: 'medium', color: exports.legendsColors.medium },
    { name: 'high', color: exports.legendsColors.high },
    { name: 'extreme', color: exports.legendsColors.extreme },
];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var getSortedGridData = function (data) {
    var tempDataCopy = __spreadArray([], data, true);
    var gridData = [];
    //get numbered positions
    tempDataCopy.forEach(function (obj) {
        var concatd = "".concat(obj.position.x).concat(obj.position.y);
        gridData.push(__assign(__assign({}, obj), { calculatedPosition: Number(concatd) }));
    });
    gridData.sort(function (a, b) {
        if (a.position.y !== b.position.y) {
            return b.position.y - a.position.y; // Sort by y in descending order
        }
        return a.position.x - b.position.x; // Sort by x in ascending order
    });
    //create array of arrays to separate rows
    var newGridData = [];
    for (var i = 0; i < gridData.length; i += 5) {
        var row = [];
        for (var j = i; j < i + 5; j++) {
            delete gridData[j].calculatedPosition;
            row.push(gridData[j]);
        }
        newGridData.push(row);
    }
    return newGridData;
};
exports.getSortedGridData = getSortedGridData;


/***/ }),

/***/ "./components/RiskList/RiskList.component.tsx":
/*!****************************************************!*\
  !*** ./components/RiskList/RiskList.component.tsx ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var react_1 = __webpack_require__(/*! react */ "react");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var RiskListCard_style_1 = __webpack_require__(/*! ./RiskListCard.style */ "./components/RiskList/RiskListCard.style.tsx");
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var NewRisk_1 = __importDefault(__webpack_require__(/*! @Components/Utils/icons/NewRisk */ "./components/Utils/icons/NewRisk.tsx"));
var RiskListCard_component_1 = __importDefault(__webpack_require__(/*! ./RiskListCard.component */ "./components/RiskList/RiskListCard.component.tsx"));
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var Selectors_1 = __webpack_require__(/*! @innovyze/lib-am-common/Selectors */ "@innovyze/lib-am-common/Selectors");
var NewRisk_2 = __webpack_require__(/*! @Components/NewRisk */ "./components/NewRisk/index.ts");
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var Risk_actions_1 = __webpack_require__(/*! @Actions/Risk.actions */ "./actions/Risk.actions.ts");
var Actions_1 = __webpack_require__(/*! @innovyze/lib-am-common/Actions */ "@innovyze/lib-am-common/Actions");
var RiskList_style_1 = __webpack_require__(/*! ./RiskList.style */ "./components/RiskList/RiskList.style.ts");
var riskConfig_types_1 = __webpack_require__(/*! @Types/riskConfig.types */ "./types/riskConfig.types.ts");
var useSystemTypes_1 = __webpack_require__(/*! @Hooks/useSystemTypes */ "./hooks/useSystemTypes.ts");
var RiskList = function () {
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var subscriptions = (0, stylovyze_1.getSubscriptions)();
    var hasFullAccess = (0, shared_utils_1.fullAccess)(subscriptions);
    var enableAddNew = (0, stylovyze_1.useIsFeatureEnabled)('info-360-asset-multiple-risk-models-create');
    var riskPage = (0, Selectors_1.selectRiskConfigsPage)();
    var pagination = (0, Selectors_1.selectRiskConfigsPagination)();
    var isLoading = (0, Selectors_1.selectRiskConfigsIsLoading)();
    var isWaiting = (0, Selectors_1.selectRiskConfigsIsWaiting)();
    var isCreating = (0, Risk_selectors_1.selectRiskConfigIsCreating)();
    var isDeleting = (0, Risk_selectors_1.selectRiskIsDeleting)();
    var _a = (0, react_1.useState)(''), configId = _a[0], setConfigId = _a[1];
    var _b = (0, react_1.useState)(false), openDelete = _b[0], setOpenDelete = _b[1];
    var _c = (0, react_1.useState)(undefined), duplicateRiskModel = _c[0], setDuplicateRiskModel = _c[1];
    var _d = (0, react_1.useState)(false), isBlockDeleteDialogOpen = _d[0], setIsBlockDeleteDialogOpen = _d[1];
    var _f = (0, react_1.useState)(false), newModel = _f[0], setNewModel = _f[1];
    var refreshList = (0, Risk_selectors_1.selectRefreshList)();
    var dispatchSliceFn = function (slice) {
        return dispatch((0, Actions_1.changeRiskConfigsSlice)(slice));
    };
    var rowsPerPage = (0, Selectors_1.selectRiskConfigsPerPage)(dispatchSliceFn);
    var systemTypes = (0, useSystemTypes_1.useSystemTypes)();
    var sortOptions = [
        { id: 'createdAt-D', caption: t('Date Created/Modified - Descending') },
        { id: 'createdAt-A', caption: t('Date Created/Modified - Ascending') },
        { id: 'name-D', caption: t('Name - Descending') },
        { id: 'name-A', caption: t('Name - Ascending') },
        { id: 'lastRun-D', caption: t('Last Run - Descending') },
        { id: 'lastRun-A', caption: t('Last Run - Ascending') },
        { id: 'runBy-D', caption: t('Run By - Descending') },
        { id: 'runBy-A', caption: t('Run By - Ascending') },
    ];
    var _g = (0, react_1.useState)('createdAt-D'), selectedSort = _g[0], setSelectedSort = _g[1];
    var options = sortOptions.map(function (idCaption) {
        return ((0, jsx_runtime_1.jsx)(material_1.MenuItem, __assign({ value: idCaption.id }, { children: idCaption.caption }), idCaption.id));
    });
    var onRefresh = function () {
        dispatch((0, Actions_1.changeRiskConfigsPage)(riskPage.page));
        dispatch((0, Actions_1.getAssetCounts)(systemTypes.map(function (s) { return s.id; })));
    };
    (0, react_1.useEffect)(function () {
        if (refreshList) {
            onRefresh();
            dispatch((0, Risk_actions_1.setRefreshList)(false));
        }
        if (pagination && pagination.sortKey) {
            setSelectedSort("".concat(pagination.sortKey, "-").concat(pagination.sortDescending ? 'D' : 'A'));
        }
    }, []);
    var handleDuplicateRisk = function (riskConfig) {
        setDuplicateRiskModel(riskConfig);
        setNewModel(true);
    };
    var handleDeleteRisk = function (id, publishState) {
        if (publishState === riskConfig_types_1.ConfigPublishState.unpublished) {
            setConfigId(id);
            setOpenDelete(true);
        }
        else {
            setIsBlockDeleteDialogOpen(true);
        }
    };
    var handleDeleteConfirmYes = function () {
        dispatch((0, Risk_actions_1.deleteRisk)({
            configId: configId,
            refresh: onRefresh,
        }));
        setOpenDelete(false);
    };
    var handleDeleteConfirmNo = function () {
        setOpenDelete(false);
    };
    var onClickOpenCreateNewModel = function () {
        if (!(isLoading || isWaiting || isDeleting || isCreating)) {
            dispatch((0, Risk_actions_1.setRiskType)('linear'));
            setNewModel(true);
        }
    };
    var onNewModelClose = function () {
        setNewModel(false);
        setDuplicateRiskModel(undefined);
    };
    var createRiskCard = function () {
        return ((0, jsx_runtime_1.jsx)(RiskListCard_style_1.NewModelCardWrapper, { children: (0, jsx_runtime_1.jsx)(material_1.CardContent, __assign({ style: { height: '100%' } }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ role: "button", onClick: function () { return onClickOpenCreateNewModel(); }, onKeyDown: function () { return onClickOpenCreateNewModel(); }, tabIndex: 0, className: "model-create_card__icon", "data-cy": "new-model" }, { children: [(0, jsx_runtime_1.jsx)(NewRisk_1.default, {}), (0, jsx_runtime_1.jsx)("div", __assign({ className: "model-create_card__note" }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ gutterBottom: true, variant: "subtitle1" }, { children: t('Create New Risk Model') })) }))] })) })) }));
    };
    var sortChange = function (event) {
        var target = event === null || event === void 0 ? void 0 : event.target;
        var sort = target.value.split('-');
        dispatch((0, Actions_1.changeRiskConfigsSort)({
            key: sort[0],
            descending: sort[1] === 'D',
        }));
        setSelectedSort(target.value);
    };
    // This stops the dialog closing when clicked on the background
    var onCloseDialog = function () { return void {}; };
    var dialogProps = {
        open: openDelete,
        onClose: onCloseDialog,
    };
    var renderBlockRiskDeleteDialog = (0, react_1.useCallback)(function () {
        return ((0, jsx_runtime_1.jsx)(stylovyze_1.WarningDialog, { open: isBlockDeleteDialogOpen, title: t('Risk Model Cannot be Deleted'), content: t('You cannot delete a Risk Model that is published. Unpublish and try deleting again.'), cancelText: t('Close'), onCancel: function () { return setIsBlockDeleteDialogOpen(false); } }));
    }, [isBlockDeleteDialogOpen]);
    return ((0, jsx_runtime_1.jsxs)(styles_1.FullPage, __assign({ className: isLoading || isWaiting || isDeleting || isCreating ? 'wait' : '' }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.WarningDialog, { dialogProps: dialogProps, "data-cy": "delete-dialog", open: openDelete, title: t('Delete Risk?'), content: t('Are you sure you want to delete this Risk Model?'), cancelText: t('Cancel'), cancelButtonProps: {
                    disabled: isDeleting,
                    dataCy: 'delete-cancel',
                }, confirmText: t('Delete'), confirmButtonProps: {
                    disabled: isDeleting,
                    dataCy: 'delete-confirm',
                }, onCancel: handleDeleteConfirmNo, onConfirm: handleDeleteConfirmYes }), renderBlockRiskDeleteDialog(), (0, jsx_runtime_1.jsx)(NewRisk_2.NewRisk, { open: newModel, duplicate: duplicateRiskModel, onClose: onNewModelClose }), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 2, direction: "row" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 10, sm: 6, md: 4, lg: 3, xl: 2 }, { children: (0, jsx_runtime_1.jsxs)(material_1.FormControl, __assign({ fullWidth: true, variant: "standard" }, { children: [(0, jsx_runtime_1.jsx)(material_1.InputLabel, { children: t('Sort By') }), (0, jsx_runtime_1.jsx)(material_1.Select, __assign({ "data-cy": "sort-by", value: selectedSort, disabled: isLoading ||
                                        isWaiting ||
                                        isDeleting ||
                                        isCreating, name: t('Sort By'), onChange: sortChange }, { children: options }))] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 2, sm: 6, md: 8, lg: 9, xl: 10, container: true, justifyContent: "flex-end", "data-cy": "grid-actionbutton" }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.DataGridButton, { type: stylovyze_1.DataGridButtonType.REFRESH, disabled: isWaiting, "data-cy": "refreshButton", onClick: onRefresh }) })), hasFullAccess && enableAddNew ? ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, sm: 6, md: 4, lg: 3, xl: 3, item: true }, { children: createRiskCard() }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})), riskPage === null || riskPage === void 0 ? void 0 : riskPage.cards.map(function (riskModel) { return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ xs: 12, sm: 6, md: 4, lg: 3, xl: 3, item: true }, { children: (0, jsx_runtime_1.jsx)(RiskListCard_component_1.default, { riskConfig: riskModel, onDuplicateRisk: handleDuplicateRisk, onDeleteRisk: handleDeleteRisk }) }), riskModel === null || riskModel === void 0 ? void 0 : riskModel.configId)); }), !isWaiting ? ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, container: true, xs: 12, style: {
                            padding: "".concat((0, stylovyze_1.rem)(16), " ").concat((0, stylovyze_1.rem)(24)),
                        } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, container: true, xs: 6 }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: 'row', spacing: '1rem', alignItems: 'center', justifyContent: 'space-between' }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "text-large" }, { children: t('Models per page:') })), (0, jsx_runtime_1.jsx)(stylovyze_1.DropDownButton, { arrow: true, color: "secondary", options: rowsPerPage.options, placement: "bottom-start", variant: "text", initialSelectedIndex: rowsPerPage.selectedIndex, fitButtonToContent: true, fitMenuToContent: true })] })) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6 }, { children: riskPage.pages > 1 ? ((0, jsx_runtime_1.jsxs)(RiskList_style_1.FlexStyledGrid, { children: [(0, jsx_runtime_1.jsx)(RiskList_style_1.StyledPagination, { count: pagination.pages, page: pagination.page, onChange: function (_e, page) {
                                                dispatch((0, Actions_1.changeRiskConfigsPage)(page));
                                                dispatch((0, Actions_1.getAssetCounts)(systemTypes.map(function (s) { return s.id; })));
                                            }, variant: "outlined" }), (0, jsx_runtime_1.jsx)(RiskList_style_1.StyledText, __assign({ variant: "caption-small" }, { children: t('{{from}}-{{to}} of {{total}}', {
                                                from: (pagination.page - 1) *
                                                    pagination.slice +
                                                    1,
                                                to: pagination.page ==
                                                    pagination.pages
                                                    ? pagination.total
                                                    : pagination.page *
                                                        pagination.slice,
                                                total: pagination.total,
                                            }) }))] })) : ([]) }))] }))) : ([])] }))] })));
};
exports["default"] = RiskList;


/***/ }),

/***/ "./components/RiskList/RiskList.style.ts":
/*!***********************************************!*\
  !*** ./components/RiskList/RiskList.style.ts ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.StyledPagination = exports.StyledText = exports.FlexStyledGrid = void 0;
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
exports.FlexStyledGrid = (0, styled_components_1.default)(material_1.Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex: 1 1 100%;\n\tflex-direction: column;\n\tpadding: ", ";\n\talign-items: center;\n"], ["\n\tdisplay: flex;\n\tflex: 1 1 100%;\n\tflex-direction: column;\n\tpadding: ", ";\n\talign-items: center;\n"])), function (props) { return (props.padding ? props.padding : (0, stylovyze_1.rem)(16) + (0, stylovyze_1.rem)(24)); });
exports.StyledText = (0, styled_components_1.default)(stylovyze_1.Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\talign-self: flex-end;\n\tmargin-left: auto;\n\tmargin-top: ", ";\n\tmargin-right: ", ";\n"], ["\n\talign-self: flex-end;\n\tmargin-left: auto;\n\tmargin-top: ", ";\n\tmargin-right: ", ";\n"])), (0, stylovyze_1.rem)(3), (0, stylovyze_1.rem)(3));
exports.StyledPagination = (0, styled_components_1.default)(material_1.Pagination)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin-left: auto;\n\tul {\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tfont-size: 1em;\n\t\tline-height: 1em;\n\t}\n\n\t.Mui-selected {\n\t\tborder: 1px solid #007ca0;\n\t\tbackground-color: transparent;\n\t}\n"], ["\n\tmargin-left: auto;\n\tul {\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tfont-size: 1em;\n\t\tline-height: 1em;\n\t}\n\n\t.Mui-selected {\n\t\tborder: 1px solid #007ca0;\n\t\tbackground-color: transparent;\n\t}\n"])));
var templateObject_1, templateObject_2, templateObject_3;


/***/ }),

/***/ "./components/RiskList/RiskListCard.component.tsx":
/*!********************************************************!*\
  !*** ./components/RiskList/RiskListCard.component.tsx ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
/* eslint-disable react/prop-types */
var react_1 = __webpack_require__(/*! react */ "react");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
__webpack_require__(/*! ./risk-card.css */ "./components/RiskList/risk-card.css");
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var Utils_1 = __webpack_require__(/*! @innovyze/lib-am-common/Utils */ "@innovyze/lib-am-common/Utils");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
var Risk_actions_1 = __webpack_require__(/*! @Actions/Risk.actions */ "./actions/Risk.actions.ts");
var Selectors_1 = __webpack_require__(/*! @innovyze/lib-am-common/Selectors */ "@innovyze/lib-am-common/Selectors");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var Actions_1 = __webpack_require__(/*! @innovyze/lib-am-common/Actions */ "@innovyze/lib-am-common/Actions");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var CheckCircle_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/CheckCircle */ "@mui/icons-material/CheckCircle"));
var RemoveCircle_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/RemoveCircle */ "@mui/icons-material/RemoveCircle"));
var Help_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/Help */ "@mui/icons-material/Help"));
var FilterAlt_1 = __importDefault(__webpack_require__(/*! @mui/icons-material/FilterAlt */ "@mui/icons-material/FilterAlt"));
var colors_1 = __webpack_require__(/*! @mui/material/colors */ "@mui/material/colors");
var riskConfig_types_1 = __webpack_require__(/*! @Types/riskConfig.types */ "./types/riskConfig.types.ts");
var lib_asset_schema_store_1 = __webpack_require__(/*! @innovyze/lib_asset_schema_store */ "@innovyze/lib_asset_schema_store");
var FilteredResultCount = styled_components_1.default.div({
    display: 'inline-block',
    cursor: 'help',
    '& svg.MuiSvgIcon-root': {
        verticalAlign: 'bottom',
        marginLeft: '0.2em',
        paddingTop: '6px',
        opacity: 0.8,
    },
});
var RiskListCard = function (_a) {
    var _b, _c, _d, _e;
    var riskConfig = _a.riskConfig, onDuplicateRisk = _a.onDuplicateRisk, onDeleteRisk = _a.onDeleteRisk;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var history = (0, react_router_dom_1.useHistory)();
    var subscriptions = (0, stylovyze_1.getSubscriptions)();
    var hasFullAccess = (0, shared_utils_1.fullAccess)(subscriptions);
    var riskNormalizeFlag = (0, stylovyze_1.useIsFeatureEnabled)('info-360-asset-risk-normalize');
    var isSaveFilterOn = !!(0, stylovyze_1.useIsFeatureEnabled)('info-360-assets-save-filter');
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    var lastRun = (0, Utils_1.formatDateTimeWithFormatDate)(riskConfig.lastRun, formatDate);
    var riskPage = (0, Selectors_1.selectRiskConfigsPage)();
    var isAssetCountsReady = (0, Selectors_1.selectIsAssetCountsReady)();
    var assetCounts = (0, Selectors_1.selectAssetCounts)();
    var assetFilters = (0, _Selectors_1.selectAssetStore)().assetFilters;
    var handleViewClick = function () {
        dispatch((0, Risk_actions_1.clearRiskConfig)());
        history.push((0, actions_1.addRouteNamespace)("results/".concat(riskConfig.configId)));
    };
    var handleDeleteClick = function () {
        onDeleteRisk(riskConfig.configId, riskConfig.publishState);
    };
    var handlePublishStateChange = function (newPublishState) {
        dispatch((0, Risk_actions_1.changeRiskConfigPublishState)({
            newPublishState: newPublishState,
            configId: riskConfig.configId,
            refresh: function () {
                dispatch((0, Actions_1.changeRiskConfigsPage)(riskPage.page));
            },
        }));
    };
    var handleDuplicateClick = function () {
        if (isSaveFilterOn) {
            onDuplicateRisk(riskConfig);
        }
        else {
            var configId = riskConfig.configId;
            dispatch((0, Risk_actions_1.duplicateRiskConfig)({ history: history, configId: configId }));
        }
    };
    var formatRunBy = function (runBy) {
        if (runBy.indexOf('@') !== -1) {
            return runBy.substring(0, runBy.lastIndexOf('@'));
        }
        return runBy;
    };
    var menuItems = function () {
        var items = [];
        if (hasFullAccess) {
            if (riskConfig.publishState === riskConfig_types_1.ConfigPublishState.published) {
                items.push({
                    onClick: function () {
                        return handlePublishStateChange(riskConfig_types_1.ConfigPublishState.unpublished);
                    },
                    text: t('Unpublish'),
                });
            }
            else {
                items.push({
                    onClick: function () {
                        return handlePublishStateChange(riskConfig_types_1.ConfigPublishState.published);
                    },
                    text: t('Publish'),
                });
            }
            items.push({
                onClick: handleDuplicateClick,
                text: t('Duplicate'),
            });
            items.push({
                onClick: handleDeleteClick,
                text: t('Delete'),
            });
        }
        return items;
    };
    var getRiskStatus = function (status) {
        var result = '-';
        if (status) {
            // DO NOT TRANSLATE THESE... That is done by the status object base on the english string
            switch (status) {
                case 'risk-calc-complete':
                    result = 'Complete';
                    break;
                case 'risk-calc-cancelled':
                    result = 'Cancelled';
                    break;
                case 'risk-calc-failed':
                case 'error':
                    result = 'Failed';
                    break;
                case 'risk-calc-initiated':
                case 'risk-calc-start':
                case 'risk-calc-in-progress':
                case 'risk-calc-getting-assets':
                case 'risk-calc-getting-risk-config':
                case 'risk-calc-getting-inspections':
                case 'risk-calc-archiving-existing-in-snowflake':
                case 'risk-calc-writing-to-snowflake':
                case 'risk-calc-post-processing-normalize':
                    result = 'In Progress';
                    break;
            }
        }
        return result;
    };
    var getRiskFormula = function (riskConfig) {
        if (riskConfig.cofWeighting != undefined &&
            riskConfig.lofWeighting != undefined &&
            riskConfig.riskMethod != undefined) {
            return "".concat(riskConfig.lofWeighting, "% ").concat(riskConfig.riskMethod == 'added' ? '+' : 'x', " ").concat(riskConfig.cofWeighting, "%");
        }
        else {
            return '-';
        }
    };
    var getFormulaValue = function (riskConfig) {
        var _a, _b;
        var formula = getRiskFormula(riskConfig);
        if (riskNormalizeFlag && formula !== '-' && riskConfig.postProcessing) {
            var process_1 = riskConfig.postProcessing.find(function (process) { return process.type === 'normalize'; });
            if (process_1 && process_1.params.useNormalize) {
                var tooltip = "((".concat(formula, ")/").concat((_a = process_1.params.maxRiskScore) !== null && _a !== void 0 ? _a : t('HCRS'), ") * ").concat((_b = process_1.params.normalizeValue) !== null && _b !== void 0 ? _b : t('NV'));
                return ((0, jsx_runtime_1.jsxs)("div", __assign({ title: tooltip, style: {
                        cursor: 'default',
                    } }, { children: [t('Normalized'), (0, jsx_runtime_1.jsx)(Help_1.default, { color: "secondary", style: {
                                verticalAlign: 'top',
                                height: '20px',
                            } })] })));
            }
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: formula });
    };
    var typeCell = function (type) {
        if (!type) {
            return '-';
        }
        var schema = (0, react_redux_1.useSelector)(function (state) {
            return (0, lib_asset_schema_store_1.assetSchemaSelectorByType)(state, type);
        });
        var assetDisplay = schema === null || schema === void 0 ? void 0 : schema.displayName;
        var systemDisplay = schema === null || schema === void 0 ? void 0 : schema.systemType.displayName;
        var displayName = "".concat(systemDisplay, " - ").concat(assetDisplay);
        return displayName !== null && displayName !== void 0 ? displayName : '-';
    };
    var renderTitle = (0, react_1.useCallback)(function (configName, publishState) {
        if (hasFullAccess ||
            publishState === riskConfig_types_1.ConfigPublishState.published) {
            return ((0, jsx_runtime_1.jsx)(material_1.Link, __assign({ underline: "hover", style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer',
                    width: '100%',
                    whiteSpace: 'nowrap',
                }, title: configName, onClick: function () {
                    handleViewClick();
                }, "data-cy": "card-title" }, { children: configName })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)("div", __assign({ style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    width: '100%',
                    whiteSpace: 'nowrap',
                } }, { children: configName })));
        }
    }, []);
    var renderHeader = function (configName, configPublishState) {
        var tooltipText = configPublishState === riskConfig_types_1.ConfigPublishState.published
            ? t('Published')
            : t('Unpublished');
        var icon = configPublishState === riskConfig_types_1.ConfigPublishState.published ? ((0, jsx_runtime_1.jsx)(CheckCircle_1.default, { sx: { color: colors_1.green[500] } })) : ((0, jsx_runtime_1.jsx)(RemoveCircle_1.default, { sx: { color: colors_1.grey[500] } }));
        var publishState = (0, jsx_runtime_1.jsx)(material_1.Tooltip, __assign({ title: tooltipText }, { children: icon }));
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "header-container" }, { children: [renderTitle(configName, configPublishState), " ", publishState] })));
    };
    var resultCount = riskConfig.assetCount > 0 ? riskConfig.assetCount : 0;
    var assetFilterName = (_b = assetFilters === null || assetFilters === void 0 ? void 0 : assetFilters.find(function (f) { return f._id === riskConfig.assetFilterId; })) === null || _b === void 0 ? void 0 : _b.name;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ style: {
            fontSize: '1rem',
        } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.PropertyCard, { columns: 2, forceMenu: true, className: "adjusted-menu-position", menuItems: menuItems(), properties: [
                {
                    title: t('Last Run'),
                    value: lastRun.length == 0 ? '-' : lastRun,
                    ellipsis: true,
                },
                {
                    title: t('Status'),
                    type: riskConfig.status ? 'status' : 'text',
                    value: getRiskStatus(riskConfig.status),
                },
                {
                    title: t('Run By'),
                    value: riskConfig.runBy
                        ? formatRunBy(riskConfig.runBy)
                        : '-',
                    ellipsis: true,
                },
                {
                    title: riskConfig.riskMethod == 'added'
                        ? t('Formula (LoF + CoF)')
                        : t('Formula (LoF x CoF)'),
                    value: getFormulaValue(riskConfig),
                    ellipsis: true,
                },
                {
                    title: t('System and Asset Type'),
                    value: typeCell(riskConfig.assetType),
                },
                isSaveFilterOn
                    ? {
                        title: t('Result Count'),
                        value: riskConfig.assetFilterId ? ((0, jsx_runtime_1.jsxs)(FilteredResultCount, __assign({ title: "".concat(t('Filtered risk model'), " (").concat(assetFilterName || 'partial results', ")") }, { children: [resultCount, (0, jsx_runtime_1.jsx)(FilterAlt_1.default, { color: "secondary" })] }))) : ((0, jsx_runtime_1.jsx)("div", { children: resultCount })),
                    }
                    : {
                        title: t('Asset Count'),
                        value: isAssetCountsReady && assetCounts
                            ? (_d = (_c = assetCounts.find(function (assetCount) {
                                return (assetCount.systemType ==
                                    riskConfig.systemType &&
                                    assetCount.assetType ==
                                        riskConfig.assetType);
                            })) === null || _c === void 0 ? void 0 : _c.count) !== null && _d !== void 0 ? _d : '-'
                            : '-',
                    },
            ], title: renderHeader((_e = riskConfig.name) !== null && _e !== void 0 ? _e : t('Default Risk Model'), riskConfig.publishState) }) }), riskConfig.configId));
};
exports["default"] = RiskListCard;


/***/ }),

/***/ "./components/RiskList/RiskListCard.style.tsx":
/*!****************************************************!*\
  !*** ./components/RiskList/RiskListCard.style.tsx ***!
  \****************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.NewModelCardWrapper = void 0;
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
exports.NewModelCardWrapper = (0, styled_components_1.default)(material_1.Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\theight: 100%;\n\n\t.model-create_card__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\theight: 100%;\n\t\tflex-direction: column;\n\t\tcursor: pointer;\n\t\t.model-create_card__note {\n\t\t\tmargin-top: 0.8rem;\n\t\t}\n\t\th6 {\n\t\t\tcolor: '#252F33';\n\t\t}\n\t}\n"], ["\n\theight: 100%;\n\n\t.model-create_card__icon {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\theight: 100%;\n\t\tflex-direction: column;\n\t\tcursor: pointer;\n\t\t.model-create_card__note {\n\t\t\tmargin-top: 0.8rem;\n\t\t}\n\t\th6 {\n\t\t\tcolor: '#252F33';\n\t\t}\n\t}\n"])));
var templateObject_1;


/***/ }),

/***/ "./components/RiskList/index.ts":
/*!**************************************!*\
  !*** ./components/RiskList/index.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var RiskList_component_1 = __webpack_require__(/*! ./RiskList.component */ "./components/RiskList/RiskList.component.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(RiskList_component_1).default; } }));


/***/ }),

/***/ "./components/RiskLogs/RiskLogs.tsx":
/*!******************************************!*\
  !*** ./components/RiskLogs/RiskLogs.tsx ***!
  \******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskLogs = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __webpack_require__(/*! react */ "react");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var Utils_1 = __webpack_require__(/*! @innovyze/lib-am-common/Utils */ "@innovyze/lib-am-common/Utils");
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var NoResultsRisk_component_1 = __webpack_require__(/*! @Components/RiskDetails/NoResultsRisk.component */ "./components/RiskDetails/NoResultsRisk.component.tsx");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var RiskLogs = function (_a) {
    var configId = _a.configId;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    (0, react_1.useEffect)(function () {
        dispatch((0, _Actions_1.setTab)('logs'));
    }, []);
    var subscriptions = (0, stylovyze_1.getSubscriptions)();
    var hasFullAccess = (0, shared_utils_1.fullAccess)(subscriptions);
    var riskStore = (0, _Selectors_1.selectRiskStore)();
    var _formatDateTime = function (time) {
        return (0, Utils_1.formatDateTimeWithFormatDate)(time, formatDate);
    };
    var logTitle = function () {
        if (!riskStore.isLoading) {
            if (riskStore.log && riskStore.log.calcStatus) {
                if (riskStore.log.calcStatus === 'risk-calc-complete') {
                    return "".concat(t('Last Run Completed, Start'), ": ").concat(_formatDateTime(riskStore.log.startTime), ", End: ").concat(_formatDateTime(riskStore.log.endTime));
                }
                else if (riskStore.log.calcStatus === 'risk-calc-failed') {
                    return "".concat(t('Last Run Failed, Start'), ": ").concat(_formatDateTime(riskStore.log.startTime), ", End: ").concat(_formatDateTime(riskStore.log.endTime));
                }
                else if (riskStore.log.calcStatus === 'risk-calc-cancelled') {
                    return "".concat(t('Last Run Cancelled, Start'), ": ").concat(_formatDateTime(riskStore.log.startTime), ", End: ").concat(_formatDateTime(riskStore.log.endTime));
                }
                else {
                    return t('Calculation Run Currently in Progress');
                }
            }
            return t('No Log Available');
        }
        return t('Fetching Log');
    };
    var logBodyErrors = function () {
        var _a, _b, _c, _d;
        var shouldShowErrors = !riskStore.isLoading &&
            ((_a = riskStore.log) === null || _a === void 0 ? void 0 : _a.calcStatus) === 'risk-calc-failed' &&
            riskStore.log.calcErrors.length > 0;
        if (shouldShowErrors) {
            var width = ((_b = riskStore.log) === null || _b === void 0 ? void 0 : _b.log.length) !== 0 ? 6 : 12;
            // Filter out duplicates. We can get duplicates since the errors are reported
            // for every risk calculation lambda
            var errors = Array.from(new Set((_d = (_c = riskStore.log) === null || _c === void 0 ? void 0 : _c.calcErrors) !== null && _d !== void 0 ? _d : []));
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: width }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: 'Errors' }, { children: (0, jsx_runtime_1.jsx)("ul", { children: errors.map(function (name, index) { return ((0, jsx_runtime_1.jsxs)("li", { children: [" ", name, " "] }, index)); }) }) })) })));
        }
    };
    var logBodyLog = function () {
        var _a, _b, _c, _d;
        if (!riskStore.isLoading &&
            riskStore.log &&
            riskStore.log.log &&
            riskStore.log.log.length != 0) {
            var width = ((_b = (_a = riskStore.log) === null || _a === void 0 ? void 0 : _a.calcErrors) === null || _b === void 0 ? void 0 : _b.length) != 0 ? 6 : 12;
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: width }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: 'Log' }, { children: (0, jsx_runtime_1.jsx)("ul", { children: (_d = (_c = riskStore.log) === null || _c === void 0 ? void 0 : _c.log) === null || _d === void 0 ? void 0 : _d.map(function (name, index) { return ((0, jsx_runtime_1.jsxs)("li", { children: [" ", name, " "] }, index)); }) }) })) })));
        }
    };
    var refreshLog = function () {
        if (!riskStore.isLoading)
            dispatch((0, _Actions_1.getLog)(configId));
    };
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: logTitle(), className: riskStore.isLoading ? 'wait' : '', titleArea: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, style: { width: 'fit-content', justifyContent: 'flex-end' }, spacing: 2 }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ variant: "contained", color: "primary", onClick: function () {
                        refreshLog();
                    } }, { children: t('Refresh') })) })) })) }, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, spacing: 3, direction: 'row' }, { children: !riskStore.isLoading &&
                (!riskStore.log || !riskStore.log.calcStatus) ? ((0, jsx_runtime_1.jsx)(NoResultsRisk_component_1.NoReasultsRisk, { adminFullAccess: hasFullAccess, configId: configId })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [riskStore.log ? logBodyErrors() : '', riskStore.log ? logBodyLog() : ''] })) })) })));
};
exports.RiskLogs = RiskLogs;


/***/ }),

/***/ "./components/RiskLogs/index.ts":
/*!**************************************!*\
  !*** ./components/RiskLogs/index.ts ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./RiskLogs */ "./components/RiskLogs/RiskLogs.tsx"), exports);


/***/ }),

/***/ "./components/RiskSetup/RiskSetup.tsx":
/*!********************************************!*\
  !*** ./components/RiskSetup/RiskSetup.tsx ***!
  \********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskSetup = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var Risk_actions_1 = __webpack_require__(/*! @Actions/Risk.actions */ "./actions/Risk.actions.ts");
var _Components_1 = __webpack_require__(/*! @Components */ "./components/index.ts");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var react_1 = __webpack_require__(/*! react */ "react");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var util_selectors_1 = __webpack_require__(/*! @Selectors/util.selectors */ "./selectors/util.selectors.ts");
var RiskSetup = function () {
    var _a;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var history = (0, react_router_dom_1.useHistory)();
    (0, react_1.useEffect)(function () {
        dispatch((0, _Actions_1.setTab)('risk'));
    }, []);
    var riskStore = (0, Risk_selectors_1.selectRiskStore)();
    var isRiskRunning = (0, util_selectors_1.selectRiskRunning)();
    var isRiskSetupDirty = (0, Risk_selectors_1.selectIsRiskSetupDirty)();
    var lofTableCells = [];
    var cofTableCells = [];
    var assetFilter = (_a = riskStore.riskConfig) === null || _a === void 0 ? void 0 : _a.assetFilter;
    if (!riskStore.isLoading) {
        for (var _i = 0, _b = riskStore.riskConfig.LOFCategories; _i < _b.length; _i++) {
            var cat = _b[_i];
            for (var _c = 0, _d = cat.components; _c < _d.length; _c++) {
                var component = _d[_c];
                if (cat.weighting !== 0 &&
                    component.select &&
                    component.weighting !== 0) {
                    lofTableCells.push([
                        cat.name,
                        cat.weighting.toString() + '%',
                        component.name,
                        cat.useHighestScore
                            ? '--'
                            : component.weighting.toString() + '%',
                    ]);
                }
            }
        }
        for (var _e = 0, _f = riskStore.riskConfig.COFCategories; _e < _f.length; _e++) {
            var cat = _f[_e];
            for (var _g = 0, _h = cat.components; _g < _h.length; _g++) {
                var component = _h[_g];
                if (cat.weighting !== 0 &&
                    component.select &&
                    component.weighting !== 0) {
                    cofTableCells.push([
                        cat.name,
                        cat.weighting.toString() + '%',
                        component.name,
                        cat.useHighestScore
                            ? '--'
                            : component.weighting.toString() + '%',
                    ]);
                }
            }
        }
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, spacing: 3 }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.NavigationPrompt, { when: isRiskSetupDirty, navigate: function (nextLocation) {
                    history.push(nextLocation);
                }, onNavigateAway: function () { return dispatch((0, Risk_actions_1.setSaveRun)(true)); }, secondaryConfirmText: t('Discard'), shouldBlockNavigation: function () { return true; }, shouldBlockReload: isRiskSetupDirty, onSecondaryNavigateAway: function () {
                    dispatch((0, Risk_actions_1.clearMatrixUpdate)(true));
                    dispatch((0, Risk_actions_1.setRiskSetupDirty)(false));
                }, content: t('You have modified your Risk model and have unsaved changes.  You can save changes, discard changes, or cancel to continue editing.'), confirmText: t('Save') }), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 6 }, { children: [(0, jsx_runtime_1.jsx)(_Components_1.RiskSetupLoFCoF, { isLoading: riskStore.isLoading, lofTableCells: lofTableCells, cofTableCells: cofTableCells }), assetFilter && ((0, jsx_runtime_1.jsx)(_Components_1.RiskSetupAssetFilter, { assetFilter: assetFilter }))] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 6, className: riskStore.isLoading ||
                    riskStore.isPreviewLoading ||
                    isRiskRunning
                    ? 'wait'
                    : '' }, { children: (0, jsx_runtime_1.jsx)(_Components_1.RiskGrade, { isLoading: riskStore.isLoading ||
                        riskStore.isPreviewLoading ||
                        isRiskRunning }) }))] })));
};
exports.RiskSetup = RiskSetup;


/***/ }),

/***/ "./components/RiskSetup/RiskSetupAssetFilter.component.tsx":
/*!*****************************************************************!*\
  !*** ./components/RiskSetup/RiskSetupAssetFilter.component.tsx ***!
  \*****************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskSetupAssetFilter = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __webpack_require__(/*! react */ "react");
var styled_components_1 = __importDefault(__webpack_require__(/*! styled-components */ "styled-components"));
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var datetime_1 = __webpack_require__(/*! @Utils/datetime */ "./utils/datetime.ts");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var asset_selectors_1 = __webpack_require__(/*! @Selectors/asset.selectors */ "./selectors/asset.selectors.ts");
var asset_actions_1 = __webpack_require__(/*! @Actions/asset.actions */ "./actions/asset.actions.ts");
var StyledFilterInfo = styled_components_1.default.p({
    display: 'block',
    width: '100%',
    marginBottom: 0,
    '& small': {
        display: 'block',
        opacity: 0.6,
        paddingTop: '0.2em',
    },
});
var RiskSetupAssetFilter = function (_a) {
    var assetFilter = _a.assetFilter;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var systemType = assetFilter.systemType, assetType = assetFilter.assetType;
    (0, react_1.useEffect)(function () {
        dispatch((0, asset_actions_1.getAssetFields)({ systemType: systemType, assetType: assetType }));
    }, []);
    var _b = (0, stylovyze_1.useUnits)(), system = _b.system, getSystemValue = _b.getSystemValue, getSystemUnit = _b.getSystemUnit;
    var assetFields = (0, asset_selectors_1.selectAssetStore)().assetFields;
    var filterMeta = function (f) {
        return "Created ".concat((0, datetime_1.timeAgo)(f.dateCreated), " by ").concat(String(f.createdBy)
            .split('@')
            .shift());
    };
    var toDisplayName = function (fieldName) {
        if (fieldName === 'spatial') {
            return 'Spatial';
        }
        if (assetFields) {
            var match = assetFields.find(function (f) { return f.name === fieldName; });
            if (match && match.displayName)
                return match.displayName;
        }
        return fieldName;
    };
    var toDisplayValue = function (fieldName, value) {
        if (!value)
            return '';
        if (typeof value !== 'string')
            return 'Area';
        if (assetFields && system !== 'Metric') {
            var match = assetFields.find(function (f) { return f.name === fieldName; });
            // Try convert fields using decimals and UOM
            if (match && match.type === 'Double' && match.units) {
                var units = getSystemUnit(match.units);
                var metricValue = "".concat(value, " ").concat(match.units);
                if (units) {
                    var systemValue = getSystemValue(metricValue);
                    return "".concat(systemValue, " ").concat(units);
                }
                return metricValue;
            }
        }
        return value;
    };
    return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, style: { paddingTop: '20px' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { className: "ScrollTable", title: t('Asset Filter'), titleArea: (0, jsx_runtime_1.jsxs)(StyledFilterInfo, { children: [assetFilter.name, (0, jsx_runtime_1.jsx)("small", { children: filterMeta(assetFilter) })] }), dataCy: "riskFilter-table", headers: [
                {
                    key: 'field',
                    cell: t('Field'),
                    sortable: false,
                },
                {
                    key: 'operator',
                    cell: t('Operator'),
                    sortable: false,
                },
                {
                    key: 'value',
                    cell: t('Value'),
                    sortable: false,
                },
            ], rows: assetFilter.filters.map(function (f, key) { return ({
                key: key,
                cells: [
                    toDisplayName(f.field),
                    f.operator,
                    toDisplayValue(f.field, f.value),
                ],
            }); }) }) })));
};
exports.RiskSetupAssetFilter = RiskSetupAssetFilter;


/***/ }),

/***/ "./components/RiskSetup/index.ts":
/*!***************************************!*\
  !*** ./components/RiskSetup/index.ts ***!
  \***************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./RiskSetup */ "./components/RiskSetup/RiskSetup.tsx"), exports);
__exportStar(__webpack_require__(/*! ./RiskSetupAssetFilter.component */ "./components/RiskSetup/RiskSetupAssetFilter.component.tsx"), exports);


/***/ }),

/***/ "./components/RiskSetupLoFCoF/RiskSetupLoFCoF.tsx":
/*!********************************************************!*\
  !*** ./components/RiskSetupLoFCoF/RiskSetupLoFCoF.tsx ***!
  \********************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskSetupLoFCoF = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var RiskSetupLoFCoF = function (_a) {
    var isLoading = _a.isLoading, lofTableCells = _a.lofTableCells, cofTableCells = _a.cofTableCells;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var headerReactNodes = function () {
        return [
            {
                key: 'category',
                cell: t('Category'),
                sortable: false,
                align: 'left',
                maxWidth: '200px',
                width: '25%',
            },
            {
                key: 'categoryWeight',
                cell: t('Category Weight'),
                sortable: false,
                align: 'left',
                width: '25%',
            },
            {
                key: 'component',
                cell: t('Component'),
                sortable: false,
                align: 'left',
                maxWidth: '200px',
                width: '25%',
            },
            {
                key: 'componentWeight',
                cell: t('Component Weight'),
                sortable: false,
                align: 'left',
                width: '25%',
            },
        ];
    };
    return ((0, jsx_runtime_1.jsx)(stylovyze_1.InfoCard, __assign({ title: t('Risk Setup') }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true }, { children: [(0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { className: "ScrollTable", title: t('LoF (Likelihood of Failure)'), dataCy: "lof-table", headers: headerReactNodes(), rows: lofTableCells.map(function (row, nRow) { return ({
                            key: nRow,
                            cells: row,
                        }); }) || [], initialized: !isLoading }) })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 12, style: { paddingTop: '20px' } }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.StylovyzeTable, { className: "ScrollTable", title: t('CoF (Consequence of Failure)'), dataCy: "cof-table", headers: headerReactNodes(), rows: cofTableCells.map(function (row, nRow) { return ({
                            key: nRow,
                            cells: row,
                        }); }) || [], initialized: !isLoading }) }))] })) })));
};
exports.RiskSetupLoFCoF = RiskSetupLoFCoF;


/***/ }),

/***/ "./components/RiskSetupLoFCoF/index.ts":
/*!*********************************************!*\
  !*** ./components/RiskSetupLoFCoF/index.ts ***!
  \*********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./RiskSetupLoFCoF */ "./components/RiskSetupLoFCoF/RiskSetupLoFCoF.tsx"), exports);


/***/ }),

/***/ "./components/Utils/icons/NewRisk.tsx":
/*!********************************************!*\
  !*** ./components/Utils/icons/NewRisk.tsx ***!
  \********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
function Scales() {
    return ((0, jsx_runtime_1.jsxs)("svg", __assign({ width: "117", height: "116", viewBox: "0 0 117 116", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M96.4179 52.4222C96.4202 52.395 96.4202 52.3677 96.4179 52.3406C96.4194 52.3134 96.4194 52.2862 96.4179 52.259C96.4089 52.2247 96.3976 52.1911 96.3843 52.1582L85.8254 29.1207V29.0919C85.795 29.0278 85.7563 28.9681 85.7102 28.9143L85.6766 28.8711C85.6216 28.812 85.5605 28.7589 85.4942 28.7127C85.4291 28.6746 85.3599 28.644 85.2879 28.6215H85.2399C85.1323 28.5749 85.0164 28.5504 84.8991 28.5495C84.8369 28.5424 84.7741 28.5424 84.7119 28.5495L69.6367 31.5828C69.2349 30.6922 68.543 29.9641 67.674 29.5174C66.805 29.0707 65.8103 28.9318 64.8522 29.1235C63.8941 29.3151 63.0293 29.8259 62.3989 30.5724C61.7686 31.319 61.4099 32.2572 61.3816 33.2338L46.316 36.2287H46.2632H46.196C46.1326 36.2517 46.0715 36.2806 46.0136 36.3151H45.9752C45.9096 36.3584 45.8499 36.41 45.7976 36.4687L45.7592 36.5167C45.7153 36.5694 45.6782 36.6274 45.6488 36.6895V36.7182L35.09 59.7558C35.0766 59.7887 35.0654 59.8223 35.0564 59.8566C35.0549 59.8838 35.0549 59.911 35.0564 59.9382C35.0541 59.9653 35.0541 59.9926 35.0564 60.0198C35.0249 60.0857 35.0007 60.1549 34.9844 60.2262V60.2262C34.9844 61.666 36.4242 62.9283 39.1263 63.8498C41.5099 64.62 43.9983 65.0166 46.5032 65.0257C49.008 65.0166 51.4964 64.62 53.88 63.8498C56.5821 62.9283 58.0219 61.666 58.0219 60.2262C58.024 60.1894 58.024 60.1525 58.0219 60.1158C58.0243 60.0886 58.0243 60.0613 58.0219 60.0342C58.0155 60.0066 58.0075 59.9793 57.9979 59.9526C57.9889 59.9183 57.9777 59.8846 57.9643 59.8518L47.8806 37.8893L61.7655 35.1152C61.9934 35.6293 62.3195 36.0939 62.7254 36.4831L64.7412 44.5078V67.4254H55.1422C54.3785 67.4254 53.646 67.7288 53.106 68.2689C52.5659 68.8089 52.2626 69.5414 52.2626 70.3051V73.1848H51.3027C50.5389 73.1848 49.8064 73.4882 49.2664 74.0282C48.7264 74.5683 48.423 75.3008 48.423 76.0645V77.0244H45.5433C45.2887 77.0244 45.0445 77.1255 44.8645 77.3055C44.6845 77.4856 44.5834 77.7297 44.5834 77.9843C44.5834 78.2389 44.6845 78.483 44.8645 78.663C45.0445 78.8431 45.2887 78.9442 45.5433 78.9442H85.859C86.1136 78.9442 86.3577 78.8431 86.5378 78.663C86.7178 78.483 86.8189 78.2389 86.8189 77.9843C86.8189 77.7297 86.7178 77.4856 86.5378 77.3055C86.3577 77.1255 86.1136 77.0244 85.859 77.0244H82.9793V76.0645C82.9793 75.3008 82.6759 74.5683 82.1359 74.0282C81.5958 73.4882 80.8634 73.1848 80.0996 73.1848H79.1397V70.3051C79.1397 69.5414 78.8363 68.8089 78.2963 68.2689C77.7562 67.7288 77.0238 67.4254 76.26 67.4254H66.661V44.5078L68.6672 36.4831C69.0801 36.0935 69.4122 35.6264 69.6444 35.1083C69.8767 34.5903 70.0045 34.0316 70.0207 33.4642L83.2481 30.8197L73.4667 52.1486C73.4534 52.1815 73.4421 52.2151 73.4331 52.2494C73.4316 52.2766 73.4316 52.3038 73.4331 52.331C73.4308 52.3581 73.4308 52.3854 73.4331 52.4126C73.4123 52.4561 73.3947 52.501 73.3803 52.547C73.3803 53.9868 74.8202 55.2491 77.5223 56.1706C82.3152 57.7383 87.483 57.7383 92.2759 56.1706C94.978 55.2491 96.4179 53.9868 96.4179 52.547C96.4205 52.5054 96.4205 52.4637 96.4179 52.4222ZM81.0595 76.0645V77.0244H50.3428V76.0645C50.3428 75.8099 50.4439 75.5658 50.6239 75.3857C50.8039 75.2057 51.0481 75.1046 51.3027 75.1046H80.0996C80.3542 75.1046 80.5983 75.2057 80.7784 75.3857C80.9584 75.5658 81.0595 75.8099 81.0595 76.0645ZM77.2199 70.3051V73.1848H54.1823V70.3051C54.1823 70.0505 54.2835 69.8064 54.4635 69.6264C54.6435 69.4463 54.8877 69.3452 55.1422 69.3452H76.26C76.5146 69.3452 76.7588 69.4463 76.9388 69.6264C77.1188 69.8064 77.2199 70.0505 77.2199 70.3051ZM93.9605 51.5871H75.8377L84.8991 31.8132L93.9605 51.5871ZM65.7011 30.9493C66.1758 30.9493 66.6397 31.09 67.0344 31.3537C67.429 31.6174 67.7366 31.9922 67.9182 32.4307C68.0998 32.8692 68.1474 33.3517 68.0548 33.8172C67.9622 34.2827 67.7336 34.7103 67.398 35.0459C67.0624 35.3815 66.6348 35.61 66.1693 35.7026C65.7038 35.7952 65.2213 35.7477 64.7828 35.5661C64.3443 35.3845 63.9695 35.0769 63.7058 34.6822C63.4421 34.2876 63.3014 33.8236 63.3014 33.349C63.3014 32.7126 63.5542 32.1022 64.0043 31.6521C64.4543 31.2021 65.0647 30.9493 65.7011 30.9493ZM46.5032 39.4924L55.5646 59.2663H37.4417L46.5032 39.4924ZM46.5032 63.1059C42.702 63.1059 39.3759 62.1076 37.8257 61.1861H55.1806C53.6304 62.1076 50.3044 63.1059 46.5032 63.1059ZM65.7011 40.4283L64.9956 37.6062C65.4623 37.6893 65.94 37.6893 66.4067 37.6062L65.7011 40.4283ZM84.8991 55.4267C81.0979 55.4267 77.7719 54.4284 76.2216 53.5069H93.5766C92.0264 54.4284 88.7003 55.4267 84.8991 55.4267Z", fill: "#007CA0" }), (0, jsx_runtime_1.jsx)("ellipse", { cx: "27.3433", cy: "88.4043", rx: "26.3726", ry: "26.8726", fill: "white" }), (0, jsx_runtime_1.jsx)("circle", { opacity: "0.2", cx: "66.9102", cy: "50.2769", r: "50", fill: "#A5BDC6" }), (0, jsx_runtime_1.jsx)("rect", { x: "6.89648", y: "66.4583", width: "42.8922", height: "43.8922", rx: "21.4461", fill: "#00ABD1" }), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M35.8482 89.5016H29.4144V96.0854H27.2698V89.5016H20.8359V87.307H27.2698V80.7231H29.4144V87.307H35.8482V89.5016Z", fill: "white" })] })));
}
exports["default"] = Scales;


/***/ }),

/***/ "./components/Utils/icons/Scales.tsx":
/*!*******************************************!*\
  !*** ./components/Utils/icons/Scales.tsx ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
function Scales() {
    return ((0, jsx_runtime_1.jsx)("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "74", height: "60", fill: "none", viewBox: "0 0 74 60" }, { children: (0, jsx_runtime_1.jsx)("path", { fill: "#768D95", d: "M73.135 28.426a.562.562 0 000-.097.875.875 0 000-.097.976.976 0 00-.04-.12L60.525.686V.652a.95.95 0 00-.137-.211l-.04-.052a1.353 1.353 0 00-.217-.188 1.189 1.189 0 00-.246-.109h-.057a1.04 1.04 0 00-.406-.086.982.982 0 00-.222 0L41.252 3.617a5.143 5.143 0 00-9.828 1.966L13.49 9.148H13.347a1.27 1.27 0 00-.217.103h-.046c-.078.052-.149.113-.211.183l-.046.057a.966.966 0 00-.131.206v.034L.126 37.157a.984.984 0 00-.04.12.88.88 0 000 .097.572.572 0 000 .097 1.19 1.19 0 00-.086.246c0 1.714 1.714 3.216 4.93 4.314 2.838.916 5.8 1.389 8.783 1.4a28.9 28.9 0 008.782-1.4c3.217-1.098 4.93-2.6 4.93-4.314a1.2 1.2 0 000-.132.583.583 0 000-.097.886.886 0 00-.028-.097.97.97 0 00-.04-.12L15.353 11.125l16.53-3.302c.27.612.659 1.165 1.142 1.628l2.4 9.553v27.283H23.998a3.428 3.428 0 00-3.429 3.428v3.429h-1.142a3.428 3.428 0 00-3.429 3.428v1.142H12.57a1.143 1.143 0 100 2.286h47.995a1.143 1.143 0 100-2.285h-3.428v-1.143a3.428 3.428 0 00-3.428-3.428h-1.143v-3.429a3.428 3.428 0 00-3.428-3.428H37.71V19.004L40.1 9.451a5.142 5.142 0 001.61-3.594L57.458 2.71 45.812 28.1a.993.993 0 00-.04.12.874.874 0 000 .097.584.584 0 000 .097 1.179 1.179 0 00-.063.16c0 1.714 1.715 3.217 4.931 4.314a28.249 28.249 0 0017.564 0c3.217-1.097 4.931-2.6 4.931-4.314.003-.05.003-.1 0-.149zM54.851 56.572v1.142H18.284v-1.142a1.143 1.143 0 011.143-1.143h34.282a1.143 1.143 0 011.142 1.143zm-4.57-6.857v3.429H22.854v-3.429a1.143 1.143 0 011.142-1.142h25.14a1.143 1.143 0 011.143 1.142zM70.21 27.432H48.635l10.787-23.54 10.788 23.54zM36.568 2.863a2.857 2.857 0 110 5.714 2.857 2.857 0 010-5.714zm-22.855 10.17L24.5 36.573H2.925l10.788-23.54zm0 28.112c-4.525 0-8.485-1.189-10.33-2.286h20.66c-1.845 1.097-5.805 2.286-10.33 2.286zm22.855-26.997l-.84-3.36a4.792 4.792 0 001.68 0l-.84 3.36zm22.854 17.855c-4.525 0-8.484-1.189-10.33-2.285h20.66c-1.845 1.096-5.804 2.285-10.33 2.285z" }) })));
}
exports["default"] = Scales;


/***/ }),

/***/ "./components/index.ts":
/*!*****************************!*\
  !*** ./components/index.ts ***!
  \*****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./AddEditComponent */ "./components/AddEditComponent/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./LoFSetup */ "./components/LoFSetup/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./RiskSetup */ "./components/RiskSetup/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./RiskSetupLoFCoF */ "./components/RiskSetupLoFCoF/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./RiskGrade */ "./components/RiskGrade/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./PercentSlider */ "./components/PercentSlider/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./RiskDetails */ "./components/RiskDetails/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./Category/Category.component */ "./components/Category/Category.component.tsx"), exports);
__exportStar(__webpack_require__(/*! ./FieldInspectionSummary */ "./components/FieldInspectionSummary/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./CoFSetup */ "./components/CoFSetup/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./RiskLogs */ "./components/RiskLogs/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./NewRisk */ "./components/NewRisk/index.ts"), exports);
__exportStar(__webpack_require__(/*! ./RenameRisk */ "./components/RenameRisk/index.ts"), exports);


/***/ }),

/***/ "./hooks/useAssetSchemaFF.ts":
/*!***********************************!*\
  !*** ./hooks/useAssetSchemaFF.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useAssetSchemaFF = void 0;
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var useAssetSchemaFF = function () {
    var riskNewSchemaFF = (0, stylovyze_1.useIsFeatureEnabled)('info-360-risk-enable-stormwater');
    var assetSchemaFF;
    // Needed to test the new schema
    if (riskNewSchemaFF) {
        assetSchemaFF = (0, stylovyze_1.useIsFeatureEnabled)('i360-release-asset-schema');
    }
    else {
        assetSchemaFF = {
            SanitarySewer: ['wwPipe'],
            WaterDistribution: ['pipe'],
        };
    }
    var validSystemTypes = Object.keys(assetSchemaFF).filter(function (systemType) {
        return assetSchemaFF[systemType] === true ||
            Array.isArray(assetSchemaFF[systemType]);
    });
    var allSystemTypesValid = validSystemTypes.length === 0;
    var isValidSystemType = function (systemType) {
        return validSystemTypes.includes(systemType) || allSystemTypesValid;
    };
    var isValidAssetType = function (systemType, assetType) {
        if (allSystemTypesValid) {
            return true;
        }
        var assetTypes = assetSchemaFF[systemType];
        if (assetTypes === true) {
            return true;
        }
        if (Array.isArray(assetTypes)) {
            return assetTypes.includes(assetType);
        }
        return false;
    };
    return {
        isValidSystemType: isValidSystemType,
        isValidAssetType: isValidAssetType,
    };
};
exports.useAssetSchemaFF = useAssetSchemaFF;


/***/ }),

/***/ "./hooks/useNoConditionData.ts":
/*!*************************************!*\
  !*** ./hooks/useNoConditionData.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useNoConditionData = void 0;
var lib_asset_schema_store_1 = __webpack_require__(/*! @innovyze/lib_asset_schema_store */ "@innovyze/lib_asset_schema_store");
var react_1 = __webpack_require__(/*! react */ "react");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var useNoConditionData = function (assetType) {
    var _a;
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        if (assetType) {
            dispatch((0, lib_asset_schema_store_1.getAssetSchemaAction)({ assetType: assetType }));
        }
    }, [assetType, dispatch]);
    var assetSchema = (0, react_redux_1.useSelector)(function (state) {
        if (assetType) {
            return (0, lib_asset_schema_store_1.assetSchemaSelectorByType)(state, assetType);
        }
    });
    var hasInspections = (_a = assetSchema === null || assetSchema === void 0 ? void 0 : assetSchema.hasCapability('Inspections')) !== null && _a !== void 0 ? _a : false;
    var noConditionData = !hasInspections;
    return noConditionData;
};
exports.useNoConditionData = useNoConditionData;


/***/ }),

/***/ "./hooks/useSystemTypes.ts":
/*!*********************************!*\
  !*** ./hooks/useSystemTypes.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useSystemTypes = void 0;
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var useAssetSchemaFF_1 = __webpack_require__(/*! ./useAssetSchemaFF */ "./hooks/useAssetSchemaFF.ts");
var lib_asset_schema_store_1 = __webpack_require__(/*! @innovyze/lib_asset_schema_store */ "@innovyze/lib_asset_schema_store");
var useSystemTypes = function () {
    var isValidSystemType = (0, useAssetSchemaFF_1.useAssetSchemaFF)().isValidSystemType;
    var systemTypes = (0, react_redux_1.useSelector)(function (state) {
        var _a;
        return Object.values((_a = (0, lib_asset_schema_store_1.systemSchemaSelector)(state)) !== null && _a !== void 0 ? _a : {}).filter(function (t) {
            return isValidSystemType(t.id);
        });
    });
    return systemTypes;
};
exports.useSystemTypes = useSystemTypes;


/***/ }),

/***/ "./i18n/useGlobalization.ts":
/*!**********************************!*\
  !*** ./i18n/useGlobalization.ts ***!
  \**********************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useGlobalization = void 0;
var react_i18next_1 = __webpack_require__(/*! react-i18next */ "react-i18next");
var settings_json_1 = __importDefault(__webpack_require__(/*! ./settings.json */ "./i18n/settings.json"));
/**
 * Translate text with react-i18next useTranslate with
 * predefined namespace for the mini-app
 * @param i18nNs overide namespace
 * @returns string
 */
var useGlobalization = function (i18nNs) {
    if (i18nNs === void 0) { i18nNs = settings_json_1.default.ns; }
    var _a = (0, react_i18next_1.useTranslation)(i18nNs), t = _a.t, other = __rest(_a, ["t"]);
    return __assign({ t: t }, other);
};
exports.useGlobalization = useGlobalization;


/***/ }),

/***/ "./pages/AssetDetails/AssetDetails.tsx":
/*!*********************************************!*\
  !*** ./pages/AssetDetails/AssetDetails.tsx ***!
  \*********************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_1 = __webpack_require__(/*! react */ "react");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var Components_1 = __webpack_require__(/*! @innovyze/lib-am-common/Components */ "@innovyze/lib-am-common/Components");
var Actions_1 = __webpack_require__(/*! @innovyze/lib-am-common/Actions */ "@innovyze/lib-am-common/Actions");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var lib_asset_schema_1 = __webpack_require__(/*! @innovyze/lib_asset_schema */ "@innovyze/lib_asset_schema");
var AssetDetails = function () {
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var params = (0, react_router_dom_1.useParams)();
    var history = (0, react_router_dom_1.useHistory)();
    var dispatch = (0, react_redux_1.useDispatch)();
    var formatDateUTC = (0, stylovyze_1.useTzDateTime)({ timeZone: 'UTC' }).formatDate;
    var riskSetting = (0, _Selectors_1.selectRiskSetting)();
    var assetType = riskSetting.assetType;
    var subscriptions = (0, stylovyze_1.getSubscriptions)();
    var hasFullAccess = (0, shared_utils_1.fullAccess)(subscriptions);
    var _a = (0, react_1.useState)(undefined), systemType = _a[0], setSystemType = _a[1];
    (0, react_1.useEffect)(function () {
        dispatch((0, Actions_1.getAssetDetail)({
            assetId: params.assetId,
            assetType: assetType,
            formatDateUTC: formatDateUTC,
            systemType: systemType,
        }));
        dispatch((0, Actions_1.getAssetPipe)({
            assetId: params.assetId,
            assetType: assetType,
            formatDateUTC: formatDateUTC,
            systemType: systemType,
        }));
        dispatch((0, Actions_1.getInspectionAttributes)({
            assetId: params.assetId,
            assetType: assetType,
        }));
    }, [assetType, systemType, dispatch]);
    (0, react_1.useEffect)(function () {
        var systemType = (0, lib_asset_schema_1.getSystemTypeIdByAssetTypePrefix)(assetType);
        setSystemType(systemType);
    }, [assetType]);
    var back = function () {
        history.goBack();
    };
    var viewInspection = function (videoURL, inspectionId, standard) {
        history.push("../riskInspectionDetails/".concat(standard, "/").concat(inspectionId));
    };
    var actions = {
        onInspectionDetailClicked: viewInspection,
    };
    return ((0, jsx_runtime_1.jsx)(Components_1.AssetDetails, { assetId: params.assetId, back: {
            action: back,
            label: t('Back to Results'),
        }, assetType: assetType, actions: actions, adminFullAccess: hasFullAccess, systemType: systemType }));
};
exports["default"] = AssetDetails;


/***/ }),

/***/ "./pages/AssetDetails/index.tsx":
/*!**************************************!*\
  !*** ./pages/AssetDetails/index.tsx ***!
  \**************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var AssetDetails_1 = __webpack_require__(/*! ./AssetDetails */ "./pages/AssetDetails/AssetDetails.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(AssetDetails_1).default; } }));


/***/ }),

/***/ "./pages/InspectionDetails/InspectionDetails.tsx":
/*!*******************************************************!*\
  !*** ./pages/InspectionDetails/InspectionDetails.tsx ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var Components_1 = __webpack_require__(/*! @innovyze/lib-am-common/Components */ "@innovyze/lib-am-common/Components");
var InspectionDetails = function () {
    var params = (0, react_router_dom_1.useParams)();
    var history = (0, react_router_dom_1.useHistory)();
    var back = function () {
        history.goBack();
    };
    return ((0, jsx_runtime_1.jsx)(Components_1.InspDetails, { inspectionId: params.inspectionId, standard: params.standard, back: {
            action: back,
            label: 'Back to Asset Details',
        } }));
};
exports["default"] = InspectionDetails;


/***/ }),

/***/ "./pages/InspectionDetails/index.tsx":
/*!*******************************************!*\
  !*** ./pages/InspectionDetails/index.tsx ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var InspectionDetails_1 = __webpack_require__(/*! ./InspectionDetails */ "./pages/InspectionDetails/InspectionDetails.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(InspectionDetails_1).default; } }));


/***/ }),

/***/ "./pages/PageRoutes.tsx":
/*!******************************!*\
  !*** ./pages/PageRoutes.tsx ***!
  \******************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.miniPageRoutesMulti = exports.miniPageRoutes = exports.mainPageRoutes = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var _1 = __webpack_require__(/*! . */ "./pages/index.ts");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var RiskManagementList_1 = __importDefault(__webpack_require__(/*! ./RiskManagementList */ "./pages/RiskManagementList/index.ts"));
// NOTE WE DONT NEED TO TRANSLATE THESE AS MOST ARE NEVER SHOWN
exports.mainPageRoutes = [
    {
        title: 'Results',
        to: (0, actions_1.addRouteNamespace)('results/:configId'),
        render: (0, jsx_runtime_1.jsx)(_1.RiskManagement, { page: 0 }),
    },
    {
        title: 'Likelihood of Failure Setup',
        to: (0, actions_1.addRouteNamespace)('lofSetup/:configId'),
        render: (0, jsx_runtime_1.jsx)(_1.RiskManagement, { page: 1 }),
    },
    {
        title: 'Consequence of Failure Setup',
        to: (0, actions_1.addRouteNamespace)('cofSetup/:configId'),
        render: (0, jsx_runtime_1.jsx)(_1.RiskManagement, { page: 2 }),
    },
    {
        title: 'Risk Setup',
        to: (0, actions_1.addRouteNamespace)('riskSetup/:configId'),
        render: (0, jsx_runtime_1.jsx)(_1.RiskManagement, { page: 3 }),
    },
    {
        title: 'Risk Log',
        to: (0, actions_1.addRouteNamespace)('riskLog/:configId'),
        render: (0, jsx_runtime_1.jsx)(_1.RiskManagement, { page: 4 }),
    },
    {
        title: 'Asset Details',
        to: (0, actions_1.addRouteNamespace)('riskAssetDetails/:assetId'),
        render: (0, jsx_runtime_1.jsx)(_1.AssetDetails, {}),
    },
    {
        title: 'Inspection Details',
        to: (0, actions_1.addRouteNamespace)('riskInspectionDetails/:standard/:inspectionId'),
        render: (0, jsx_runtime_1.jsx)(_1.InspectionDetails, {}),
    },
];
exports.miniPageRoutes = __spreadArray([
    {
        title: 'Risk',
        to: '/risk',
        icon: (0, jsx_runtime_1.jsx)("img", { src: __webpack_require__(/*! ./repo-icon.svg */ "./pages/repo-icon.svg"), alt: "risk" }),
        render: (0, jsx_runtime_1.jsx)(_1.RiskManagement, {}),
    }
], exports.mainPageRoutes, true);
exports.miniPageRoutesMulti = __spreadArray([
    {
        title: 'Risk',
        to: '/risk',
        icon: (0, jsx_runtime_1.jsx)("img", { src: __webpack_require__(/*! ./repo-icon.svg */ "./pages/repo-icon.svg"), alt: "risk" }),
        render: (0, jsx_runtime_1.jsx)(RiskManagementList_1.default, {}),
    }
], exports.mainPageRoutes, true);
exports["default"] = [exports.mainPageRoutes, exports.miniPageRoutes];


/***/ }),

/***/ "./pages/RiskManagement/FullRiskPage.tsx":
/*!***********************************************!*\
  !*** ./pages/RiskManagement/FullRiskPage.tsx ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var icons_material_1 = __webpack_require__(/*! @mui/icons-material */ "@mui/icons-material");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var shared_utils_1 = __webpack_require__(/*! @innovyze/shared-utils */ "@innovyze/shared-utils");
var LoFSetup_1 = __webpack_require__(/*! @Components/LoFSetup */ "./components/LoFSetup/index.ts");
var CoFSetup_1 = __webpack_require__(/*! @Components/CoFSetup */ "./components/CoFSetup/index.ts");
var RiskSetup_1 = __webpack_require__(/*! @Components/RiskSetup */ "./components/RiskSetup/index.ts");
var RiskLogs_1 = __webpack_require__(/*! @Components/RiskLogs */ "./components/RiskLogs/index.ts");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var RiskDetails_1 = __webpack_require__(/*! @Components/RiskDetails */ "./components/RiskDetails/index.ts");
var FullRiskPage = function (_a) {
    var getSecondary = _a.getSecondary, back = _a.back, multipleModels = _a.multipleModels, beforeTabChange = _a.beforeTabChange, pageIndex = _a.pageIndex, onAddComponent = _a.onAddComponent, onEditComponent = _a.onEditComponent, refreshRiskScore = _a.refreshRiskScore, onEditName = _a.onEditName, t = _a.t;
    var showRiskDetailsDatagrid = (0, stylovyze_1.useIsFeatureEnabled)('info-360-render-risk-datagrid');
    var subscriptions = (0, stylovyze_1.getSubscriptions)();
    var hasViewerAccess = (0, shared_utils_1.viewerAccess)(subscriptions);
    var riskStore = (0, Risk_selectors_1.selectRiskStore)();
    var params = (0, react_router_dom_1.useParams)();
    var isLoaded = riskStore.riskConfig.riskSetting.name.length != 0;
    var riskDetailsTab = showRiskDetailsDatagrid ? ((0, jsx_runtime_1.jsx)(RiskDetails_1.RiskDetailsDatagrid, { configId: params.configId, refreshRiskScore: refreshRiskScore })) : ((0, jsx_runtime_1.jsx)(RiskDetails_1.RiskDetails, { configId: params.configId }));
    return ((0, jsx_runtime_1.jsx)(styles_1.FullPageWrapper, { title: riskStore.riskConfig.riskSetting.name.length == 0
            ? ' '
            : riskStore.riskConfig.riskSetting.name, minorHeader: !hasViewerAccess && isLoaded ? ((0, jsx_runtime_1.jsx)("div", __assign({ style: {
                paddingLeft: '20px',
                paddingRight: '20px',
            } }, { children: (0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ title: t('Edit Name'), "data-cy": "editButton", onClick: onEditName }, { children: (0, jsx_runtime_1.jsx)(icons_material_1.Create, {}) })) }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})), applyPadding: true, headerUnderline: true, secondary: riskStore.riskConfig.riskSetting ? getSecondary() : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), back: multipleModels
            ? {
                action: back,
                label: t('Back to Risk Models'),
            }
            : undefined, secondaryNav: {
            items: [
                // TODO: Just hidden for the moment
                //{ content: <div></div>, title: 'Summary' },
                { content: riskDetailsTab, title: t('Results') },
                {
                    content: ((0, jsx_runtime_1.jsx)(LoFSetup_1.LoFSetup, { onAddComponent: onAddComponent, onEditComponent: onEditComponent })),
                    title: t('Likelihood of Failure Setup'),
                    disabled: !isLoaded || hasViewerAccess,
                },
                {
                    content: ((0, jsx_runtime_1.jsx)(CoFSetup_1.CoFSetup, { onAddComponent: onAddComponent, onEditComponent: onEditComponent })),
                    title: t('Consequence of Failure Setup'),
                    disabled: !isLoaded || hasViewerAccess,
                },
                {
                    content: (0, jsx_runtime_1.jsx)(RiskSetup_1.RiskSetup, {}),
                    title: t('Risk Setup'),
                    disabled: !isLoaded || hasViewerAccess,
                },
                {
                    content: (0, jsx_runtime_1.jsx)(RiskLogs_1.RiskLogs, { configId: params.configId }),
                    title: t('Log'),
                    disabled: !isLoaded || hasViewerAccess,
                },
            ],
            itemIndex: pageIndex,
            beforeItemIndexChanged: beforeTabChange,
        } }));
};
exports["default"] = FullRiskPage;


/***/ }),

/***/ "./pages/RiskManagement/RiskManagement.page.tsx":
/*!******************************************************!*\
  !*** ./pages/RiskManagement/RiskManagement.page.tsx ***!
  \******************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskManagement = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var stylovyze_2 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var _Components_1 = __webpack_require__(/*! @Components */ "./components/index.ts");
var react_1 = __webpack_require__(/*! react */ "react");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var _Selectors_1 = __webpack_require__(/*! @Selectors */ "./selectors/index.ts");
var _Actions_1 = __webpack_require__(/*! @Actions */ "./actions/index.ts");
var RiskCalcStatus_1 = __importDefault(__webpack_require__(/*! @Components/RiskCalcStatus/RiskCalcStatus */ "./components/RiskCalcStatus/RiskCalcStatus.ts"));
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var actions_1 = __webpack_require__(/*! @Utils/actions */ "./utils/actions.ts");
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var Selectors_1 = __webpack_require__(/*! @innovyze/lib-am-common/Selectors */ "@innovyze/lib-am-common/Selectors");
var Actions_1 = __webpack_require__(/*! @innovyze/lib-am-common/Actions */ "@innovyze/lib-am-common/Actions");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var Utils_1 = __webpack_require__(/*! @innovyze/lib-am-common/Utils */ "@innovyze/lib-am-common/Utils");
var InspectionStandardType_1 = __webpack_require__(/*! @Types/InspectionStandardType */ "./types/InspectionStandardType.ts");
var FullRiskPage_1 = __importDefault(__webpack_require__(/*! ./FullRiskPage */ "./pages/RiskManagement/FullRiskPage.tsx"));
var lib_asset_schema_store_1 = __webpack_require__(/*! @innovyze/lib_asset_schema_store */ "@innovyze/lib_asset_schema_store");
var useNoConditionData_1 = __webpack_require__(/*! @Hooks/useNoConditionData */ "./hooks/useNoConditionData.ts");
var RiskManagement = function (_a) {
    var _b;
    var page = _a.page;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    var params = (0, react_router_dom_1.useParams)();
    var history = (0, react_router_dom_1.useHistory)();
    var location = (0, react_router_dom_1.useLocation)();
    var pageIndex = ((_b = location.state) === null || _b === void 0 ? void 0 : _b.pageIndex) || page;
    var token = (0, stylovyze_2.useAuth0)().token;
    var formatDate = (0, stylovyze_1.useCompanyDateTime)().formatDate;
    var isRiskSetupDirty = (0, _Selectors_1.selectIsRiskSetupDirty)();
    var enablePreview = (0, _Selectors_1.selectEnablePreview)();
    var didMatrixUpdate = (0, _Selectors_1.selectDidMatrixUpdate)();
    var _c = (0, react_1.useState)(true), forLoF = _c[0], setForLoF = _c[1];
    var _d = (0, react_1.useState)(true), forInspection = _d[0], setForInspection = _d[1];
    var _e = (0, react_1.useState)(), cat = _e[0], setCat = _e[1];
    var _f = (0, react_1.useState)(true), isNew = _f[0], setNew = _f[1];
    var _g = (0, react_1.useState)(false), step2 = _g[0], setStep2 = _g[1];
    var _h = (0, react_1.useState)({
        name: '',
        select: false,
        weighting: 0,
        type: '',
        metadata: undefined,
        metadataType: undefined,
        maxDistance: undefined,
        field: undefined,
        fieldAlias: undefined,
        nullScore: undefined,
    }), component = _h[0], setComponent = _h[1];
    var tab = (0, _Selectors_1.selectRiskTab)();
    var lofStore = (0, _Selectors_1.selectLofStore)();
    var cofStore = (0, _Selectors_1.selectCofStore)();
    var isLoFLoading = lofStore.isLoadingCategories || lofStore.isLoadingFields;
    var isCoFLoading = cofStore.isLoadingCategories || cofStore.isLoadingFields;
    var riskStore = (0, _Selectors_1.selectRiskStore)();
    var calcStatus = (0, _Selectors_1.selectRiskStatus)();
    var lastRun = (0, _Selectors_1.selectRiskLastRun)();
    var riskPage = (0, Selectors_1.selectRiskConfigsPage)();
    var riskConfig = (0, _Selectors_1.selectRiskConfig)();
    var riskSetting = (0, _Selectors_1.selectRiskSetting)();
    var riskMatrixRanges = (0, _Selectors_1.selectUpdatedRiskRanges)();
    var riskMatrixGrid = (0, _Selectors_1.selectUpdatedRiskMatrixGrid)();
    var isRiskRunning = (0, _Selectors_1.selectRiskRunning)();
    var _j = (0, react_1.useState)(false), openCancel = _j[0], setOpenCancel = _j[1];
    var _k = (0, react_1.useState)(false), isRiskRunCancelling = _k[0], setIsRiskRunCancelling = _k[1];
    var overallRisk = (0, _Selectors_1.selectOverallRisk)();
    var _l = (0, react_1.useState)(false), editName = _l[0], setEditName = _l[1];
    var _m = (0, react_1.useState)(false), completeLoad = _m[0], setCompleteLoad = _m[1];
    var noConditionData = (0, useNoConditionData_1.useNoConditionData)(riskStore.riskConfig.riskSetting.assetType);
    //Feature flags
    var multipleModels = !!(0, stylovyze_1.useIsFeatureEnabled)('info-360-asset-multiple-risk-models');
    var websocketRiskStatus = (0, stylovyze_1.useIsFeatureEnabled)('info-360-websocket-risk-status');
    var websocketRiskScore = (0, stylovyze_1.useIsFeatureEnabled)('info-360-websocket-risk-score');
    /* eslint-disable-next-line */
    var updateStatusWebsocket = function (data) {
        // console.log('updateStatusWebsocket', data);
        var status = data.payload.calcStatus;
        var previousStatus = data.payload.previousStatus;
        updateStatus(status, previousStatus);
    };
    var updateStatus = function (status, previousStatus) {
        // console.log('updateStatusWebsocket', status, previousStatus);
        var result = '';
        var running = false;
        if (status) {
            switch (status) {
                case 'risk-calc-complete':
                case 'risk-calc-failed':
                case 'risk-calc-cancelled':
                    result = t('Risk Service: Ready');
                    // If we have changed state then display a snackbar the once
                    if (previousStatus != undefined &&
                        previousStatus != 'risk-calc-complete' &&
                        previousStatus != 'risk-calc-failed' &&
                        previousStatus != 'risk-calc-cancelled') {
                        if (status === 'risk-calc-complete') {
                            dispatch((0, stylovyze_1.success)(t('Risk calculation completed')));
                            dispatch((0, _Actions_1.setRunCompleteReload)(true));
                        }
                        else if (status === 'risk-calc-cancelled') {
                            dispatch((0, stylovyze_1.error)(t('Risk calculation cancelled')));
                        }
                        else {
                            dispatch((0, stylovyze_1.error)(t('Risk calculation failed')));
                        }
                        dispatch((0, _Actions_1.getLog)(params.configId));
                        dispatch((0, _Actions_1.clearRiskScanId)());
                        dispatch((0, _Actions_1.reloadRiskDetails)(params.configId));
                        dispatch((0, _Actions_1.setRefreshList)(true));
                        dispatch((0, _Actions_1.setSearchStart)(false));
                        // Do this in case another client has clicked cancel for your run
                        setIsRiskRunCancelling(false);
                    }
                    break;
                case 'risk-calc-initiated':
                case 'risk-calc-start':
                    result = t('Risk Service: In Progress');
                    running = true;
                    break;
                case 'risk-calc-getting-assets':
                    result = t('Risk Service: Getting Assets');
                    running = true;
                    break;
                case 'risk-calc-getting-inspections':
                    result = t('Risk Service: Getting Inspections');
                    running = true;
                    break;
                case 'risk-calc-getting-risk-config':
                    result = t('Risk Service: Gettting Risk Configuration');
                    running = true;
                    break;
                case 'risk-calc-in-progress':
                case 'risk-calc-post-processing-normalize':
                    result = t('Risk Service: In Progress');
                    running = true;
                    break;
                case 'risk-calc-writing-to-snowflake':
                    result = t('Risk Service: Writing Results');
                    running = true;
                    break;
                case 'risk-calc-archiving-existing-in-snowflake':
                    result = t('Risk Service: Archiving Results');
                    running = true;
                    break;
                // case 'error':
                // 	result = 'Risk Service: Unable to connect';
                // 	break;
            }
        }
        dispatch((0, _Actions_1.setRiskStatus)(result));
        dispatch((0, _Actions_1.setRiskRunning)(running));
        return true;
    };
    var pollRiskCalcStatus = function (cancel) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!cancel) return [3 /*break*/, 2];
                    return [4 /*yield*/, RiskCalcStatus_1.default.cancelPollForCalcStatus()];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, RiskCalcStatus_1.default.pollForCalcStatus(token || '', params.configId, updateStatus)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }); };
    /* eslint-disable-next-line */
    var riskCalcStatusErrorCallBack = function (data) {
        console.log('riskCalcStatusErrorCallBack', data);
    };
    var webSocket = (0, Utils_1.useWebSockets)();
    (0, react_1.useEffect)(function () {
        if (websocketRiskStatus) {
            webSocket.setupRoutes('riskCalcStatus', updateStatusWebsocket, riskCalcStatusErrorCallBack);
            webSocket.sendMessage(JSON.stringify({
                path: 'risk',
                action: 'riskCalcStatus',
                configId: params.configId,
            }));
        }
    }, [params.configId]);
    (0, react_1.useEffect)(function () {
        // This is to stop it reloading everytime the tab changes
        if (riskStore.riskConfig.riskSetting.configId !== params.configId) {
            setCompleteLoad(true);
            dispatch((0, _Actions_1.getRiskConfig)(params.configId));
            if (!websocketRiskStatus)
                pollRiskCalcStatus(false);
            // If we have a new config ID and we aren't on the details tab switch to it
            if (tab != 'details')
                history.push((0, actions_1.addRouteNamespace)("results/".concat(params.configId)));
        }
        dispatch((0, lib_asset_schema_store_1.getAllAssetsSchemaAction)());
    }, []);
    (0, react_1.useEffect)(function () {
        if (!isRiskRunning) {
            setIsRiskRunCancelling(false);
        }
    }, [isRiskRunning]);
    var riskScoreCallBack = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var response, resolvedResponse, rows;
        return __generator(this, function (_a) {
            response = data.payload;
            // const requestId = data.requestId;
            // const connectionId = data.connectionId;
            if (response.data && response.data.length > 0) {
                resolvedResponse = {
                    pagination: response.pagination,
                    data: response.data,
                    scanId: response.scanId,
                };
                rows = resolvedResponse.data;
                resolvedResponse.data = rows.map(function (riskDetail) {
                    if (riskDetail.ASSET_ID.indexOf('#') > 0) {
                        return __assign(__assign({}, riskDetail), { ASSET_ID: riskDetail.ASSET_ID.split('#')[1] });
                    }
                    else {
                        return riskDetail;
                    }
                });
                dispatch((0, _Actions_1.getRiskDetailsWSReseived)({
                    searchStr: data.requestBody.queryParameters.search,
                    response: resolvedResponse,
                }));
            }
            else {
                dispatch((0, _Actions_1.getRiskDetailsRejected)({
                    code: 500,
                    text: 'Failed to get risk details',
                }));
                dispatch((0, _Actions_1.setRiskDetailsIsBusy)(false));
                dispatch((0, _Actions_1.setSearchStart)(false));
            }
            return [2 /*return*/];
        });
    }); };
    var riskScoreErrorCallBack = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch((0, _Actions_1.getRiskDetailsRejected)({
                code: 500,
                text: 'Failed to get risk details',
            }));
            dispatch((0, _Actions_1.setRiskDetailsIsBusy)(false));
            dispatch((0, _Actions_1.setSearchStart)(false));
            return [2 /*return*/];
        });
    }); };
    var query = (0, _Selectors_1.selectRiskDetailsQueryObj)();
    var startSearch = (0, _Selectors_1.selectRiskDetailsStartSearch)();
    var searchString = (0, _Selectors_1.selectRiskDetailsSearch)();
    var refreshRiskScore = function () {
        if (websocketRiskScore) {
            webSocket.setupRoutes('riskScore', riskScoreCallBack, riskScoreErrorCallBack);
            dispatch((0, _Actions_1.setRiskDetailsIsBusy)(true));
            dispatch((0, _Actions_1.clearRiskScanId)());
            webSocket.sendMessage(JSON.stringify({
                path: 'risk',
                action: 'riskScore',
                queryParameters: query,
            }));
        }
        else {
            dispatch((0, _Actions_1.getRiskDetailsDefaulted)());
        }
    };
    (0, react_1.useEffect)(function () {
        if (startSearch !== 0) {
            refreshRiskScore();
        }
    }, [searchString]);
    (0, react_1.useEffect)(function () {
        // This so we dont try and load everything at once
        if (completeLoad &&
            riskStore.riskConfig.riskSetting.configId === params.configId) {
            setCompleteLoad(false);
            dispatch((0, _Actions_1.setSearchStart)(true));
            refreshRiskScore();
            dispatch((0, _Actions_1.getLog)(params.configId));
            dispatch((0, _Actions_1.getLoFInspectionFields)({
                assetType: riskStore.riskConfig.riskSetting.assetType,
                inspectionStandard: riskStore.riskConfig.riskSetting.inspectionStandard,
            }));
            dispatch((0, _Actions_1.getLoFFields)(riskStore.riskConfig.riskSetting.assetType));
            dispatch((0, _Actions_1.getCoFFields)(riskStore.riskConfig.riskSetting.assetType));
            dispatch((0, _Actions_1.getSimulationData)());
            dispatch((0, _Actions_1.getTaskData)(riskStore.riskConfig.riskSetting.assetType));
            dispatch((0, _Actions_1.getSpatialLayerList)());
            dispatch((0, _Actions_1.getProximityAttributeFields)(riskStore.riskConfig.riskSetting.assetType));
            dispatch((0, _Actions_1.getCustomTableFields)(riskStore.riskConfig.riskSetting.assetType));
        }
    }, [completeLoad, riskStore]);
    var onAddComponent = function (forLoF, forInspection, category) {
        if ((forLoF && !isLoFLoading) || (!forLoF && !isCoFLoading)) {
            if (category)
                setCat(category);
            setForLoF(forLoF);
            setForInspection(forInspection);
            setNew(true);
            setComponent({
                name: '',
                select: false,
                weighting: 0,
                type: '',
                metadata: undefined,
                metadataType: undefined,
                maxDistance: undefined,
                field: undefined,
                fieldAlias: undefined,
                nullScore: undefined,
            });
            setStep2(true);
        }
    };
    var onEditComponent = function (forLoF, forInspection, category, component) {
        if (category)
            setCat(category);
        setForInspection(forInspection);
        setForLoF(forLoF);
        setNew(false);
        setComponent(component);
        setStep2(true);
    };
    var refresh = function () {
        dispatch((0, _Actions_1.getRiskConfig)(params.configId));
    };
    var saveCLOFConfig = function () {
        if (tab === 'lof') {
            dispatch((0, _Actions_1.saveLoF)({ refresh: refresh }));
        }
        else if (tab === 'cof') {
            dispatch((0, _Actions_1.saveCoF)({ refresh: refresh }));
        }
        dispatch((0, _Actions_1.setRefreshList)(true));
    };
    var isConfigValid = function () {
        if (tab === 'lof') {
            var categories = lofStore.categories;
            if (!categories || categories.length === 0)
                return false;
            // For Risk Models with noConditionData they can have just the single fake Condition Category and still be valid
            if (noConditionData && categories.length == 1)
                return true;
            var categoriesTotalWeight = categories
                .filter(function (category) { return !category.useThisOnly; })
                .map(function (category) { return category.weighting; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            if (categoriesTotalWeight !== 100 &&
                categories.filter(function (category) { return !category.useThisOnly; }).length > 0)
                return false;
            for (var _i = 0, categories_1 = categories; _i < categories_1.length; _i++) {
                var category = categories_1[_i];
                if (!category.useHighestScore &&
                    category.weighting !== 0 &&
                    category.components &&
                    category.components.length != 0) {
                    // Total of 0 or 100 from active componments is valid
                    var total = category.components
                        .map(function (component) {
                        return component.select ? component.weighting : 0;
                    })
                        .reduce(function (prev, current) { return prev + current; }, 0);
                    if (total !== 0 && total !== 100)
                        return false;
                }
            }
            return true;
        }
        else if (tab === 'cof') {
            var categories = cofStore.categories;
            if (!categories)
                return false;
            var categoriesTotalWeight = categories
                .map(function (category) { return category.weighting; })
                .reduce(function (prev, current) { return prev + current; }, 0);
            if (categoriesTotalWeight !== 100 && categories.length > 0)
                return false;
            for (var _a = 0, categories_2 = categories; _a < categories_2.length; _a++) {
                var category = categories_2[_a];
                if (!category.useHighestScore &&
                    category.weighting !== 0 &&
                    category.components &&
                    category.components.length != 0) {
                    // Total of 0 or 100 from active componments is valid
                    var total = category.components
                        .map(function (component) {
                        return component.select ? component.weighting : 0;
                    })
                        .reduce(function (prev, current) { return prev + current; }, 0);
                    if (total !== 0 && total !== 100)
                        return false;
                }
            }
            return true;
        }
    };
    var canBeSaved = function () {
        if (tab === 'lof') {
            return lofStore.isChanged && isConfigValid();
        }
        else if (tab === 'cof') {
            return cofStore.isChanged && isConfigValid();
        }
        return false;
    };
    var getLastRun = function (lastRun) {
        if (lastRun != undefined && lastRun != '') {
            return t('Last Run was {{date}}', {
                date: (0, Utils_1.formatDateTimeWithFormatDate)(lastRun, formatDate),
            });
        }
        else
            return '';
    };
    (0, react_1.useEffect)(function () {
        dispatch((0, _Actions_1.setRiskLastRun)(getLastRun(riskStore === null || riskStore === void 0 ? void 0 : riskStore.riskConfig.riskSetting.LastRun)));
    }, [riskStore === null || riskStore === void 0 ? void 0 : riskStore.riskConfig.riskSetting.LastRun]);
    var onPreviewClicked = function () {
        if (riskSetting.matrix) {
            var previewObjPyld = {
                cofWeighting: overallRisk.cofWeighting,
                lofWeighting: overallRisk.lofWeighting,
                riskMethod: overallRisk.riskMethod,
                grades: riskMatrixRanges,
                grid: riskMatrixGrid,
                preview: {
                    grades: riskMatrixRanges,
                    grid: riskMatrixGrid,
                },
                configId: riskSetting.configId,
                initialLoad: true,
            };
            dispatch((0, _Actions_1.initRiskMatrixPreview)(previewObjPyld));
        }
    };
    var onPreviewCancelClicked = function () {
        if (riskSetting.matrix) {
            var matrix = {
                grades: riskMatrixRanges,
                grid: riskMatrixGrid,
                preview: {
                    grades: riskMatrixRanges,
                    grid: riskMatrixGrid,
                },
            };
            dispatch((0, _Actions_1.cancelRiskMatrixPreview)({
                configId: riskSetting.configId,
                matrix: matrix,
            }));
        }
    };
    var onRunClicked = function () {
        dispatch((0, _Actions_1.runRisk)(params.configId));
        dispatch((0, _Actions_1.setRefreshList)(true));
    };
    var onCancelClicked = function () {
        setIsRiskRunCancelling(true);
        setOpenCancel(true);
    };
    // This stops the dialog closing when clicked on the background
    var onCloseDialog = function () { return void {}; };
    var dialogProps = {
        open: openCancel,
        onClose: onCloseDialog,
    };
    var handleCancelConfirmYes = function () {
        dispatch((0, _Actions_1.resetRisk)(params.configId));
        setOpenCancel(false);
    };
    var handleCancelConfirmNo = function () {
        setIsRiskRunCancelling(false);
        setOpenCancel(false);
    };
    var onSaveRiskClicked = function () {
        if (didMatrixUpdate) {
            //if Risk Matrix was updated
            var oldRiskConfig = __assign({}, riskConfig);
            var oldRiskSetting = __assign({}, riskSetting);
            var newMatrix = {
                grades: __assign({}, riskStore.riskMatrix.grades),
                grid: __spreadArray([], riskStore.riskMatrix.grid, true),
            };
            var newSetting = __assign(__assign({}, oldRiskSetting), { matrix: newMatrix });
            var newRiskConfig = __assign(__assign({}, oldRiskConfig), { riskSetting: newSetting });
            dispatch((0, _Actions_1.saveRiskConfigAction)(newRiskConfig));
        }
        dispatch((0, _Actions_1.setOnlyGradesUpdated)(false));
        dispatch((0, _Actions_1.setDidMatrixUpdate)(false));
        dispatch((0, _Actions_1.setRiskSetupDirty)(false));
        dispatch((0, _Actions_1.setMatrixPreviewStatus)(''));
        dispatch((0, _Actions_1.setSaveRun)(true));
        dispatch((0, _Actions_1.setRefreshList)(true));
    };
    var onEditName = function () {
        setEditName(true);
    };
    var onEditNameClose = function (saved) {
        setEditName(false);
        if (saved) {
            dispatch((0, Actions_1.changeRiskConfigsPage)(riskPage.page));
        }
    };
    var getActionButton = function () {
        if (enablePreview &&
            !riskStore.isOnlyGradesUpdated &&
            !riskStore.isPreviewLoading) {
            return ((0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ dataCy: "button-preview", disabled: riskStore.isLoading, variant: "contained", color: "primary", style: {
                    height: '36px',
                    marginLeft: '12px',
                    width: '100%',
                }, onClick: onPreviewClicked }, { children: t('Preview') }), "button-preview"));
        }
        else if (riskStore.isPreviewLoading) {
            return ((0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ dataCy: "button-cancel-preview", variant: "contained", color: "error", style: {
                    height: '36px',
                    marginLeft: '12px',
                    width: '100%',
                }, onClick: onPreviewCancelClicked }, { children: t('Cancel Preview') }), "button-cancel-preview"));
        }
        else if (isRiskSetupDirty) {
            return ((0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ dataCy: "button-save", disabled: riskStore.isLoading, variant: "contained", color: "primary", style: {
                    height: '36px',
                    marginLeft: '12px',
                    width: '100%',
                }, onClick: onSaveRiskClicked }, { children: t('Save') }), "button-save"));
        }
        else if (isRiskRunning) {
            return ((0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ dataCy: "button-cancel", variant: "contained", color: "error", disabled: isRiskRunCancelling, style: {
                    height: '36px',
                    marginLeft: '12px',
                    width: '100%',
                }, onClick: onCancelClicked }, { children: t('Cancel Run') }), "button-cancel"));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ dataCy: "button-run", disabled: riskStore.isLoading, variant: "contained", color: "primary", style: {
                    height: '36px',
                    marginLeft: '12px',
                    width: '100%',
                }, onClick: onRunClicked }, { children: t('Run') }), "button-run"));
        }
    };
    var getSecondary = function () {
        if (tab === 'lof' || tab === 'cof') {
            return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, width: "350px", style: { textAlign: 'end' } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 7, style: { alignSelf: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "caption-small" }, { children: lastRun })), (0, jsx_runtime_1.jsx)(stylovyze_1.Text, { children: calcStatus })] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 5 }, { children: (0, jsx_runtime_1.jsx)(stylovyze_1.Button, __assign({ disabled: !canBeSaved(), variant: "contained", color: "primary", style: {
                                height: '36px',
                                marginLeft: '12px',
                                width: '100%',
                            }, onClick: saveCLOFConfig }, { children: t('Save') })) }))] })));
        }
        else if (tab === 'risk') {
            return ((0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, width: "350px", style: { textAlign: 'end' } }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 7, style: { alignSelf: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "caption-small" }, { children: lastRun })), (0, jsx_runtime_1.jsx)(stylovyze_1.Text, { children: calcStatus })] })), (0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ item: true, xs: 5 }, { children: getActionButton() }))] })));
        }
        else {
            return ((0, jsx_runtime_1.jsx)(material_1.Grid, __assign({ container: true, width: "350px", style: { textAlign: 'end' } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, xs: 12, style: { alignSelf: 'center' } }, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.Text, __assign({ variant: "caption-small" }, { children: lastRun })), (0, jsx_runtime_1.jsx)(stylovyze_1.Text, { children: calcStatus })] })) })));
        }
    };
    var beforeTabChange = function (event) {
        event.cancelled = true;
        switch (event.toIndex) {
            case 0:
                history.push((0, actions_1.addRouteNamespace)("results/".concat(params.configId)));
                break;
            case 1:
                history.push((0, actions_1.addRouteNamespace)("lofSetup/".concat(params.configId)));
                break;
            case 2:
                history.push((0, actions_1.addRouteNamespace)("cofSetup/".concat(params.configId)));
                break;
            case 3:
                history.push((0, actions_1.addRouteNamespace)("riskSetup/".concat(params.configId)));
                break;
            case 4:
                history.push((0, actions_1.addRouteNamespace)("riskLog/".concat(params.configId)));
                break;
        }
        return event;
    };
    var back = function () {
        if (!websocketRiskStatus)
            pollRiskCalcStatus(true);
        history.push('/risk/');
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(stylovyze_1.WarningDialog, { dialogProps: dialogProps, "data-cy": "cancel-dialog", open: openCancel, title: t('Cancel Risk Run?'), content: t('Are you sure you want to cancel the risk run?'), cancelText: t('No'), cancelButtonProps: {
                    dataCy: 'cancel-cancel',
                }, confirmText: t('Cancel Run'), confirmButtonProps: {
                    dataCy: 'cancel-confirm',
                }, onCancel: handleCancelConfirmNo, onConfirm: handleCancelConfirmYes }), step2 ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(_Components_1.AddEditComponent, { countKey: isNew
                            ? 'NewConfig'
                            : "".concat(params.configId, "-").concat(component.type, "-").concat(forLoF ? 'lof' : 'cof', "-").concat(component.name), forLoF: forLoF, observations: (forLoF &&
                            riskStore.riskConfig.riskSetting
                                .inspectionStandard ===
                                InspectionStandardType_1.InspectionStandardType.PACP) ||
                            riskStore.riskConfig.riskSetting
                                .inspectionStandard ===
                                InspectionStandardType_1.InspectionStandardType.MACP, inspectionType: forInspection
                            ? riskStore.riskConfig.riskSetting
                                .inspectionStandard
                            : undefined, isNew: isNew, assetType: riskStore.riskConfig.riskSetting.assetType, assetFilterId: riskStore.riskConfig.riskSetting.assetFilterId, category: cat, component: component, onApply: function () {
                            setStep2(false);
                        }, onCancel: function () {
                            setStep2(false);
                        } }), (0, jsx_runtime_1.jsx)(stylovyze_1.NavigationPrompt, { title: t('Add New Component'), content: t('Navigating away from this page will cancel the new component. Do you want to continue to navigate away from this page?'), cancelText: t('No'), confirmText: t('Yes'), when: true, shouldBlockReload: true, navigate: function (nextLocation) {
                            history.push(nextLocation);
                        }, shouldBlockNavigation: function () { return true; } })] })) : ((0, jsx_runtime_1.jsx)(FullRiskPage_1.default, { getSecondary: getSecondary, back: back, multipleModels: multipleModels, beforeTabChange: beforeTabChange, pageIndex: pageIndex !== null && pageIndex !== void 0 ? pageIndex : 0, refreshRiskScore: refreshRiskScore, onAddComponent: onAddComponent, onEditComponent: onEditComponent, onEditName: onEditName, t: t })), (0, jsx_runtime_1.jsx)(_Components_1.RenameRisk, { open: editName, onClose: onEditNameClose })] }));
};
exports.RiskManagement = RiskManagement;
exports["default"] = exports.RiskManagement;


/***/ }),

/***/ "./pages/RiskManagement/index.ts":
/*!***************************************!*\
  !*** ./pages/RiskManagement/index.ts ***!
  \***************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var RiskManagement_page_1 = __webpack_require__(/*! ./RiskManagement.page */ "./pages/RiskManagement/RiskManagement.page.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(RiskManagement_page_1).default; } }));


/***/ }),

/***/ "./pages/RiskManagementList/RiskManagementList.page.tsx":
/*!**************************************************************!*\
  !*** ./pages/RiskManagementList/RiskManagementList.page.tsx ***!
  \**************************************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskManagementList = void 0;
var jsx_runtime_1 = __webpack_require__(/*! react/jsx-runtime */ "../node_modules/react/jsx-runtime.js");
var asset_actions_1 = __webpack_require__(/*! @Actions/asset.actions */ "./actions/asset.actions.ts");
var Risk_actions_1 = __webpack_require__(/*! @Actions/Risk.actions */ "./actions/Risk.actions.ts");
var RiskList_1 = __importDefault(__webpack_require__(/*! @Components/RiskList */ "./components/RiskList/index.ts"));
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var Selectors_1 = __webpack_require__(/*! @innovyze/lib-am-common/Selectors */ "@innovyze/lib-am-common/Selectors");
var Actions_1 = __webpack_require__(/*! @innovyze/lib-am-common/Actions */ "@innovyze/lib-am-common/Actions");
var useGlobalization_1 = __webpack_require__(/*! @Translations/useGlobalization */ "./i18n/useGlobalization.ts");
var styles_1 = __webpack_require__(/*! @Utils/styles */ "./utils/styles.ts");
var react_1 = __webpack_require__(/*! react */ "react");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var LoF_actions_1 = __webpack_require__(/*! @Actions/LoF.actions */ "./actions/LoF.actions.ts");
var CoF_actions_1 = __webpack_require__(/*! @Actions/CoF.actions */ "./actions/CoF.actions.ts");
var Risk_selectors_1 = __webpack_require__(/*! @Selectors/Risk.selectors */ "./selectors/Risk.selectors.ts");
var RiskCalcStatus_1 = __importDefault(__webpack_require__(/*! @Components/RiskCalcStatus/RiskCalcStatus */ "./components/RiskCalcStatus/RiskCalcStatus.ts"));
var lib_asset_schema_store_1 = __webpack_require__(/*! @innovyze/lib_asset_schema_store */ "@innovyze/lib_asset_schema_store");
var react_router_dom_1 = __webpack_require__(/*! react-router-dom */ "react-router-dom");
var useSystemTypes_1 = __webpack_require__(/*! @Hooks/useSystemTypes */ "./hooks/useSystemTypes.ts");
var RiskManagementList = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    var pathname = (0, react_router_dom_1.useLocation)().pathname;
    var t = (0, useGlobalization_1.useGlobalization)().t;
    var isLoading = (0, Selectors_1.selectRiskConfigsIsLoading)();
    var isWaiting = (0, Selectors_1.selectRiskConfigsIsWaiting)();
    var isCreating = (0, Risk_selectors_1.selectRiskConfigIsCreating)();
    var riskPage = (0, Selectors_1.selectRiskConfigsPage)();
    var isSaveFilterOn = (0, stylovyze_1.useIsFeatureEnabled)('info-360-assets-save-filter');
    var systemTypes = (0, useSystemTypes_1.useSystemTypes)();
    (0, react_1.useEffect)(function () {
        if (riskPage === undefined || riskPage.total === 0) {
            dispatch((0, Actions_1.getRiskConfigsClear)());
            dispatch((0, Actions_1.getAssetCounts)(systemTypes.map(function (s) { return s.id; })));
        }
        dispatch((0, Risk_actions_1.clearRiskConfig)());
        dispatch((0, LoF_actions_1.getLoFConfigResolved)([]));
        dispatch((0, CoF_actions_1.getCoFComponentsResolved)([]));
        dispatch((0, lib_asset_schema_store_1.getAllAssetsSchemaAction)());
        // Cancel any polling
        RiskCalcStatus_1.default.cancelPollForCalcStatus();
    }, []);
    (0, react_1.useEffect)(function () {
        // Reload filters when nagivating back to /risk page
        if (String(pathname).includes('risk') && isSaveFilterOn) {
            dispatch((0, asset_actions_1.getAssetFilterList)());
        }
    }, [pathname]);
    var riskListTab = function () {
        return ((0, jsx_runtime_1.jsx)(styles_1.FullPage, { children: (0, jsx_runtime_1.jsx)(RiskList_1.default, {}) }));
    };
    var secondaryNav = function () {
        var tabs = [{ content: riskListTab(), title: t('Risk Models') }];
        return tabs;
    };
    return ((0, jsx_runtime_1.jsx)(styles_1.FullPageWrapper, { className: isLoading || isWaiting || isCreating ? 'wait' : '', title: t('Risk Models'), applyPadding: true, headerUnderline: true, 
        //secondary={<CreateSecondaryButtons />}
        secondaryNav: {
            items: secondaryNav(),
            itemIndex: 0,
        } }));
};
exports.RiskManagementList = RiskManagementList;
exports["default"] = exports.RiskManagementList;


/***/ }),

/***/ "./pages/RiskManagementList/index.ts":
/*!*******************************************!*\
  !*** ./pages/RiskManagementList/index.ts ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports["default"] = void 0;
var RiskManagementList_page_1 = __webpack_require__(/*! ./RiskManagementList.page */ "./pages/RiskManagementList/RiskManagementList.page.tsx");
Object.defineProperty(exports, "default", ({ enumerable: true, get: function () { return __importDefault(RiskManagementList_page_1).default; } }));


/***/ }),

/***/ "./pages/index.ts":
/*!************************!*\
  !*** ./pages/index.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RiskManagementList = exports.AssetDetails = exports.InspectionDetails = exports.RiskManagement = void 0;
var RiskManagement_1 = __importDefault(__webpack_require__(/*! ./RiskManagement */ "./pages/RiskManagement/index.ts"));
exports.RiskManagement = RiskManagement_1.default;
var InspectionDetails_1 = __importDefault(__webpack_require__(/*! ./InspectionDetails */ "./pages/InspectionDetails/index.tsx"));
exports.InspectionDetails = InspectionDetails_1.default;
var AssetDetails_1 = __importDefault(__webpack_require__(/*! ./AssetDetails */ "./pages/AssetDetails/index.tsx"));
exports.AssetDetails = AssetDetails_1.default;
var RiskManagementList_1 = __importDefault(__webpack_require__(/*! ./RiskManagementList */ "./pages/RiskManagementList/index.ts"));
exports.RiskManagementList = RiskManagementList_1.default;
__exportStar(__webpack_require__(/*! ./PageRoutes */ "./pages/PageRoutes.tsx"), exports);


/***/ }),

/***/ "./reducers/riskDetailsPagination.ts":
/*!*******************************************!*\
  !*** ./reducers/riskDetailsPagination.ts ***!
  \*******************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.paginationDefault = exports.headerReactNodes = exports.mapRowToCells = exports.ColumnNoCDFindAsset = exports.ColumnFindAsset = exports.ColumnNoCD = exports.Column = void 0;
var Reducers_1 = __webpack_require__(/*! @innovyze/lib-am-common/Reducers */ "@innovyze/lib-am-common/Reducers");
// Columns in order displayed by table
var Column;
(function (Column) {
    Column[Column["AssetId"] = 0] = "AssetId";
    Column[Column["RiskTrend"] = 1] = "RiskTrend";
    Column[Column["CurrentRisk"] = 2] = "CurrentRisk";
    Column[Column["CurrentLOF"] = 3] = "CurrentLOF";
    Column[Column["CurrentCOF"] = 4] = "CurrentCOF";
    Column[Column["ConditionData"] = 5] = "ConditionData";
    Column[Column["Grade"] = 6] = "Grade";
})(Column = exports.Column || (exports.Column = {}));
var ColumnNoCD;
(function (ColumnNoCD) {
    ColumnNoCD[ColumnNoCD["AssetId"] = 0] = "AssetId";
    ColumnNoCD[ColumnNoCD["RiskTrend"] = 1] = "RiskTrend";
    ColumnNoCD[ColumnNoCD["CurrentRisk"] = 2] = "CurrentRisk";
    ColumnNoCD[ColumnNoCD["CurrentLOF"] = 3] = "CurrentLOF";
    ColumnNoCD[ColumnNoCD["CurrentCOF"] = 4] = "CurrentCOF";
    ColumnNoCD[ColumnNoCD["Grade"] = 5] = "Grade";
})(ColumnNoCD = exports.ColumnNoCD || (exports.ColumnNoCD = {}));
var ColumnFindAsset;
(function (ColumnFindAsset) {
    ColumnFindAsset[ColumnFindAsset["AssetId"] = 0] = "AssetId";
    ColumnFindAsset[ColumnFindAsset["RiskTrend"] = 1] = "RiskTrend";
    ColumnFindAsset[ColumnFindAsset["CurrentRisk"] = 2] = "CurrentRisk";
    ColumnFindAsset[ColumnFindAsset["CurrentLOF"] = 3] = "CurrentLOF";
    ColumnFindAsset[ColumnFindAsset["CurrentCOF"] = 4] = "CurrentCOF";
    ColumnFindAsset[ColumnFindAsset["ConditionData"] = 5] = "ConditionData";
    ColumnFindAsset[ColumnFindAsset["Grade"] = 6] = "Grade";
    ColumnFindAsset[ColumnFindAsset["Menu"] = 7] = "Menu";
})(ColumnFindAsset = exports.ColumnFindAsset || (exports.ColumnFindAsset = {}));
var ColumnNoCDFindAsset;
(function (ColumnNoCDFindAsset) {
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["AssetId"] = 0] = "AssetId";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["RiskTrend"] = 1] = "RiskTrend";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["CurrentRisk"] = 2] = "CurrentRisk";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["CurrentLOF"] = 3] = "CurrentLOF";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["CurrentCOF"] = 4] = "CurrentCOF";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["Grade"] = 5] = "Grade";
    ColumnNoCDFindAsset[ColumnNoCDFindAsset["Menu"] = 6] = "Menu";
})(ColumnNoCDFindAsset = exports.ColumnNoCDFindAsset || (exports.ColumnNoCDFindAsset = {}));
var mapRowToCells = function (row) {
    var _a, _b, _c, _d, _e, _f;
    return [
        (row === null || row === void 0 ? void 0 : row.ASSET_ID) || '',
        (row === null || row === void 0 ? void 0 : row.RISK_CHANGE) == null || (row === null || row === void 0 ? void 0 : row.RISK_CHANGE) == undefined
            ? ''
            : row === null || row === void 0 ? void 0 : row.RISK_CHANGE,
        (_a = row === null || row === void 0 ? void 0 : row.CURRENT_RISK) === null || _a === void 0 ? void 0 : _a.toString(),
        (_b = row === null || row === void 0 ? void 0 : row.CURRENT_LOF) === null || _b === void 0 ? void 0 : _b.toString(),
        (_c = row === null || row === void 0 ? void 0 : row.CURRENT_COF) === null || _c === void 0 ? void 0 : _c.toString(),
        (_e = (_d = row === null || row === void 0 ? void 0 : row.CONDITION_DATA) === null || _d === void 0 ? void 0 : _d.toString()) !== null && _e !== void 0 ? _e : '',
        (_f = row === null || row === void 0 ? void 0 : row.GRADE) === null || _f === void 0 ? void 0 : _f.toString(),
        '',
    ];
};
exports.mapRowToCells = mapRowToCells;
var headerReactNodes = function (noConditionData, showFindAsset, t) {
    var rows = [
        {
            key: 'ASSET_ID',
            cell: t ? t('Asset ID') : 'Asset ID',
            maxWidth: '200px',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
        {
            key: 'RISK_CHANGE',
            cell: t ? t('Risk Trend') : 'Risk Trend',
            width: 'auto',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
        {
            key: 'CURRENT_RISK',
            cell: t ? t('Risk Score') : 'Risk Score',
            width: 'auto',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
        {
            key: 'CURRENT_LOF',
            cell: t ? t('Total LoF') : 'Total LoF',
            width: 'auto',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
        {
            key: 'CURRENT_COF',
            cell: t ? t('Total CoF') : 'Total CoF',
            width: 'auto',
            align: 'left',
            sortable: true,
            padding: '0 10px',
        },
    ];
    if (!noConditionData) {
        rows.push({
            key: 'CONDITION_DATA',
            cell: t ? t('Condition Data') : 'Condition Data',
            width: 'auto',
            align: 'left',
            sortable: false,
            padding: '0 10px',
        });
    }
    rows.push({
        key: 'GRADE',
        cell: t ? t('Grade') : 'Grade',
        width: '150px',
        align: 'left',
        sortable: true,
        padding: '0 10px',
    });
    if (showFindAsset) {
        rows.push({
            key: 'MENU',
            cell: '',
            width: '68px',
            align: 'center',
            padding: '0 10px',
        });
    }
    return rows;
};
exports.headerReactNodes = headerReactNodes;
var paginationDefault = function () { return (__assign(__assign({}, Reducers_1.paginationInitialState), { sortKey: 'uploadDateTime', sortDescending: true })); };
exports.paginationDefault = paginationDefault;


/***/ }),

/***/ "./selectors/CoF.selectors.ts":
/*!************************************!*\
  !*** ./selectors/CoF.selectors.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectMaxCoFValue = exports.selectorMaxCoFValue = exports.selectCoFComponentFields = exports.selectorCoFConfigChanged = exports.selectCofStore = exports.CoFComponentFieldsSelector = exports.CoFConfigChanged = exports.CoFStoreSelector = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
exports.CoFStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.CoFConfig; });
exports.CoFConfigChanged = (0, toolkit_1.createSelector)(exports.CoFStoreSelector, function (cofStore) { return cofStore.isChanged; });
exports.CoFComponentFieldsSelector = (0, toolkit_1.createSelector)(exports.CoFStoreSelector, function (cofStore) { return cofStore.componentFields; });
var selectCofStore = function () { return (0, react_redux_1.useSelector)(exports.CoFStoreSelector); };
exports.selectCofStore = selectCofStore;
var selectorCoFConfigChanged = function () { return (0, react_redux_1.useSelector)(exports.CoFConfigChanged); };
exports.selectorCoFConfigChanged = selectorCoFConfigChanged;
var selectCoFComponentFields = function () {
    return (0, react_redux_1.useSelector)(exports.CoFComponentFieldsSelector);
};
exports.selectCoFComponentFields = selectCoFComponentFields;
exports.selectorMaxCoFValue = (0, toolkit_1.createSelector)(exports.CoFStoreSelector, function (cofStore) {
    var maxValue = 10;
    cofStore.categories.forEach(function (category) {
        category.components.forEach(function (component) {
            if (component.select) {
                if (component.type === _Types_1.ComponentType.MultiParam &&
                    component.scoreMatrix) {
                    component.scoreMatrix.forEach(function (data) {
                        if (data.score > maxValue)
                            maxValue = data.score;
                    });
                }
                else if (component.metadata) {
                    component.metadata.forEach(function (data) {
                        if (data.value > maxValue)
                            maxValue = data.value;
                    });
                }
            }
        });
    });
    return maxValue;
});
var selectMaxCoFValue = function () { return (0, react_redux_1.useSelector)(exports.selectorMaxCoFValue); };
exports.selectMaxCoFValue = selectMaxCoFValue;


/***/ }),

/***/ "./selectors/LoF.selectors.ts":
/*!************************************!*\
  !*** ./selectors/LoF.selectors.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectMaxLoFValue = exports.selectorMaxLoFValue = exports.selectLoFComponentFields = exports.selectLoFComponentInspectionFields = exports.selectorLoFConfigChanged = exports.selectLofConfig = exports.selectLofStore = exports.LoFComponentFieldsSelector = exports.LoFComponentInspectionFieldsSelector = exports.LoFConfigChanged = exports.LoFStoreSelector = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var _Types_1 = __webpack_require__(/*! @Types */ "./types/index.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
exports.LoFStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.LoFConfig; });
var LoFConfigSelector = (0, toolkit_1.createSelector)(exports.LoFStoreSelector, function (lofStore) { return lofStore.categories; });
exports.LoFConfigChanged = (0, toolkit_1.createSelector)(exports.LoFStoreSelector, function (lofStore) { return lofStore.isChanged; });
exports.LoFComponentInspectionFieldsSelector = (0, toolkit_1.createSelector)(exports.LoFStoreSelector, function (lofStore) { return lofStore.componentInspectionFields; });
exports.LoFComponentFieldsSelector = (0, toolkit_1.createSelector)(exports.LoFStoreSelector, function (lofStore) { return lofStore.componentFields; });
var selectLofStore = function () { return (0, react_redux_1.useSelector)(exports.LoFStoreSelector); };
exports.selectLofStore = selectLofStore;
var selectLofConfig = function () { return (0, react_redux_1.useSelector)(LoFConfigSelector); };
exports.selectLofConfig = selectLofConfig;
var selectorLoFConfigChanged = function () { return (0, react_redux_1.useSelector)(exports.LoFConfigChanged); };
exports.selectorLoFConfigChanged = selectorLoFConfigChanged;
var selectLoFComponentInspectionFields = function () {
    return (0, react_redux_1.useSelector)(exports.LoFComponentInspectionFieldsSelector);
};
exports.selectLoFComponentInspectionFields = selectLoFComponentInspectionFields;
var selectLoFComponentFields = function () {
    return (0, react_redux_1.useSelector)(exports.LoFComponentFieldsSelector);
};
exports.selectLoFComponentFields = selectLoFComponentFields;
exports.selectorMaxLoFValue = (0, toolkit_1.createSelector)(exports.LoFStoreSelector, function (lofStore) {
    var maxValue = 10;
    lofStore.categories.forEach(function (category) {
        category.components.forEach(function (component) {
            if (component.select) {
                if (component.type === _Types_1.ComponentType.MultiParam &&
                    component.scoreMatrix) {
                    component.scoreMatrix.forEach(function (data) {
                        if (data.score > maxValue)
                            maxValue = data.score;
                    });
                }
                else if (component.metadata) {
                    component.metadata.forEach(function (data) {
                        if (data.value > maxValue)
                            maxValue = data.value;
                    });
                }
            }
        });
    });
    return maxValue;
});
var selectMaxLoFValue = function () { return (0, react_redux_1.useSelector)(exports.selectorMaxLoFValue); };
exports.selectMaxLoFValue = selectMaxLoFValue;


/***/ }),

/***/ "./selectors/Risk.selectors.ts":
/*!*************************************!*\
  !*** ./selectors/Risk.selectors.ts ***!
  \*************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectRefreshMatrixGrid = exports.selectorRefreshMatrixGrid = exports.selectPreviewStatus = exports.selectRiskType = exports.selectUpdatedRiskMatrixGrid = exports.selectUpdatedRiskRanges = exports.selectOnlyGradesUpdated = exports.selectIsPreviewOnLoad = exports.selectIsPreviewLoading = exports.selectPreviewCancelled = exports.selectEnablePreview = exports.selectDidMatrixUpdate = exports.selectRiskMatrix = exports.selectRiskCount = exports.useSelectIsCountLoading = exports.selectorIsCountLoading = exports.selectRiskDetailsStatus = exports.selectRiskIsDeleting = exports.selectRiskIsSaving = exports.selectRiskConfigIsCreating = exports.selectRiskConfigNameError = exports.selectIsRiskSetupDirty = exports.selectRiskDetailsFilterProps = exports.selectRiskDetailsSearch = exports.selectSaveRunSettings = exports.selectRiskDetailsIsWaiting = exports.selectIsLoading = exports.selectRiskDetailsIsLoading = exports.selectRowsPerPage = exports.selectRiskDetailsPagination = exports.selectRiskDetailsTablePage = exports.selectRiskDetailsStartSearch = exports.selectRiskDetailsQueryObj = exports.selectRiskDetailsQuery = exports.selectRiskTab = exports.selectRiskSetting = exports.selectRiskConfig = exports.selectRiskStore = exports.selectRefreshList = exports.selectRunCompleteReload = exports.selectorRowsPerPage = exports.selectCanReload = exports.selectSelectedRiskRows = exports.selectSelectionGridRows = exports.riskDetailsQuerySelectorObj = exports.riskDetailsQuerySelector = exports.searchQuerySelector = exports.selectorRiskDetailsRows = exports.selectorRiskDetailsPagination = exports.RiskConfigSelector = void 0;
exports.useSelectCofCategories = exports.useSelectLofCategories = exports.selectOverallRisk = exports.selectorOverallRisk = exports.selectEditedCellsList = exports.selectorEditedCellsList = void 0;
/*eslint import/no-unresolved: [2, { ignore: ['\\.lib-am-common/Reducers$'] }]*/
var AM_COMMON = __importStar(__webpack_require__(/*! @innovyze/lib-am-common/Reducers */ "@innovyze/lib-am-common/Reducers"));
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var riskDetailsPagination_1 = __webpack_require__(/*! @Reducers/riskDetailsPagination */ "./reducers/riskDetailsPagination.ts");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var riskStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.RiskStore; });
exports.RiskConfigSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (RiskStore) { return RiskStore.riskConfig; });
var RiskSettingSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (RiskStore) { return RiskStore.riskConfig.riskSetting; });
var RiskTabSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.tab; });
var cofCategoriesSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskConfig.COFCategories; });
var lofCategoriesSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskConfig.LOFCategories; });
exports.selectorRiskDetailsPagination = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { var _a; return (_a = riskStore.riskDetails) === null || _a === void 0 ? void 0 : _a.pagination; });
exports.selectorRiskDetailsRows = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { var _a; return (_a = riskStore.riskDetails) === null || _a === void 0 ? void 0 : _a.rows; });
var selectorPaginationQuery = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskDetails.query; });
var selectorFilterQuery = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.dropdownFilters.query; });
var selectorIsRiskSetupDirty = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isSetupDirty; });
exports.searchQuerySelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) {
    return riskStore.search.length
        ? "&search=".concat(encodeURIComponent(riskStore.search))
        : '';
});
exports.riskDetailsQuerySelector = (0, toolkit_1.createSelector)(riskStoreSelector, selectorPaginationQuery, selectorFilterQuery, exports.searchQuerySelector, function (riskStore, pag, filters, search) {
    var settings = riskStore.riskConfig.riskSetting;
    var riskDetails = riskStore.riskDetails;
    var q = pag;
    q = q.length
        ? q + "&configId=".concat(settings.configId)
        : "?configId=".concat(settings.configId);
    if (riskDetails.scanId) {
        q = q.length
            ? q + "&scanId=".concat(riskDetails.scanId)
            : "?scanId=".concat(riskDetails.scanId);
    }
    if (filters.length) {
        q += filters;
    }
    if (search.length) {
        q += search;
    }
    q = q + '&includeScores=true';
    return q;
});
exports.riskDetailsQuerySelectorObj = (0, toolkit_1.createSelector)(riskStoreSelector, selectorPaginationQuery, selectorFilterQuery, exports.searchQuerySelector, function (riskStore, pag, filters, search) {
    var _a, _b, _c, _d, _e;
    var settings = riskStore.riskConfig.riskSetting;
    var riskDetails = riskStore.riskDetails;
    var obj = {};
    if (pag === null || pag === void 0 ? void 0 : pag.length) {
        obj['sort'] = (_b = (_a = riskStore.riskDetails) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.sortKey;
        obj['sortDescending'] =
            (_e = (_d = (_c = riskStore.riskDetails) === null || _c === void 0 ? void 0 : _c.pagination) === null || _d === void 0 ? void 0 : _d.sortDescending) !== null && _e !== void 0 ? _e : false;
    }
    obj['configId'] = settings.configId;
    if (riskDetails.scanId) {
        obj['scanId'] = riskDetails.scanId;
    }
    if (filters.length) {
        obj['filters'] = riskStore.dropdownFilters.filters;
    }
    if (search.length) {
        obj['search'] = encodeURIComponent(riskStore.search);
    }
    obj['includeScores'] = true;
    return obj;
});
var riskDetailsStartSeachSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.startSearch; });
var selectorRiskDetailsTablePage = (0, toolkit_1.createSelector)([exports.selectorRiskDetailsPagination, exports.selectorRiskDetailsRows], function (pagination, rows) { return ({
    pages: pagination.pages,
    page: pagination.page,
    cells: rows.map(function (r) { return (0, riskDetailsPagination_1.mapRowToCells)(r); }),
    rowIds: rows.map(function (r) { return (r === null || r === void 0 ? void 0 : r._id) || ''; }),
    sortKey: pagination.sortKey,
    sortDescending: pagination.sortDescending,
    total: pagination.total,
}); });
var selectorCanReload = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { var _a, _b; return ((_b = (_a = riskStore.riskDetails) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.total) > 0; });
var selectorRunCompleteReload = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.runCompleteReload; });
var selectorRiskDetailsSlice = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskDetails.pagination.slice; });
var selectorRiskDetailsIsLoading = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskDetails.isLoading; });
var selectorIsLoading = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isLoading; });
var selectorRiskDetailsIsWaiting = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskDetails.isWaiting; });
var selectorSaveRunSettings = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.saveRun; });
var selectorRiskDetailsSearch = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.search; });
var selectorRiskConfigNameError = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskConfigNameError; });
var selectorRiskConfigIsCreating = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isCreating; });
var selectorRiskConfigIsSaving = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isSaving; });
var selectorRiskIsDeleting = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isDeleting; });
var riskDetailsStatusSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskDetails.status; });
var selectorRefreshList = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.refreshList; });
var RiskIsCountLoadingStoreSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isCountLoading; });
var RiskCountStoreSelector = (0, toolkit_1.createSelector)(riskStoreSelector, function (state) { return state.riskCount; });
var selectorFilterProps = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) {
    return Object.values(riskStore.dropdownFilters.selects);
});
var passInSelection = function (state, selectedItems) { return selectedItems; };
exports.selectSelectionGridRows = (0, toolkit_1.createSelector)([exports.selectorRiskDetailsRows, passInSelection], function (rows, selection) { return rows === null || rows === void 0 ? void 0 : rows.filter(function (_a) {
    var _id = _a._id;
    return selection.includes(_id);
}); });
exports.selectSelectedRiskRows = (0, toolkit_1.createSelector)([exports.selectSelectionGridRows], function (rows) {
    return rows.map(function (_a) {
        var _id = _a._id;
        return ({
            _id: _id,
        });
    });
});
var selectCanReload = function () { return (0, react_redux_1.useSelector)(selectorCanReload); };
exports.selectCanReload = selectCanReload;
var selectorRowsPerPage = function (dispatchSliceFn) {
    return (0, toolkit_1.createSelector)(selectorRiskDetailsSlice, function (slice) {
        return AM_COMMON.rowsPerPage(slice || 10, dispatchSliceFn);
    });
};
exports.selectorRowsPerPage = selectorRowsPerPage;
var selectRunCompleteReload = function () {
    return (0, react_redux_1.useSelector)(selectorRunCompleteReload);
};
exports.selectRunCompleteReload = selectRunCompleteReload;
var selectRefreshList = function () { return (0, react_redux_1.useSelector)(selectorRefreshList); };
exports.selectRefreshList = selectRefreshList;
var selectRiskStore = function () { return (0, react_redux_1.useSelector)(riskStoreSelector); };
exports.selectRiskStore = selectRiskStore;
var selectRiskConfig = function () { return (0, react_redux_1.useSelector)(exports.RiskConfigSelector); };
exports.selectRiskConfig = selectRiskConfig;
var selectRiskSetting = function () { return (0, react_redux_1.useSelector)(RiskSettingSelector); };
exports.selectRiskSetting = selectRiskSetting;
var selectRiskTab = function () { return (0, react_redux_1.useSelector)(RiskTabSelector); };
exports.selectRiskTab = selectRiskTab;
var selectRiskDetailsQuery = function () {
    return (0, react_redux_1.useSelector)(exports.riskDetailsQuerySelector);
};
exports.selectRiskDetailsQuery = selectRiskDetailsQuery;
var selectRiskDetailsQueryObj = function () {
    return (0, react_redux_1.useSelector)(exports.riskDetailsQuerySelectorObj);
};
exports.selectRiskDetailsQueryObj = selectRiskDetailsQueryObj;
var selectRiskDetailsStartSearch = function () {
    return (0, react_redux_1.useSelector)(riskDetailsStartSeachSelector);
};
exports.selectRiskDetailsStartSearch = selectRiskDetailsStartSearch;
var selectRiskDetailsTablePage = function () {
    return (0, react_redux_1.useSelector)(selectorRiskDetailsTablePage);
};
exports.selectRiskDetailsTablePage = selectRiskDetailsTablePage;
var selectRiskDetailsPagination = function () {
    return (0, react_redux_1.useSelector)(exports.selectorRiskDetailsPagination);
};
exports.selectRiskDetailsPagination = selectRiskDetailsPagination;
var selectRowsPerPage = function (dispatchSliceFn) {
    return (0, react_redux_1.useSelector)((0, exports.selectorRowsPerPage)(dispatchSliceFn));
};
exports.selectRowsPerPage = selectRowsPerPage;
var selectRiskDetailsIsLoading = function () {
    return (0, react_redux_1.useSelector)(selectorRiskDetailsIsLoading);
};
exports.selectRiskDetailsIsLoading = selectRiskDetailsIsLoading;
var selectIsLoading = function () { return (0, react_redux_1.useSelector)(selectorIsLoading); };
exports.selectIsLoading = selectIsLoading;
var selectRiskDetailsIsWaiting = function () {
    return (0, react_redux_1.useSelector)(selectorRiskDetailsIsWaiting);
};
exports.selectRiskDetailsIsWaiting = selectRiskDetailsIsWaiting;
var selectSaveRunSettings = function () { return (0, react_redux_1.useSelector)(selectorSaveRunSettings); };
exports.selectSaveRunSettings = selectSaveRunSettings;
var selectRiskDetailsSearch = function () {
    return (0, react_redux_1.useSelector)(selectorRiskDetailsSearch);
};
exports.selectRiskDetailsSearch = selectRiskDetailsSearch;
var selectRiskDetailsFilterProps = function () {
    return (0, react_redux_1.useSelector)(selectorFilterProps);
};
exports.selectRiskDetailsFilterProps = selectRiskDetailsFilterProps;
var selectIsRiskSetupDirty = function () {
    return (0, react_redux_1.useSelector)(selectorIsRiskSetupDirty);
};
exports.selectIsRiskSetupDirty = selectIsRiskSetupDirty;
var selectRiskConfigNameError = function () {
    return (0, react_redux_1.useSelector)(selectorRiskConfigNameError);
};
exports.selectRiskConfigNameError = selectRiskConfigNameError;
var selectRiskConfigIsCreating = function () {
    return (0, react_redux_1.useSelector)(selectorRiskConfigIsCreating);
};
exports.selectRiskConfigIsCreating = selectRiskConfigIsCreating;
var selectRiskIsSaving = function () { return (0, react_redux_1.useSelector)(selectorRiskConfigIsSaving); };
exports.selectRiskIsSaving = selectRiskIsSaving;
var selectRiskIsDeleting = function () { return (0, react_redux_1.useSelector)(selectorRiskIsDeleting); };
exports.selectRiskIsDeleting = selectRiskIsDeleting;
var selectRiskDetailsStatus = function () {
    return (0, react_redux_1.useSelector)(riskDetailsStatusSelector);
};
exports.selectRiskDetailsStatus = selectRiskDetailsStatus;
var selectorIsCountLoading = function (key) {
    return (0, toolkit_1.createSelector)(RiskIsCountLoadingStoreSelector, function (state) {
        return state.indexOf(key) !== -1;
    });
};
exports.selectorIsCountLoading = selectorIsCountLoading;
var useSelectIsCountLoading = function (key) {
    return (0, react_redux_1.useSelector)((0, exports.selectorIsCountLoading)(key));
};
exports.useSelectIsCountLoading = useSelectIsCountLoading;
var selectorRiskCount = function (key) {
    return (0, toolkit_1.createSelector)(RiskCountStoreSelector, function (state) {
        if (state) {
            return state[key];
        }
    });
};
var selectRiskCount = function (key) { return (0, react_redux_1.useSelector)(selectorRiskCount(key)); };
exports.selectRiskCount = selectRiskCount;
//=====risk matrix selectors
var selectorRiskMatrix = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskMatrix; });
var selectRiskMatrix = function () { return (0, react_redux_1.useSelector)(selectorRiskMatrix); };
exports.selectRiskMatrix = selectRiskMatrix;
var selectorDidMatrixUpdate = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.didMatrixUpdate; });
var selectDidMatrixUpdate = function () { return (0, react_redux_1.useSelector)(selectorDidMatrixUpdate); };
exports.selectDidMatrixUpdate = selectDidMatrixUpdate;
var selectorEnablePreview = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskType === 'matrix' && riskStore.enablePreview; });
var selectEnablePreview = function () { return (0, react_redux_1.useSelector)(selectorEnablePreview); };
exports.selectEnablePreview = selectEnablePreview;
var selectorPreviewCancelled = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskType === 'matrix' && riskStore.cancelPreview; });
var selectPreviewCancelled = function () {
    return (0, react_redux_1.useSelector)(selectorPreviewCancelled);
};
exports.selectPreviewCancelled = selectPreviewCancelled;
var selectorIsPreviewLoading = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskType === 'matrix' && riskStore.isPreviewLoading; });
var selectIsPreviewLoading = function () {
    return (0, react_redux_1.useSelector)(selectorIsPreviewLoading);
};
exports.selectIsPreviewLoading = selectIsPreviewLoading;
var selectorIsPreviewOnLoad = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isPreviewOnLoad; });
var selectIsPreviewOnLoad = function () { return (0, react_redux_1.useSelector)(selectorIsPreviewOnLoad); };
exports.selectIsPreviewOnLoad = selectIsPreviewOnLoad;
var selectorOnlyGradesUpdated = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.isOnlyGradesUpdated; });
var selectOnlyGradesUpdated = function () {
    return (0, react_redux_1.useSelector)(selectorOnlyGradesUpdated);
};
exports.selectOnlyGradesUpdated = selectOnlyGradesUpdated;
var selectorUpdatedRiskRanges = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskMatrix.grades; });
var selectUpdatedRiskRanges = function () {
    return (0, react_redux_1.useSelector)(selectorUpdatedRiskRanges);
};
exports.selectUpdatedRiskRanges = selectUpdatedRiskRanges;
var selectorUpdatedRiskMatrixGrid = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskMatrix.grid; });
var selectUpdatedRiskMatrixGrid = function () {
    return (0, react_redux_1.useSelector)(selectorUpdatedRiskMatrixGrid);
};
exports.selectUpdatedRiskMatrixGrid = selectUpdatedRiskMatrixGrid;
var selectorRiskType = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.riskConfig.riskSetting.riskType; });
var selectRiskType = function () { return (0, react_redux_1.useSelector)(selectorRiskType); };
exports.selectRiskType = selectRiskType;
var selectorPreviewStatus = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.previewStatus; });
var selectPreviewStatus = function () { return (0, react_redux_1.useSelector)(selectorPreviewStatus); };
exports.selectPreviewStatus = selectPreviewStatus;
exports.selectorRefreshMatrixGrid = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.refreshMatrixGrid; });
var selectRefreshMatrixGrid = function () {
    return (0, react_redux_1.useSelector)(exports.selectorRefreshMatrixGrid);
};
exports.selectRefreshMatrixGrid = selectRefreshMatrixGrid;
exports.selectorEditedCellsList = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.editedCellsList; });
var selectEditedCellsList = function () { return (0, react_redux_1.useSelector)(exports.selectorEditedCellsList); };
exports.selectEditedCellsList = selectEditedCellsList;
exports.selectorOverallRisk = (0, toolkit_1.createSelector)(riskStoreSelector, function (riskStore) { return riskStore.overallRisk; });
var selectOverallRisk = function () { return (0, react_redux_1.useSelector)(exports.selectorOverallRisk); };
exports.selectOverallRisk = selectOverallRisk;
var useSelectLofCategories = function () { return (0, react_redux_1.useSelector)(lofCategoriesSelector); };
exports.useSelectLofCategories = useSelectLofCategories;
var useSelectCofCategories = function () { return (0, react_redux_1.useSelector)(cofCategoriesSelector); };
exports.useSelectCofCategories = useSelectCofCategories;
///============


/***/ }),

/***/ "./selectors/asset.selectors.ts":
/*!**************************************!*\
  !*** ./selectors/asset.selectors.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectAssetStore = exports.assetStoreSelector = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
exports.assetStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.assets; });
var selectAssetStore = function () { return (0, react_redux_1.useSelector)(exports.assetStoreSelector); };
exports.selectAssetStore = selectAssetStore;


/***/ }),

/***/ "./selectors/component.selectors.ts":
/*!******************************************!*\
  !*** ./selectors/component.selectors.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.useComponentMetadataStore = exports.ComponentStoreSelector = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
exports.ComponentStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state === null || state === void 0 ? void 0 : state.ComponentStore; });
var ComponentRangeMetadataStoreSelector = (0, toolkit_1.createSelector)(exports.ComponentStoreSelector, function (store) { return store; });
var useComponentMetadataStore = function () {
    return (0, react_redux_1.useSelector)(ComponentRangeMetadataStoreSelector);
};
exports.useComponentMetadataStore = useComponentMetadataStore;


/***/ }),

/***/ "./selectors/index.ts":
/*!****************************!*\
  !*** ./selectors/index.ts ***!
  \****************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./CoF.selectors */ "./selectors/CoF.selectors.ts"), exports);
__exportStar(__webpack_require__(/*! ./LoF.selectors */ "./selectors/LoF.selectors.ts"), exports);
__exportStar(__webpack_require__(/*! ./Risk.selectors */ "./selectors/Risk.selectors.ts"), exports);
__exportStar(__webpack_require__(/*! ./component.selectors */ "./selectors/component.selectors.ts"), exports);
__exportStar(__webpack_require__(/*! ./util.selectors */ "./selectors/util.selectors.ts"), exports);
__exportStar(__webpack_require__(/*! ./asset.selectors */ "./selectors/asset.selectors.ts"), exports);


/***/ }),

/***/ "./selectors/util.selectors.ts":
/*!*************************************!*\
  !*** ./selectors/util.selectors.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.selectDataGridState = exports.DataGridSateSelector = exports.selectRiskLastRun = exports.selectRiskRunning = exports.selectRiskStatus = exports.selectRiskNullScore = exports.selectRiskMultiScoreEditDataGrid = exports.selectRiskMultiScoreDataGrid = exports.selectRiskScoreDataGrid = exports.selectRiskScoreTable = exports.selectRiskUnitScores = exports.selectRiskEditScores = exports.selectRiskScores = void 0;
var toolkit_1 = __webpack_require__(/*! @reduxjs/toolkit */ "@reduxjs/toolkit");
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var react_redux_1 = __webpack_require__(/*! react-redux */ "react-redux");
var parseNamespace = function (state) { return state[config_store_1.moduleNamespace]; };
var UtilStoreSelector = (0, toolkit_1.createSelector)(parseNamespace, function (state) { return state.util; });
var RiskScoresSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskScores; });
var RiskScoresEditSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskEditScores; });
var RiskUnitScoresSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskUnitScores; });
var RiskScoreTableSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskScoreTable; });
var RiskScoreDataGridSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskScoreDataGrid; });
var RiskMultiScoreDataGridSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskMultiScoreDataGrid; });
var RiskMultiScoreEditDataGridSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskMultiScoreEditDataGrid; });
var RiskNullScoreSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskNullScore; });
var RiskStatusSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskStatus; });
var RiskRunningSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskRunning; });
var RiskLastRunSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.riskLastRun; });
var selectRiskScores = function () { return (0, react_redux_1.useSelector)(RiskScoresSelector); };
exports.selectRiskScores = selectRiskScores;
var selectRiskEditScores = function () { return (0, react_redux_1.useSelector)(RiskScoresEditSelector); };
exports.selectRiskEditScores = selectRiskEditScores;
var selectRiskUnitScores = function () { return (0, react_redux_1.useSelector)(RiskUnitScoresSelector); };
exports.selectRiskUnitScores = selectRiskUnitScores;
var selectRiskScoreTable = function () { return (0, react_redux_1.useSelector)(RiskScoreTableSelector); };
exports.selectRiskScoreTable = selectRiskScoreTable;
var selectRiskScoreDataGrid = function () {
    return (0, react_redux_1.useSelector)(RiskScoreDataGridSelector);
};
exports.selectRiskScoreDataGrid = selectRiskScoreDataGrid;
var selectRiskMultiScoreDataGrid = function () {
    return (0, react_redux_1.useSelector)(RiskMultiScoreDataGridSelector);
};
exports.selectRiskMultiScoreDataGrid = selectRiskMultiScoreDataGrid;
var selectRiskMultiScoreEditDataGrid = function () {
    return (0, react_redux_1.useSelector)(RiskMultiScoreEditDataGridSelector);
};
exports.selectRiskMultiScoreEditDataGrid = selectRiskMultiScoreEditDataGrid;
var selectRiskNullScore = function () { return (0, react_redux_1.useSelector)(RiskNullScoreSelector); };
exports.selectRiskNullScore = selectRiskNullScore;
var selectRiskStatus = function () { return (0, react_redux_1.useSelector)(RiskStatusSelector); };
exports.selectRiskStatus = selectRiskStatus;
var selectRiskRunning = function () { return (0, react_redux_1.useSelector)(RiskRunningSelector); };
exports.selectRiskRunning = selectRiskRunning;
var selectRiskLastRun = function () { return (0, react_redux_1.useSelector)(RiskLastRunSelector); };
exports.selectRiskLastRun = selectRiskLastRun;
exports.DataGridSateSelector = (0, toolkit_1.createSelector)(UtilStoreSelector, function (state) { return state.dataGridState; });
var selectorDataGridState = function (key) {
    return (0, toolkit_1.createSelector)(exports.DataGridSateSelector, function (state) {
        if (state) {
            return state[key];
        }
    });
};
var selectDataGridState = function (key) {
    return (0, react_redux_1.useSelector)(selectorDataGridState(key));
};
exports.selectDataGridState = selectDataGridState;
exports["default"] = exports.selectRiskScores;


/***/ }),

/***/ "./services/Risk/Risk.services.ts":
/*!****************************************!*\
  !*** ./services/Risk/Risk.services.ts ***!
  \****************************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getRiskPreviewApi = exports.initRiskPreviewApi = exports.getRiskCountScoreMatrixApi = exports.getTaskDataApi = exports.getSimulationDataApi = exports.getRiskCountTaskApi = exports.getRiskCountCustomTableApi = exports.getRiskCountProximityAtributeApi = exports.getRiskCountProximityApi = exports.getRiskCountObservationApi = exports.getRiskCountAtributeApi = exports.getRiskCountInspectionApi = exports.changeRiskConfigPublishStateApi = exports.deleteRiskApi = exports.getSpatialLayerListApi = exports.getRiskCalcLogApi = exports.getRiskCalcStatusService = exports.getRiskDetailsApi = exports.resetRiskPreviewCalculationApi = exports.resetRiskCalculationApi = exports.startRiskCalculationApi = exports.duplicateRiskConfigApi = exports.saveRiskConfigApi = exports.createRiskConfigApi = exports.getRiskConfigApi = void 0;
var risks_api_1 = __importStar(__webpack_require__(/*! @Apis/risks.api */ "./apis/risks.api.ts"));
var i18next_1 = __webpack_require__(/*! i18next */ "i18next");
var lib_get_service_1 = __webpack_require__(/*! @innovyze/lib_get_service */ "@innovyze/lib_get_service");
var getRiskConfigApi = function (configId) {
    var address = "/risk/config?configId=".concat(configId);
    return risks_api_1.default.get(address);
};
exports.getRiskConfigApi = getRiskConfigApi;
var createRiskConfigApi = function (config) {
    var address = '/risk/config';
    return risks_api_1.default.post(address, config);
};
exports.createRiskConfigApi = createRiskConfigApi;
var saveRiskConfigApi = function (config) {
    var address = '/risk/config/version';
    return risks_api_1.default.post(address, config);
};
exports.saveRiskConfigApi = saveRiskConfigApi;
var duplicateRiskConfigApi = function (configId, config) {
    var address = "/risk/config/duplicate?configId=".concat(configId);
    return risks_api_1.default.post(address, config);
};
exports.duplicateRiskConfigApi = duplicateRiskConfigApi;
var startRiskCalculationApi = function (configId) {
    var address = "/risk/calc?configId=".concat(configId);
    return risks_api_1.default.post(address);
};
exports.startRiskCalculationApi = startRiskCalculationApi;
var resetRiskCalculationApi = function (configId) {
    var address = "/risk/calc/reset?configId=".concat(configId);
    return risks_api_1.default.put(address);
};
exports.resetRiskCalculationApi = resetRiskCalculationApi;
var resetRiskPreviewCalculationApi = function (configId) {
    var address = "/risk/calc/reset?configId=".concat(configId, "&isMatrixPreview=true");
    return risks_api_1.default.put(address);
};
exports.resetRiskPreviewCalculationApi = resetRiskPreviewCalculationApi;
var getRiskDetailsApi = function (query) {
    var address = '/risk/score';
    return risks_api_1.default.get("".concat(address).concat(query));
};
exports.getRiskDetailsApi = getRiskDetailsApi;
var RiskCalcStatusService = /** @class */ (function () {
    function RiskCalcStatusService(token, configId) {
        var _this = this;
        this.token = token;
        this.configId = configId;
        this.getHeaders = function () {
            var headers = {
                Authorization: "Bearer ".concat(_this.token),
                'Content-Type': 'application/json',
                Accept: 'application/json',
            };
            var tenantId = (0, lib_get_service_1.getTenantId)();
            if (tenantId)
                headers['X-Tenant-Id'] = tenantId;
            return headers;
        };
    }
    RiskCalcStatusService.prototype.getProcessStatus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch("".concat(risks_api_1.riskBaseUrl, "risk/calc/status?configId=").concat(this.configId), {
                            method: 'GET',
                            headers: this.getHeaders(),
                        })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3: throw new Error((0, i18next_1.t)('Unable to get risk calculation status'));
                }
            });
        });
    };
    return RiskCalcStatusService;
}());
exports["default"] = RiskCalcStatusService;
var getRiskCalcStatusService = function (token, configId) {
    return new RiskCalcStatusService(token, configId);
};
exports.getRiskCalcStatusService = getRiskCalcStatusService;
var getRiskCalcLogApi = function (configId) {
    var address = "/risk/calc/log?configId=".concat(configId);
    return risks_api_1.default.get("".concat(address));
};
exports.getRiskCalcLogApi = getRiskCalcLogApi;
var getSpatialLayerListApi = function () {
    var address = '/spatial/layerlist';
    return risks_api_1.default.get(address);
};
exports.getSpatialLayerListApi = getSpatialLayerListApi;
var deleteRiskApi = function (id) {
    var address = "/risk/config?configId=".concat(id);
    return risks_api_1.default.delete(address);
};
exports.deleteRiskApi = deleteRiskApi;
var changeRiskConfigPublishStateApi = function (newPublishState, configId) {
    var address = "/risk/config/publish?configId=".concat(configId);
    return risks_api_1.default.put(address, { newPublishState: newPublishState });
};
exports.changeRiskConfigPublishStateApi = changeRiskConfigPublishStateApi;
var getRiskCountApi = function (assetType, assetFilterId, fieldType, metadata, metadataType, additionalParams) {
    var params = new URLSearchParams(__assign({ assetType: assetType, fieldType: fieldType }, additionalParams));
    if (assetFilterId) {
        params.append('assetFilterId', assetFilterId);
    }
    var address = "/risk/count?".concat(params.toString());
    return risks_api_1.default.post(address, {
        metadata: metadata,
        metadataType: metadataType,
    });
};
var getRiskCountInspectionApi = function (metadata, metadataType, assetType, assetFilterId, fieldName, inspectionType) {
    return getRiskCountApi(assetType, assetFilterId, 'inspection', metadata, metadataType, {
        fieldName: fieldName,
        inspectionType: inspectionType.toUpperCase(),
    });
};
exports.getRiskCountInspectionApi = getRiskCountInspectionApi;
var getRiskCountAtributeApi = function (metadata, metadataType, assetType, assetFilterId, fieldName) {
    return getRiskCountApi(assetType, assetFilterId, 'attribute', metadata, metadataType, {
        fieldName: fieldName,
    });
};
exports.getRiskCountAtributeApi = getRiskCountAtributeApi;
var getRiskCountObservationApi = function (metadata, metadataType, assetType, assetFilterId, fieldName) {
    fieldName = fieldName === 'Code' ? 'PACP_CODE' : fieldName;
    return getRiskCountApi(assetType, assetFilterId, 'observation', metadata, metadataType, {
        fieldName: fieldName,
    });
};
exports.getRiskCountObservationApi = getRiskCountObservationApi;
var getRiskCountProximityApi = function (metadata, metadataType, assetType, assetFilterId, layerName) {
    return getRiskCountApi(assetType, assetFilterId, 'proximity', metadata, metadataType, {
        layerName: layerName,
    });
};
exports.getRiskCountProximityApi = getRiskCountProximityApi;
var getRiskCountProximityAtributeApi = function (metadata, metadataType, assetType, assetFilterId, layerName, fieldName, valueType, distance) {
    return getRiskCountApi(assetType, assetFilterId, 'proximityAttribute', metadata, metadataType, {
        layerName: layerName,
        fieldName: fieldName,
        maxDistance: distance,
    });
};
exports.getRiskCountProximityAtributeApi = getRiskCountProximityAtributeApi;
var getRiskCountCustomTableApi = function (metadata, metadataType, assetType, assetFilterId, fieldName, tableName, valueType) {
    return getRiskCountApi(assetType, assetFilterId, 'customTable', metadata, metadataType, {
        fieldName: fieldName,
        tableName: tableName,
        valueType: valueType,
    });
};
exports.getRiskCountCustomTableApi = getRiskCountCustomTableApi;
var getRiskCountTaskApi = function (metadata, metadataType, assetType, assetFilterId, fieldName, tableName, valueType, uploadId) {
    var address = "/risk/count?assetType=".concat(assetType, "&assetFilterId=").concat(assetFilterId, "&fieldType=task&fieldName=").concat(fieldName, "&tableName=").concat(tableName, "&uploadId=").concat(uploadId, "&valueType=").concat(valueType);
    return risks_api_1.default.post(address, {
        metadata: metadata,
        metadataType: metadataType,
    });
};
exports.getRiskCountTaskApi = getRiskCountTaskApi;
var getSimulationDataApi = function () {
    return risks_api_1.default.get('/risk/simulations');
};
exports.getSimulationDataApi = getSimulationDataApi;
var getTaskDataApi = function (assetType) {
    return risks_api_1.default.get("/risk/tasks?assetType=".concat(assetType));
};
exports.getTaskDataApi = getTaskDataApi;
var getRiskCountScoreMatrixApi = function (components, scoreMatrix, assetType, assetFilterId, inspectionType) {
    var address = "/risk/count?assetType=".concat(assetType, "&fieldType=multiParam");
    if (assetFilterId)
        address += "&assetFilterId=".concat(assetFilterId);
    if (inspectionType)
        address += "&inspectionType=".concat(inspectionType.toUpperCase());
    return risks_api_1.default.post(address, {
        paramComponents: components,
        scoreMatrix: scoreMatrix,
    });
};
exports.getRiskCountScoreMatrixApi = getRiskCountScoreMatrixApi;
var initRiskPreviewApi = function (cofWeighting, lofWeighting, riskMethod, grades, grid, preview, configId) {
    var address = "/risk/calc?configId=".concat(configId, "&isMatrixPreview=true");
    return risks_api_1.default.post(address, {
        cofWeighting: cofWeighting,
        lofWeighting: lofWeighting,
        riskMethod: riskMethod,
        grades: grades,
        grid: grid,
        preview: preview,
    });
};
exports.initRiskPreviewApi = initRiskPreviewApi;
var getRiskPreviewApi = function (configId) {
    var address = "risk/preview/status?configId=".concat(configId);
    return risks_api_1.default.get(address);
};
exports.getRiskPreviewApi = getRiskPreviewApi;


/***/ }),

/***/ "./store/config.store.ts":
/*!*******************************!*\
  !*** ./store/config.store.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.routeNamespace = exports.moduleNamespace = void 0;
exports.moduleNamespace = 'appAmRisk';
exports.routeNamespace = '/risk';


/***/ }),

/***/ "./types/InspectionStandardType.ts":
/*!*****************************************!*\
  !*** ./types/InspectionStandardType.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.InspectionStandardType = void 0;
var InspectionStandardType;
(function (InspectionStandardType) {
    InspectionStandardType["PACP"] = "pacp";
    InspectionStandardType["WSA"] = "wsa";
    InspectionStandardType["MACP"] = "macp";
})(InspectionStandardType = exports.InspectionStandardType || (exports.InspectionStandardType = {}));


/***/ }),

/***/ "./types/asset.types.ts":
/*!******************************!*\
  !*** ./types/asset.types.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/category.types.ts":
/*!*********************************!*\
  !*** ./types/category.types.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/cof.types.ts":
/*!****************************!*\
  !*** ./types/cof.types.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/component.types.ts":
/*!**********************************!*\
  !*** ./types/component.types.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getTypeDisplay = exports.ComponentType = void 0;
var ComponentType;
(function (ComponentType) {
    ComponentType["SpatialProximity"] = "Spatial Proximity";
    ComponentType["SpatialAttribute"] = "ProximityAttribute";
    ComponentType["CustomTable"] = "customTable";
    ComponentType["MultiParam"] = "multiParam";
    ComponentType["Attribute"] = "attribute";
    ComponentType["Simulation"] = "simulation";
    ComponentType["Task"] = "task";
    ComponentType["Observation"] = "observation";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var getTypeDisplay = function (value, t) {
    switch (value) {
        case ComponentType.SpatialProximity:
            return t('Spatial Proximity');
        case ComponentType.SpatialAttribute:
            return t('Spatial Proximity -- Attribute');
        case ComponentType.CustomTable:
            return t('Custom Table');
        case ComponentType.Simulation:
            return t('Simulation');
        case ComponentType.Task:
            return t('Task');
        case ComponentType.MultiParam:
            return t('Multi Parameter');
        case ComponentType.Observation:
            return t('Observation');
        default:
            return t('Attribute');
    }
};
exports.getTypeDisplay = getTypeDisplay;


/***/ }),

/***/ "./types/export.types.ts":
/*!*******************************!*\
  !*** ./types/export.types.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/index.ts":
/*!************************!*\
  !*** ./types/index.ts ***!
  \************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
__exportStar(__webpack_require__(/*! ./store.types */ "./types/store.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./component.types */ "./types/component.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./lof.types */ "./types/lof.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./asset.types */ "./types/asset.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./scoreTableType */ "./types/scoreTableType.ts"), exports);
__exportStar(__webpack_require__(/*! ./scoreDataGridType */ "./types/scoreDataGridType.ts"), exports);
__exportStar(__webpack_require__(/*! ./cof.types */ "./types/cof.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./risk.types */ "./types/risk.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./category.types */ "./types/category.types.ts"), exports);
__exportStar(__webpack_require__(/*! ./export.types */ "./types/export.types.ts"), exports);


/***/ }),

/***/ "./types/lof.types.ts":
/*!****************************!*\
  !*** ./types/lof.types.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/risk.types.ts":
/*!*****************************!*\
  !*** ./types/risk.types.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/riskConfig.types.ts":
/*!***********************************!*\
  !*** ./types/riskConfig.types.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.ConfigPublishState = void 0;
var ConfigPublishState;
(function (ConfigPublishState) {
    ConfigPublishState["published"] = "published";
    ConfigPublishState["unpublished"] = "unpublished";
})(ConfigPublishState = exports.ConfigPublishState || (exports.ConfigPublishState = {}));


/***/ }),

/***/ "./types/scoreDataGridType.ts":
/*!************************************!*\
  !*** ./types/scoreDataGridType.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/scoreTableType.ts":
/*!*********************************!*\
  !*** ./types/scoreTableType.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));


/***/ }),

/***/ "./types/store.types.ts":
/*!******************************!*\
  !*** ./types/store.types.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");


/***/ }),

/***/ "./utils/actions.ts":
/*!**************************!*\
  !*** ./utils/actions.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.addRouteNamespace = exports.addNamespace = void 0;
var config_store_1 = __webpack_require__(/*! @Store/config.store */ "./store/config.store.ts");
var addNamespace = function (action) { return config_store_1.moduleNamespace + '/' + action; };
exports.addNamespace = addNamespace;
var addRouteNamespace = function (route) {
    return config_store_1.routeNamespace + '/' + route;
};
exports.addRouteNamespace = addRouteNamespace;


/***/ }),

/***/ "./utils/datetime.ts":
/*!***************************!*\
  !*** ./utils/datetime.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.timeAgo = exports.WEEK = exports.DAY = exports.HOUR = exports.MINUTE = void 0;
var luxon_1 = __webpack_require__(/*! luxon */ "../node_modules/luxon/build/node/luxon.js");
exports.MINUTE = 60 * 1000;
exports.HOUR = 60 * exports.MINUTE;
exports.DAY = 24 * exports.HOUR;
exports.WEEK = 7 * exports.DAY;
var timeAgo = function (date) {
    var _a;
    if (date === void 0) { date = new Date().toISOString(); }
    var dt = luxon_1.DateTime.fromISO(date).minus(2 * exports.MINUTE);
    // Is it within the last week?
    if (dt.toMillis() > Date.now() - 1 * exports.WEEK) {
        // -> "15 minutes ago"
        // -> "6 hours ago"
        // -> "2 days ago"
        return (_a = dt.toRelative()) !== null && _a !== void 0 ? _a : '';
    }
    else {
        // -> "11 Dec 24"
        return dt.toFormat('DD');
    }
};
exports.timeAgo = timeAgo;


/***/ }),

/***/ "./utils/observationFields.ts":
/*!************************************!*\
  !*** ./utils/observationFields.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.getObservationFields = void 0;
var getObservationFields = function (t) {
    return [
        {
            label: t('Code'),
            value: 'PACP_CODE',
            disabled: false,
        },
    ];
};
exports.getObservationFields = getObservationFields;


/***/ }),

/***/ "./utils/styles.ts":
/*!*************************!*\
  !*** ./utils/styles.ts ***!
  \*************************/
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.TableBodyCellMenu = exports.TableBodyCell = exports.StyledMoreVert = exports.actionStyles = exports.Title = exports.StyledFormControl = exports.TableHeader = exports.StyledTable = exports.StyledGrid = exports.OuterGrid = exports.PaperStyled = exports.FullPage = exports.FullPageWrapper = exports.rem = exports.em = void 0;
var styled_components_1 = __importStar(__webpack_require__(/*! styled-components */ "styled-components"));
var material_1 = __webpack_require__(/*! @mui/material */ "@mui/material");
var stylovyze_1 = __webpack_require__(/*! @innovyze/stylovyze */ "@innovyze/stylovyze");
var em = function (px, basePx) {
    if (basePx === void 0) { basePx = 16; }
    return "".concat(px / basePx, "em");
};
exports.em = em;
var rem = function (px, basePx) {
    if (basePx === void 0) { basePx = 16; }
    return "".concat(px / basePx, "rem");
};
exports.rem = rem;
exports.FullPageWrapper = (0, styled_components_1.default)(stylovyze_1.PageWrapper)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n\tpadding-bottom: 0px;\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100%;\n\tpadding-bottom: 0px;\n"])));
exports.FullPage = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\theight: 100%;\n\tpadding: 1px;\n"], ["\n\theight: 100%;\n\tpadding: 1px;\n"])));
exports.PaperStyled = (0, styled_components_1.default)(material_1.Paper)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n"])));
exports.OuterGrid = (0, styled_components_1.default)(material_1.Grid)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tflex-direction: column;\n\tflex-grow: 1;\n"], ["\n\tflex-direction: column;\n\tflex-grow: 1;\n"])));
exports.StyledGrid = (0, styled_components_1.default)(material_1.Grid)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tpadding: ", " ", ";\n"], ["\n\tpadding: ", " ", ";\n"])), (0, exports.rem)(12), (0, exports.rem)(21));
exports.StyledTable = (0, styled_components_1.default)(material_1.Table)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\ttable-layout: 'auto';\n\toverflow: hidden;\n"], ["\n\ttable-layout: 'auto';\n\toverflow: hidden;\n"])));
exports.TableHeader = (0, styled_components_1.default)(material_1.TableHead)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\tbackground: #f2f2f2;\n"], ["\n\tbackground: #f2f2f2;\n"])));
exports.StyledFormControl = (0, styled_components_1.default)(material_1.FormControl)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\twidth: 90%;\n"], ["\n\twidth: 90%;\n"])));
exports.Title = (0, styled_components_1.default)(material_1.Typography)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tfont-style: normal;\n\tfont-weight: 600;\n\tfont-size: 18px;\n\tline-height: 24px;\n\ttext-align: left;\n\tcolor: #272833;\n\tmargin-bottom: 0;\n"], ["\n\tfont-style: normal;\n\tfont-weight: 600;\n\tfont-size: 18px;\n\tline-height: 24px;\n\ttext-align: left;\n\tcolor: #272833;\n\tmargin-bottom: 0;\n"])));
exports.actionStyles = (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tcolor: #768d95;\n"], ["\n\tcolor: #768d95;\n"])));
exports.StyledMoreVert = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\t", "\n\tfloat: right;\n"], ["\n\t", "\n\tfloat: right;\n"])), exports.actionStyles);
exports.TableBodyCell = (0, styled_components_1.default)(material_1.TableCell)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n\tcursor: default;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"], ["\n\tcursor: default;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n"])));
exports.TableBodyCellMenu = (0, styled_components_1.default)(exports.TableBodyCell)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\tcursor: inherit;\n\twidth: 5%;\n"], ["\n\tcursor: inherit;\n\twidth: 5%;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;


/***/ }),

/***/ "./utils/translations.ts":
/*!*******************************!*\
  !*** ./utils/translations.ts ***!
  \*******************************/
/***/ (function(__unused_webpack_module, exports) {


var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.translatedFilters = void 0;
var translatedFilters = function (filters, t) {
    return filters.map(function (filter) {
        var filterCaption = filter.column.caption;
        switch (filterCaption) {
            case 'Grade':
                filterCaption = t('Grade');
                break;
            case 'Condition Data':
                filterCaption = t('Condition Data');
                break;
        }
        var options = filter.options.map(function (opt) {
            switch (opt.caption) {
                case 'Negligible':
                    return { id: opt.id, caption: t('Negligible') };
                case 'Low':
                    return { id: opt.id, caption: t('Low') };
                case 'Medium':
                    return { id: opt.id, caption: t('Medium') };
                case 'High':
                    return { id: opt.id, caption: t('High') };
                case 'Extreme':
                    return { id: opt.id, caption: t('Extreme') };
                case 'No':
                    return { id: opt.id, caption: t('No') };
                case 'Yes':
                    return { id: opt.id, caption: t('Yes') };
                default:
                    return opt;
            }
        });
        var column = __assign(__assign({}, filter.column), { caption: filterCaption });
        return __assign(__assign({}, filter), { column: column, options: options });
    });
};
exports.translatedFilters = translatedFilters;


/***/ }),

/***/ "./utils/urlFormatting.ts":
/*!********************************!*\
  !*** ./utils/urlFormatting.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, exports) => {


Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.formatUrlTrailing = void 0;
var formatUrlTrailing = function (url) {
    return url.match(/\/$/) ? url : url + '/';
};
exports.formatUrlTrailing = formatUrlTrailing;


/***/ }),

/***/ "./components/FieldInspectionSummary/summary.png":
/*!*******************************************************!*\
  !*** ./components/FieldInspectionSummary/summary.png ***!
  \*******************************************************/
/***/ ((module) => {

module.exports = "data:image/png;base64,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";

/***/ }),

/***/ "./pages/repo-icon.svg":
/*!*****************************!*\
  !*** ./pages/repo-icon.svg ***!
  \*****************************/
/***/ ((module) => {

module.exports = "data:image/svg+xml;base64,IAkJPHN2ZwoJCQl3aWR0aD0iMjEiCgkJCWhlaWdodD0iMjIiCgkJCXZpZXdCb3g9IjAgMCAyMSAyMiIKCQkJZmlsbD0ibm9uZSIKCQkJeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KCQkJPHBhdGgKCQkJCWQ9Ik0xMC45ODI4IDE1LjYwMzZMMTYuNjkzMyA5LjE0NkwxMC4yMzU5IDE0Ljg1NjlDOS45MTEyNiAxNC43ODIgOS41NTY4MSAxNC44Njg0IDkuMzA0MTUgMTUuMTIxMUM4LjkxMzQ4IDE1LjUxMiA4LjkxMzcgMTYuMTQ0NyA5LjMwNDE1IDE2LjUzNTNDOS42OTQ4MSAxNi45MjYgMTAuMzI3NyAxNi45MjYgMTAuNzE4NCAxNi41MzUzQzEwLjk3MTMgMTYuMjgyNyAxMS4wNTc5IDE1LjkyODIgMTAuOTgyOCAxNS42MDM2WiIKCQkJCWZpbGw9IndoaXRlIgoJCQkvPgoJCQk8cGF0aAoJCQkJZD0iTTE3LjI5NTkgOS44MDYxNUwxNi4yNDY2IDEwLjk5MjZDMTcuMjg0OCAxMi4zMjg0IDE3LjkwNTIgMTQuMDA0MiAxNy45MDUyIDE1LjgyM0gxOS40NjA4QzE5LjQ2MDggMTMuNTM2NCAxOC42NDgxIDExLjQ0MDIgMTcuMjk1OSA5LjgwNjE1WiIKCQkJCWZpbGw9IndoaXRlIgoJCQkvPgoJCQk8cGF0aAoJCQkJZmlsbC1ydWxlPSJldmVub2RkIgoJCQkJY2xpcC1ydWxlPSJldmVub2RkIgoJCQkJZD0iTTExLjA5NzUgOC4wMDc5QzEyLjQ5NzIgOC4yMDEwMSAxMy43ODAzIDguNzYzNTYgMTQuODQ2NyA5LjU5MjE3TDE2LjAzMzIgOC41NDI4M0MxNC40MjMgNy4yMTA3OCAxMi4zNjQgNi40MDIyMiAxMC4xMTY3IDYuMzc4OTFMMTEuMDk3NSA4LjAwNzlaTTUuMTcxNDEgOS42MDEyOUgyLjkxMDc4QzEuNDU0NzYgMTEuMjYzIDAuNTcyMjY2IDEzLjQzOTggMC41NzIyNjYgMTUuODIyOEgyLjEyNzgyQzIuMTI3ODIgMTMuMjk4IDMuMzIwMTggMTEuMDQ2MyA1LjE3MTQxIDkuNjAxMjlaIgoJCQkJZmlsbD0id2hpdGUiCgkJCS8+CgkJCTxwYXRoCgkJCQlkPSJNNS41MTYxMyA2LjM0OTYxSDQuNjY2OTlWNy4xOTg2NEg1LjUxNjEzVjYuMzQ5NjFaIgoJCQkJZmlsbD0id2hpdGUiCgkJCS8+CgkJCTxwYXRoCgkJCQlkPSJNNS41MTYxMyAzLjM3NzQ0SDQuNjY2OTlWNS45MjQ5NUg1LjUxNjEzVjMuMzc3NDRaIgoJCQkJZmlsbD0id2hpdGUiCgkJCS8+CgkJCTxwYXRoCgkJCQlkPSJNMTAuMDkzNCA4LjYyNzQzSDAuMTMwODU5TDUuMTEyNDggMEwxMC4wOTM0IDguNjI3NDNaTTEuNjAxOCA3Ljc3ODE5SDguNjIyMjFMNS4xMTI0OCAxLjY5ODI3TDEuNjAxOCA3Ljc3ODE5WiIKCQkJCWZpbGw9IndoaXRlIgoJCQkvPgoJCTwvc3ZnPiA=";

/***/ }),

/***/ "@innovyze/lib-am-common/Actions":
/*!**************************************************!*\
  !*** external "@innovyze/lib-am-common/Actions" ***!
  \**************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Actions__;

/***/ }),

/***/ "@innovyze/lib-am-common/Components":
/*!*****************************************************!*\
  !*** external "@innovyze/lib-am-common/Components" ***!
  \*****************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Components__;

/***/ }),

/***/ "@innovyze/lib-am-common/Reducers":
/*!***************************************************!*\
  !*** external "@innovyze/lib-am-common/Reducers" ***!
  \***************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Reducers__;

/***/ }),

/***/ "@innovyze/lib-am-common/Selectors":
/*!****************************************************!*\
  !*** external "@innovyze/lib-am-common/Selectors" ***!
  \****************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Selectors__;

/***/ }),

/***/ "@innovyze/lib-am-common/Types":
/*!************************************************!*\
  !*** external "@innovyze/lib-am-common/Types" ***!
  \************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Types__;

/***/ }),

/***/ "@innovyze/lib-am-common/Utils":
/*!************************************************!*\
  !*** external "@innovyze/lib-am-common/Utils" ***!
  \************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_am_common_Utils__;

/***/ }),

/***/ "@innovyze/lib_asset_schema":
/*!*********************************************!*\
  !*** external "@innovyze/lib_asset_schema" ***!
  \*********************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_asset_schema__;

/***/ }),

/***/ "@innovyze/lib_asset_schema_store":
/*!***************************************************!*\
  !*** external "@innovyze/lib_asset_schema_store" ***!
  \***************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_asset_schema_store__;

/***/ }),

/***/ "@innovyze/lib_get_service":
/*!********************************************!*\
  !*** external "@innovyze/lib_get_service" ***!
  \********************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_lib_get_service__;

/***/ }),

/***/ "@innovyze/shared-utils":
/*!*****************************************!*\
  !*** external "@innovyze/shared-utils" ***!
  \*****************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_shared_utils__;

/***/ }),

/***/ "@mui/icons-material":
/*!**************************************!*\
  !*** external "@mui/icons-material" ***!
  \**************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_icons_material__;

/***/ }),

/***/ "@mui/icons-material/ArrowDownward":
/*!****************************************************!*\
  !*** external "@mui/icons-material/ArrowDownward" ***!
  \****************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_icons_material_ArrowDownward__;

/***/ }),

/***/ "@mui/icons-material/ArrowForward":
/*!***************************************************!*\
  !*** external "@mui/icons-material/ArrowForward" ***!
  \***************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_icons_material_ArrowForward__;

/***/ }),

/***/ "@mui/icons-material/CheckCircle":
/*!**************************************************!*\
  !*** external "@mui/icons-material/CheckCircle" ***!
  \**************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_icons_material_CheckCircle__;

/***/ }),

/***/ "@mui/icons-material/DoneSharp":
/*!************************************************!*\
  !*** external "@mui/icons-material/DoneSharp" ***!
  \************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_icons_material_DoneSharp__;

/***/ }),

/***/ "@mui/icons-material/FilterAlt":
/*!************************************************!*\
  !*** external "@mui/icons-material/FilterAlt" ***!
  \************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_icons_material_FilterAlt__;

/***/ }),

/***/ "@mui/icons-material/Help":
/*!*******************************************!*\
  !*** external "@mui/icons-material/Help" ***!
  \*******************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_icons_material_Help__;

/***/ }),

/***/ "@mui/icons-material/RemoveCircle":
/*!***************************************************!*\
  !*** external "@mui/icons-material/RemoveCircle" ***!
  \***************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_icons_material_RemoveCircle__;

/***/ }),

/***/ "@mui/icons-material/Star":
/*!*******************************************!*\
  !*** external "@mui/icons-material/Star" ***!
  \*******************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_icons_material_Star__;

/***/ }),

/***/ "@mui/material/Skeleton":
/*!*****************************************!*\
  !*** external "@mui/material/Skeleton" ***!
  \*****************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_material_Skeleton__;

/***/ }),

/***/ "@mui/material/colors":
/*!***************************************!*\
  !*** external "@mui/material/colors" ***!
  \***************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_material_colors__;

/***/ }),

/***/ "@mui/system":
/*!******************************!*\
  !*** external "@mui/system" ***!
  \******************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_system__;

/***/ }),

/***/ "@mui/x-data-grid-premium":
/*!*******************************************!*\
  !*** external "@mui/x-data-grid-premium" ***!
  \*******************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_x_data_grid_premium__;

/***/ }),

/***/ "@innovyze/stylovyze":
/*!**********************************************************************************************************************************************!*\
  !*** external {"commonjs":"@innovyze/stylovyze","commonjs2":"@innovyze/stylovyze","amd":"@Innovyze/Stylovyze","root":"@Innovyze/Stylovyze"} ***!
  \**********************************************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_stylovyze__;

/***/ }),

/***/ "@mui/material":
/*!****************************************************************************************************************************!*\
  !*** external {"commonjs":"@mui/material","commonjs2":"@mui/material","amd":"@MaterialUi/Core","root":"@MaterialUi/Core"} ***!
  \****************************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_material__;

/***/ }),

/***/ "@mui/styles":
/*!****************************************************************************************************************************!*\
  !*** external {"commonjs":"@mui/styles","commonjs2":"@mui/styles","amd":"@MaterialUi/styles","root":"@MaterialUi/styles"} ***!
  \****************************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__mui_styles__;

/***/ }),

/***/ "@reduxjs/toolkit":
/*!**********************************************************************************************************************************!*\
  !*** external {"commonjs":"@reduxjs/toolkit","commonjs2":"@reduxjs/toolkit","amd":"@Reduxjs/Toolkit","root":"@Reduxjs/Toolkit"} ***!
  \**********************************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__reduxjs_toolkit__;

/***/ }),

/***/ "i18next":
/*!**********************************************************************************************!*\
  !*** external {"commonjs":"i18next","commonjs2":"i18next","amd":"I18next","root":"I18next"} ***!
  \**********************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_i18next__;

/***/ }),

/***/ "react":
/*!**************************************************************************************!*\
  !*** external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"} ***!
  \**************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "react-i18next":
/*!********************************************************************************************************************!*\
  !*** external {"commonjs":"react-i18next","commonjs2":"react-i18next","amd":"ReactI18next","root":"ReactI18next"} ***!
  \********************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_i18next__;

/***/ }),

/***/ "react-redux":
/*!************************************************************************************************************!*\
  !*** external {"commonjs":"react-redux","commonjs2":"react-redux","amd":"ReactRedux","root":"ReactRedux"} ***!
  \************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_redux__;

/***/ }),

/***/ "react-router-dom":
/*!******************************************************************************************************************************!*\
  !*** external {"commonjs":"react-router-dom","commonjs2":"react-router-dom","amd":"ReactRouterDom","root":"ReactRouterDom"} ***!
  \******************************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_router_dom__;

/***/ }),

/***/ "styled-components":
/*!************************************************************************************************************************************!*\
  !*** external {"commonjs":"styled-components","commonjs2":"styled-components","amd":"StyledComponents","root":"StyledComponents"} ***!
  \************************************************************************************************************************************/
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE_styled_components__;

/***/ }),

/***/ "./i18n/settings.json":
/*!****************************!*\
  !*** ./i18n/settings.json ***!
  \****************************/
/***/ ((module) => {

module.exports = /*#__PURE__*/JSON.parse('{"contextSeparator":" [[translation context:]] ","keySeparator":false,"nsSeparator":false,"defaultLanguage":"en-US","ns":"app-am-risk"}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/nonce */
/******/ 	(() => {
/******/ 		__webpack_require__.nc = undefined;
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./pages/index.ts");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=Pages.js.map